import React from 'react'
import { Icon } from 'react-icons-kit/Icon'
import { search } from 'react-icons-kit/icomoon/search'
import { linkedin } from 'react-icons-kit/icomoon/linkedin'
import { facebook } from 'react-icons-kit/fa/facebook'
import { whatsapp } from 'react-icons-kit/fa/whatsapp'
import { telegram } from 'react-icons-kit/fa/telegram'
import { reddit } from 'react-icons-kit/fa/reddit'
import { instagram } from 'react-icons-kit/fa/instagram'
import { link } from 'react-icons-kit/icomoon/link'
import { location } from 'react-icons-kit/icomoon/location'
import { calculator } from 'react-icons-kit/icomoon/calculator'
import { priceTags } from 'react-icons-kit/icomoon/priceTags'
import { laptop } from 'react-icons-kit/icomoon/laptop'
import { mobile } from 'react-icons-kit/icomoon/mobile'
import { tablet } from 'react-icons-kit/icomoon/tablet'
import { download } from 'react-icons-kit/icomoon/download'
import { image } from 'react-icons-kit/icomoon/image'
import { arrowRight2 } from 'react-icons-kit/icomoon/arrowRight2'
import { arrowLeft2 } from 'react-icons-kit/icomoon/arrowLeft2'
import { fileText } from 'react-icons-kit/feather/fileText'
import { archive } from 'react-icons-kit/feather/archive'
import { menu } from 'react-icons-kit/feather/menu'
import { mail } from 'react-icons-kit/feather/mail'
import { filter } from 'react-icons-kit/feather/filter'
import { eye } from 'react-icons-kit/feather/eye'
import { zoomIn } from 'react-icons-kit/feather/zoomIn'
import { arrowDownCircle } from 'react-icons-kit/feather/arrowDownCircle'
import { arrowUpCircle } from 'react-icons-kit/feather/arrowUpCircle'
import { refresh } from 'react-icons-kit/fa/refresh'
import { trash } from 'react-icons-kit/fa/trash'
import { chevronDown } from 'react-icons-kit/fa/chevronDown'
import { chevronRight } from 'react-icons-kit/fa/chevronRight'
import { arrowLeft } from 'react-icons-kit/fa/arrowLeft'
import { arrowRight } from 'react-icons-kit/fa/arrowRight'
import { wechat } from 'react-icons-kit/fa/wechat'
import { edit } from 'react-icons-kit/fa/edit'
import { copy } from 'react-icons-kit/fa/copy'
import { arrowsAlt } from 'react-icons-kit/fa/arrowsAlt'
import { send } from 'react-icons-kit/fa/send'
import { heart } from 'react-icons-kit/entypo/heart'
import { star } from 'react-icons-kit/entypo/star'
import { pencil } from 'react-icons-kit/entypo/pencil'
import { graph } from 'react-icons-kit/entypo/graph'
import { withLine } from 'react-icons-kit/entypo/withLine'
import { line } from 'react-icons-kit/entypo/line'
import { horizontalMiddle } from 'react-icons-kit/entypo/horizontalMiddle'
import { right } from 'react-icons-kit/entypo/right'
import { left } from 'react-icons-kit/entypo/left'
import { iosArrowUp } from 'react-icons-kit/ionicons/iosArrowUp'
import { iosArrowBack } from 'react-icons-kit/ionicons/iosArrowBack'
import { iosArrowDown } from 'react-icons-kit/ionicons/iosArrowDown'
import { androidMoreVertical } from 'react-icons-kit/ionicons/androidMoreVertical'
import { androidMoreHorizontal } from 'react-icons-kit/ionicons/androidMoreHorizontal'
import { u1F4C3 } from 'react-icons-kit/noto_emoji_regular/u1F4C3'
import { u1F48C } from 'react-icons-kit/noto_emoji_regular/u1F48C'
import { u1F4DD } from 'react-icons-kit/noto_emoji_regular/u1F4DD'
import { u1F4BA } from 'react-icons-kit/noto_emoji_regular/u1F4BA'
import { u2747 } from 'react-icons-kit/noto_emoji_regular/u2747'
import { u1F4AC } from 'react-icons-kit/noto_emoji_regular/u1F4AC'
import { u1F465 } from 'react-icons-kit/noto_emoji_regular/u1F465'
import { u1F534 } from 'react-icons-kit/noto_emoji_regular/u1F534'
import { u1F3E1 } from 'react-icons-kit/noto_emoji_regular/u1F3E1'
import { u1F389 } from 'react-icons-kit/noto_emoji_regular/u1F389'
import { u1F4DC } from 'react-icons-kit/noto_emoji_regular/u1F4DC'
import { u1F4B5 } from 'react-icons-kit/noto_emoji_regular/u1F4B5'
import { u1F557 } from 'react-icons-kit/noto_emoji_regular/u1F557'
import { u1F6A9 } from 'react-icons-kit/noto_emoji_regular/u1F6A9'
import { u1F4B2 } from 'react-icons-kit/noto_emoji_regular/u1F4B2'
import { u1F4E6 } from 'react-icons-kit/noto_emoji_regular/u1F4E6'
import { u1F491 } from 'react-icons-kit/noto_emoji_regular/u1F491'
import { u1F4E3 } from 'react-icons-kit/noto_emoji_regular/u1F4E3'
import { u1F386 } from 'react-icons-kit/noto_emoji_regular/u1F386'
import { u2795 } from 'react-icons-kit/noto_emoji_regular/u2795'
import { u1F6B9 } from 'react-icons-kit/noto_emoji_regular/u1F6B9'
import { u1F481 } from 'react-icons-kit/noto_emoji_regular/u1F481'
import { u1F501 } from 'react-icons-kit/noto_emoji_regular/u1F501'
import { u1F318 } from 'react-icons-kit/noto_emoji_regular/u1F318'
import { u1F312 } from 'react-icons-kit/noto_emoji_regular/u1F312'
import { u274E } from 'react-icons-kit/noto_emoji_regular/u274E'
import { compose } from 'react-icons-kit/ionicons/compose'
import { ic_palette } from 'react-icons-kit/md/ic_palette'
import { iosTrashOutline } from 'react-icons-kit/ionicons/iosTrashOutline'
import { forward } from 'react-icons-kit/ionicons/forward'
import { u1F4C4 } from 'react-icons-kit/noto_emoji_regular/u1F4C4'
import { u1F476 } from 'react-icons-kit/noto_emoji_regular/u1F476'
import { pinOutline } from 'react-icons-kit/typicons/pinOutline'
import { ic_file_upload } from 'react-icons-kit/md/ic_file_upload'
import { qrcode } from 'react-icons-kit/fa/qrcode'
import { fontSize } from 'react-icons-kit/icomoon/fontSize'
import { font } from 'react-icons-kit/icomoon/font'
import { screen_expand_1 } from 'react-icons-kit/ikons/screen_expand_1'
import { paragraphCenter } from 'react-icons-kit/icomoon/paragraphCenter'
import { bold } from 'react-icons-kit/icomoon/bold'
import { eyedropper } from 'react-icons-kit/icomoon/eyedropper'
import { droplet } from 'react-icons-kit/icomoon/droplet'
import { u1F464 } from 'react-icons-kit/noto_emoji_regular/u1F464'
import { u2796 } from 'react-icons-kit/noto_emoji_regular/u2796'
import { u2733 } from 'react-icons-kit/noto_emoji_regular/u2733'
import { u1F536 } from 'react-icons-kit/noto_emoji_regular/u1F536'
import { u2753 } from 'react-icons-kit/noto_emoji_regular/u2753'
import { discover, compare, planning, host1, invitationrsvp, finance, timeline, seatchart, market, checklist } from '../assets/svgs'
import { first, fav, msg, host, rsvp, budget, timelineimg } from '../assets/userlogin'
import { iconwrapper } from './commonfunctions'
import { PLANNING_BUDGET_ICON, PLANNING_CHECKLIST_ICON, PLANNING_TIMELINE_ICON, PLANNING_INVITE_ICON, PLANNING_SEATING_ICON, PLANNING_QR_ICON, PLANNING_VENUECOMPARE_ICON, PLANNING_GUESTBOOK_ICON, DATETIME_ICON, THINTELEGRAM_ICON, PLANNING_COMMUNICATION_ICON, ACCESSORIES_ICON, BAKERYDESSERT_ICON, BEAUTY_ICON, BRIDALBOUTIQUES_ICON, CATERING_ICON, DANCE_ICON, DECORATION_ICON, DJ_ICON, DRESSATTIRE_ICON, EMCEES_ICON, ENTERTAINMENT_ICON, EVENTRENTALS_ICON, FLORISTS_ICON, GIFTS_ICON, HONEYMOON_ICON, JEWELLERY_ICON, MENSWEAR_ICON, MUSIC_ICON, PHOTOGRAPHY_ICON, PLANNER_ICON, TRANSPORT_ICON, VENUE_ICON, VIDEOGRAPHER_ICON, PAPER_ICON, PHOTOBOOTH_ICON, MAPGPS_ICON } from './svgicons'
import { S3CLOUD_CLOUDFRONT_ASSET } from './s3directories'

export var production = true
export var DUMMY = false

// export const WEBSITE_URL = production ? 'weavebliss.com' : 'localhost:3001'
// export const WEBSITE_URL = production ? 'weavebliss.com' : '192.168.1.75:3001'
export const WEBSITE_URL = production ? 'weavebliss.com' : '192.168.1.14:3001'
export const STARTUP_NAME = 'WeaveBliss'
export const SUPPORT_EMAIL = 'support@weavebliss.com'
export const CONTACT_WEAVEBLISS = '6588954019'

export const FACEBOOKGATE = true
export const GOOGLEGATE = true

export const WEB_WEAVEBLISS = S3CLOUD_CLOUDFRONT_ASSET + 'logo/logo512.png'
export const WEB_WEAVEBLISSTRANSPARENT = S3CLOUD_CLOUDFRONT_ASSET + 'logo/logo512_transparent.png'

export const eventgate = true

// for video advertisement 
export const videoadgate = false

// for guestbook
export const guestbookbool = true
export const guestart = false
export const guestemoji = false

// for seatchart corner
export const hideseatcorner = true

// for transaction
export const transactionandquote = false

// for market
export const marketbool = false

// for guestlist 
export const cryptobool = true

// for auscipious date app
export const auspiciousbool = false

export const hostjoin = false // constant to determine whether to activate hosting feature 
export const searchgate = false // constant to determine whether to activate search feature
export const promotion = false // allow promotion page, need to comment away Promo as well

export const DEBUG = false
export const RECAPTCHA_KEY = '6LfCJscUAAAAAHktsZp4N7spiHntR5izcUiBd7_e'
export const FB_APPID = '847158232379563'

// color
export const NEAR_TRANSPARENT_GREY = '#eee'
export const NORMAL_GREY = 'grey'
export const SELECTION_GREY = 'rgb(239, 239, 239)'
export const SOFT_GREY = 'rgb(186, 186, 186)'
export const LIKEABLE_RED = '#d2232a'
export const GENERAL_GREY = 'rgb(112, 112, 112)'
export const MSG_IMPT = '#f36c6c'
// export const VC_NAME_COLOR = '#353840'
export const VC_NAME_COLOR = '#21201f'
export const MAIN_PINK_COLOR = '#eb5d7b'
// font
export const SUB_FF = 'Lato'

// for all imgs
const production_v = 'production/vendor/'
const production_u = 'production/user/'

// share between frontend and backend
export const S3_DIRECTORY_PRODUCTION = {
    'VENDOR_PROFILE_IMG': production_v + 'profileimg/',
    'VENDOR_PROFILEBACKGROUND_IMG': production_v + 'profilebg/',
    'VENDOR_PROJECT_PORTFOLIO_IMG': production_v + 'project/',
    'VENDOR_PRICELIST_IMG': production_v + 'pricelist/',
    'VENDOR_QUOTE': production_v + 'quote/',

    'USER_PROFILE_IMG': production_u + 'profileimg/',
    'USER_GUETSBOOK_PERSONAL_IMG': production_u + 'guestbook/personal/',
    'USER_GUESTBOOK_ART_MAIN_IMG': production_u + 'guestbook/art/',
    'USER_GUETSBOOK_GUEST_UPLOAD_IMG': production_u + 'guestbook/guest/',
    'USER_INVITATIONCARD_IMG': production_u + 'invitation/',
    'USER_ITINERARY_IMG': production_u + 'itinerary/img/',
    'USER_QR_IMG': production_u + 'qr/img/', // not in use yet
}

const nonproduction_v = 'nonproduction/vendor/'
const nonproduction_u = 'nonproduction/user/'

// share between frontend and backend
export const S3_DIRECTORY_NONPRODUCTION = {
    'VENDOR_PROFILE_IMG': nonproduction_v + 'profileimg/',
    'VENDOR_PROFILEBACKGROUND_IMG': nonproduction_v + 'profilebg/',
    'VENDOR_PROJECT_PORTFOLIO_IMG': nonproduction_v + 'project/',
    'VENDOR_PRICELIST_IMG': nonproduction_v + 'pricelist/',
    'VENDOR_QUOTE': nonproduction_v + 'quote/',

    'USER_PROFILE_IMG': nonproduction_u + 'profileimg/',
    'USER_GUETSBOOK_PERSONAL_IMG': nonproduction_u + 'guestbook/personal/',
    'USER_GUESTBOOK_ART_MAIN_IMG': nonproduction_u + 'guestbook/art/',
    'USER_GUETSBOOK_GUEST_UPLOAD_IMG': nonproduction_u + 'guestbook/guest/',
    'USER_INVITATIONCARD_IMG': nonproduction_u + 'invitation/',
    'USER_ITINERARY_IMG': nonproduction_u + 'itinerary/img/',
    'USER_QR_IMG': nonproduction_u + 'qr/img/', // not in use yet
}

export const CRYPTOQN = 'Your cryptocurrency wallet address?'

// RSVP DEFAULT QUESTIONS, with uppercasing for Accept and Decline
export const RSVP_DEFAULT_QNS_WEDDING = [
    ['What is your name?', 1, null, 'all', null, null, null, '1-name'],
    ['Your email?', 1, null, 'all', null, null, null, '2-email'],
    ['Your contact?', 1, null, 'all', null, null, null, '3-contact'],
    ['Your address?', 1, null, 'all', null, null, null, '4-address'],
    [CRYPTOQN, 1, null, 'all', null, null, null, '7-nftwalletaddress'],
    [`Will you be able to join us at our wedding??`, 0, null, 'all', null, null, null, '8-rsvp', [['Accept', []], ['Decline', []]]]
]

// RSVP DEFAULT QUESTIONS, with uppercasing for Accept and Decline
export const RSVP_DEFAULT_QNS_EVENT = [
    ['What is your name?', 1, null, 'all', null, null, null, '1-name'],
    ['Your email?', 1, null, 'all', null, null, null, '2-email'],
    ['Your contact?', 1, null, 'all', null, null, null, '3-contact'],
    ['Your address?', 1, null, 'all', null, null, null, '4-address'],
    [CRYPTOQN, 1, null, 'all', null, null, null, '7-nftwalletaddress'],
    [`Will you be able to join us at our event?`, 0, null, 'all', null, null, null, '8-rsvp', [['Accept', []], ['Decline', []]]]
]

// RSVP DEFAULT QUESTIONS, with lowercasing for Accept and Decline
export const RSVP_DEFAULT_QNS_WEDDINGLOW = [
    ['What is your name?', 1, null, 'all', null, null, null, '1-name'],
    ['Your email?', 1, null, 'all', null, null, null, '2-email'],
    ['Your contact?', 1, null, 'all', null, null, null, '3-contact'],
    ['Your address?', 1, null, 'all', null, null, null, '4-address'],
    [CRYPTOQN, 1, null, 'all', null, null, null, '7-nftwalletaddress'],
    [`Will you be able to join us at our wedding??`, 0, null, 'all', null, null, null, '8-rsvp', [['accept', []], ['decline', []]]]
]

// RSVP DEFAULT QUESTIONS, with lowercasing for Accept and Decline
export const RSVP_DEFAULT_QNS_EVENTLOW = [
    ['What is your name?', 1, null, 'all', null, null, null, '1-name'],
    ['Your email?', 1, null, 'all', null, null, null, '2-email'],
    ['Your contact?', 1, null, 'all', null, null, null, '3-contact'],
    ['Your address?', 1, null, 'all', null, null, null, '4-address'],
    [CRYPTOQN, 1, null, 'all', null, null, null, '7-nftwalletaddress'],
    [`Will you be able to join us at our event?`, 0, null, 'all', null, null, null, '8-rsvp', [['accept', []], ['decline', []]]]
]

// for quiz and pricelistlookup
export const DEVICE_DIM_MAP = {
    'WEB': { wt: 720, ht: 450, fs: 14 },
    'TABLET': { wt: 630, ht: 360, fs: 14 },
    'MOBILE': { wt: 360, ht: 180, fs: 12 }
}
const quizdir = S3CLOUD_CLOUDFRONT_ASSET + `quiz/`
export const VT_QUIZ_MAP = { // constant to determine whether to activate quiz feature
    'Photographers': {
        'pages': ['qn', 'qn', 'qn', 'img', 'img'],
        'imgset': [
            {
                title: 'The wedding style you like?',
                choose: 3, // max number of images one can choose
                imgs: [
                    { src: quizdir + 'Contemporary.jpg', name: 'Contemporary' },
                    { src: quizdir + 'Film.jpg', name: 'Film' },
                    { src: quizdir + 'Natural.png', name: 'Natural' },
                    { src: quizdir + 'PhotoJournalism.jpg', name: 'Photo Journalism' },
                    { src: quizdir + 'Vintage.jpg', name: 'Vintage' }
                ]
            },
            {
                title: 'Favourite scene?',
                choose: 3, // max number of images one can choose
                imgs: [
                    { src: quizdir + 'Beach.jpeg', name: 'Beach' },
                    { src: quizdir + 'Nature.jpg', name: 'Nature' },
                    { src: quizdir + 'Rustic.jpg', name: 'Rustic', },
                    { src: quizdir + 'Quirky.png', name: 'Quirky' },
                    { src: quizdir + 'Pets.png', name: 'Pets' },
                    { src: quizdir + 'Sporty.jpg', name: 'Sporty' },
                    { src: quizdir + 'Glamorous.png', name: 'Glamorous' },
                    { src: quizdir + 'Industrial.png', name: 'Industrial' },
                    { src: quizdir + 'Artistic.jpg', name: 'Artistic' },
                    { src: quizdir + 'Traditional.jpg', name: 'Traditional' },
                ]
            },
        ],
        'qnset': [
            {
                choose: 1, // max number of selection to choose
                qn: 'When are you taking your wedding photos?',
                selections: ['within 3 months', 'within half a year', 'within a year', 'preparing']
            },
            {
                choose: 1, // max number of selection to choose
                qn: 'Wedding Photography for?',
                selections: ['Engagement Shoot', 'Solemnization', 'Actual Day']
            },
            {
                choose: 3, // max number of selection to choose
                qn: 'What do you want to see most in your wedding photos?',
                selections: ['Candid laughter', 'Creative poses', 'Friends helping me get ready', 'The subtle glance', 'Admiring the dress']
            },
        ],
    },
    'Videographers': {
        'pages': ['qn', 'qn'],
        'imgset': [],
        'qnset': [
            {
                choose: 1, // max number of selection to choose
                qn: 'Wedding Photography for?',
                selections: ['Solemnization', 'Actual Day']
            },
            {
                choose: 1, // max number of selection to choose
                qn: 'Choose your favourite videography style',
                selections: [

                    `Cinematic.
A style that is very similar to the movie. From scene transitions, shooting angles to how the story unfolds.`,

                    `Documentary.
Closely resemblence Cinematic style, but may feel less sophisticated than Cinematic style.`,

                    `Short Form.
Short videos and easy to share on social media platforms`,

                    `Storytelling.
Style includes the post-voiceover, and narrate the story of the wedding day and the couple`,

                    `Traditional.
The simplest style of wedding videography. Mainly focus on the wedding ceremony and reception`

                ]
            }
        ]
    },
    'Venue': {
        'pages': ['qn', 'qn', 'qn', 'img'],
        'imgset': [
            {
                title: 'Venue Type',
                choose: 1, // max number of images one can choose
                imgs: [
                    { src: quizdir + 'BanquetHall.jpeg', name: '' },
                    { src: quizdir + 'Beach.jpeg', name: '' },
                    { src: quizdir + 'Yacht.jpeg', name: '' },
                    { src: quizdir + 'farm.jpeg', name: '' },
                    { src: quizdir + 'Garden.jpg', name: '' },
                    { src: quizdir + 'Historic.jpeg', name: '' },
                    { src: quizdir + 'Hotel.jpeg', name: '' },
                    { src: quizdir + 'Mansion.jpeg', name: '' },
                    { src: quizdir + 'Park.jpeg', name: '' },
                    { src: quizdir + 'Religious.jpeg', name: '' },
                    { src: quizdir + 'Restaurant.jpeg', name: '' },
                    { src: quizdir + 'Rooftop.jpeg', name: '' },
                ]
            },
        ],
        'qnset': [
            {
                choose: 1, // max number of selection to choose
                qn: 'Venue for?',
                selections: ['Solemnization', 'Actual Day']
            },
            {
                choose: 1, // max number of selection to choose
                qn: 'Are you planning to have a wedding lunch or dinner?',
                selections: ['Lunch', 'Dinner', 'Lunch & Dinner']
            },
            {
                choose: 1, // max number of selection to choose
                qn: 'How many guests are you planning to have?',
                selections: ['0 - 99', '100 - 199', '200 - 299', '300 - 399', '400+']
            },
        ]
    }
}

const QUIZ_CSS = { display: 'flex', width: 14, height: 14, borderRadius: 10, backgroundColor: 'var(--mainpink)', border: '3px solid white', right: 0, top: 0, margin: 3 }
export const QUIZ_DOT = <div style={QUIZ_CSS} />
export const QUIZ_DOT_ABSOLUTE = <div style={{ position: 'absolute', pointerEvents: 'none', ...QUIZ_CSS }} />

export const TELEGRAM_WEDDING = 'SingaporeWeddings'
export const TELEGRAM_WEDDINGMARKETPLACE = 'sgweddingmarketplace'

export const MAX_WEB = 1920 // max web device can go
export const WEB = 1024 // to check device type
export const TABLET = 767 // ipad/pad size

export const NEXT_PAGE_TIMING = 500 // 500ms to next page
export const VALIDATE_TIMING = 1000 // 500ms to next page

export const NUM_WORDS_CANSEND = 200 // USER CAN SEND AT MOST 200 WORDS MSG TO VENDOR
export const LEN_MSG_CANSEND = 3000 // USER CAN SEND AT MOST 3K CHAR MSG TO VENDOR

export const IMG_ALT = ''
export const MIN_NUM_PROJECT_IMG = 4 // for vendor project 
export const MAX_NUM_PROJECT_IMG = 15// for vendor project 
export const MIN_NUM_PROJECT_OBJ = 4 //  for vendor project
export const MAX_NUM_PROJECT_OBJ = 15 // for vendor project
export const MIN_NUM_PROJECT_OBJ_TEXT_SIZE = 1 // for vendor project
export const MAX_NUM_PROJECT_OBJ_TEXT_SIZE = 1000 // for vendor project
export const MAX_NUM_PROJECT_CAN_BE_CREATED = 5// for venodr project
export const MAX_BOARD_FOR_USER = 50 // for user board
export const MAX_BOARD_PROJ_FOR_USER = 100 // for user board project
export const VENDORCARD_WT_WEB = 240
export const VENDORCARD_WT_SMALLMOBILE = 150
export const VENDORCARD_WT_MOBILE = 170
export const VENDORCARD_WT_LARGEMOBILE = 180
export const HOME_USER_MAX_NUMBER_CARD = 6// sync with backend
export const VENDOR_NOT_READY = 'VENDOR_NOT_READY'
export const EMPTY = '' // for empty textbox etc, home.action.js
export const EMPTYSPACE = <div className='empty space'>{'\u00A0'}</div>
export const HOMEUSER_MAX_NUM_FILTER = 10
export const DEFAULT_COUNTRY = 'SINGAPORE'
export const OPTIONAL = <div style={{ marginLeft: 5, color: 'rgb(181, 181, 181)' }}>(optional)</div>
export const IMPORTANT = <div style={{ color: 'red' }}>*</div>
export const COLLECTION_VENDORTYPE = [ // for all drop down with all vendor types 
    { value: '' },
    { value: 'Accessories' },
    { value: 'Beauty, Hair and Makeup' },
    { value: 'Bridal Boutiques' },
    { value: 'Catering' },
    { value: 'Dance' },
    { value: 'Decoration' },
    { value: 'DJ' },
    { value: 'Dress Attire' },
    { value: 'Emcees' },
    { value: 'Entertainment' },
    { value: 'Event Rentals' },
    { value: 'Florists' },
    { value: 'Gifts' },
    { value: 'Honeymoon' },
    { value: 'Jewellery' },
    { value: 'Menswear' },
    { value: 'Music' },
    { value: 'Paper Stationary' },
    { value: 'Photobooths' },
    { value: 'Photographers' },
    { value: 'Transport' },
    { value: 'Venue' },
    { value: 'Videographers' },
    { value: 'Bakery and Desserts' }, //test
    { value: 'Planners' }
]

export const HOME_COLLECTION_READABLEVT_WEDDING_MAP = {
    '': '',
    'Accessories': ACCESSORIES_ICON,
    'Beauty, Hair and Makeup': BEAUTY_ICON,
    'Bridal Boutiques': BRIDALBOUTIQUES_ICON,
    'Catering': CATERING_ICON,
    'Dance': DANCE_ICON,
    'Decoration': DECORATION_ICON,
    'DJ': DJ_ICON,
    'Dress and Attire': DRESSATTIRE_ICON,
    'Emcees': EMCEES_ICON,
    'Entertainment': ENTERTAINMENT_ICON,
    'Event Rentals': EVENTRENTALS_ICON,
    'Florists': FLORISTS_ICON,
    'Gifts': GIFTS_ICON,
    'Honeymoon': HONEYMOON_ICON,
    'Jewellery': JEWELLERY_ICON,
    'Menswear': MENSWEAR_ICON,
    'Music': MUSIC_ICON,
    'Paper Stationary': PAPER_ICON,
    'Photobooths': PHOTOBOOTH_ICON,
    'Photographers': PHOTOGRAPHY_ICON,
    'Transport': TRANSPORT_ICON,
    'Venue': VENUE_ICON,
    'Videographers': VIDEOGRAPHER_ICON,
    'Bakery and Desserts': BAKERYDESSERT_ICON, //test
    'Planners': PLANNER_ICON
}

export const HOME_COLLECTION_VENDORTYPE_WEDDING = [ // Home > bubblebox
    { value: 'All', icon: '' },
    { value: 'Accessories', icon: ACCESSORIES_ICON },
    { value: 'Bakeryanddesserts', icon: BAKERYDESSERT_ICON },
    { value: 'Beautyhairandmakeup', icon: BEAUTY_ICON },
    { value: 'Bridalboutiques', icon: BRIDALBOUTIQUES_ICON },
    { value: 'Catering', icon: CATERING_ICON },
    { value: 'Dance', icon: DANCE_ICON },
    { value: 'Decoration', icon: DECORATION_ICON },
    { value: 'Dj', icon: DJ_ICON },
    { value: 'Dressattire', icon: DRESSATTIRE_ICON },
    { value: 'Emcees', icon: EMCEES_ICON },
    { value: 'Entertainment', icon: ENTERTAINMENT_ICON },
    { value: 'Eventrentals', icon: EVENTRENTALS_ICON },
    { value: 'Florists', icon: FLORISTS_ICON },
    { value: 'Gifts', icon: GIFTS_ICON },
    { value: 'Honeymoon', icon: HONEYMOON_ICON },
    { value: 'Jewellery', icon: JEWELLERY_ICON },
    { value: 'Menswear', icon: MENSWEAR_ICON },
    { value: 'Music', icon: MUSIC_ICON },
    { value: 'Paperstationary', icon: PAPER_ICON },
    { value: 'Photobooths', icon: PHOTOBOOTH_ICON },
    { value: 'Photographers', icon: PHOTOGRAPHY_ICON },
    { value: 'Planners', icon: PLANNER_ICON },
    { value: 'Transport', icon: TRANSPORT_ICON },
    { value: 'Venue', icon: VENUE_ICON },
    { value: 'Videographers', icon: VIDEOGRAPHER_ICON },
]

export const WEDDINGVT_ICON_MAP = {
    'All': '',
    'Accessories': ACCESSORIES_ICON,
    'Bakeryanddesserts': BAKERYDESSERT_ICON,
    'Beautyhairandmakeup': BEAUTY_ICON,
    'Bridalboutiques': BRIDALBOUTIQUES_ICON,
    'Catering': CATERING_ICON,
    'Dance': DANCE_ICON,
    'Decoration': DECORATION_ICON,
    'Dj': DJ_ICON,
    'Dressattire': DRESSATTIRE_ICON,
    'Emcees': EMCEES_ICON,
    'Entertainment': ENTERTAINMENT_ICON,
    'Eventrentals': EVENTRENTALS_ICON,
    'Florists': FLORISTS_ICON,
    'Gifts': GIFTS_ICON,
    'Honeymoon': HONEYMOON_ICON,
    'Jewellery': JEWELLERY_ICON,
    'Menswear': MENSWEAR_ICON,
    'Music': MUSIC_ICON,
    'Paperstationary': PAPER_ICON,
    'Photobooths': PHOTOBOOTH_ICON,
    'Photographers': PHOTOGRAPHY_ICON,
    'Planners': PLANNER_ICON,
    'Transport': TRANSPORT_ICON,
    'Venue': VENUE_ICON,
    'Videographers': VIDEOGRAPHER_ICON,
}

export const HOME_COLLECTION_VENDORTYPE_EVENT = [ // Home > bubblebox
    { value: 'All', icon: '' },
    { value: 'Accessories', icon: ACCESSORIES_ICON },
    { value: 'Bakeryanddesserts', icon: BAKERYDESSERT_ICON },
    { value: 'Beautyhairandmakeup', icon: BEAUTY_ICON },
    // { value: 'Bridalboutiques' },
    { value: 'Catering', icon: CATERING_ICON },
    { value: 'Dance', icon: DANCE_ICON },
    { value: 'Decoration', icon: DECORATION_ICON },
    { value: 'Dj', icon: DJ_ICON },
    { value: 'Dressattire', icon: DRESSATTIRE_ICON },
    { value: 'Emcees', icon: EMCEES_ICON },
    { value: 'Entertainment', icon: ENTERTAINMENT_ICON },
    { value: 'Eventrentals', icon: EVENTRENTALS_ICON },
    { value: 'Florists', icon: FLORISTS_ICON },
    { value: 'Gifts', icon: GIFTS_ICON },
    // { value: 'Honeymoon' },
    { value: 'Jewellery', icon: JEWELLERY_ICON },
    { value: 'Menswear', icon: MENSWEAR_ICON },
    { value: 'Music', icon: MUSIC_ICON },
    { value: 'Paperstationary', icon: PAPER_ICON },
    { value: 'Photobooths', icon: PHOTOBOOTH_ICON },
    { value: 'Photographers', icon: PHOTOGRAPHY_ICON },
    { value: 'Planners', icon: PLANNER_ICON },
    { value: 'Transport', icon: TRANSPORT_ICON },
    { value: 'Venue', icon: VENUE_ICON },
    { value: 'Videographers', icon: VIDEOGRAPHER_ICON },
]
export const HOME_COLLECTION_VENDORTYPE_EVENT_ARR = [ // including All, Event is subset of Wedding 
    'All',
    'Accessories',
    'Bakeryanddesserts',
    'Beautyhairandmakeup',
    // 'Bridalboutiques' ,
    'Catering',
    'Dance',
    'Decoration',
    'Dj',
    'Dressattire',
    'Emcees',
    'Entertainment',
    'Eventrentals',
    'Florists',
    'Gifts',
    // 'Honeymoon' ,
    'Jewellery',
    'Menswear',
    'Music',
    'Paperstationary',
    'Photobooths',
    'Photographers',
    'Planners',
    'Transport',
    'Venue',
    'Videographers',
]
export const HOME_COLLECTION_VENDORTYPE_WEDDING_ARR = [// including All
    'All',
    'Accessories',
    'Bakeryanddesserts',
    'Beautyhairandmakeup',
    'Bridalboutiques',
    'Catering',
    'Dance',
    'Decoration',
    'Dj',
    'Dressattire',
    'Emcees',
    'Entertainment',
    'Eventrentals',
    'Florists',
    'Gifts',
    'Honeymoon',
    'Jewellery',
    'Menswear',
    'Music',
    'Paperstationary',
    'Photobooths',
    'Photographers',
    'Planners',
    'Transport',
    'Venue',
    'Videographers',
]
export const VENDORPROFILE_COLLECTION_VENDORTYPE_WEDDING = [ // use in vendorprofile and Favouritevendor
    // excluding All
    'Accessories',
    'Bakeryanddesserts',
    'Beautyhairandmakeup',
    'Bridalboutiques',
    'Catering',
    'Dance',
    'Decoration',
    'Dj',
    'Dressattire',
    'Emcees',
    'Entertainment',
    'Eventrentals',
    'Florists',
    'Gifts',
    'Honeymoon',
    'Jewellery',
    'Menswear',
    'Music',
    'Paperstationary',
    'Photobooths',
    'Photographers',
    'Planners',
    'Transport',
    'Venue',
    'Videographers'
]
export const VENDORPROFILE_COLLECTION_VENDORTYPE_EVENT = [// excluding All
    'Accessories',
    'Bakeryanddesserts',
    'Beautyhairandmakeup',
    'Catering',
    'Dance',
    'Decoration',
    'Dj',
    'Dressattire',
    'Emcees',
    'Entertainment',
    'Eventrentals',
    'Florists',
    'Gifts',
    'Jewellery',
    'Menswear',
    'Music',
    'Paperstationary',
    'Photobooths',
    'Photographers',
    'Planners',
    'Transport',
    'Venue',
    'Videographers',
]
export const FILTERDATE_MAP = {
    // '2020': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    // '2021': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    '2021': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    '2022': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    '2023': [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
}
export const MARKET_NUMMTH_CHARMTH_MAP = { 1: 'Jan', 2: 'Feb', 3: 'Mar', 4: 'Apr', 5: 'May', 6: 'June', 7: 'July', 8: 'Aug', 9: 'Sept', 10: 'Oct', 11: 'Nov', 12: 'Dec' }
export const NUMMTH_CHARMTH_MAP = { 0: 'Jan', 1: 'Feb', 2: 'Mar', 3: 'Apr', 4: 'May', 5: 'June', 6: 'July', 7: 'Aug', 8: 'Sept', 9: 'Oct', 10: 'Nov', 11: 'Dec' }
export const NUMMTH_FULLCHARMTH_MAP = { 0: 'January', 1: 'Feburary', 2: 'March', 3: 'April', 4: 'May', 5: 'June', 6: 'July', 7: 'August', 8: 'September', 9: 'October', 10: 'November', 11: 'December' }

export const VENDORPROFILE_COLLECTION_TYPE_GUEST = ['Chinese Wedding', 'Malay Wedding', 'Tamil Wedding', 'Birthday Celebration', 'Graduation Ceremony', 'Baby Shower', 'Marriage Proposal', 'House Warming', 'School Reunion']
export const GUESTCATEGORY_KEY = ['Wedding Type', 'Event Type']
export const GUESTCATEGORY_DETAIL_MAP = {
    'Wedding Type': ['Chinese Wedding', 'Malay Wedding', 'Tamil Wedding'],
    'Event Type': ['Birthday Celebration', 'Graduation Ceremony', 'Baby Shower', 'Marriage Proposal', 'House Warming', 'School Reunion']
}
export const INVITATIONTYPES_ARR = ['Wedding'] // used in invitation, 'House-Warming', 'Baby Shower', 'Birthday Party', 'Postponement', 'Baby Shower'
export const SEATING_ARR = ['Wedding', 'Party'] // 'Rehearsal Dinner', 'Wedding Lunch', 'Ceremony', 'After Party', 'Other'
export const GUESTBOOK_ARR = ['Wedding', 'Event']//, 'House-Warming', 'Baby Shower', 'Birthday Party'
export const NONE = 'None'
export const COMPARISON_TEXT = <div style={{ margin: 5, color: '#707070', fontSize: 20, display: 'flex', alignContent: 'center', textAlign: 'center', flexDirection: 'row', height: 40, alignItems: 'center' }}>Compare</div>

export const DEFAULT_FILTERSUB_BOTH = { cat: 'Others', header: 'Covid19 Flexi Schedule', type: 0 }

export const SEARCH_FILTER_WEDDING = { // NOTE: EVENT_FILTER_EVENT is subset of SEARCH_FILTER_WEDDING
    // use in vendorlookup, vendorprofile, 
    // header, is the query string sending to backend
    // type implies, only one check box can be selected out of n checkboxes
    // Keys - "Others" is RESTRICTED, do not use
    'All': {
        'active': true, // ensure this set of data has at least a single Keys
        'Keys': ['Sort'],
        'Sort': [
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
        ]
    },
    'Accessories': {
        'active': true,
        'Keys': ['Sort', 'Accessories Types'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Accessories Types': [
            { header: 'Costume Accessories', type: 0 },
            { header: 'Custom Accessories', type: 0 },
            { header: 'Designer Accessories', type: 0 },
        ]
    },
    'Beautyhairandmakeup': {
        'active': true,
        'Keys': ['Sort', 'Hair Services', 'Beauty Services', 'Makeup Services'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Hair Services': [
            { header: 'Blowouts', type: 0 },
            { header: 'Coloring', type: 0 },
            { header: 'Extensions', type: 0 },
            { header: 'Relaxer', type: 0 },
            { header: 'Haircuts', type: 0 },
            { header: 'Keratin', type: 0 },
            { header: 'Perm', type: 0 },
            { header: 'Textured Hair Styling', type: 0 },
            { header: 'Updos / Styling', type: 0 },
            { header: 'Hair Trial', type: 0 },
            { header: 'On-Site Hair', type: 0 },
        ],
        'Beauty Services': [
            { header: 'Body Art', type: 0 },
            { header: 'Consultations', type: 0 },
            { header: 'Facials', type: 0 },
            { header: 'Manicure / Pedicure', type: 0 },
            { header: 'Massages', type: 0 },
            { header: 'Men\'s Grooming', type: 0 },
            { header: 'Spa', type: 0 },
            { header: 'Teeth Whitening', type: 0 },
            { header: 'Skincare', type: 0 },
        ],
        'Makeup Services': [
            { header: 'Airbrush Makeup', type: 0 },
            { header: 'Contour Makeup', type: 0 },
            { header: 'Eye Makeup', type: 0 },
            { header: 'Natural Makeup', type: 0 },
            { header: 'On-Site Makeup', type: 0 },
            { header: 'Wedding Party Makeup', type: 0 },
            { header: 'Makeup Trial', type: 0 },
            { header: 'Fake Lashes', type: 0 },
            { header: 'Brow/Lash Tinting', type: 0 },
            { header: 'Tattoo Coverage', type: 0 },
        ],
    },
    'Bridalboutiques': {
        'active': true,
        'Keys': ['Sort', 'Clientele'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Clientele': [
            { header: 'Bride', type: 0 },
            { header: 'Bridemaids', type: 0 },
            { header: 'Flower Girls', type: 0 },
            { header: 'Groom', type: 0 },
            { header: 'Father of the Bride', type: 0 },
            { header: 'Father of the Groom', type: 0 },
        ]
    },
    'Catering': {
        'active': true,
        'Keys': ['Sort', 'Cuisines', 'Services', 'Dietary Needs', 'Bar Services'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Cuisines': [
            { header: 'Malay', type: 0 },
            { header: 'Chinese', type: 0 },
            { header: 'Indian', type: 0 },
            { header: 'Middle Eastern', type: 0 },
            { header: 'Seafood', type: 0 },
            { header: 'Spanish', type: 0 },
            { header: 'BBQ', type: 0 },
            { header: 'Caribbean', type: 0 },
        ],
        'Services': [
            { header: 'Breakfast / Brunch', type: 0 },
            { header: 'Buffet', type: 0 },
            { header: 'Cake Cutting', type: 0 },
            { header: 'Cocktail Reception', type: 0 },
            { header: 'Custom Menu', type: 0 },
            { header: 'Plated', type: 0 },
            { header: 'Stations', type: 0 },
            { header: 'Tastings', type: 0 },
        ],
        'Dietary Needs': [
            { header: 'Gluten Free', type: 0 },
            { header: 'Lactose Free', type: 0 },
            { header: 'Halal', type: 0 },
            { header: 'Nut Free', type: 0 },
            { header: 'Vegan', type: 0 },
            { header: 'Vegetarian', type: 0 },
        ],
        'Bar Services': [
            { header: 'Bartender(s)', type: 0 },
            { header: 'Open Bar', type: 0 },
            { header: 'Champagne Toast', type: 0 },
            { header: 'Signature Drink', type: 0 },
        ]
    },
    'Dance': {
        'active': true,
        'Keys': ['Sort', 'Dance Service'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Dance Service': [
            { header: 'Tamil', type: 0 },
            { header: 'Others', type: 0 },
        ]
    },
    'Decoration': {
        'active': true,
        'Keys': ['Sort', 'Decoration Service'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Decoration Service': [
            { header: 'Complete Styling Service', type: 0 },
            { header: 'Ballons', type: 0 },
            { header: 'Candles', type: 0 },
            { header: 'Candelabras', type: 0 },
            { header: 'Chair Covers', type: 0 },
            { header: 'Dining Furniture Hire', type: 0 },
            { header: 'Arcade Game Hire', type: 0 },
            { header: 'Sound/PA Hire', type: 0 },
            { header: 'Set-up', type: 0 },
            { header: 'Last-Minute Orders', type: 0 },
            { header: 'Clean-Up', type: 0 },
            { header: 'Dance Floor Hire', type: 0 },
            { header: 'Portable Toilet', type: 0 },
        ]
    },
    'Dj': {
        'active': true,
        'Keys': ['Sort', 'Music Genres'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Music Genres': [
            { header: 'Mandrain', type: 0 },
            { header: 'Malay', type: 0 },
            { header: 'Tamil', type: 0 },
            { header: 'Christian', type: 0 },
            { header: 'Club', type: 0 },
            { header: 'Country', type: 0 },
            { header: 'Electronic', type: 0 },
            { header: 'Hip Hop', type: 0 },
            { header: 'Indie', type: 0 },
            { header: 'International', type: 0 },
            { header: 'Jazz', type: 0 },
            { header: 'Oldies', type: 0 },
            { header: 'Pop', type: 0 },
            { header: 'R&B / Soul', type: 0 },
            { header: 'Rock', type: 0 },
            { header: 'Asian', type: 0 },
        ]
    },
    'Dressattire': {
        'active': true,
        'Keys': ['Sort'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
        ]
    },
    'Emcees': {
        'active': true,
        'Keys': ['Sort'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
        ]
    },
    'Entertainment': {
        'active': true,
        'Keys': ['Sort', 'Entertainment Services'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Entertainment Services': [
            { header: 'Bands', type: 0 },
            { header: 'Dancers', type: 0 },
            { header: 'DJs', type: 0 },
            { header: 'Ensembles', type: 0 },
            { header: 'Headliners/Celebrity Bookings', type: 0 },
            { header: 'Illusionists/Magicians', type: 0 },
            { header: 'Performance Acts', type: 0 },
        ]
    },
    'Eventrentals': {
        'active': true,
        'Keys': ['Sort', 'Rental Services'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Rental Services': [
            { header: 'Audiovisual', type: 0 },
            { header: 'Backdrops', type: 0 },
            { header: 'Dance Floors', type: 0 },
            { header: 'Furniture', type: 0 },
            { header: 'Games', type: 0 },
            { header: 'Lighting', type: 0 },
            { header: 'Linens', type: 0 },
            { header: 'Stages', type: 0 },
            { header: 'Tabletop', type: 0 },
        ]
    },
    'Florists': {
        'active': true,
        'Keys': ['Sort', 'Floral Arrangements'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Floral Arrangements': [
            { header: 'Aisle Decor', type: 0 },
            { header: 'Altar Decor', type: 0 },
            { header: 'Artificial', type: 0 },
            { header: 'Bouquets', type: 0 },
            { header: 'Boutonnieres', type: 0 },
            { header: 'Centerpieces', type: 0 },
            { header: 'Chuppah Decor', type: 0 },
            { header: 'Corsages', type: 0 },
            { header: 'Flower Baskets', type: 0 },
            { header: 'Flower Crowns', type: 0 },
            { header: 'Flower Petals', type: 0 },
            { header: 'Non-Floral', type: 0 },
            { header: 'Single Flowers', type: 0 },
        ]
    },
    'Gifts': {
        'active': true,
        'Keys': ['Sort', 'Service'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Service': [
            { header: 'Favors & Wearables', type: 0 },
            { header: 'Swag Bags', type: 0 },
            { header: 'Goodie Bags', type: 0 },
        ]
    },
    'Honeymoon': {
        'active': true,
        'Keys': ['Sort', 'Honeymoon Services'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Honeymoon Services': [
            { header: 'Asia', type: 0 },
            { header: 'West', type: 0 },
        ]
    },
    'Jewellery': {
        'active': true,
        'Keys': ['Sort', 'Jewellery Types'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Jewellery Types': [
            { header: 'Wedding Bands', type: 0 },
            { header: 'Engagement Rings', type: 0 },
            { header: 'Custom Engagement Rings', type: 0 },
            { header: 'Custom Wedding Bands', type: 0 },
            { header: 'Designer Engagement Rings', type: 0 },
            { header: 'Designer Wedding Bands', type: 0 },
            { header: 'Custom Design', type: 0 },
        ]

    },
    'Menswear': {
        'active': true,
        'Keys': ['Sort', 'Menswear Services'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Menswear Services': [
            { header: 'Bow Ties', type: 0 },
            { header: 'Shoes', type: 0 },
            { header: 'Ties, Tuxedos & Suits', type: 0 },
            { header: 'Vests', type: 0 },
            { header: 'Cummerbunds', type: 0 },
        ]
    },
    'Music': {
        'active': true,
        'Keys': ['Sort', 'Music Genres'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Music Genres': [
            { header: 'Mandrain', type: 0 },
            { header: 'Malay', type: 0 },
            { header: 'Tamil', type: 0 },
        ]

    },
    'Paperstationary': {
        'active': true,
        'Keys': ['Sort', 'Invitations Services'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Invitations Services': [
            { header: 'Assembly', type: 0 },
            { header: 'Design', type: 0 },
            { header: 'Embossed', type: 0 },
            { header: 'Engraving', type: 0 },
            { header: 'Letterpress', type: 0 },
            { header: 'Printing', type: 0 },
            { header: 'Custom', type: 0 },
        ]
    },
    'Photobooths': {
        'active': true,
        'Keys': ['Sort', 'Photobooths Services'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Photobooths Services': [
            { header: 'Photo Guestbook ', type: 0 },
            { header: 'Backdrops', type: 0 },
            { header: 'Prints', type: 0 },
        ]

    },
    'Photographers': {
        'active': true,
        'Keys': ['Sort', 'Photography Style', 'Photography Type', 'Photography Services', 'Photography Theme'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Photography Style': [
            { header: 'Contemporary', type: 0 },
            { header: 'Film', type: 0 },
            { header: 'Natural', type: 0 },
            { header: 'Photo Journalism', type: 0 },
            { header: 'Vintage', type: 0 },
        ],
        'Photography Type': [
            { header: 'Engagement Shoot', type: 0 },
            { header: 'Solemnization', type: 0 },
            { header: 'Actual Day', type: 0 },
        ],
        'Photography Services': [
            { header: 'Additional Hours', type: 0 },
            { header: 'Destination / Travel', type: 0 },
            { header: 'High-Res Images', type: 0 },
            { header: 'One Event / Day', type: 0 },
            { header: 'Second Shooter', type: 0 },
            { header: 'Video', type: 0 },
            { header: 'Wedding Portraits', type: 0 },
        ],
        'Photography Theme': [
            { header: 'Beach', type: 0 },
            { header: 'Nature', type: 0 },
            { header: 'Rustic', type: 0 },
            { header: 'Quirky', type: 0 },
            { header: 'Pets', type: 0 },
            { header: 'Sporty', type: 0 },
            { header: 'Glamorous', type: 0 },
            { header: 'Industrial', type: 0 },
            { header: 'School', type: 0 },
            { header: 'Artistic', type: 0 },
            { header: 'Traditional', type: 0 },
        ]
    },
    'Transport': {
        'active': true,
        'Keys': ['Sort', 'Transport Services'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Transport Services': [
            { header: 'Buses', type: 0 },
            { header: 'Luxury/Specialty Vehicles', type: 0 },
        ]

    },
    'Venue': {
        'active': true,
        'Keys': ['Sort', 'Venue Usage', 'Maximum Capacity', 'Venue Type', 'Settings', 'Amenities'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Venue Usage': [
            { header: 'Solemnization', type: 0 },
            { header: 'Actual Day', type: 0 },
        ],
        'Maximum Capacity': [
            { header: '0 - 99', type: 0 },
            { header: '100 - 199', type: 0 },
            { header: '200 - 299', type: 0 },
            { header: '300 - 399', type: 0 },
            { header: '400+', type: 0 },
        ],
        'Venue Type': [
            { header: 'Banquet Hall', type: 0 },
            { header: 'Beach', type: 0 },
            { header: 'Boat / Yacht', type: 0 },
            { header: 'Golf Club', type: 0 },
            { header: 'Country Club', type: 0 },
            { header: 'Farm / Ranch', type: 0 },
            { header: 'Garden', type: 0 },
            { header: 'Historic Building', type: 0 },
            { header: 'Hotel', type: 0 },
            { header: 'Mansion', type: 0 },
            { header: 'Museum', type: 0 },
            { header: 'Park', type: 0 },
            { header: 'Religious', type: 0 },
            { header: 'Restaurant', type: 0 },
            { header: 'Rooftop', type: 0 },
        ],
        'Settings': [
            { header: 'Indoor', type: 0 },
            { header: 'Covered Outdoor', type: 0 },
            { header: 'Uncovered Outdoor', type: 0 },
        ],
        'Amenities': [
            { header: 'Accommodations', type: 0 },
            { header: 'Bar Services', type: 0 },
            { header: 'Catering Services', type: 0 },
            { header: 'Event Planner', type: 0 },
            { header: 'Get Ready Rooms', type: 0 },
            { header: 'Liability Insurance', type: 0 },
            { header: 'Outside Vendors', type: 0 },
            { header: 'Pet Friendly', type: 0 },
            { header: 'Wifi', type: 0 },
        ],
    },
    'Videographers': {
        'active': true,
        'Keys': ['Sort', 'Videography Style', 'Videography Services'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Videography Style': [
            { header: 'Cinematic', type: 0 },
            { header: 'Documentary', type: 0 },
            { header: 'Short Form', type: 0 },
            { header: 'Storytelling', type: 0 },
            { header: 'Traditional', type: 0 },
        ],
        'Videography Services': [
            { header: 'Drone Footage', type: 0 },
            { header: 'Full Feature Video', type: 0 },
            { header: 'Highlight Video', type: 0 },
            { header: 'Multi. Cameras', type: 0 },
            { header: 'Multi. Locations', type: 0 },
            { header: 'One Event / Day', type: 0 },
            { header: 'Raw Footage', type: 0 },
        ],
    },
    'Bakeryanddesserts': {
        'active': true,
        'Keys': ['Sort', 'Bakery and Desserts Services'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Bakery and Desserts Services': [
            { header: 'Cakes', type: 0 },
            { header: 'Candies', type: 0 },
            { header: 'Chocolates', type: 0 },
            { header: 'Cookies', type: 0 },
            { header: 'Gluten-free', type: 0 },
            { header: 'Pastries', type: 0 },
            { header: 'Pies', type: 0 },
        ]
    },
    'Planners': {
        'active': true,
        'Keys': ['Sort', 'Planning Services'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Planning Services': [
            { header: 'Day-of-Coordination', type: 0 },
            { header: 'Full Planning', type: 0 },
            { header: 'Partial Planning', type: 0 },
        ]

    }
}

export const SEARCH_FILTER_EVENT = { // not in use yet
    'All': {
        'active': true, // ensure this set of data has at least a single Keys
        'Keys': ['Sort'],
        'Sort': [
            // {  header: 'Price ( High - Low )', type: 1 },
            // {  header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ]
    },
    'Accessories': {
        'active': true,
        'Keys': ['Sort', 'Accessories Types'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Accessories Types': [
            { header: 'Costume Accessories', type: 0 },
            { header: 'Custom Accessories', type: 0 },
            { header: 'Designer Accessories', type: 0 },
        ]
    },
    'Beautyhairandmakeup': {
        'active': true,
        'Keys': ['Sort', 'Hair Services', 'Beauty Services', 'Makeup Services'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Hair Services': [
            { header: 'Blowouts', type: 0 },
            { header: 'Coloring', type: 0 },
            { header: 'Extensions', type: 0 },
            { header: 'Relaxer', type: 0 },
            { header: 'Haircuts', type: 0 },
            { header: 'Keratin', type: 0 },
            { header: 'Perm', type: 0 },
            { header: 'Textured Hair Styling', type: 0 },
            { header: 'Updos / Styling', type: 0 },
            { header: 'Hair Trial', type: 0 },
            { header: 'On-Site Hair', type: 0 },
        ],
        'Beauty Services': [
            { header: 'Body Art', type: 0 },
            { header: 'Consultations', type: 0 },
            { header: 'Facials', type: 0 },
            { header: 'Manicure / Pedicure', type: 0 },
            { header: 'Massages', type: 0 },
            { header: 'Men\'s Grooming', type: 0 },
            { header: 'Spa', type: 0 },
            { header: 'Teeth Whitening', type: 0 },
            { header: 'Skincare', type: 0 },
        ],
        'Makeup Services': [
            { header: 'Airbrush Makeup', type: 0 },
            { header: 'Contour Makeup', type: 0 },
            { header: 'Eye Makeup', type: 0 },
            { header: 'Natural Makeup', type: 0 },
            { header: 'On-Site Makeup', type: 0 },
            { header: 'Makeup Trial', type: 0 },
            { header: 'Fake Lashes', type: 0 },
            { header: 'Brow/Lash Tinting', type: 0 },
            { header: 'Tattoo Coverage', type: 0 },
        ],
    },
    'Bridalboutiques': {
        'active': false,
        'Keys': [],
        'Sort': [

        ],
        'Clientele': [

        ]
    },
    'Catering': {
        'active': true,
        'Keys': ['Sort', 'Cuisines', 'Services', 'Dietary Needs', 'Bar Services'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Cuisines': [
            { header: 'Malay', type: 0 },
            { header: 'Chinese', type: 0 },
            { header: 'Indian', type: 0 },
            { header: 'Middle Eastern', type: 0 },
            { header: 'Seafood', type: 0 },
            { header: 'Spanish', type: 0 },
            { header: 'BBQ', type: 0 },
            { header: 'Caribbean', type: 0 },
        ],
        'Services': [
            { header: 'Breakfast / Brunch', type: 0 },
            { header: 'Buffet', type: 0 },
            { header: 'Cake Cutting', type: 0 },
            { header: 'Cocktail Reception', type: 0 },
            { header: 'Custom Menu', type: 0 },
            { header: 'Plated', type: 0 },
            { header: 'Stations', type: 0 },
            { header: 'Tastings', type: 0 },
        ],
        'Dietary Needs': [
            { header: 'Gluten Free', type: 0 },
            { header: 'Lactose Free', type: 0 },
            { header: 'Halal', type: 0 },
            { header: 'Nut Free', type: 0 },
            { header: 'Vegan', type: 0 },
            { header: 'Vegetarian', type: 0 },
        ],
        'Bar Services': [
            { header: 'Bartender(s)', type: 0 },
            { header: 'Open Bar', type: 0 },
            { header: 'Champagne Toast', type: 0 },
            { header: 'Signature Drink', type: 0 },
        ]
    },
    'Dance': {
        'active': true,
        'Keys': ['Sort', 'Dance Service'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Dance Service': [
            { header: 'Tamil', type: 0 },
            { header: 'Others', type: 0 },
        ]
    },
    'Decoration': {
        'active': true,
        'Keys': ['Sort', 'Decoration Service'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Decoration Service': [
            { header: 'Complete Styling Service', type: 0 },
            { header: 'Ballons', type: 0 },
            { header: 'Candles', type: 0 },
            { header: 'Candelabras', type: 0 },
            { header: 'Chair Covers', type: 0 },
            { header: 'Dining Furniture Hire', type: 0 },
            { header: 'Arcade Game Hire', type: 0 },
            { header: 'Sound/PA Hire', type: 0 },
            { header: 'Set-up', type: 0 },
            { header: 'Last-Minute Orders', type: 0 },
            { header: 'Clean-Up', type: 0 },
            { header: 'Dance Floor Hire', type: 0 },
            { header: 'Portable Toilet', type: 0 },
        ]
    },
    'Dj': {
        'active': true,
        'Keys': ['Sort', 'Music Genres'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Music Genres': [
            { header: 'Mandrain', type: 0 },
            { header: 'Malay', type: 0 },
            { header: 'Tamil', type: 0 },
            { header: 'Christian', type: 0 },
            { header: 'Club', type: 0 },
            { header: 'Country', type: 0 },
            { header: 'Electronic', type: 0 },
            { header: 'Hip Hop', type: 0 },
            { header: 'Indie', type: 0 },
            { header: 'International', type: 0 },
            { header: 'Jazz', type: 0 },
            { header: 'Oldies', type: 0 },
            { header: 'Pop', type: 0 },
            { header: 'R&B / Soul', type: 0 },
            { header: 'Rock', type: 0 },
            { header: 'Asian', type: 0 },
        ]
    },
    'Dressattire': {
        'active': true,
        'Keys': ['Sort'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
        ]
    },
    'Emcees': {
        'active': true,
        'Keys': ['Sort'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
        ]
    },
    'Entertainment': {
        'active': true,
        'Keys': ['Sort', 'Entertainment Services'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Entertainment Services': [
            { header: 'Bands', type: 0 },
            { header: 'Dancers', type: 0 },
            { header: 'DJs', type: 0 },
            { header: 'Ensembles', type: 0 },
            { header: 'Headliners/Celebrity Bookings', type: 0 },
            { header: 'Illusionists/Magicians', type: 0 },
            { header: 'Performance Acts', type: 0 },
        ]
    },
    'Eventrentals': {
        'active': true,
        'Keys': ['Sort', 'Rental Services'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Rental Services': [
            { header: 'Audiovisual', type: 0 },
            { header: 'Backdrops', type: 0 },
            { header: 'Dance Floors', type: 0 },
            { header: 'Furniture', type: 0 },
            { header: 'Games', type: 0 },
            { header: 'Lighting', type: 0 },
            { header: 'Linens', type: 0 },
            { header: 'Stages', type: 0 },
            { header: 'Tabletop', type: 0 },
        ]
    },
    'Florists': {
        'active': true,
        'Keys': ['Sort', 'Floral Arrangements'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ], 'Floral Arrangements': [
            { header: 'Aisle Decor', type: 0 },
            { header: 'Altar Decor', type: 0 },
            { header: 'Artificial', type: 0 },
            { header: 'Bouquets', type: 0 },
            { header: 'Boutonnieres', type: 0 },
            { header: 'Centerpieces', type: 0 },
            { header: 'Chuppah Decor', type: 0 },
            { header: 'Corsages', type: 0 },
            { header: 'Flower Baskets', type: 0 },
            { header: 'Flower Crowns', type: 0 },
            { header: 'Flower Petals', type: 0 },
            { header: 'Non-Floral', type: 0 },
            { header: 'Single Flowers', type: 0 },
        ]
    },
    'Gifts': {
        'active': true,
        'Keys': ['Sort', 'Service'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Service': [
            { header: 'Favors & Wearables', type: 0 },
            { header: 'Swag Bags', type: 0 },
            { header: 'Goodie Bags', type: 0 },
        ]
    },
    'Jewellery': {
        'active': true,
        'Keys': ['Sort', 'Jewellery Types'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Jewellery Types': [
            { header: 'Custom Design', type: 0 },
        ]
    },
    'Menswear': {
        'active': true,
        'Keys': ['Sort', 'Menswear Services'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Menswear Services': [
            { header: 'Bow Ties', type: 0 },
            { header: 'Shoes', type: 0 },
            { header: 'Ties, Tuxedos & Suits', type: 0 },
            { header: 'Vests', type: 0 },
            { header: 'Cummerbunds', type: 0 },
        ]
    },
    'Music': {
        'active': true,
        'Keys': ['Sort', 'Music Genres'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Music Genres': [
            { header: 'Mandrain', type: 0 },
            { header: 'Malay', type: 0 },
            { header: 'Tamil', type: 0 },
        ]
    },
    'Paperstationary': {
        'active': true,
        'Keys': ['Sort', 'Invitations Services'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Invitations Services': [
            { header: 'Assembly', type: 0 },
            { header: 'Design', type: 0 },
            { header: 'Embossed', type: 0 },
            { header: 'Engraving', type: 0 },
            { header: 'Letterpress', type: 0 },
            { header: 'Printing', type: 0 },
            { header: 'Custom', type: 0 },
        ]
    },
    'Photobooths': {
        'active': true,
        'Keys': ['Sort', 'Photobooths Services'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Photobooths Services': [
            { header: 'Photo Guestbook ', type: 0 },
            { header: 'Backdrops', type: 0 },
            { header: 'Prints', type: 0 },
        ]
    },
    'Photographers': {
        'active': true,
        'Keys': ['Sort', 'Photography Style', 'Photography Services'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Photography Style': [
            { header: 'Contemporary', type: 0 },
            { header: 'Film', type: 0 },
            { header: 'Natural', type: 0 },
            { header: 'Photo Journalism', type: 0 },
            { header: 'Traditional', type: 0 },
            { header: 'Vintage', type: 0 },
        ],
        'Photography Services': [
            { header: 'Additional Hours', type: 0 },
            { header: 'Destination / Travel', type: 0 },
            { header: 'High-Res Images', type: 0 },
            { header: 'One Event / Day', type: 0 },
            { header: 'Second Shooter', type: 0 },
            { header: 'Video', type: 0 },
        ],
    },
    'Transport': {
        'active': true,
        'Keys': ['Sort', 'Transport Services'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Transport Services': [
            { header: 'Buses', type: 0 },
            { header: 'Luxury/Specialty Vehicles', type: 0 },
        ]

    },
    'Venue': {
        'active': true,
        'Keys': ['Sort', 'Maximum Capacity', 'Venue Type', 'Settings', 'Amenities'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Maximum Capacity': [
            { header: '0 - 99', type: 0 },
            { header: '100 - 199', type: 0 },
            { header: '200 - 299', type: 0 },
            { header: '300 - 399', type: 0 },
            { header: '400+', type: 0 },
        ],
        'Venue Type': [
            { header: 'Banquet Hall', type: 0 },
            { header: 'Beach', type: 0 },
            { header: 'Boat / Yacht', type: 0 },
            { header: 'Golf Club', type: 0 },
            { header: 'Country Club', type: 0 },
            { header: 'Farm / Ranch', type: 0 },
            { header: 'Garden', type: 0 },
            { header: 'Historic Building', type: 0 },
            { header: 'Hotel', type: 0 },
            { header: 'Mansion', type: 0 },
            { header: 'Museum', type: 0 },
            { header: 'Park', type: 0 },
            { header: 'Religious', type: 0 },
            { header: 'Restaurant', type: 0 },
            { header: 'Rooftop', type: 0 },
        ],
        'Settings': [
            { header: 'Indoor', type: 0 },
            { header: 'Covered Outdoor', type: 0 },
            { header: 'Uncovered Outdoor', type: 0 },
        ],
        'Amenities': [
            { header: 'Accommodations', type: 0 },
            { header: 'Bar Services', type: 0 },
            { header: 'Catering Services', type: 0 },
            { header: 'Event Planner', type: 0 },
            { header: 'Get Ready Rooms', type: 0 },
            { header: 'Liability Insurance', type: 0 },
            { header: 'Outside Vendors', type: 0 },
            { header: 'Pet Friendly', type: 0 },
            { header: 'Wifi', type: 0 },
        ],

    },
    'Videographers': {
        'active': true,
        'Keys': ['Sort', 'Videography Style', 'Videography Services'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],

        'Videography Style': [
            { header: 'Cinematic', type: 0 },
            { header: 'Documentary', type: 0 },
            { header: 'Short Form', type: 0 },
            { header: 'Storytelling', type: 0 },
            { header: 'Traditional', type: 0 },
        ],
        'Videography Services': [
            { header: 'Drone Footage', type: 0 },
            { header: 'Full Feature Video', type: 0 },
            { header: 'Highlight Video', type: 0 },
            { header: 'Multi. Cameras', type: 0 },
            { header: 'Multi. Locations', type: 0 },
            { header: 'One Event / Day', type: 0 },
            { header: 'Raw Footage', type: 0 },
        ],
    },
    'Bakeryanddesserts': {
        'active': true,
        'Keys': ['Sort', 'Bakery and Desserts Services'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Bakery and Desserts Services': [
            { header: 'Cakes', type: 0 },
            { header: 'Candies', type: 0 },
            { header: 'Chocolates', type: 0 },
            { header: 'Cookies', type: 0 },
            { header: 'Gluten-free', type: 0 },
            { header: 'Pastries', type: 0 },
            { header: 'Pies', type: 0 },
        ]
    },
    'Planners': {
        'active': true,
        'Keys': ['Sort', 'Planning Services'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
            // {  header: 'Score', type: 1 },
        ],
        'Planning Services': [
            { header: 'Day-of-Coordination', type: 0 },
            { header: 'Full Planning', type: 0 },
            { header: 'Partial Planning', type: 0 },
        ]

    },
    'Honeymoon': {
        'active': true,
        'Keys': ['Sort'],
        'Sort': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
            { header: 'No. Of Pricelists', type: 1 },
            { header: 'No. Of Projects', type: 1 },
            { header: 'No. Of Reviews', type: 1 },
        ]
    },
}

export const PRICELIST_FILTER_WEDDING = {
    // use in pricelist
    //  header : is the query string sending to backend
    //  type : implies,
    //      1 - only one check box can be selected out of n checkboxes
    //      0 - means all can be selected
    // Keys - "Others" is RESTRICTED, do not use
    // EVERY HEADER MUST BE UNIQUE, is store in an array.
    'All': {
        'active': true, // ensure this set of data has at least a single Keys
        'Keys': ['Price', 'Wedding', 'Valid Year'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ],
        'Wedding': [
            { header: 'Actual-wedding', type: 1 },
            { header: 'Pre-wedding', type: 1 },
            { header: 'Pre + Actual', type: 1 },
        ],
        'Valid Year': [
            { header: '2024', type: 0 },
            { header: '2025', type: 0 },
            { header: '2026', type: 0 },
            { header: '2027', type: 0 },
            { header: '2028', type: 0 },

        ]
    },
    'Accessories': {
        'active': true,
        'Keys': ['Price'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ]
    },
    'Beautyhairandmakeup': {
        'active': true,
        'Keys': ['Price', 'Wedding'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ],
        'Wedding': [
            { header: 'Actual-wedding', type: 1 },
            { header: 'Pre-wedding', type: 1 },
            { header: 'Pre + Actual', type: 1 },
        ],
    },
    'Bridalboutiques': {
        'active': true,
        'Keys': ['Price', 'Wedding'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ],
        'Wedding': [
            { header: 'Actual-wedding', type: 1 },
            { header: 'Pre-wedding', type: 1 },
            { header: 'Pre + Actual', type: 1 },
        ],
    },
    'Catering': {
        'active': true,
        'Keys': ['Price', 'Wedding', 'Cuisines', 'Services', 'Dietary Needs', 'Bar Services'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ],
        'Wedding': [
            { header: 'Actual-wedding', type: 1 },
            { header: 'Pre-wedding', type: 1 },
            { header: 'Pre + Actual', type: 1 },
        ],
        'Cuisines': [
            { header: 'Malay', type: 0 },
            { header: 'Chinese', type: 0 },
            { header: 'Indian', type: 0 },
            { header: 'Middle Eastern', type: 0 },
            { header: 'Seafood', type: 0 },
            { header: 'Spanish', type: 0 },
            { header: 'BBQ', type: 0 },
            { header: 'Caribbean', type: 0 },
        ],
        'Services': [
            { header: 'Breakfast / Brunch', type: 0 },
            { header: 'Buffet', type: 0 },
            { header: 'Cake Cutting', type: 0 },
            { header: 'Cocktail Reception', type: 0 },
            { header: 'Custom Menu', type: 0 },
            { header: 'Plated', type: 0 },
            { header: 'Stations', type: 0 },
            { header: 'Tastings', type: 0 },
        ],
        'Dietary Needs': [
            { header: 'Gluten Free', type: 0 },
            { header: 'Lactose Free', type: 0 },
            { header: 'Halal', type: 0 },
            { header: 'Nut Free', type: 0 },
            { header: 'Vegan', type: 0 },
            { header: 'Vegetarian', type: 0 },
        ],
        'Bar Services': [
            { header: 'Bartender(s)', type: 0 },
            { header: 'Open Bar', type: 0 },
            { header: 'Champagne Toast', type: 0 },
            { header: 'Signature Drink', type: 0 },
        ]
    },
    'Dance': {
        'active': true,
        'Keys': ['Price'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ]
    },
    'Decoration': {
        'active': true,
        'Keys': ['Price'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ]
    },
    'Dj': {
        'active': true,
        'Keys': ['Price'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ]
    },
    'Dressattire': {
        'active': true,
        'Keys': ['Price'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ]
    },
    'Emcees': {
        'active': true,
        'Keys': ['Price'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ]
    },
    'Entertainment': {
        'active': true,
        'Keys': ['Price'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ]
    },
    'Eventrentals': {
        'active': true,
        'Keys': ['Price'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ]
    },
    'Florists': {
        'active': true,
        'Keys': ['Price'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ]
    },
    'Gifts': {
        'active': true,
        'Keys': ['Price'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ]
    },
    'Honeymoon': {
        'active': true,
        'Keys': ['Price'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ]
    },
    'Jewellery': {
        'active': true,
        'Keys': ['Price'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ]
    },
    'Menswear': {
        'active': true,
        'Keys': ['Price'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ]
    },
    'Music': {
        'active': true,
        'Keys': ['Price'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ]
    },
    'Paperstationary': {
        'active': true,
        'Keys': ['Price'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ]
    },
    'Photobooths': {
        'active': true,
        'Keys': ['Price'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ]
    },
    'Photographers': {
        'active': true,
        'Keys': ['Price'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ]
    },
    'Transport': {
        'active': true,
        'Keys': ['Price'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ]
    },
    'Venue': {
        'active': true,
        'Keys': ['Price', 'Wedding', 'Venue Usage', 'Meals', 'Food Service Styles', 'Menu Options', 'Valid Year', 'Maximum Capacity', 'Venue Type', 'Settings', 'Amenities'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ],
        'Wedding': [
            { header: 'Actual-wedding', type: 1 },
            { header: 'Pre-wedding', type: 1 },
            { header: 'Pre + Actual', type: 1 },
        ],
        'Venue Usage': [
            { header: 'Solemnization', type: 0 }, // When Solemnization check, Category of Wedding, header of Actual-wedding set to true
            { header: 'Actual Day', type: 0 }, // When Solemnization check, Category of Wedding, header of Actual-wedding set to true
        ],
        'Valid Year': [
            { header: '2024', type: 0 },
            { header: '2025', type: 0 },
            { header: '2026', type: 0 },
            { header: '2027', type: 0 }
        ],
        'Meals': [
            { header: 'Lunch', type: 0 },
            { header: 'Dinner', type: 0 }
        ],
        'Food Service Styles': [
            { header: 'Banquet', type: 0 },
            { header: 'Buffet', type: 0 }
        ],
        'Menu Options': [
            { header: 'Chinese', type: 1 },
            { header: 'Western', type: 1 },
            { header: 'Japanese', type: 1 },
            { header: 'Indian', type: 1 },
            { header: 'Malay', type: 1 },
            { header: 'International', type: 1 },
            { header: 'Fusion', type: 1 },
            { header: 'Vegetarian', type: 1 },
            { header: 'Thai', type: 1 },
        ],
        'Valid Year': [
            { header: '2024', type: 0 },
            { header: '2025', type: 0 },
            { header: '2026', type: 0 },
            { header: '2027', type: 0 }
        ],
        'Maximum Capacity': [
            { header: '0 - 99', type: 0 },
            { header: '100 - 199', type: 0 },
            { header: '200 - 299', type: 0 },
            { header: '300 - 399', type: 0 },
            { header: '400+', type: 0 },
        ],
        'Venue Type': [
            { header: 'Banquet Hall', type: 0 },
            { header: 'Beach', type: 0 },
            { header: 'Boat / Yacht', type: 0 },
            { header: 'Golf Club', type: 0 },
            { header: 'Country Club', type: 0 },
            { header: 'Farm / Ranch', type: 0 },
            { header: 'Garden', type: 0 },
            { header: 'Historic Building', type: 0 },
            { header: 'Hotel', type: 0 },
            { header: 'Mansion', type: 0 },
            { header: 'Museum', type: 0 },
            { header: 'Park', type: 0 },
            { header: 'Religious', type: 0 },
            { header: 'Restaurant', type: 0 },
            { header: 'Rooftop', type: 0 },
        ],
        'Settings': [
            { header: 'Indoor', type: 0 },
            { header: 'Covered Outdoor', type: 0 },
            { header: 'Uncovered Outdoor', type: 0 },
        ],
        'Amenities': [
            { header: 'Accommodations', type: 0 },
            { header: 'Bar Services', type: 0 },
            { header: 'Catering Services', type: 0 },
            { header: 'Event Planner', type: 0 },
            { header: 'Get Ready Rooms', type: 0 },
            { header: 'Liability Insurance', type: 0 },
            { header: 'Outside Vendors', type: 0 },
            { header: 'Pet Friendly', type: 0 },
            { header: 'Wifi', type: 0 },
        ]
    },
    'Videographers': {
        'active': true,
        'Keys': ['Price'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ]
    },
    'Bakeryanddesserts': {
        'active': true,
        'Keys': ['Price'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ]
    },
    'Planners': {
        'active': true,
        'Keys': ['Price'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ]
    }
}

export const PRICELIST_FILTER_EVENT = {  // not in use yet
    // use in pricelist
    //  header : is the query string sending to backend
    //  type : implies,
    //      1 - only one check box can be selected out of n checkboxes
    //      0 - means all can be selected
    // Keys - "Others" is RESTRICTED, do not use
    // EVERY HEADER MUST BE UNIQUE, is store in an array.
    'All': {
        'active': true, // ensure this set of data has at least a single Keys
        'Keys': ['Price', 'Event', 'Valid Year'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ],
        'Event': [
            { header: 'Personal Party', type: 1 },
            { header: 'Corporate Event', type: 1 }
        ],
        'Valid Year': [
            { header: '2024', type: 0 },
            { header: '2025', type: 0 },
            { header: '2026', type: 0 },
            { header: '2027', type: 0 }
        ]
    },
    'Accessories': {
        'active': true,
        'Keys': ['Price', 'Event', 'Valid Year'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ],
        'Event': [
            { header: 'Personal Party', type: 1 },
            { header: 'Corporate Event', type: 1 }
        ],
        'Valid Year': [
            { header: '2024', type: 0 },
            { header: '2025', type: 0 },
            { header: '2026', type: 0 },
            { header: '2027', type: 0 }
        ]
    },
    'Beautyhairandmakeup': {
        'active': true,
        'Keys': ['Price', 'Event', 'Valid Year'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ],
        'Event': [
            { header: 'Personal Party', type: 1 },
            { header: 'Corporate Event', type: 1 }
        ],
        'Valid Year': [
            { header: '2024', type: 0 },
            { header: '2025', type: 0 },
            { header: '2026', type: 0 },
            { header: '2027', type: 0 }
        ]
    },
    'Bridalboutiques': {
        'active': true,
        'Keys': ['Price', 'Event'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ],
        'Event': [
            { header: 'Personal Party', type: 1 },
            { header: 'Corporate Event', type: 1 }
        ],
    },
    'Catering': {
        'active': true,
        'Keys': ['Price', 'Event', 'Cuisines', 'Services', 'Dietary Needs', 'Bar Services'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ],
        'Event': [
            { header: 'Personal Party', type: 1 },
            { header: 'Corporate Event', type: 1 }
        ],
        'Cuisines': [
            { header: 'Malay', type: 0 },
            { header: 'Chinese', type: 0 },
            { header: 'Indian', type: 0 },
            { header: 'Middle Eastern', type: 0 },
            { header: 'Seafood', type: 0 },
            { header: 'Spanish', type: 0 },
            { header: 'BBQ', type: 0 },
            { header: 'Caribbean', type: 0 },
        ],
        'Services': [
            { header: 'Breakfast / Brunch', type: 0 },
            { header: 'Buffet', type: 0 },
            { header: 'Cake Cutting', type: 0 },
            { header: 'Cocktail Reception', type: 0 },
            { header: 'Custom Menu', type: 0 },
            { header: 'Plated', type: 0 },
            { header: 'Stations', type: 0 },
            { header: 'Tastings', type: 0 },
        ],
        'Dietary Needs': [
            { header: 'Gluten Free', type: 0 },
            { header: 'Lactose Free', type: 0 },
            { header: 'Halal', type: 0 },
            { header: 'Nut Free', type: 0 },
            { header: 'Vegan', type: 0 },
            { header: 'Vegetarian', type: 0 },
        ],
        'Bar Services': [
            { header: 'Bartender(s)', type: 0 },
            { header: 'Open Bar', type: 0 },
            { header: 'Champagne Toast', type: 0 },
            { header: 'Signature Drink', type: 0 },
        ]
    },
    'Dance': {
        'active': true,
        'Keys': ['Price', 'Event', 'Valid Year'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ],
        'Event': [
            { header: 'Personal Party', type: 1 },
            { header: 'Corporate Event', type: 1 }
        ],
        'Valid Year': [
            { header: '2024', type: 0 },
            { header: '2025', type: 0 },
            { header: '2026', type: 0 },
            { header: '2027', type: 0 }
        ]
    },
    'Decoration': {
        'active': true,
        'Keys': ['Price', 'Event', 'Valid Year'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ],
        'Event': [
            { header: 'Personal Party', type: 1 },
            { header: 'Corporate Event', type: 1 }
        ],
        'Valid Year': [
            { header: '2024', type: 0 },
            { header: '2025', type: 0 },
            { header: '2026', type: 0 },
            { header: '2027', type: 0 }
        ]
    },
    'Dj': {
        'active': true,
        'Keys': ['Price', 'Event', 'Valid Year'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ],
        'Event': [
            { header: 'Personal Party', type: 1 },
            { header: 'Corporate Event', type: 1 }
        ],
        'Valid Year': [
            { header: '2024', type: 0 },
            { header: '2025', type: 0 },
            { header: '2026', type: 0 },
            { header: '2027', type: 0 }
        ]
    },
    'Dressattire': {
        'active': true,
        'Keys': ['Price', 'Event', 'Valid Year'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ],
        'Event': [
            { header: 'Personal Party', type: 1 },
            { header: 'Corporate Event', type: 1 }
        ],
        'Valid Year': [
            { header: '2024', type: 0 },
            { header: '2025', type: 0 },
            { header: '2026', type: 0 },
            { header: '2027', type: 0 }
        ]
    },
    'Emcees': {
        'active': true,
        'Keys': ['Price', 'Event', 'Valid Year'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ],
        'Event': [
            { header: 'Personal Party', type: 1 },
            { header: 'Corporate Event', type: 1 }
        ],
        'Valid Year': [
            { header: '2024', type: 0 },
            { header: '2025', type: 0 },
            { header: '2026', type: 0 },
            { header: '2027', type: 0 }
        ]
    },
    'Entertainment': {
        'active': true,
        'Keys': ['Price', 'Event', 'Valid Year'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ],
        'Event': [
            { header: 'Personal Party', type: 1 },
            { header: 'Corporate Event', type: 1 }
        ],
        'Valid Year': [
            { header: '2024', type: 0 },
            { header: '2025', type: 0 },
            { header: '2026', type: 0 },
            { header: '2027', type: 0 }
        ]
    },
    'Eventrentals': {
        'active': true,
        'Keys': ['Price', 'Event', 'Valid Year'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ],
        'Event': [
            { header: 'Personal Party', type: 1 },
            { header: 'Corporate Event', type: 1 }
        ],
        'Valid Year': [
            { header: '2024', type: 0 },
            { header: '2025', type: 0 },
            { header: '2026', type: 0 },
            { header: '2027', type: 0 }
        ]
    },
    'Florists': {
        'active': true,
        'Keys': ['Price', 'Event', 'Valid Year'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ],
        'Event': [
            { header: 'Personal Party', type: 1 },
            { header: 'Corporate Event', type: 1 }
        ],
        'Valid Year': [
            { header: '2024', type: 0 },
            { header: '2025', type: 0 },
            { header: '2026', type: 0 },
            { header: '2027', type: 0 }
        ]
    },
    'Gifts': {
        'active': true,
        'Keys': ['Price'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ]
    },
    'Honeymoon': {
        'active': true,
        'Keys': ['Price', 'Event', 'Valid Year'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ],
        'Event': [
            { header: 'Personal Party', type: 1 },
            { header: 'Corporate Event', type: 1 }
        ],
        'Valid Year': [
            { header: '2024', type: 0 },
            { header: '2025', type: 0 },
            { header: '2026', type: 0 },
            { header: '2027', type: 0 }
        ]
    },
    'Jewellery': {
        'active': true,
        'Keys': ['Price', 'Event', 'Valid Year'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ],
        'Event': [
            { header: 'Personal Party', type: 1 },
            { header: 'Corporate Event', type: 1 }
        ],
        'Valid Year': [
            { header: '2024', type: 0 },
            { header: '2025', type: 0 },
            { header: '2026', type: 0 },
            { header: '2027', type: 0 }
        ]
    },
    'Menswear': {
        'active': true,
        'Keys': ['Price', 'Event', 'Valid Year'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ],
        'Event': [
            { header: 'Personal Party', type: 1 },
            { header: 'Corporate Event', type: 1 }
        ],
        'Valid Year': [
            { header: '2024', type: 0 },
            { header: '2025', type: 0 },
            { header: '2026', type: 0 },
            { header: '2027', type: 0 }
        ]
    },
    'Music': {
        'active': true,
        'Keys': ['Price', 'Event', 'Valid Year'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ],
        'Event': [
            { header: 'Personal Party', type: 1 },
            { header: 'Corporate Event', type: 1 }
        ],
        'Valid Year': [
            { header: '2024', type: 0 },
            { header: '2025', type: 0 },
            { header: '2026', type: 0 },
            { header: '2027', type: 0 }
        ]
    },
    'Paperstationary': {
        'active': true,
        'Keys': ['Price', 'Event', 'Valid Year'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ],
        'Event': [
            { header: 'Personal Party', type: 1 },
            { header: 'Corporate Event', type: 1 }
        ],
        'Valid Year': [
            { header: '2024', type: 0 },
            { header: '2025', type: 0 },
            { header: '2026', type: 0 },
            { header: '2027', type: 0 }
        ]
    },
    'Photobooths': {
        'active': true,
        'Keys': ['Price', 'Event', 'Valid Year'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ],
        'Event': [
            { header: 'Personal Party', type: 1 },
            { header: 'Corporate Event', type: 1 }
        ],
        'Valid Year': [
            { header: '2024', type: 0 },
            { header: '2025', type: 0 },
            { header: '2026', type: 0 },
            { header: '2027', type: 0 }
        ]
    },
    'Photographers': {
        'active': true,
        'Keys': ['Price', 'Event', 'Valid Year'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ],
        'Event': [
            { header: 'Personal Party', type: 1 },
            { header: 'Corporate Event', type: 1 }
        ],
        'Valid Year': [
            { header: '2024', type: 0 },
            { header: '2025', type: 0 },
            { header: '2026', type: 0 },
            { header: '2027', type: 0 }
        ]
    },
    'Transport': {
        'active': true,
        'Keys': ['Price', 'Event', 'Valid Year'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ],
        'Event': [
            { header: 'Personal Party', type: 1 },
            { header: 'Corporate Event', type: 1 }
        ],
        'Valid Year': [
            { header: '2024', type: 0 },
            { header: '2025', type: 0 },
            { header: '2026', type: 0 },
            { header: '2027', type: 0 }
        ]
    },
    'Venue': {
        'active': true,
        'Keys': ['Price', 'Event', 'Venue Usage', 'Meals', 'Food Service Styles', 'Menu Options', 'Valid Year', 'Maximum Capacity', 'Venue Type', 'Settings', 'Amenities'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ],
        'Event': [
            { header: 'Personal Party', type: 1 },
            { header: 'Corporate Event', type: 1 }
        ],
        'Venue Usage': [
            { header: 'Solemnization', type: 0 }, // When Solemnization check, Category of Event, header of Actual-wedding set to true
            { header: 'Actual Day', type: 0 }, // When Solemnization check, Category of Event, header of Actual-wedding set to true
        ],
        'Valid Year': [
            { header: '2024', type: 0 },
            { header: '2025', type: 0 },
            { header: '2026', type: 0 },
            { header: '2027', type: 0 }
        ],
        'Meals': [
            { header: 'Lunch', type: 0 },
            { header: 'Dinner', type: 0 }
        ],
        'Food Service Styles': [
            { header: 'Banquet', type: 0 },
            { header: 'Buffet', type: 0 }
        ],
        'Menu Options': [
            { header: 'Chinese', type: 1 },
            { header: 'Western', type: 1 },
            { header: 'Japanese', type: 1 },
            { header: 'Indian', type: 1 },
            { header: 'Malay', type: 1 },
            { header: 'International', type: 1 },
            { header: 'Fusion', type: 1 },
            { header: 'Vegetarian', type: 1 },
            { header: 'Thai', type: 1 },
        ],
        'Valid Year': [
            { header: '2024', type: 0 },
            { header: '2025', type: 0 },
            { header: '2026', type: 0 },
            { header: '2027', type: 0 }
        ],
        'Maximum Capacity': [
            { header: '0 - 99', type: 0 },
            { header: '100 - 199', type: 0 },
            { header: '200 - 299', type: 0 },
            { header: '300 - 399', type: 0 },
            { header: '400+', type: 0 },
        ],
        'Venue Type': [
            { header: 'Banquet Hall', type: 0 },
            { header: 'Beach', type: 0 },
            { header: 'Boat / Yacht', type: 0 },
            { header: 'Golf Club', type: 0 },
            { header: 'Country Club', type: 0 },
            { header: 'Farm / Ranch', type: 0 },
            { header: 'Garden', type: 0 },
            { header: 'Historic Building', type: 0 },
            { header: 'Hotel', type: 0 },
            { header: 'Mansion', type: 0 },
            { header: 'Museum', type: 0 },
            { header: 'Park', type: 0 },
            { header: 'Religious', type: 0 },
            { header: 'Restaurant', type: 0 },
            { header: 'Rooftop', type: 0 },
        ],
        'Settings': [
            { header: 'Indoor', type: 0 },
            { header: 'Covered Outdoor', type: 0 },
            { header: 'Uncovered Outdoor', type: 0 },
        ],
        'Amenities': [
            { header: 'Accommodations', type: 0 },
            { header: 'Bar Services', type: 0 },
            { header: 'Catering Services', type: 0 },
            { header: 'Event Planner', type: 0 },
            { header: 'Get Ready Rooms', type: 0 },
            { header: 'Liability Insurance', type: 0 },
            { header: 'Outside Vendors', type: 0 },
            { header: 'Pet Friendly', type: 0 },
            { header: 'Wifi', type: 0 },
        ]
    },
    'Videographers': {
        'active': true,
        'Keys': ['Price', 'Event', 'Valid Year'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ],
        'Event': [
            { header: 'Personal Party', type: 1 },
            { header: 'Corporate Event', type: 1 }
        ],
        'Valid Year': [
            { header: '2024', type: 0 },
            { header: '2025', type: 0 },
            { header: '2026', type: 0 },
            { header: '2027', type: 0 }
        ]
    },
    'Bakeryanddesserts': {
        'active': true,
        'Keys': ['Price', 'Event', 'Valid Year'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ],
        'Event': [
            { header: 'Personal Party', type: 1 },
            { header: 'Corporate Event', type: 1 }
        ],
        'Valid Year': [
            { header: '2024', type: 0 },
            { header: '2025', type: 0 },
            { header: '2026', type: 0 },
            { header: '2027', type: 0 }
        ]
    },
    'Planners': {
        'active': true,
        'Keys': ['Price', 'Event', 'Valid Year'],
        'Price': [
            { header: 'Price ( High - Low )', type: 1 },
            { header: 'Price ( Low - High )', type: 1 },
        ],
        'Event': [
            { header: 'Personal Party', type: 1 },
            { header: 'Corporate Event', type: 1 }
        ],
        'Valid Year': [
            { header: '2024', type: 0 },
            { header: '2025', type: 0 },
            { header: '2026', type: 0 },
            { header: '2027', type: 0 }
        ]
    }
}

export const PROJECTGALLERY_FILTER_WEDDING = {
    'All': {
        'active': true, // ensure this set of data has at least a single Keys
        'Keys': ['Event Type', 'Location', 'Guest Count'],
        'Event Type': [
            { header: 'Wedding', type: 0, },
            { header: 'Event', type: 0 },
            { header: 'Wedding & Event', type: 0 },
        ],
        'Location': [
            { header: 'Singapore', type: 0 },
            { header: 'Malaysia', type: 0 },
            { header: 'Taiwan', type: 0 },
            { header: 'Hong Kong', type: 0 },
            { header: 'China', type: 0 },
            { header: 'Korea', type: 0 },
        ],
        'Guest Count': [
            { header: 'Under 25', type: 0 },
            { header: '25-99', type: 0 },
            { header: '100-149', type: 0 },
            { header: '150-199', type: 0 },
            { header: '200-299', type: 0 },
            { header: '300-399', type: 0 },
            { header: '400-499', type: 0 },
            { header: '500-999', type: 0 },
            { header: '1000+', type: 0 },
        ],

    }
}

export const PROJECTGALLERY_FILTER_WEDDING_OLD = [
    { cat: 'Both', filter: 'Location', label: 'Singapore', checked: false, type: 1 }, // need special treatment
    { cat: 'Both', filter: 'Location', label: 'Malaysia', checked: false, type: 1 },
    { cat: 'Both', filter: 'Location', label: 'Taiwan', checked: false, type: 1 },
    { cat: 'Both', filter: 'Location', label: 'Hong Kong', checked: false, type: 1 },
    { cat: 'Both', filter: 'Location', label: 'China', checked: false, type: 1 },
    { cat: 'Both', filter: 'Location', label: 'Korea', checked: false, type: 1 },

    { cat: 'Both', filter: 'Guest Count', label: 'Under 25', checked: false, type: 1 }, // need special treatment
    { cat: 'Both', filter: 'Guest Count', label: '25-99', checked: false, type: 1 },
    { cat: 'Both', filter: 'Guest Count', label: '100-149', checked: false, type: 1 },
    { cat: 'Both', filter: 'Guest Count', label: '150-199', checked: false, type: 1 },
    { cat: 'Both', filter: 'Guest Count', label: '200-299', checked: false, type: 1 },
    { cat: 'Both', filter: 'Guest Count', label: '300-399', checked: false, type: 1 },
    { cat: 'Both', filter: 'Guest Count', label: '400-499', checked: false, type: 1 },
    { cat: 'Both', filter: 'Guest Count', label: '500-999', checked: false, type: 1 },
    { cat: 'Both', filter: 'Guest Count', label: '1000+', checked: false, type: 1 },

    // { cat: 'Wedding', filter: 'Styles', label: 'Casual', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Styles', label: 'Country', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Styles', label: 'Formal/Black-tie/White-tie', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Styles', label: 'Glamorous', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Styles', label: 'Modern', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Styles', label: 'Romantic', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Styles', label: 'Rustic', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Styles', label: 'Traditional Chinese', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Styles', label: 'Traditional Malay', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Styles', label: 'Traditional Indian', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Styles', label: 'Traditional', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Styles', label: 'Vintage', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Styles', label: 'Fall', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Styles', label: 'Spring', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Styles', label: 'Winter', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Styles', label: 'Summer', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Styles', label: 'Garden', checked: false, type: 1 },

    // { cat: 'Wedding', filter: 'Settings', label: 'Ballroom', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Settings', label: 'Beach/Waterfront', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Settings', label: 'Farm/Barn', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Settings', label: 'Garden', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Settings', label: 'Country Club', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Settings', label: 'Historic Estate/Mansion', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Settings', label: 'Hotel/Inn/Resort', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Settings', label: 'Museum/Gallery', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Settings', label: 'Outdoor', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Settings', label: 'Parl/Ranch', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Settings', label: 'Bar/Restaurant', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Settings', label: 'Vineyard/Winery', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Settings', label: 'Private Residence', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Settings', label: 'Raw Space', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Settings', label: 'Hotels, Inns & Resorts', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Settings', label: 'Ballrooms & Banquet Halls', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Settings', label: 'Historic Estates & Mansions', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Settings', label: 'Golf & Country Clubs', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Settings', label: 'Parks', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Settings', label: 'Beaches', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Settings', label: 'Museums & Galleries', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Settings', label: 'Lodges & Retreats', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Settings', label: 'Urban & Downtown', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Settings', label: 'Zoos', checked: false, type: 1 },

    // { cat: 'Wedding', filter: 'Themes', label: 'Sports', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Themes', label: 'Fashion', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Themes', label: 'Music', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Themes', label: 'Games', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Themes', label: 'Nightclub', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Themes', label: 'Movie/TV', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Themes', label: 'Holiday', checked: false, type: 1 },
    // { cat: 'Wedding', filter: 'Themes', label: 'Other', checked: false, type: 1 },
]

export const READABLE_VENDORTYPE_MAP = {
    '': 'None',
    'All': 'All',
    'Accessories': 'Accessories',
    'Beautyhairandmakeup': `Beauty, Hair and Makeup`,
    'Bridalboutiques': 'Bridal Boutiques',
    'Catering': 'Catering',
    'Dance': 'Dance',
    'Decoration': 'Decoration',
    'Dj': 'DJ',
    'Dressattire': 'Dress and Attire',
    'Emcees': 'Emcees',
    'Entertainment': 'Entertainment',
    'Eventrentals': 'Event Rentals',
    'Florists': 'Florists',
    'Gifts': 'Gifts',
    'Honeymoon': 'Honeymoon',
    'Jewellery': 'Jewellery',
    'Menswear': 'Menswear',
    'Music': 'Music',
    'Paperstationary': 'Paper Stationary',
    'Photobooths': 'Photobooths',
    'Photographers': 'Photographers',
    'Transport': 'Transport',
    'Venue': 'Venue',
    'Videographers': 'Videographers',
    'Bakeryanddesserts': `Bakery and Desserts`,
    'Planners': 'Planners'
}

// export const READABLE_VENDORTYPE_MAP = {
//     '': 'None',
//     'All': 'All',
//     'Accessories': 'Accessories',
//     'Beautyhairandmakeup': 'Beauty, Hair and Makeup',
//     'Bridalboutiques': 'Bridal Boutiques',
//     'Catering': 'Catering',
//     'Dance': 'Dance',
//     'Decoration': 'Decoration',
//     'Dj': 'DJ',
//     'Dressattire': 'Dress and Attire',
//     'Emcees': 'Emcees',
//     'Entertainment': 'Entertainment',
//     'Eventrentals': 'Event Rentals',
//     'Florists': 'Florists',
//     'Gifts': 'Gifts',
//     'Honeymoon': 'Honeymoon',
//     'Jewellery': 'Jewellery',
//     'Menswear': 'Menswear',
//     'Music': 'Music',
//     'Paperstationary': 'Paper Stationary',
//     'Photobooths': 'Photobooths',
//     'Photographers': 'Photographers',
//     'Transport': 'Transport',
//     'Venue': 'Venue',
//     'Videographers': 'Videographers',
//     'Bakeryanddesserts': 'Bakery and Desserts',
//     'Planners': 'Planners'
// }

export const INVERSE_READABLE_VENDORTYPE_MAP = {
    'Accessories': 'Accessories',
    'Beauty, Hair and Makeup': 'Beautyhairandmakeup',
    'Bridal Boutiques': 'Bridalboutiques',
    'Catering': 'Catering',
    'Dance': 'Dance',
    'Decoration': 'Decoration',
    'DJ': 'Dj',
    'Dress and Attire': 'Dressattire',
    'Emcees': 'Emcees',
    'Entertainment': 'Entertainment',
    'Event Rentals': 'Eventrentals',
    'Florists': 'Florists',
    'Gifts': 'Gifts',
    'Honeymoon': 'Honeymoon',
    'Jewellery': 'Jewellery',
    'Menswear': 'Menswear',
    'Music': 'Music',
    'Paper Stationary': 'Paperstationary',
    'Photobooths': 'Photobooths',
    'Photographers': 'Photographers',
    'Transport': 'Transport',
    'Venue': 'Venue',
    'Videographers': 'Videographers',
    'Bakery and Desserts': 'Bakeryanddesserts',
    'Planners': 'Planners'
}

export const READABLE_PREACTUAL_MAP = {
    'Pre + Actual': 'Pre Wed & Actual Wed',
    'Pre-wedding': 'Pre Wed',
    'Actual-wedding': 'Actual Wed',
    'Corporate event': 'Corporate Event',
    'Personal Party': 'Personal Party',
}








export const ABBREVCITY_ALLOW_ARR = ['sg', 'my', 'ch', 'tw', 'kr', 'hk', 'idn', 'jpn']
export const CITY_CURRENCY_MAP = {
    'Singapore': 'SGD',
    'Malaysia': 'RM',
    'China': 'RMB',
    'Taiwan': 'NTD',
    'Korea': 'KRW',
    'Japan': 'YEN',
    'Hong Kong': 'HKD',
    'Indonesia': 'IDR'
}
export const ABBREVCITY_CURRENCY_MAP = {
    'sg': 'SGD',
    'my': 'RM',
    'ch': 'RMB',
    'tw': 'NTD',
    'kr': 'KRW',
    'hk': 'HKD',
    'idn': 'IDR',
    'jpn': 'YEN',
}

export const PRESENCELOC_ABBREV_MAP = {
    'Singapore': 'sg',
    'Malaysia': 'my',
    'China': 'ch',
    'Hong Kong': 'hk',
    'Taiwan': 'tw',
    'Korea': 'kr',
    'Indonesia': 'idn',
    'Japan': 'yen',
}
export const PRESENCELOC_CAPABBREV_MAP = {
    'Singapore': 'SG',
    'Malaysia': 'MY',
    'China': 'CH',
    'Hong Kong': 'HK',
    'Taiwan': 'TW',
    'Korea': 'KR',
    'Indonesia': 'IDN',
    'Japan': 'JPN',
}
export const ABBREV_PRESENCELOC_MAP = {
    'sg': 'Singapore',
    'my': 'Malaysia',
    'ch': 'China',
    'hk': 'Hong Kong',
    'tw': 'Taiwan',
    'kr': 'Korea',
    'idn': 'Indonesia',
    'jpn': 'Japan'
}

export const CURRENCY_MAP = {
    'Singapore': 'SGD',
    'Malaysia': 'RM',
    'China': 'RMB',
    'Taiwan': 'NTD',
    'Hong Kong': 'HKD',
    'Korea': 'WON',
    'Indonesia': 'IDR',
    'Japan': 'YEN'
}
export const COUNTRY_RELATED_DATA = {
    'Afghanistan': {
        currency: 'AFN',
        abbrev: 'af',
        capabbrev: 'AF',
    },
    'Albania': {
        currency: 'ALL',
        abbrev: 'al',
        capabbrev: 'AL',
    },
    'Algeria': {
        currency: 'DZD',
        abbrev: 'dz',
        capabbrev: 'DZ',
    },
    'Argentina': {
        currency: 'ARS',
        abbrev: 'ar',
        capabbrev: 'AR',
    },
    'Australia': {
        currency: 'AUD',
        abbrev: 'au',
        capabbrev: 'AU',
    },
    'Austria': {
        currency: 'EUR',
        abbrev: 'at',
        capabbrev: 'AT',
    },
    'Bangladesh': {
        currency: 'BDT',
        abbrev: 'bd',
        capabbrev: 'BD',
    },
    'Belgium': {
        currency: 'EUR',
        abbrev: 'be',
        capabbrev: 'BE',
    },
    'Brazil': {
        currency: 'BRL',
        abbrev: 'br',
        capabbrev: 'BR',
    },
    'Brunei': {
        currency: 'BND',
        abbrev: 'bn',
        capabbrev: 'BN',
    },
    'Bulgaria': {
        currency: 'BGN',
        abbrev: 'bg',
        capabbrev: 'BG',
    },
    'Cambodia': {
        currency: 'KHR',
        abbrev: 'kh',
        capabbrev: 'KH',
    },
    'Canada': {
        currency: 'CAD',
        abbrev: 'ca',
        capabbrev: 'CA',
    },
    'Chile': {
        currency: 'CLP',
        abbrev: 'cl',
        capabbrev: 'CL',
    },
    'China': {
        currency: 'RMB',
        abbrev: 'cn',
        capabbrev: 'CN',
    },
    'Colombia': {
        currency: 'COP',
        abbrev: 'co',
        capabbrev: 'CO',
    },
    'Croatia': {
        currency: 'EUR',
        abbrev: 'hr',
        capabbrev: 'HR',
    },
    'Czech Republic': {
        currency: 'CZK',
        abbrev: 'cz',
        capabbrev: 'CZ',
    },
    'Denmark': {
        currency: 'DKK',
        abbrev: 'dk',
        capabbrev: 'DK',
    },
    'Egypt': {
        currency: 'EGP',
        abbrev: 'eg',
        capabbrev: 'EG',
    },
    'Estonia': {
        currency: 'EUR',
        abbrev: 'ee',
        capabbrev: 'EE',
    },
    'Finland': {
        currency: 'EUR',
        abbrev: 'fi',
        capabbrev: 'FI',
    },
    'France': {
        currency: 'EUR',
        abbrev: 'fr',
        capabbrev: 'FR',
    },
    'Germany': {
        currency: 'EUR',
        abbrev: 'de',
        capabbrev: 'DE',
    },
    'Ghana': {
        currency: 'GHS',
        abbrev: 'gh',
        capabbrev: 'GH',
    },
    'Greece': {
        currency: 'EUR',
        abbrev: 'gr',
        capabbrev: 'GR',
    },
    'Hong Kong': {
        currency: 'HKD',
        abbrev: 'hk',
        capabbrev: 'HK',
    },
    'Hungary': {
        currency: 'HUF',
        abbrev: 'hu',
        capabbrev: 'HU',
    },
    'Iceland': {
        currency: 'ISK',
        abbrev: 'is',
        capabbrev: 'IS',
    },
    'India': {
        currency: 'INR',
        abbrev: 'in',
        capabbrev: 'IN',
    },
    'Indonesia': {
        currency: 'IDR',
        abbrev: 'id',
        capabbrev: 'ID',
    },
    'Iran': {
        currency: 'IRR',
        abbrev: 'ir',
        capabbrev: 'IR',
    },
    'Iraq': {
        currency: 'IQD',
        abbrev: 'iq',
        capabbrev: 'IQ',
    },
    'Ireland': {
        currency: 'EUR',
        abbrev: 'ie',
        capabbrev: 'IE',
    },
    'Israel': {
        currency: 'ILS',
        abbrev: 'il',
        capabbrev: 'IL',
    },
    'Italy': {
        currency: 'EUR',
        abbrev: 'it',
        capabbrev: 'IT',
    },
    'Japan': {
        currency: 'YEN',
        abbrev: 'jp',
        capabbrev: 'JP',
    },
    'Jordan': {
        currency: 'JOD',
        abbrev: 'jo',
        capabbrev: 'JO',
    },
    'Kazakhstan': {
        currency: 'KZT',
        abbrev: 'kz',
        capabbrev: 'KZ',
    },
    'Kenya': {
        currency: 'KES',
        abbrev: 'ke',
        capabbrev: 'KE',
    },
    'Korea': {
        currency: 'WON',
        abbrev: 'kr',
        capabbrev: 'KR',
    },
    'Kuwait': {
        currency: 'KWD',
        abbrev: 'kw',
        capabbrev: 'KW',
    },
    'Laos': {
        currency: 'LAK',
        abbrev: 'la',
        capabbrev: 'LA',
    },
    'Latvia': {
        currency: 'EUR',
        abbrev: 'lv',
        capabbrev: 'LV',
    },
    'Lebanon': {
        currency: 'LBP',
        abbrev: 'lb',
        capabbrev: 'LB',
    },
    'Lithuania': {
        currency: 'EUR',
        abbrev: 'lt',
        capabbrev: 'LT',
    },
    'Luxembourg': {
        currency: 'EUR',
        abbrev: 'lu',
        capabbrev: 'LU',
    },
    'Malaysia': {
        currency: 'RM',
        abbrev: 'my',
        capabbrev: 'MY',
    },
    'Mexico': {
        currency: 'MXN',
        abbrev: 'mx',
        capabbrev: 'MX',
    },
    'Morocco': {
        currency: 'MAD',
        abbrev: 'ma',
        capabbrev: 'MA',
    },
    'Myanmar': {
        currency: 'MMK',
        abbrev: 'mm',
        capabbrev: 'MM',
    },
    'Nepal': {
        currency: 'NPR',
        abbrev: 'np',
        capabbrev: 'NP',
    },
    'Netherlands': {
        currency: 'EUR',
        abbrev: 'nl',
        capabbrev: 'NL',
    },
    'New Zealand': {
        currency: 'NZD',
        abbrev: 'nz',
        capabbrev: 'NZ',
    },
    'Nigeria': {
        currency: 'NGN',
        abbrev: 'ng',
        capabbrev: 'NG',
    },
    'Norway': {
        currency: 'NOK',
        abbrev: 'no',
        capabbrev: 'NO',
    },
    'Pakistan': {
        currency: 'PKR',
        abbrev: 'pk',
        capabbrev: 'PK',
    },
    'Peru': {
        currency: 'PEN',
        abbrev: 'pe',
        capabbrev: 'PE',
    },
    'Philippines': {
        currency: 'PHP',
        abbrev: 'ph',
        capabbrev: 'PH',
    },
    'Poland': {
        currency: 'PLN',
        abbrev: 'pl',
        capabbrev: 'PL',
    },
    'Portugal': {
        currency: 'EUR',
        abbrev: 'pt',
        capabbrev: 'PT',
    },
    'Qatar': {
        currency: 'QAR',
        abbrev: 'qa',
        capabbrev: 'QA',
    },
    'Romania': {
        currency: 'RON',
        abbrev: 'ro',
        capabbrev: 'RO',
    },
    'Russia': {
        currency: 'RUB',
        abbrev: 'ru',
        capabbrev: 'RU',
    },
    'Saudi Arabia': {
        currency: 'SAR',
        abbrev: 'sa',
        capabbrev: 'SA',
    },
    'Serbia': {
        currency: 'RSD',
        abbrev: 'rs',
        capabbrev: 'RS',
    },
    'Singapore': {
        currency: 'SGD',
        abbrev: 'sg',
        capabbrev: 'SG',
    },
    'Slovakia': {
        currency: 'EUR',
        abbrev: 'sk',
        capabbrev: 'SK',
    },
    'Slovenia': {
        currency: 'EUR',
        abbrev: 'si',
        capabbrev: 'SI',
    },
    'South Africa': {
        currency: 'ZAR',
        abbrev: 'za',
        capabbrev: 'ZA',
    },
    'Spain': {
        currency: 'EUR',
        abbrev: 'es',
        capabbrev: 'ES',
    },
    'Sri Lanka': {
        currency: 'LKR',
        abbrev: 'lk',
        capabbrev: 'LK',
    },
    'Sweden': {
        currency: 'SEK',
        abbrev: 'se',
        capabbrev: 'SE',
    },
    'Switzerland': {
        currency: 'CHF',
        abbrev: 'ch',
        capabbrev: 'CH',
    },
    'Taiwan': {
        currency: 'NTD',
        abbrev: 'tw',
        capabbrev: 'TW',
    },
    'Thailand': {
        currency: 'THB',
        abbrev: 'th',
        capabbrev: 'TH',
    },
    'Turkey': {
        currency: 'TRY',
        abbrev: 'tr',
        capabbrev: 'TR',
    },
    'Ukraine': {
        currency: 'UAH',
        abbrev: 'ua',
        capabbrev: 'UA',
    },
    'United Arab Emirates': {
        currency: 'AED',
        abbrev: 'ae',
        capabbrev: 'AE',
    },
    'United Kingdom': {
        currency: 'GBP',
        abbrev: 'gb',
        capabbrev: 'GB',
    },
    'United States': {
        currency: 'USD',
        abbrev: 'us',
        capabbrev: 'US',
    },
    'Uruguay': {
        currency: 'UYU',
        abbrev: 'uy',
        capabbrev: 'UY',
    },
    'Uzbekistan': {
        currency: 'UZS',
        abbrev: 'uz',
        capabbrev: 'UZ',
    },
    'Venezuela': {
        currency: 'VES',
        abbrev: 've',
        capabbrev: 'VE',
    },
    'Vietnam': {
        currency: 'VND',
        abbrev: 'vn',
        capabbrev: 'VN',
    },
    'Zimbabwe': {
        currency: 'ZWL',
        abbrev: 'zw',
        capabbrev: 'ZW',
    },
};

export const WEDDING_CUSTOM = ['Malay', 'Chinese', 'Hindu', 'Western', 'Korean', 'Japanese']
export const BUDGET_IN_ENG_SG = ['100 - 5,000', '5,000 - 10,000', '10,000 - 20,000', '20,000 - 50,000', '50,000 - 100,000', 'More than 100,000'] // use in user's questions
export const BUDGET_IN_ENG_MY = ['100 - 5,000', '5,000 - 10,000', '10,000 - 30,000', '30,000 - 50,000 ', 'More than 50,000'] // use in user's questions
export const BUDGET_IN_ENG_CH = ['100 - 5,000', '5,000 - 10,000', '10,000 - 20,000', '20,000 - 50,000', '50,000 - 100,000', 'More than 100,000'] // use in user's questions
export const BUDGET_IN_ENG_TW = ['100 - 5,000', '5,000 - 10,000', '10,000 - 20,000', '20,000 - 50,000', '50,000 - 100,000', 'More than 100,000'] // use in user's questions
export const BUDGET_IN_ENG_HK = ['100 - 5,000', '5,000 - 10,000', '10,000 - 20,000', '20,000 - 50,000', '50,000 - 100,000', 'More than 100,000'] // use in user's questions
export const BUDGET_IN_ENG_KR = ['100 - 5,000', '5,000 - 10,000', '10,000 - 20,000', '20,000 - 50,000', '50,000 - 100,000', 'More than 100,000'] // use in user's questions
export const INVITESOCIALMEDIASIM_ARR = [<Icon size={10} icon={facebook} />, <Icon size={10} icon={whatsapp} />, <Icon size={10} icon={telegram} />, <Icon size={10} icon={instagram} />]
export const GUEST_ICON = <Icon size={25} icon={pencil} />
export const SEARCH_ICON = <Icon size={15} icon={search} /> // Home > Searchbar
export const SEARCH_LARGE_ICON = <Icon size={24} icon={search} /> // Home > Searchbar
export const PACKAGE_ICON = <Icon size={15} icon={fileText} /> // Home > vendor category > every single cards
export const HUMANSIM_ICON = <Icon size={10} icon={u1F6B9} />
export const FACEBOOK_ICON = <Icon size={15} icon={facebook} />
export const WHATSAPP_ICON = <Icon size={15} icon={whatsapp} />
export const TELEGRAM_ICON = <Icon size={15} icon={telegram} />
export const REDDIT_ICON = <Icon size={15} icon={reddit} />
export const INSTAGRAM_ICON = <Icon size={15} icon={instagram} />
export const WECHAT_ICON = <Icon size={15} icon={wechat} />
export const LINKEDIN_ICON = <Icon size={15} icon={linkedin} />
export const WHATSAPP_ICON_LARGE = <Icon size={30} icon={whatsapp} />
export const TELEGRAM_ICON_LARGE = <Icon size={30} icon={telegram} />
export const HUMAN_ICON = <Icon size={18} icon={u1F6B9} />
export const GPS_ICON = <Icon size={15} icon={location} />
export const SMALL_GPS_ICON = <Icon size={10} icon={location} />
export const LINK_ICON = <Icon size={15} icon={link} />
export const LINKLARGE_ICON = <Icon size={18} icon={link} />
export const EMAIL_ICON = <Icon size={17} icon={mail} />
export const HEART_ICON = <Icon size={23} icon={heart} />
export const LEFTRIGHT_ICON = <Icon size={23} icon={u1F312} />
export const RIGHTLEFT_ICON = <Icon size={23} icon={u1F318} />
export const EMPTY23_SMALL = <Icon size={23} icon={u1F534} />
export const NAVBAR_ICON = <Icon size={25} icon={menu} />
export const STAR_ICON = <Icon size={25} icon={star} />
export const SMALL_STAR_ICON = <Icon size={15} icon={star} />
export const PENCIL_ICON = <Icon size={25} icon={pencil} />
export const PENCIL_ICON_SMALL = <Icon size={20} icon={pencil} />
export const PENCIL_ICON_SMALLL = <Icon size={18} icon={pencil} />
export const FILTER_ICON = <Icon size={20} icon={filter} />
export const CHART_ICON = <Icon size={20} icon={graph} />
export const REFRESH_ICON = <Icon size={20} icon={refresh} />
export const ARROWUP_ICON = <Icon size={30} icon={iosArrowUp} />
export const ARROWDOWN_ICON = <Icon size={30} icon={iosArrowDown} />
export const ARROWUPSMALL_ICON = <Icon size={16} icon={iosArrowUp} />
export const ARROWDOWNSMALL_ICON = <Icon size={16} icon={iosArrowDown} />
export const MORE_ICON = <Icon size={20} icon={androidMoreVertical} />
export const MOREHORIZONTAL_ICON = <Icon size={20} icon={androidMoreHorizontal} />
export const SENDMSG_ICON = <Icon size={15} icon={send} />
export const TRASH_ICON = <Icon size={18} icon={trash} />
export const BACK_ICON = <Icon size={18} icon={iosArrowBack} />
export const EXPLORE_ICON = <Icon size={20} icon={search} />
export const LEFTARROW_ICON_SMALL = <Icon size={18} icon={arrowLeft} />
export const RIGHTARROW_ICON_SMALL = <Icon size={18} icon={arrowRight} />
export const DESKTOP_ICON_SMALL = <Icon size={20} icon={laptop} />
export const MOBILE_ICON_SMALL = <Icon size={20} icon={mobile} />
export const TABLET_ICON_SMALL = <Icon size={20} icon={tablet} />
export const SEND_INVITATION_SMALL = <Icon size={28} icon={u1F48C} />
export const TIMELINE_SMALL = <Icon size={28} icon={line} />
export const BUDGET_SMALL = <Icon size={28} icon={u1F4B5} />
export const TODO_SMALL = <Icon size={28} icon={u1F4DD} />
export const CHAIR_SMALL = <Icon size={28} icon={u1F4BA} />
export const FLOWER_SMALL = <Icon size={28} icon={u2747} />
export const TRASH_SMALL = <Icon size={15} icon={trash} />
export const SIXDOT_SMALL = <Icon size={20} icon={arrowsAlt} />
export const DOWNLOAD_SMALL = <Icon size={18} icon={download} />
export const PALETTE_SMALL = <Icon size={18} icon={ic_palette} />
export const EDITGL_SMALL = <Icon size={18} icon={compose} />
export const BOOK_SMALL = <Icon size={18} icon={u1F4C3} />
export const ITINERARY_SMALL = <Icon size={28} icon={u1F4C3} />
export const PERSON_SMALL = <Icon size={18} icon={u1F465} />
export const DIALOG_SMALL = <Icon size={30} icon={u1F4AC} />
export const EMPTY_SMALL = <Icon size={30} icon={u1F534} />
export const HOME_SMALL = <Icon size={24} icon={u1F3E1} />
export const PARTY_SMALL = <Icon size={24} icon={u1F389} />
export const WEDDING_SMALL = <Icon size={24} icon={u1F481} />
export const SWITCH_SMALL = <Icon size={24} icon={u1F501} />
export const PRICELIST_SMALL = <Icon size={24} icon={u1F4DC} />
export const PROJECTWED_SMALL = <Icon size={24} icon={u1F491} />
export const PROJECTEVENT_SMALL = <Icon size={24} icon={u1F386} />

// export const TOOLS_SMALL = <Icon size={24} icon={u1F527} />

export const PROMOTION_SMALL = <Icon size={24} icon={u1F4E3} />
export const CALCULATOR_LARGE = <Icon size={28} icon={calculator} />
export const HASHTAG_LARGE = <Icon size={28} icon={priceTags} />
export const EDIT_ICON = <Icon size={20} icon={edit} />
export const COPY_ICON = <Icon size={20} icon={copy} />
export const HIDE_SMALL = <Icon size={15} icon={withLine} />
export const SHOW_SMALL = <Icon size={15} icon={eye} />
export const TIME_SMALL = <Icon size={18} icon={u1F557} />
export const DOLLAR_SMALL = <Icon size={18} icon={u1F4B2} />
export const DELIEVERABLES_SMALL = <Icon size={18} icon={u1F4E6} />
export const MORE_SMALL = <Icon size={18} icon={u2795} />
export const ARROWRIGHT_SMALL = <Icon size={18} icon={arrowRight2} />
export const ARROWLEFT_SMALL = <Icon size={18} icon={arrowLeft2} />
export const ZOOMIIN_SMALL = <Icon size={18} icon={zoomIn} />
export const SHOP_SMALL = <svg width="23px" height="23px" viewBox="0 0 17 18" className="bi bi-shop" fill="currentColor" xmlns="http://www.w3.org/2000/svg"> <path fill="evenodd" d="M0 15.5a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 0 1H.5a.5.5 0 0 1-.5-.5zM3.12 1.175A.5.5 0 0 1 3.5 1h9a.5.5 0 0 1 .38.175l2.759 3.219A1.5 1.5 0 0 1 16 5.37v.13h-1v-.13a.5.5 0 0 0-.12-.325L12.27 2H3.73L1.12 5.045A.5.5 0 0 0 1 5.37v.13H0v-.13a1.5 1.5 0 0 1 .361-.976l2.76-3.22z" /> <path d="M2.375 6.875c.76 0 1.375-.616 1.375-1.375h1a1.375 1.375 0 0 0 2.75 0h1a1.375 1.375 0 0 0 2.75 0h1a1.375 1.375 0 1 0 2.75 0h1a2.375 2.375 0 0 1-4.25 1.458 2.371 2.371 0 0 1-1.875.917A2.37 2.37 0 0 1 8 6.958a2.37 2.37 0 0 1-1.875.917 2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.5h1c0 .76.616 1.375 1.375 1.375z" /> <path d="M4.75 5.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm3.75 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm3.75 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z" /> <path fillRule="evenodd" d="M2 7.846V7H1v.437c.291.207.632.35 1 .409zm-1 .737c.311.14.647.232 1 .271V15H1V8.583zm13 .271a3.354 3.354 0 0 0 1-.27V15h-1V8.854zm1-1.417c-.291.207-.632.35-1 .409V7h1v.437zM3 9.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5V15H7v-5H4v5H3V9.5zm6 0a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-4zm1 .5v3h2v-3h-2z" /> </svg>
export const ARROWDOWN_SMALL = <Icon size={24} icon={arrowDownCircle} />
export const ARROWUP_SMALL = <Icon size={24} icon={arrowUpCircle} />
export const HORIZONTALMIDDLE = <Icon size={18} icon={horizontalMiddle} />
export const MOVERIGHT = <Icon size={15} icon={right} />
export const MOVELEFT = <Icon size={15} icon={left} />
export const HEART_LARGE = <Icon size={30} icon={heart} />
export const PIN_SMALL = <Icon size={24} icon={pinOutline} />
export const IOSTRASH_SMALL = <Icon size={24} icon={iosTrashOutline} />
export const EJECT_SMALL = <Icon size={24} icon={forward} />
export const STAR_SMALL = <Icon size={18} icon={u2747} />
export const X_SMALL = <Icon size={18} icon={u274E} />
export const SWAP_SMALL = <Icon size={24} icon={u1F501} />
export const IG_UL = <Icon size={24} icon={ic_file_upload} />
export const QR_NORM = <Icon size={24} icon={qrcode} />
export const FS_SMALL = <Icon size={18} icon={fontSize} />
export const F_SMALL = <Icon size={18} icon={font} />
export const LINK_SMALL = <Icon size={18} icon={link} />
export const RESIZE_SMALL = <Icon size={18} icon={screen_expand_1} />
export const IMG_SMALL = <Icon size={18} icon={image} />
export const CENTER_SMALL = <Icon size={18} icon={paragraphCenter} />
export const FS_BOLD = <Icon size={18} icon={bold} />
export const FC_SMALL = <Icon size={18} icon={eyedropper} />
export const BC_SMALL = <Icon size={18} icon={droplet} />
export const ALIGNQR_SMALL = <Icon size={18} icon={u1F536} />

export const TITLE_SMALL = <Icon size={30} icon={u2796} />
export const BABY_SMALL = <Icon size={30} icon={u1F476} />
export const SUBTEXT_SMALL = <Icon size={30} icon={u1F4C4} />
export const CONTENTEXAMPLE_SMALL = <Icon size={30} icon={u2733} />
export const NAMEUSERS_SMALL = <Icon size={30} icon={u1F464} />
export const ADDNEWUSER_SMALL = <Icon size={24} icon={u1F464} />
export const QUESTIONMARK_SMALL = <Icon size={14} icon={u2753} />

export const a4wt = '2480px' // in landscape mode
export const a4ht = '1754px'
export const a3wt = '3508px' // in landscape mode 
export const a3ht = '2480px'
export const a3wtint = 3508 // in landscape mode 
export const a3htint = 2480
export const canva_dlratio = 1
export const canva_editratio = 5

const s_ = { width: 30, height: 40, verticalAlign: 'middle', fill: '#707070', overflow: 'hidden' }
const vb_ = "0 0 1024 1024"
const v_ = "1.1"
const x_ = "http://www.w3.org/2000/svg"

export const PUREARROWLEFT_ICON = <svg className="icon" style={{ ...s_, width: 50, height: 30, fill: 'currentColor' }} viewBox={vb_} version={v_} xmlns={x_}><path d="M691.498667 798.165333a42.666667 42.666667 0 0 1-57.621334 2.496l-2.709333-2.496-256-256a42.666667 42.666667 0 0 1-2.496-57.621333l2.496-2.709333 256-256a42.666667 42.666667 0 0 1 62.826667 57.621333l-2.496 2.709333L465.706667 512l225.813333 225.834667a42.666667 42.666667 0 0 1 2.496 57.621333l-2.496 2.709333z" fill="white" ></path></svg>
export const PROFILE_SMALL = <svg className="icon" style={{ ...s_, width: 50, height: 30, fill: 'currentColor' }} viewBox={vb_} version={v_} xmlns={x_}><path d="M896 707.2h-256c-19.2 0-32 12.8-32 32v192c0 19.2 12.8 32 32 32h256c19.2 0 32-12.8 32-32v-192c0-19.2-16-32-32-32zM768 864h-32c-19.2 0-32-12.8-32-32s12.8-32 32-32h32c19.2 0 32 12.8 32 32s-16 32-32 32z" fill="#666666" p-id="2145"></path><path d="M576 931.2v-192c0-35.2 28.8-64 64-64h51.2l3.2-3.2c-22.4-16-48-28.8-73.6-38.4 86.4-51.2 147.2-144 147.2-249.6 0-160-128-288-288-288s-288 128-288 288c0 108.8 60.8 201.6 147.2 249.6-121.6 48-214.4 153.6-240 288-3.2 9.6 0 19.2 6.4 25.6 3.2 9.6 12.8 12.8 22.4 12.8h454.4c-6.4-9.6-6.4-19.2-6.4-28.8z" fill="#666666" p-id="2146"></path></svg>
export const MAP_SMALL = <svg className="icon" style={{ ...s_, width: 50, height: 30, fill: 'currentColor' }} viewBox={vb_} version={v_} xmlns={x_}><path d="M295.643367 1021.665327c0.286714 0.184316 0.675826 0.102398 0.962541 0.286714 2.334673 1.187816 4.771745 2.047959 7.393132 2.047959 1.413092 0 2.805704-0.184316 4.218796-0.573429l347.763925-94.902422 347.763925 94.902422c1.413092 0.389112 2.826183 0.573429 4.218796 0.573429 2.621388 0 5.058459-0.860143 7.352173-2.088918 0.327673-0.163837 0.675826-0.102398 0.962541-0.286714l288.00448-176.0016c6.102918-3.747765 8.99054-11.140897 7.044979-18.02204l-159.474571-559.99392c-1.310694-4.710306-4.730785-8.539989-9.277254-10.424112-4.546469-1.822684-9.625407-1.535969-13.946601 0.839663l-158.778264 89.086218c-7.679846 4.321194-10.424112 14.089958-6.102918 21.790284 4.321194 7.741285 14.048999 10.465071 21.831243 6.102918l141.083898-79.194576 150.627387 528.823984-256.465911 156.771265-60.926781-487.373293c-1.085418-8.806224-9.379652-14.909142-17.878682-13.885162-8.744785 1.085418-14.970581 9.092938-13.885162 17.858203l61.029179 488.274395-317.105978-86.567229 0-87.365933c0-8.826703-7.167857-15.99456-15.99456-15.99456s-15.99456 7.167857-15.99456 15.99456l0 87.365933-317.146937 86.567229 61.029179-488.274395c1.085418-8.765265-5.119898-16.772785-13.885162-17.858203-8.703826-1.02398-16.772785 5.078938-17.878682 13.885162l-60.885822 487.373293-256.465911-156.730305 150.627387-528.783024 141.083898 79.194576c7.741285 4.280234 17.469091 1.576928 21.831243-6.102918 4.321194-7.720806 1.576928-17.448611-6.102918-21.790284l-158.819224-89.127177c-4.259755-2.396112-9.338693-2.723786-13.926121-0.839663-4.546469 1.884122-7.966561 5.693326-9.277254 10.424112l-159.474571 559.99392c-1.98652 6.922102 0.901102 14.274275 7.044979 18.02204l287.963521 176.0016zM645.148057 747.771285c3.071939 2.826183 6.942581 4.218796 10.854183 4.218796 3.850163 0 7.679846-1.372133 10.751785-4.136877 10.649387-9.686846 261.237655-239.652167 261.237655-475.863763 0-152.531989-119.457451-271.98944-271.98944-271.98944s-271.98944 119.457451-271.98944 271.98944c0 232.115678 250.48587 465.910682 261.155737 475.761365zM655.98176 32.030079c136.803664 0 240.00032 103.176176 240.00032 240.00032 0 195.109058-191.770885 394.785064-239.897922 441.806204-48.02464-47.574089-240.082238-249.891962-240.082238-441.806204 0-136.824144 103.196656-240.00032 240.00032-240.00032zM799.99424 272.00992c0-79.399372-64.613108-143.992-143.992-143.992s-143.992 64.613108-143.992 143.992 64.613108 143.992 143.992 143.992 143.992-64.613108 143.992-143.992zM655.98176 384.0128c-61.766445 0-112.00288-50.236435-112.00288-112.00288s50.236435-112.00288 112.00288-112.00288 112.00288 50.236435 112.00288 112.00288-50.236435 112.00288-112.00288 112.00288z" ></path></svg>

export const TOOLS_SMALL = <svg className="icon" style={{ ...s_, width: 23, height: 23, fill: 'currentColor' }} viewBox={vb_} version={v_} xmlns={x_}><path d="M256 78.769231H137.846154C104.369231 78.769231 78.769231 104.369231 78.769231 137.846154v118.153846c0 33.476923 25.6 59.076923 59.076923 59.076923h118.153846c33.476923 0 59.076923-25.6 59.076923-59.076923V137.846154c0-33.476923-25.6-59.076923-59.076923-59.076923z m0 630.153846H137.846154c-33.476923 0-59.076923 25.6-59.076923 59.076923v118.153846c0 33.476923 25.6 59.076923 59.076923 59.076923h118.153846c33.476923 0 59.076923-25.6 59.076923-59.076923v-118.153846c0-33.476923-25.6-59.076923-59.076923-59.076923z m0-315.076923H137.846154c-33.476923 0-59.076923 25.6-59.076923 59.076923v118.153846c0 33.476923 25.6 59.076923 59.076923 59.076923h118.153846c33.476923 0 59.076923-25.6 59.076923-59.076923v-118.153846c0-33.476923-25.6-59.076923-59.076923-59.076923zM571.076923 78.769231h-118.153846c-33.476923 0-59.076923 25.6-59.076923 59.076923v118.153846c0 33.476923 25.6 59.076923 59.076923 59.076923h118.153846c33.476923 0 59.076923-25.6 59.076923-59.076923V137.846154c0-33.476923-25.6-59.076923-59.076923-59.076923z m0 630.153846h-118.153846c-33.476923 0-59.076923 25.6-59.076923 59.076923v118.153846c0 33.476923 25.6 59.076923 59.076923 59.076923h118.153846c33.476923 0 59.076923-25.6 59.076923-59.076923v-118.153846c0-33.476923-25.6-59.076923-59.076923-59.076923z m0-315.076923h-118.153846c-33.476923 0-59.076923 25.6-59.076923 59.076923v118.153846c0 33.476923 25.6 59.076923 59.076923 59.076923h118.153846c33.476923 0 59.076923-25.6 59.076923-59.076923v-118.153846c0-33.476923-25.6-59.076923-59.076923-59.076923zM886.153846 78.769231h-118.153846c-33.476923 0-59.076923 25.6-59.076923 59.076923v118.153846c0 33.476923 25.6 59.076923 59.076923 59.076923h118.153846c33.476923 0 59.076923-25.6 59.076923-59.076923V137.846154c0-33.476923-25.6-59.076923-59.076923-59.076923z m0 630.153846h-118.153846c-33.476923 0-59.076923 25.6-59.076923 59.076923v118.153846c0 33.476923 25.6 59.076923 59.076923 59.076923h118.153846c33.476923 0 59.076923-25.6 59.076923-59.076923v-118.153846c0-33.476923-25.6-59.076923-59.076923-59.076923z m0-315.076923h-118.153846c-33.476923 0-59.076923 25.6-59.076923 59.076923v118.153846c0 33.476923 25.6 59.076923 59.076923 59.076923h118.153846c33.476923 0 59.076923-25.6 59.076923-59.076923v-118.153846c0-33.476923-25.6-59.076923-59.076923-59.076923z" p-id="5220"></path></svg>
export const TOOLS_LARGE = <svg className="icon" style={{ ...s_, width: 30, height: 30, fill: 'currentColor' }} viewBox={vb_} version={v_} xmlns={x_}><path d="M256 78.769231H137.846154C104.369231 78.769231 78.769231 104.369231 78.769231 137.846154v118.153846c0 33.476923 25.6 59.076923 59.076923 59.076923h118.153846c33.476923 0 59.076923-25.6 59.076923-59.076923V137.846154c0-33.476923-25.6-59.076923-59.076923-59.076923z m0 630.153846H137.846154c-33.476923 0-59.076923 25.6-59.076923 59.076923v118.153846c0 33.476923 25.6 59.076923 59.076923 59.076923h118.153846c33.476923 0 59.076923-25.6 59.076923-59.076923v-118.153846c0-33.476923-25.6-59.076923-59.076923-59.076923z m0-315.076923H137.846154c-33.476923 0-59.076923 25.6-59.076923 59.076923v118.153846c0 33.476923 25.6 59.076923 59.076923 59.076923h118.153846c33.476923 0 59.076923-25.6 59.076923-59.076923v-118.153846c0-33.476923-25.6-59.076923-59.076923-59.076923zM571.076923 78.769231h-118.153846c-33.476923 0-59.076923 25.6-59.076923 59.076923v118.153846c0 33.476923 25.6 59.076923 59.076923 59.076923h118.153846c33.476923 0 59.076923-25.6 59.076923-59.076923V137.846154c0-33.476923-25.6-59.076923-59.076923-59.076923z m0 630.153846h-118.153846c-33.476923 0-59.076923 25.6-59.076923 59.076923v118.153846c0 33.476923 25.6 59.076923 59.076923 59.076923h118.153846c33.476923 0 59.076923-25.6 59.076923-59.076923v-118.153846c0-33.476923-25.6-59.076923-59.076923-59.076923z m0-315.076923h-118.153846c-33.476923 0-59.076923 25.6-59.076923 59.076923v118.153846c0 33.476923 25.6 59.076923 59.076923 59.076923h118.153846c33.476923 0 59.076923-25.6 59.076923-59.076923v-118.153846c0-33.476923-25.6-59.076923-59.076923-59.076923zM886.153846 78.769231h-118.153846c-33.476923 0-59.076923 25.6-59.076923 59.076923v118.153846c0 33.476923 25.6 59.076923 59.076923 59.076923h118.153846c33.476923 0 59.076923-25.6 59.076923-59.076923V137.846154c0-33.476923-25.6-59.076923-59.076923-59.076923z m0 630.153846h-118.153846c-33.476923 0-59.076923 25.6-59.076923 59.076923v118.153846c0 33.476923 25.6 59.076923 59.076923 59.076923h118.153846c33.476923 0 59.076923-25.6 59.076923-59.076923v-118.153846c0-33.476923-25.6-59.076923-59.076923-59.076923z m0-315.076923h-118.153846c-33.476923 0-59.076923 25.6-59.076923 59.076923v118.153846c0 33.476923 25.6 59.076923 59.076923 59.076923h118.153846c33.476923 0 59.076923-25.6 59.076923-59.076923v-118.153846c0-33.476923-25.6-59.076923-59.076923-59.076923z" p-id="5220"></path></svg>

export const COU_ICON = <svg className="icon" style={{ ...s_, width: 20, height: 20, backgroundColor: 'white' }} viewBox={vb_} version={v_} xmlns={x_}><path d="M886.8 353.6c-20.5-48.4-49.8-92-87.2-129.3-37.4-37.4-80.9-66.7-129.3-87.2-50.2-21.2-103.5-32-158.4-32s-108.2 10.8-158.4 32c-48.4 20.5-92 49.8-129.3 87.2-37.4 37.4-66.7 80.9-87.2 129.3-21.2 50.2-32 103.5-32 158.4s10.8 108.2 32 158.4c20.5 48.4 49.8 92 87.2 129.3 37.4 37.4 80.9 66.7 129.3 87.2 50.2 21.2 103.5 32 158.4 32s108.2-10.8 158.4-32c48.4-20.5 92-49.8 129.3-87.2 37.4-37.4 66.7-80.9 87.2-129.3 21.2-50.2 32-103.5 32-158.4s-10.7-108.2-32-158.4zM713.9 543.3l21.2 43.8-38.9 33.6 2.8 13.2c3.2 15.4 6.6 33.5 8.2 44.2-3 2.7-6.9 6.3-12.1 11-7.5 6.8-20.6 18.7-31.8 28.6-2-8.2-4.3-19.3-7-34.3-4.4-25-7.4-47.8-7.4-48.1l-0.4-3.4-0.7-1.5-19.2-70.8-49.1 8.8-27.6-23.3 22.6-36.7-4.7-48.8c8.8-8.6 17.7-16.9 21.1-19.5 11.8-6.3 13.8-19.9 14.8-26.6 0.8-5.4 1.5-12.6 2-21.4 0.5-7.3 0.7-14.4 0.9-19.8l38.1-40.5 143.8-49.3c42.8 51.9 71.4 115.8 79.9 185.9L752.9 472l-39 71.3z m29.8 163.9c-0.2 0.2-0.5 0.3-0.6 0.4 0.2-0.1 0.4-0.2 0.6-0.4zM232.6 284c1.3 3.4 2.7 7.1 4 10.5 8.9 24 17.3 46.7 34.4 55.8 10 5.3 46 19.8 73.4 30.6-8.3 8.9-18 19.5-27.7 30.7-43.9 50.7-53.7 73-52 89.3-3.9 3.2-12.7 7.2-22.4 10.5l-41.9-67-33.2-38.5c13.8-45.1 36.3-86.3 65.4-121.9z m117 550.2l-2.7-68.1 20.1-78-23.3-54.3 4.8-11.7 39.4 14.4 71.8 51.2-53 36.9-40.2 117.5c-5.8-2.5-11.4-5.1-16.9-7.9zM512 872.8c-35.6 0-69.9-5.2-102.4-14.8l35.7-104.2 94.2-65.6-130-92.7-86.6-31.6-29.2 70.3 24.7 57.7-17.9 69.3 1.8 44.4C210.9 740.1 151.2 632.9 151.2 512c0-17 1.2-33.8 3.5-50.2l8.5 9.9 57.6 92.1 15.7-3.3c0.5-0.1 12.5-2.6 26-7.6 21.2-7.8 35.1-17.2 42.6-29 5.1-8.1 7.1-17.1 5.7-26.1 1.5-4.1 9-20.3 45.2-61.4 22.6-25.7 44.9-48 45.1-48.2l25-25-33-12.7c-32.4-12.5-86.7-34-99.3-40.3-4.1-4.9-10.5-22.3-14-31.8-4.3-11.5-8.3-22.5-13.1-30.8 64.4-59.9 150.7-96.6 245.5-96.6 93.8 0 179.3 35.9 243.5 94.8l-134.6 46.1-58 61.6-0.2 8.9c-0.3 14.9-1.3 33.9-2.5 43.2-6 4.9-15.3 13.5-30.7 28.9l-7.7 7.7 5.3 55.1-35.4 57.3 74.4 62.7 28.9-5.2 8.3 30.6c0.8 6.2 3.9 28.6 8.3 52.6 10.4 57 18.1 68.6 24.6 75.1 3.8 3.8 9.7 6.9 16.6 6.9 3.9 0 8.2-1 12.7-3.3 2.2-1.2 4.6-2.7 7.6-4.9 4-3 9.2-7.2 16-13 11.7-10 25.7-22.8 37-33.1 7.3-6.7 15.6-14.2 18-16.1 5.1-3.6 10.6-10.3 10.1-22.7-0.1-2.4-0.4-5.3-0.9-9-0.7-5.3-1.9-12.5-3.5-21.3-1-5.7-2.1-11.3-3.1-16.1l45.2-39.1-26.2-54.2 15-27.4 92.2-2.7c-1.6 197.9-163 358.4-361.1 358.4z" p-id="3522"></path></svg>
export const PLUS_ICON = <svg className="icon" style={{ ...s_, width: 20, height: 20, backgroundColor: 'white', borderRadius: 30 }} viewBox={vb_} version={v_} xmlns={x_}><path d="M474 152m8 0l60 0q8 0 8 8l0 704q0 8-8 8l-60 0q-8 0-8-8l0-704q0-8 8-8ZM168 474m8 0l672 0q8 0 8 8l0 60q0 8-8 8l-672 0q-8 0-8-8l0-60q0-8 8-8Z" p-id="2132"></path></svg>
export const ARROWLEFT_ICON = <svg className="icon" style={{ ...s_, fill: 'inherit', width: 32, height: 32, borderRadius: '100%', backgroundColor: 'white' }} viewBox={vb_} version={v_} xmlns={x_}><path d="M512 0C229.184 0 0 229.184 0 512c0 282.752 229.184 512 512 512s512-229.248 512-512c0-282.816-229.216-512-512-512z m96 704c28.672 30.656 46.688 60 16 96-31.424 36.864-73.76 22.208-96 0L288 560c-32-29.312-26.688-64.672 0-96L528 224c22.24-22.176 64.288-32.288 96 0 36 36.672 6.24 73.792-16 96l-192 192 192 192z" ></path></svg>
export const CLOSE_ICON = <svg className="icon" style={{ ...s_, fill: 'inherit', width: 32, height: 32, borderRadius: '100%' }} viewBox={vb_} version={v_} xmlns={x_}><path d="M442.24 517.504l-114.88 115.2a48 48 0 1 0 67.968 67.776l114.688-115.008L624.768 700.48a48 48 0 0 0 67.968-67.84l-114.88-115.136 114.88-115.072a48 48 0 1 0-67.968-67.84L510.016 449.6 395.328 334.592a48 48 0 0 0-67.968 67.84l114.88 115.072zM512 1024A512 512 0 1 1 512 0a512 512 0 0 1 0 1024z"></path></svg>
export const GUESTBOOK_SMALL = <svg className="icon" style={s_} viewBox={vb_} version={v_} xmlns={x_}><path d="M107.2 777.6c-11.2 0-22.4-4-29.6-10.4-8.8-8-12.8-19.2-9.6-30.4 1.6-6.4 5.6-12 8-14.4 15.2-17.6 36.8-23.2 57.6-27.2-0.8-11.2-4.8-23.2-11.2-37.6-10.4-25.6-24.8-49.6-41.6-72-6.4-8-12.8-16-19.2-23.2-21.6-25.6-43.2-52-52.8-85.6-12-41.6 0-88 28.8-120 29.6-31.2 75.2-45.6 117.6-36.8 8.8 1.6 14.4 10.4 12 19.2-1.6 8.8-10.4 14.4-19.2 12-31.2-6.4-65.6 4-87.2 27.2-21.6 23.2-30.4 58.4-21.6 88.8 8 27.2 26.4 49.6 46.4 72.8 6.4 8 13.6 16 20 24.8 18.4 24 34.4 50.4 45.6 79.2 5.6 12.8 11.2 28.8 12.8 45.6 9.6-1.6 19.2-4 26.4-8 33.6-17.6 40-65.6 42.4-110.4 0-8 6.4-14.4 13.6-15.2 8-0.8 15.2 4 17.6 11.2 5.6 17.6 3.2 36 1.6 52-2.4 22.4-3.2 36 5.6 45.6 8.8 8.8 23.2 8.8 44.8 7.2 13.6-0.8 28-1.6 42.4 1.6 8.8 1.6 14.4 10.4 12 19.2s-10.4 14.4-19.2 12c-7.2-0.8-18.4 0-31.2 0-24 1.6-50.4 3.2-70.4-16.8-3.2-3.2-6.4-7.2-8-10.4-8.8 13.6-20 24.8-35.2 33.6-13.6 7.2-28 10.4-43.2 12-5.6 24-20.8 44-41.6 52-4 1.6-8.8 2.4-14.4 2.4z m-8-33.6c2.4 1.6 8 2.4 11.2 1.6 8-3.2 13.6-9.6 17.6-16.8-11.2 2.4-20.8 6.4-28 14.4l-0.8 0.8zM350.4 932c-4.8 0-8.8-0.8-13.6-1.6-29.6-8-42.4-40-42.4-67.2 0-41.6 21.6-78.4 39.2-108 7.2-12.8 16-28 29.6-39.2l9.6-7.2c-4 0-7.2 0-11.2-1.6-12-3.2-22.4-11.2-28-21.6-9.6-16.8-8.8-35.2-7.2-49.6 3.2-28 12.8-48.8 27.2-62.4 11.2-10.4 27.2-15.2 43.2-14.4 12.8 0.8 24.8 7.2 32 16.8 4.8 6.4 8 14.4 9.6 20.8 5.6 16.8 9.6 33.6 12.8 50.4 0.8-0.8 0.8-1.6 1.6-2.4 6.4-11.2 12-22.4 20.8-32.8 4.8-6.4 12.8-15.2 24.8-19.2 12.8-4.8 25.6-2.4 35.2 5.6 2.4-2.4 4.8-4 8-5.6 11.2-6.4 25.6-7.2 38.4-3.2 12.8 4.8 23.2 14.4 28 26.4 4.8 12.8 4 24.8 3.2 36 0 2.4-0.8 5.6-0.8 8-0.8 9.6 2.4 16 4.8 17.6 2.4 0.8 8.8-0.8 14.4-6.4 2.4-2.4 5.6-5.6 8-8.8 4.8-6.4 11.2-12.8 19.2-18.4 7.2-4.8 17.6-3.2 22.4 4 4.8 7.2 3.2 17.6-4 22.4-4 3.2-8 8-12.8 12.8-3.2 4-6.4 7.2-10.4 11.2-12 12-31.2 21.6-49.6 12.8-16-7.2-24.8-24.8-24-48 0-3.2 0.8-6.4 0.8-9.6 0.8-8 1.6-16-0.8-21.6-1.6-3.2-4.8-6.4-8.8-8-4-1.6-8.8-1.6-12 0.8-6.4 3.2-9.6 11.2-12 20.8 0 19.2-2.4 38.4-5.6 56.8-1.6 8-9.6 13.6-17.6 12.8-8.8-0.8-14.4-8.8-13.6-16.8l3.2-36c0.8-5.6 0.8-12.8 2.4-20V632c0-6.4-0.8-8-0.8-8h-3.2c-3.2 0.8-6.4 4-10.4 8.8-6.4 8-12 17.6-17.6 28-7.2 12.8-14.4 25.6-24 36.8 2.4 62.4-11.2 125.6-39.2 181.6-6.4 12.8-14.4 27.2-27.2 38.4-13.6 8.8-28 14.4-41.6 14.4zM424.8 720c-4.8 2.4-8.8 4-13.6 5.6-10.4 4-20 8-27.2 14.4-8.8 7.2-16 19.2-22.4 30.4-16 28-34.4 59.2-34.4 92 0 15.2 6.4 32.8 18.4 36 7.2 1.6 16-0.8 23.2-7.2 8.8-7.2 14.4-17.6 20-28 22.4-44 34.4-93.6 36-143.2z m-42.4-46.4c5.6 0 10.4 2.4 13.6 8 3.2 4.8 3.2 11.2 0.8 15.2 0.8 0 1.6-0.8 2.4-0.8 8.8-4 17.6-7.2 24.8-12.8-2.4-25.6-7.2-52-15.2-76.8-1.6-4-3.2-8.8-4.8-11.2-2.4-3.2-6.4-4-9.6-4.8-6.4-0.8-13.6 1.6-18.4 6.4-8.8 8-14.4 21.6-16.8 42.4-0.8 9.6-1.6 21.6 3.2 29.6 1.6 3.2 5.6 5.6 8.8 6.4 1.6 0 3.2 0.8 4 0 1.6-0.8 4.8-1.6 7.2-1.6zM245.6 536c-8.8 0-16-7.2-16-16v-13.6c0-8.8 7.2-16 16-16s16 7.2 16 16V520c0 9.6-7.2 16-16 16zM666.4 672c-2.4 0-5.6-0.8-8-2.4-5.6-3.2-8.8-8.8-8-15.2L660.8 528c0-2.4 0.8-4.8 2.4-6.4l231.2-408.8c4.8-8 12-14.4 20-17.6 9.6-4 19.2-3.2 28 1.6l61.6 35.2c8 4.8 13.6 12.8 15.2 23.2 1.6 8.8 0 18.4-4.8 26.4l-231.2 408c-0.8 2.4-2.4 4-4.8 4.8l-103.2 74.4c-2.4 2.4-5.6 3.2-8.8 3.2z m25.6-137.6l-7.2 88 72-52 229.6-406.4c1.6-3.2 1.6-5.6 0.8-6.4l-61.6-35.2s-2.4 1.6-4 4.8L692 534.4zM960.8 250.4c-1.6 0-2.4 0-4-0.8L864 197.6c-4-2.4-5.6-7.2-3.2-11.2l39.2-69.6c4-6.4 9.6-12 16-14.4 7.2-3.2 14.4-2.4 20.8 0.8l61.6 35.2c6.4 3.2 10.4 9.6 11.2 17.6 0.8 7.2 0 14.4-4 21.6l-39.2 69.6c-0.8 1.6-2.4 3.2-4.8 4 0.8-0.8 0-0.8-0.8-0.8z m-81.6-63.2l78.4 44.8 35.2-63.2c1.6-3.2 2.4-7.2 2.4-11.2 0-1.6-0.8-4.8-4-5.6l-61.6-35.2c-2.4-1.6-5.6-0.8-7.2 0-3.2 1.6-6.4 4-8 7.2l-35.2 63.2z" ></path></svg>
export const GUESTBOOK_BIG = <svg className="icon" style={{ ...s_, width: 40, height: 40, fill: 'white' }} viewBox={vb_} version={v_} xmlns={x_}><path d="M107.2 777.6c-11.2 0-22.4-4-29.6-10.4-8.8-8-12.8-19.2-9.6-30.4 1.6-6.4 5.6-12 8-14.4 15.2-17.6 36.8-23.2 57.6-27.2-0.8-11.2-4.8-23.2-11.2-37.6-10.4-25.6-24.8-49.6-41.6-72-6.4-8-12.8-16-19.2-23.2-21.6-25.6-43.2-52-52.8-85.6-12-41.6 0-88 28.8-120 29.6-31.2 75.2-45.6 117.6-36.8 8.8 1.6 14.4 10.4 12 19.2-1.6 8.8-10.4 14.4-19.2 12-31.2-6.4-65.6 4-87.2 27.2-21.6 23.2-30.4 58.4-21.6 88.8 8 27.2 26.4 49.6 46.4 72.8 6.4 8 13.6 16 20 24.8 18.4 24 34.4 50.4 45.6 79.2 5.6 12.8 11.2 28.8 12.8 45.6 9.6-1.6 19.2-4 26.4-8 33.6-17.6 40-65.6 42.4-110.4 0-8 6.4-14.4 13.6-15.2 8-0.8 15.2 4 17.6 11.2 5.6 17.6 3.2 36 1.6 52-2.4 22.4-3.2 36 5.6 45.6 8.8 8.8 23.2 8.8 44.8 7.2 13.6-0.8 28-1.6 42.4 1.6 8.8 1.6 14.4 10.4 12 19.2s-10.4 14.4-19.2 12c-7.2-0.8-18.4 0-31.2 0-24 1.6-50.4 3.2-70.4-16.8-3.2-3.2-6.4-7.2-8-10.4-8.8 13.6-20 24.8-35.2 33.6-13.6 7.2-28 10.4-43.2 12-5.6 24-20.8 44-41.6 52-4 1.6-8.8 2.4-14.4 2.4z m-8-33.6c2.4 1.6 8 2.4 11.2 1.6 8-3.2 13.6-9.6 17.6-16.8-11.2 2.4-20.8 6.4-28 14.4l-0.8 0.8zM350.4 932c-4.8 0-8.8-0.8-13.6-1.6-29.6-8-42.4-40-42.4-67.2 0-41.6 21.6-78.4 39.2-108 7.2-12.8 16-28 29.6-39.2l9.6-7.2c-4 0-7.2 0-11.2-1.6-12-3.2-22.4-11.2-28-21.6-9.6-16.8-8.8-35.2-7.2-49.6 3.2-28 12.8-48.8 27.2-62.4 11.2-10.4 27.2-15.2 43.2-14.4 12.8 0.8 24.8 7.2 32 16.8 4.8 6.4 8 14.4 9.6 20.8 5.6 16.8 9.6 33.6 12.8 50.4 0.8-0.8 0.8-1.6 1.6-2.4 6.4-11.2 12-22.4 20.8-32.8 4.8-6.4 12.8-15.2 24.8-19.2 12.8-4.8 25.6-2.4 35.2 5.6 2.4-2.4 4.8-4 8-5.6 11.2-6.4 25.6-7.2 38.4-3.2 12.8 4.8 23.2 14.4 28 26.4 4.8 12.8 4 24.8 3.2 36 0 2.4-0.8 5.6-0.8 8-0.8 9.6 2.4 16 4.8 17.6 2.4 0.8 8.8-0.8 14.4-6.4 2.4-2.4 5.6-5.6 8-8.8 4.8-6.4 11.2-12.8 19.2-18.4 7.2-4.8 17.6-3.2 22.4 4 4.8 7.2 3.2 17.6-4 22.4-4 3.2-8 8-12.8 12.8-3.2 4-6.4 7.2-10.4 11.2-12 12-31.2 21.6-49.6 12.8-16-7.2-24.8-24.8-24-48 0-3.2 0.8-6.4 0.8-9.6 0.8-8 1.6-16-0.8-21.6-1.6-3.2-4.8-6.4-8.8-8-4-1.6-8.8-1.6-12 0.8-6.4 3.2-9.6 11.2-12 20.8 0 19.2-2.4 38.4-5.6 56.8-1.6 8-9.6 13.6-17.6 12.8-8.8-0.8-14.4-8.8-13.6-16.8l3.2-36c0.8-5.6 0.8-12.8 2.4-20V632c0-6.4-0.8-8-0.8-8h-3.2c-3.2 0.8-6.4 4-10.4 8.8-6.4 8-12 17.6-17.6 28-7.2 12.8-14.4 25.6-24 36.8 2.4 62.4-11.2 125.6-39.2 181.6-6.4 12.8-14.4 27.2-27.2 38.4-13.6 8.8-28 14.4-41.6 14.4zM424.8 720c-4.8 2.4-8.8 4-13.6 5.6-10.4 4-20 8-27.2 14.4-8.8 7.2-16 19.2-22.4 30.4-16 28-34.4 59.2-34.4 92 0 15.2 6.4 32.8 18.4 36 7.2 1.6 16-0.8 23.2-7.2 8.8-7.2 14.4-17.6 20-28 22.4-44 34.4-93.6 36-143.2z m-42.4-46.4c5.6 0 10.4 2.4 13.6 8 3.2 4.8 3.2 11.2 0.8 15.2 0.8 0 1.6-0.8 2.4-0.8 8.8-4 17.6-7.2 24.8-12.8-2.4-25.6-7.2-52-15.2-76.8-1.6-4-3.2-8.8-4.8-11.2-2.4-3.2-6.4-4-9.6-4.8-6.4-0.8-13.6 1.6-18.4 6.4-8.8 8-14.4 21.6-16.8 42.4-0.8 9.6-1.6 21.6 3.2 29.6 1.6 3.2 5.6 5.6 8.8 6.4 1.6 0 3.2 0.8 4 0 1.6-0.8 4.8-1.6 7.2-1.6zM245.6 536c-8.8 0-16-7.2-16-16v-13.6c0-8.8 7.2-16 16-16s16 7.2 16 16V520c0 9.6-7.2 16-16 16zM666.4 672c-2.4 0-5.6-0.8-8-2.4-5.6-3.2-8.8-8.8-8-15.2L660.8 528c0-2.4 0.8-4.8 2.4-6.4l231.2-408.8c4.8-8 12-14.4 20-17.6 9.6-4 19.2-3.2 28 1.6l61.6 35.2c8 4.8 13.6 12.8 15.2 23.2 1.6 8.8 0 18.4-4.8 26.4l-231.2 408c-0.8 2.4-2.4 4-4.8 4.8l-103.2 74.4c-2.4 2.4-5.6 3.2-8.8 3.2z m25.6-137.6l-7.2 88 72-52 229.6-406.4c1.6-3.2 1.6-5.6 0.8-6.4l-61.6-35.2s-2.4 1.6-4 4.8L692 534.4zM960.8 250.4c-1.6 0-2.4 0-4-0.8L864 197.6c-4-2.4-5.6-7.2-3.2-11.2l39.2-69.6c4-6.4 9.6-12 16-14.4 7.2-3.2 14.4-2.4 20.8 0.8l61.6 35.2c6.4 3.2 10.4 9.6 11.2 17.6 0.8 7.2 0 14.4-4 21.6l-39.2 69.6c-0.8 1.6-2.4 3.2-4.8 4 0.8-0.8 0-0.8-0.8-0.8z m-81.6-63.2l78.4 44.8 35.2-63.2c1.6-3.2 2.4-7.2 2.4-11.2 0-1.6-0.8-4.8-4-5.6l-61.6-35.2c-2.4-1.6-5.6-0.8-7.2 0-3.2 1.6-6.4 4-8 7.2l-35.2 63.2z" ></path></svg>

// for guestbookedit
const iconstyle = { width: '100%', height: '50%', verticalAlign: 'middle', fill: 'currentColor', overflow: 'hidden' }
export const LOOKUP_ICON = <svg style={iconstyle} viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5355"><path d="M85.333333 512c40.32-194.730667 216.021333-341.333333 426.666667-341.333333s386.346667 146.602667 426.666667 341.333333c-40.32 194.730667-216.021333 341.333333-426.666667 341.333333s-386.346667-146.602667-426.666667-341.333333z m426.666667 213.333333a213.333333 213.333333 0 1 0 0-426.666666 213.333333 213.333333 0 0 0 0 426.666666z m0-85.333333a128 128 0 1 0 0-256 128 128 0 0 0 0 256z" fill="#000000"></path></svg>
export const MOD_ICON = <svg style={iconstyle} viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3070"><path d="M952.087273 145.92C938.356364 91.461818 863.185455 0 512 0 346.530909 0 226.443636 18.152727 154.996364 53.992727 75.869091 93.090909 69.818182 147.316364 69.818182 162.909091v309.527273a535.272727 535.272727 0 0 0 272.756363 466.618181l135.214546 75.869091a69.818182 69.818182 0 0 0 68.421818 0l135.214546-75.869091A535.272727 535.272727 0 0 0 954.181818 472.436364V162.909091a69.818182 69.818182 0 0 0-2.094545-16.989091zM884.363636 472.436364a465.454545 465.454545 0 0 1-237.149091 405.643636L512 954.181818l-135.214545-76.101818A465.454545 465.454545 0 0 1 139.636364 472.436364V162.909091s0-93.090909 372.363636-93.090909c349.090909 0 372.363636 93.090909 372.363636 93.090909z" p-id="3071"></path><path d="M720.058182 324.421818L488.727273 555.752727l-138.24-138.24a34.909091 34.909091 0 0 0-49.338182 49.338182l162.909091 162.909091a34.909091 34.909091 0 0 0 49.338182 0l256-256a34.909091 34.909091 0 0 0-49.338182-49.338182z" p-id="3072"></path></svg>
export const PROJECTOR_ICON = <svg style={iconstyle} viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="18182"><path d="M213.333333 554.666667h85.333334v85.333333H213.333333zM341.333333 554.666667h85.333334v85.333333H341.333333zM938.666667 213.333333h-21.333334c-46.933333-51.2-115.2-85.333333-192-85.333333s-145.066667 34.133333-192 85.333333H85.333333c-25.6 0-42.666667 17.066667-42.666666 42.666667v512c0 25.6 17.066667 42.666667 42.666666 42.666667v85.333333h85.333334v-85.333333h682.666666v85.333333h85.333334v-85.333333c25.6 0 42.666667-17.066667 42.666666-42.666667V256c0-25.6-17.066667-42.666667-42.666666-42.666667z m-42.666667 512H128V298.666667h354.133333c-8.533333 25.6-12.8 55.466667-12.8 85.333333 0 140.8 115.2 256 256 256 64 0 123.733333-25.6 170.666667-64V725.333333z m-170.666667-170.666666c-93.866667 0-170.666667-76.8-170.666666-170.666667 0-29.866667 8.533333-59.733333 21.333333-85.333333 29.866667-51.2 85.333333-85.333333 149.333333-85.333334 59.733333 0 110.933333 29.866667 140.8 76.8 4.266667 4.266667 4.266667 8.533333 4.266667 8.533334 17.066667 25.6 25.6 55.466667 25.6 85.333333 0 93.866667-76.8 170.666667-170.666667 170.666667z" p-id="18183"></path></svg>
export const GUESTCHAR_ICON = <svg style={iconstyle} viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5355"><path d="M508 557.8c32.8-35.1 52.9-82.2 52.9-133.9 0-108.2-88-196.2-196.2-196.2s-196.2 88-196.2 196.2c0 51.9 20.3 99.1 53.3 134.3-21 12.2-40.5 27.3-58.2 44.9-53.8 53.8-83.5 125.4-83.5 201.6 0 46.2 11.4 79 34.7 100.1 37.5 33.9 93.3 28.1 157.8 21.5 29.6-3 60.2-6.2 92.5-6.2s62.9 3.1 92.5 6.2c25.2 2.6 49.1 5 71.1 5 34.3 0 63.9-5.9 86.7-26.6 23.4-21.1 34.7-53.8 34.7-100.1 0-76.1-29.7-147.7-83.5-201.6-17.6-17.8-37.4-32.9-58.6-45.2zM364.7 291.7c72.9 0 132.2 59.3 132.2 132.2 0 72.9-59.3 132.2-132.2 132.2s-132.2-59.3-132.2-132.2c0.1-72.9 59.4-132.2 132.2-132.2z m208 565.5c-16.4 14.8-61.1 10.2-108.4 5.4-29.8-3-63.5-6.5-99-6.5s-69.2 3.5-99 6.5c-47.3 4.8-92 9.4-108.4-5.4-9-8.2-13.6-25.8-13.6-52.6 0-91.6 56.1-170.4 135.7-203.9 25.7 12.4 54.5 19.3 84.9 19.3 33.1 0 64.3-8.3 91.7-22.8-1.1 1.5-2.3 3-3.6 4.4 78.4 34 133.4 112.2 133.4 202.9-0.1 26.8-4.7 44.5-13.7 52.7zM858.8 466.7c-17.8-17.8-37.6-32.9-58.8-45.3 33.3-35.6 53.5-83.6 52.9-136.2-0.3-23-4.5-45-12.1-65.5 0-0.1-0.1-0.2-0.1-0.4-0.3-0.7-0.5-1.4-0.8-2.1-28-73.3-98.8-125.9-181.6-126.6-68.7-0.6-129.4 34.2-165 87.4-14.2 21.3 1 49.8 26.6 49.8 10.7 0 20.6-5.3 26.6-14.2 5.1-7.6 11-14.7 17.5-21.1 1.7-1 3.4-2.2 5-3.6 24-21.3 55.7-34.1 90.4-33.4 56.7 1.1 104.9 38.3 122.5 89.5 4.8 14.2 7.2 29.5 6.8 45.3-1.7 67.6-54.9 123.6-122.4 128.4-3.2 0.2-6.4 0.3-9.5 0.4-2.1 0-4.2 0.2-6.2 0.6-14.9 0-27.9 10.5-30.9 25.2 0 0.2-0.1 0.4-0.1 0.6-4 19.1 10.1 37.3 29.6 38.1 2.5 0.1 5 0.1 7.6 0.1 30.7 0 59.7-7.1 85.6-19.7 78.4 34 136 113.5 136 204.2 0 26.7-4.6 44.4-13.6 52.6-16.4 14.8-61.1 10.2-108.4 5.4-9-0.9-28.6-2.7-29-2.5-17.4 0.3-31.4 14.5-31.4 31.9s13.9 31.5 31.1 31.9c0.1 0.1 15.4 1.6 22.7 2.4 25.2 2.6 49.1 5 71.1 5 34.3 0 63.9-5.9 86.7-26.6 23.4-21.1 34.7-53.8 34.7-100.1 0-76.1-29.7-147.7-83.5-201.5z" p-id="5356"></path></svg>
export const LOOKUPUNSTYLE_ICON = <svg style={{ width: 24, height: 24, marginRight: 5, fill: 'inherit' }} viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5355"><path d="M85.333333 512c40.32-194.730667 216.021333-341.333333 426.666667-341.333333s386.346667 146.602667 426.666667 341.333333c-40.32 194.730667-216.021333 341.333333-426.666667 341.333333s-386.346667-146.602667-426.666667-341.333333z m426.666667 213.333333a213.333333 213.333333 0 1 0 0-426.666666 213.333333 213.333333 0 0 0 0 426.666666z m0-85.333333a128 128 0 1 0 0-256 128 128 0 0 0 0 256z"></path></svg>

export const TIMEFRAMEICON_SIZE = 36

export const ICONNAME_ICON_MAP = [
    <div style={{ width: 36, height: 40, border: 'thin dashed #707070', display: 'block', backgroundColor: 'white', zIndex: 2 }} />,
    "M512 1020c-52.8 0-95.2-42.4-95.2-95.2 0-8.8 7.2-16 16-16s16 7.2 16 16c0 35.2 28 63.2 63.2 63.2s63.2-28 63.2-63.2c0-8.8 7.2-16 16-16s16 7.2 16 16c0 52.8-42.4 95.2-95.2 95.2zM941.6 940.8H82.4c-6.4 0-12-4-14.4-9.6-2.4-5.6-1.6-12 2.4-16.8 112-130.4 174.4-296.8 174.4-468.8v-7.2c0-148 120-268 268-268s268 120 268 268v7.2c0 172 61.6 338.4 174.4 468.8 4 4.8 4.8 11.2 2.4 16.8-4 5.6-9.6 9.6-16 9.6z m-825.6-32h792c-103.2-132-160-295.2-160-463.2v-7.2c0-129.6-105.6-236-236-236S276 308 276 438.4v7.2c0 168-56 331.2-160 463.2zM272 211.2c-23.2 0-42.4-3.2-54.4-11.2-21.6-13.6-16-38.4-11.2-57.6 2.4-10.4 4.8-20.8 4.8-31.2 0-10.4-3.2-21.6-5.6-32.8-4.8-21.6-11.2-48.8 11.2-64 40-25.6 153.6-1.6 241.6 22.4 5.6 1.6 9.6 5.6 11.2 11.2s0 11.2-4 15.2c-11.2 12-17.6 27.2-17.6 44s6.4 32 17.6 44c4 4 5.6 9.6 4 15.2s-5.6 9.6-11.2 11.2c-60.8 16.8-134.4 33.6-186.4 33.6z m-2.4-175.2c-16.8 0-28.8 2.4-35.2 6.4-4 2.4 0 17.6 2.4 29.6s5.6 25.6 6.4 39.2c0 14.4-3.2 27.2-5.6 39.2-1.6 7.2-4.8 20-3.2 23.2 20.8 13.6 96 5.6 194.4-20-7.2-13.6-11.2-29.6-11.2-45.6s4-31.2 11.2-45.6c-67.2-17.6-123.2-26.4-159.2-26.4zM752 211.2c-52.8 0-126.4-16.8-187.2-33.6-5.6-1.6-9.6-5.6-11.2-11.2-1.6-5.6 0-11.2 4-15.2 11.2-12 17.6-27.2 17.6-44 0-16-6.4-32-17.6-44-4-4-5.6-9.6-4-15.2 1.6-5.6 5.6-9.6 11.2-11.2 88-24 201.6-48 241.6-22.4 21.6 13.6 16 38.4 11.2 57.6-2.4 10.4-4.8 20.8-4.8 31.2 0 10.4 3.2 21.6 5.6 32.8 4.8 21.6 11.2 48.8-11.2 64-12.8 8-32 11.2-55.2 11.2z m-156-58.4c98.4 25.6 172.8 33.6 193.6 20 4-2.4 0-17.6-2.4-29.6s-5.6-25.6-6.4-39.2c0-14.4 3.2-27.2 5.6-39.2 1.6-7.2 4.8-20 3.2-23.2-20.8-13.6-96-5.6-194.4 20 7.2 13.6 11.2 29.6 11.2 45.6 0.8 16-3.2 32-10.4 45.6zM512 202.4c-52.8 0-95.2-42.4-95.2-95.2 0-52.8 42.4-95.2 95.2-95.2 52.8 0 95.2 42.4 95.2 95.2 0 52.8-42.4 95.2-95.2 95.2z m0-158.4c-35.2 0-63.2 28-63.2 63.2s28 63.2 63.2 63.2 63.2-28 63.2-63.2c0-34.4-28-63.2-63.2-63.2zM856.8 811.2H167.2c-4.8 0-8-3.2-8-8s3.2-8 8-8h689.6c4.8 0 8 3.2 8 8s-3.2 8-8 8z",
    "M1004 298.4H20c-4.8 0-8-3.2-8-8V107.2c0-4.8 3.2-8 8-8h984c4.8 0 8 3.2 8 8v183.2c0 4-3.2 8-8 8z m-976-16h968V115.2H28v167.2zM1004 1020H20c-8.8 0-16-7.2-16-16V107.2c0-8.8 7.2-16 16-16h984c8.8 0 16 7.2 16 16v896.8c0 8.8-7.2 16-16 16z m-968-32h952V123.2H36v864.8zM158.4 210.4c-8.8 0-16-7.2-16-16V20c0-8.8 7.2-16 16-16s16 7.2 16 16v174.4c0 8.8-7.2 16-16 16zM291.2 210.4c-8.8 0-16-7.2-16-16V20c0-8.8 7.2-16 16-16s16 7.2 16 16v174.4c0 8.8-7.2 16-16 16zM732.8 210.4c-8.8 0-16-7.2-16-16V20c0-8.8 7.2-16 16-16s16 7.2 16 16v174.4c0 8.8-7.2 16-16 16zM865.6 210.4c-8.8 0-16-7.2-16-16V20c0-8.8 7.2-16 16-16s16 7.2 16 16v174.4c0 8.8-7.2 16-16 16zM586.4 862.4c-1.6 0-4-0.8-5.6-2.4 0 0-33.6-32-74.4-75.2-3.2-3.2-3.2-8 0-11.2 3.2-3.2 8-3.2 11.2 0 30.4 32.8 57.6 58.4 68 68.8C620 809.6 800 632 800 560.8c0-63.2-51.2-114.4-114.4-114.4-25.6 0-49.6 8-69.6 23.2-3.2 2.4-8.8 2.4-11.2-1.6-2.4-3.2-2.4-8.8 1.6-11.2 23.2-17.6 50.4-26.4 79.2-26.4 72 0 130.4 58.4 130.4 130.4 0 84.8-216 289.6-224.8 298.4-0.8 2.4-3.2 3.2-4.8 3.2zM437.6 862.4c-1.6 0-4-0.8-5.6-2.4-8.8-8.8-224.8-212.8-224.8-298.4 0-72 58.4-130.4 130.4-130.4 38.4 0 75.2 17.6 100 47.2 24.8-29.6 61.6-47.2 100-47.2 72 0 130.4 58.4 130.4 130.4 0 84.8-216 289.6-224.8 298.4-1.6 1.6-3.2 2.4-5.6 2.4zM337.6 448c-63.2 0-114.4 51.2-114.4 114.4 0 72 180 248.8 214.4 281.6 34.4-32.8 214.4-210.4 214.4-281.6 0-63.2-51.2-114.4-114.4-114.4-36.8 0-72 18.4-93.6 48.8-3.2 4-10.4 4-12.8 0-21.6-31.2-56-48.8-93.6-48.8z",
    "M805.6 924.8h-168c-6.4 0-11.2-3.2-14.4-8.8-2.4-5.6-2.4-12 1.6-16.8l84-112.8c6.4-8 20-8 25.6 0l84 112.8c4 4.8 4 11.2 1.6 16.8-3.2 5.6-8.8 8.8-14.4 8.8z m-136-32h104l-52-70.4-52 70.4zM364.8 818.4C161.6 818.4 4 566.4 4 349.6c0-107.2 36.8-196 106.4-257.6 64-56.8 154.4-88 254.4-88s190.4 31.2 254.4 88c69.6 61.6 106.4 150.4 106.4 257.6 0 216.8-157.6 468.8-360.8 468.8z m0-782.4c-200 0-328.8 123.2-328.8 313.6 0 202.4 144 436.8 328.8 436.8s328.8-235.2 328.8-436.8c0-190.4-128.8-313.6-328.8-313.6zM721.6 812c-63.2 0-124-28.8-176.8-83.2-3.2-3.2-4.8-7.2-4.8-11.2 0-4 1.6-8 4.8-11.2C635.2 620 693.6 480 693.6 349.6c0-69.6-16.8-129.6-48.8-179.2-3.2-4.8-3.2-10.4-1.6-15.2 2.4-4.8 6.4-8.8 12-9.6 21.6-4 43.2-5.6 65.6-5.6 178.4 0 298.4 115.2 298.4 285.6 0.8 178.4-129.6 386.4-297.6 386.4zM578.4 717.6c44 40.8 92.8 62.4 143.2 62.4 150.4 0 266.4-190.4 266.4-355.2 0-154.4-104.8-253.6-266.4-253.6-12.8 0-24.8 0.8-36.8 1.6 27.2 50.4 41.6 109.6 41.6 176-0.8 133.6-57.6 276.8-148 368.8zM940 433.6c-4.8 0-8-3.2-8-8 0-158.4-124-189.6-176.8-196-4-0.8-7.2-4.8-7.2-8.8 0.8-4 4.8-7.2 8.8-7.2 119.2 13.6 191.2 92.8 191.2 212 0 4-3.2 8-8 8zM617.6 368.8c-4.8 0-8-3.2-8-8 0-141.6-96-233.6-244.8-233.6-4.8 0-8-3.2-8-8s3.2-8 8-8c158.4 0 260.8 97.6 260.8 249.6 0 4.8-3.2 8-8 8zM467.2 936.8H262.4c-6.4 0-12-4-14.4-9.6-2.4-5.6-1.6-12 2.4-16.8L352.8 792c6.4-7.2 18.4-7.2 24 0l102.4 118.4c4 4.8 4.8 11.2 2.4 16.8-2.4 5.6-8 9.6-14.4 9.6z m-169.6-32H432l-67.2-78.4-67.2 78.4zM584.8 1020c-0.8 0-2.4 0-3.2-0.8-8.8-1.6-14.4-10.4-12-19.2 5.6-25.6-12.8-52.8-32-76.8-17.6-22.4-37.6-44.8-61.6-62.4-17.6-12.8-46.4-28.8-80-31.2-8.8-0.8-15.2-8-15.2-16.8s8-15.2 16.8-15.2c41.6 2.4 76 21.6 97.6 37.6 27.2 20 48.8 44.8 68 68 24 29.6 47.2 65.6 38.4 104-2.4 8-9.6 12.8-16.8 12.8zM949.6 1020c-0.8 0-2.4 0-3.2-0.8-8.8-1.6-14.4-10.4-12-19.2 5.6-25.6-12.8-52.8-32-76.8-17.6-22.4-37.6-44.8-61.6-62.4-17.6-12.8-46.4-28.8-80-31.2-8.8-0.8-15.2-8-15.2-16.8s8-15.2 16.8-15.2c41.6 2.4 76 21.6 97.6 37.6 27.2 20 48.8 44.8 68 68 24 29.6 47.2 65.6 38.4 104-3.2 8-9.6 12.8-16.8 12.8z",
    "M844.8 256.8c-4 0-8-1.6-11.2-4.8l-61.6-61.6c-4.8-4.8-6.4-12.8-2.4-19.2L824 77.6c2.4-4 7.2-7.2 12-8 4.8-0.8 9.6 0.8 13.6 4.8l100.8 100.8c3.2 3.2 4.8 8.8 4.8 13.6-0.8 4.8-3.2 9.6-8 12l-93.6 54.4c-4 0.8-6.4 1.6-8.8 1.6z m-41.6-80l44 44 65.6-37.6-71.2-71.2-38.4 64.8zM236.8 1020c-12 0-23.2-4.8-31.2-12.8L16.8 818.4c-8-8-12.8-19.2-12.8-31.2s4.8-23.2 12.8-31.2L340.8 432c36-36 84.8-60 135.2-67.2 44-5.6 85.6-26.4 116.8-57.6l96.8-96.8c6.4-6.4 16-6.4 22.4 0l100.8 100.8c3.2 3.2 4.8 7.2 4.8 11.2s-1.6 8-4.8 11.2L717.6 430.4c-31.2 31.2-52 72.8-57.6 116.8-7.2 51.2-30.4 99.2-67.2 135.2l-324 324c-8.8 8.8-20 13.6-32 13.6z m464.8-776L616 329.6c-36 36-84.8 60-135.2 67.2-44 5.6-85.6 26.4-116.8 57.6L39.2 778.4c-2.4 2.4-3.2 5.6-3.2 8.8 0 3.2 1.6 6.4 3.2 8.8l188.8 188.8c4.8 4.8 12.8 4.8 16.8 0l324-324c31.2-31.2 52-72.8 57.6-116.8 7.2-51.2 30.4-99.2 67.2-135.2l84.8-84.8-76.8-80zM698.4 146.4c-4 0-8-1.6-11.2-4.8L616 70.4c-6.4-6.4-6.4-16 0-22.4 6.4-6.4 16-6.4 22.4 0l70.4 70.4c6.4 6.4 6.4 16 0 22.4-2.4 4-6.4 5.6-10.4 5.6zM735.2 104.8c-6.4 0-12-3.2-14.4-9.6l-31.2-68.8c-4-8 0-17.6 8-20.8 8-4 17.6 0 20.8 8l31.2 68.8c4 8 0 17.6-8 20.8-1.6 0.8-4 1.6-6.4 1.6zM656.8 183.2c-2.4 0-4.8-0.8-6.4-1.6l-68.8-31.2c-8-4-12-12.8-8-20.8s12.8-12 20.8-8l68.8 31.2c8 4 12 12.8 8 20.8-2.4 6.4-8.8 9.6-14.4 9.6zM964.8 412.8c-4 0-8-1.6-11.2-4.8l-70.4-70.4c-6.4-6.4-6.4-16 0-22.4 6.4-6.4 16-6.4 22.4 0l70.4 70.4c6.4 6.4 6.4 16 0 22.4-3.2 3.2-7.2 4.8-11.2 4.8zM888 452c-6.4 0-12-3.2-14.4-9.6l-31.2-68.8c-4-8 0-17.6 8-20.8 8-4 17.6 0 20.8 8l31.2 68.8c4 8 0 17.6-8 20.8-2.4 0.8-4.8 1.6-6.4 1.6zM1004 335.2c-2.4 0-4.8-0.8-6.4-1.6l-68.8-31.2c-8-4-12-12.8-8-20.8s12.8-12 20.8-8l68.8 31.2c8 4 12 12.8 8 20.8-2.4 6.4-8 9.6-14.4 9.6zM328.8 932c-2.4 0-4-0.8-5.6-2.4L192 798.4c-3.2-3.2-3.2-8 0-11.2l199.2-199.2c3.2-3.2 8-3.2 11.2 0l131.2 131.2c3.2 3.2 3.2 8 0 11.2l-199.2 199.2c-1.6 1.6-4 2.4-5.6 2.4z m-120-139.2l120 120 188-188-120-120-188 188zM728 404.8c-2.4 0-4-0.8-5.6-2.4L621.6 301.6c-3.2-3.2-3.2-8 0-11.2L696 216c3.2-3.2 8-3.2 11.2 0L808 316.8c1.6 1.6 2.4 3.2 2.4 5.6s-0.8 4-2.4 5.6l-74.4 74.4c-0.8 1.6-3.2 2.4-5.6 2.4zM638.4 296L728 385.6l63.2-63.2-89.6-89.6-63.2 63.2z",
    "M1004 1020H20c-8.8 0-16-7.2-16-16V186.4c0-8.8 7.2-16 16-16h984c8.8 0 16 7.2 16 16v817.6c0 8.8-7.2 16-16 16z m-968-32h952V202.4H36v785.6zM722.4 202.4H301.6c-8.8 0-16-7.2-16-16V20c0-8.8 7.2-16 16-16h420.8c8.8 0 16 7.2 16 16v166.4c0 8.8-7.2 16-16 16z m-404.8-32h388.8V36H317.6v134.4zM597.6 815.2c-1.6 0-4-0.8-5.6-2.4-0.8 0-40.8-38.4-86.4-88-3.2-3.2-3.2-8 0.8-11.2 3.2-3.2 8-3.2 11.2 0.8 36 38.4 68 69.6 80 81.6 34.4-33.6 219.2-215.2 219.2-287.2 0-64.8-52.8-116.8-116.8-116.8-29.6 0-58.4 11.2-80 32-3.2 3.2-8 3.2-11.2 0-3.2-3.2-3.2-8 0-11.2 24.8-24 57.6-36.8 91.2-36.8 73.6 0 132.8 59.2 132.8 132.8 0 86.4-220 295.2-229.6 304.8-1.6 0.8-3.2 1.6-5.6 1.6zM426.4 815.2c-1.6 0-4-0.8-5.6-2.4-9.6-8.8-229.6-216.8-229.6-304.8 0-73.6 59.2-132.8 132.8-132.8 39.2 0 76.8 17.6 102.4 48 24.8-30.4 62.4-48 102.4-48 73.6 0 132.8 59.2 132.8 132.8 0 86.4-220 295.2-229.6 304.8-2.4 1.6-4 2.4-5.6 2.4z m-102.4-424c-64.8 0-116.8 52.8-116.8 116.8 0 73.6 184.8 254.4 219.2 287.2 34.4-33.6 219.2-215.2 219.2-287.2 0-64.8-52.8-116.8-116.8-116.8-37.6 0-73.6 18.4-95.2 49.6-3.2 4-10.4 4-12.8 0-23.2-31.2-59.2-49.6-96.8-49.6z",
    "M1004 857.6H20c-8.8 0-16-7.2-16-16V182.4c0-8.8 7.2-16 16-16h984c8.8 0 16 7.2 16 16v659.2c0 8.8-7.2 16-16 16z m-968-32h952V198.4H36v627.2zM512 685.6c-1.6 0-4-0.8-5.6-2.4-7.2-6.4-171.2-162.4-171.2-228 0-56 45.6-100.8 100.8-100.8 29.6 0 56.8 12.8 76 34.4 19.2-21.6 46.4-34.4 76-34.4 56 0 100.8 45.6 100.8 100.8 0 64-153.6 211.2-171.2 228-1.6 1.6-4 2.4-5.6 2.4z m-76-315.2c-47.2 0-84.8 38.4-84.8 84.8 0 47.2 111.2 164 160.8 211.2 49.6-48 160.8-164.8 160.8-211.2 0-47.2-38.4-84.8-84.8-84.8-27.2 0-53.6 13.6-69.6 36-3.2 4-10.4 4-12.8 0-16-22.4-42.4-36-69.6-36zM1004 849.6H20c-3.2 0-6.4-2.4-8-5.6-0.8-3.2 0-7.2 3.2-8.8l392-268.8c3.2-2.4 8-1.6 10.4 1.6 38.4 43.2 80 84 94.4 98.4 14.4-14.4 56-55.2 93.6-99.2 2.4-3.2 7.2-4 10.4-1.6l392.8 268.8c3.2 1.6 4 5.6 3.2 8.8-1.6 4-4.8 6.4-8 6.4z m-958.4-16h932L612.8 583.2C568 636 518.4 682.4 517.6 683.2c-3.2 3.2-8 3.2-11.2 0-0.8-0.8-50.4-47.2-95.2-100L45.6 833.6zM669.6 419.2h-1.6c-2.4-0.8-4-1.6-4.8-4-15.2-28-43.2-44.8-75.2-44.8-27.2 0-53.6 13.6-69.6 36-3.2 4-10.4 4-12.8 0-16-22.4-41.6-36-69.6-36-31.2 0-60 17.6-75.2 44.8-0.8 2.4-3.2 3.2-4.8 4-2.4 0.8-4.8 0-6.4-0.8L15.2 188.8c-3.2-1.6-4-5.6-3.2-8.8 0.8-3.2 4-5.6 8-5.6h984c3.2 0 6.4 2.4 8 5.6 0.8 3.2 0 7.2-3.2 8.8L674.4 418.4c-1.6 0.8-3.2 0.8-4.8 0.8z m-81.6-64.8c34.4 0 65.6 17.6 84.8 45.6l305.6-209.6H45.6L351.2 400c18.4-28.8 50.4-45.6 84.8-45.6 29.6 0 56.8 12.8 76 34.4 19.2-21.6 46.4-34.4 76-34.4z",
    "M1004 1020h-84.8c-6.4 0-12.8-4-15.2-10.4l-13.6-36H133.6l-13.6 36c-2.4 6.4-8 10.4-15.2 10.4H20c-8.8 0-16-7.2-16-16V766.4c0-2.4 0.8-4.8 1.6-6.4l137.6-300.8v-152C143.2 140 279.2 4 446.4 4h132c167.2 0 303.2 136 303.2 303.2v152.8L1018.4 760c0.8 2.4 1.6 4 1.6 6.4v237.6c0 8.8-7.2 16-16 16z m-73.6-32h57.6V770.4l-137.6-299.2c-1.6-2.4-1.6-4.8-1.6-8V307.2c0-149.6-121.6-271.2-271.2-271.2H446.4c-149.6 0-271.2 121.6-271.2 271.2v156c0 3.2-0.8 5.6-1.6 8L36 770.4v217.6h57.6l13.6-36c2.4-6.4 8-10.4 15.2-10.4h779.2c6.4 0 12.8 4 15.2 10.4l13.6 36zM1004 774.4H20c-2.4 0-5.6-1.6-6.4-4-1.6-2.4-1.6-4.8-0.8-8l139.2-304c1.6-3.2 4-4.8 7.2-4.8h705.6c3.2 0 5.6 1.6 7.2 4.8l139.2 304c0.8 2.4 0.8 5.6-0.8 8-0.8 3.2-4 4-6.4 4z m-971.2-16H992l-132-288h-696l-131.2 288zM451.2 471.2h-208c-4.8 0-8-3.2-8-8V346.4c0-4.8 3.2-8 8-8h208c4.8 0 8 3.2 8 8v116.8c0 4-4 8-8 8z m-200-16h192V354.4h-192v100.8zM780.8 471.2h-208c-4.8 0-8-3.2-8-8V346.4c0-4.8 3.2-8 8-8h208c4.8 0 8 3.2 8 8v116.8c0 4-4 8-8 8z m-200-16h192V354.4h-192v100.8zM512 313.6c-1.6 0-4-0.8-5.6-2.4C496.8 301.6 408 217.6 408 179.2c0-33.6 27.2-60.8 60.8-60.8 16 0 32 6.4 43.2 17.6 11.2-11.2 27.2-17.6 43.2-17.6 33.6 0 60.8 27.2 60.8 60.8 0 37.6-88 122.4-98.4 132-1.6 1.6-4 2.4-5.6 2.4z m-43.2-179.2c-24.8 0-44.8 20-44.8 44.8 0 22.4 52 80 88 115.2 36-35.2 88-92.8 88-115.2 0-24.8-20-44.8-44.8-44.8-14.4 0-28 7.2-36.8 19.2-3.2 4-10.4 4-12.8 0-8.8-12-22.4-19.2-36.8-19.2z",
    "M698.4 703.2H333.6c-5.6 0-10.4-2.4-12.8-7.2 0-0.8-40.8-59.2-84.8-135.2-4.8-8-1.6-17.6 5.6-21.6 8-4.8 17.6-1.6 21.6 5.6 35.2 60 67.2 108.8 78.4 126.4h347.2c12-17.6 44-66.4 78.4-126.4 4.8-8 14.4-10.4 21.6-5.6 8 4.8 10.4 14.4 5.6 21.6C752 636.8 712 695.2 711.2 696c-3.2 4-8 7.2-12.8 7.2zM249.6 560.8c-3.2 0-6.4-2.4-8-5.6-1.6-4 0.8-8.8 5.6-10.4 32-10.4 68-18.4 107.2-24V84c0-4.8 3.2-8 8-8s8 3.2 8 8v443.2c0 4-3.2 7.2-7.2 8-40.8 6.4-78.4 14.4-111.2 24.8-0.8 0-1.6 0.8-2.4 0.8zM249.6 568.8c-5.6 0-11.2-3.2-13.6-8-112-194.4-148.8-323.2-108-382.4 36-52 118.4-91.2 232-109.6 8.8-1.6 16.8 4.8 18.4 12.8 1.6 8.8-4 16.8-12.8 18.4-105.6 17.6-180 52-211.2 96.8-32 46.4 8 172.8 108.8 348 4.8 8 1.6 17.6-5.6 21.6-2.4 1.6-4.8 2.4-8 2.4zM782.4 568.8c-2.4 0-5.6-0.8-8-2.4-8-4.8-10.4-14.4-5.6-21.6 100.8-175.2 140.8-301.6 108.8-348-30.4-44.8-105.6-79.2-210.4-96.8-8.8-1.6-14.4-9.6-12.8-18.4 1.6-8.8 9.6-14.4 18.4-12.8 113.6 19.2 196 58.4 231.2 110.4 40.8 59.2 4.8 188-107.2 381.6-4 4.8-9.6 8-14.4 8zM782.4 560.8h-2.4c-32.8-10.4-70.4-18.4-111.2-24.8-4-0.8-7.2-4-7.2-8V84c0-4.8 3.2-8 8-8s8 3.2 8 8V520c39.2 6.4 75.2 14.4 107.2 24 4 1.6 6.4 5.6 5.6 10.4-1.6 4-4.8 6.4-8 6.4zM362.4 100c-8 0-14.4-5.6-16-13.6-1.6-8.8 4-16.8 12.8-18.4 99.2-16.8 212.8-16.8 312 0 8.8 1.6 14.4 9.6 12.8 18.4-1.6 8.8-9.6 14.4-18.4 12.8-96-16-205.6-16-301.6 0 0 0.8-0.8 0.8-1.6 0.8zM669.6 535.2h-0.8c-98.4-14.4-206.4-14.4-304.8 0-2.4 0-4.8 0-6.4-1.6-1.6-1.6-2.4-4-2.4-6.4V84c0-4.8 3.2-8 8-8s8 3.2 8 8v433.6c94.4-12.8 196.8-12.8 291.2 0V84c0-4.8 3.2-8 8-8s8 3.2 8 8v443.2c0 2.4-0.8 4.8-2.4 6.4-3.2 0.8-4.8 1.6-6.4 1.6zM189.6 968C87.2 968 4 884.8 4 782.4s83.2-185.6 185.6-185.6S375.2 680 375.2 782.4 291.2 968 189.6 968z m0-338.4c-84.8 0-153.6 68.8-153.6 153.6S104.8 936 189.6 936s153.6-68.8 153.6-153.6-69.6-152.8-153.6-152.8zM868 968c-73.6 0-132.8-59.2-132.8-132.8s59.2-132.8 132.8-132.8 132.8 59.2 132.8 132.8-60 132.8-132.8 132.8z m0-233.6c-55.2 0-100.8 45.6-100.8 100.8s45.6 100.8 100.8 100.8 100.8-45.6 100.8-100.8-45.6-100.8-100.8-100.8zM189.6 960c-4.8 0-8-3.2-8-8v-100.8c0-4.8 3.2-8 8-8s8 3.2 8 8V952c0 4.8-4 8-8 8zM189.6 722.4c-4.8 0-8-3.2-8-8V613.6c0-4.8 3.2-8 8-8s8 3.2 8 8v100.8c0 4.8-4 8-8 8zM120.8 791.2H20c-4.8 0-8-3.2-8-8s3.2-8 8-8h100.8c4.8 0 8 3.2 8 8s-3.2 8-8 8zM358.4 791.2H257.6c-4.8 0-8-3.2-8-8s3.2-8 8-8h100.8c4.8 0 8 3.2 8 8s-3.2 8-8 8zM69.6 910.4c-2.4 0-4-0.8-5.6-2.4-3.2-3.2-3.2-8 0-11.2l71.2-71.2c3.2-3.2 8-3.2 11.2 0s3.2 8 0 11.2l-71.2 71.2c-1.6 1.6-3.2 2.4-5.6 2.4zM237.6 742.4c-2.4 0-4-0.8-5.6-2.4-3.2-3.2-3.2-8 0-11.2l71.2-71.2c3.2-3.2 8-3.2 11.2 0s3.2 8 0 11.2l-71.2 71.2c-1.6 1.6-4 2.4-5.6 2.4zM140.8 742.4c-2.4 0-4-0.8-5.6-2.4L64 668.8c-3.2-3.2-3.2-8 0-11.2s8-3.2 11.2 0l71.2 71.2c3.2 3.2 3.2 8 0 11.2-1.6 1.6-3.2 2.4-5.6 2.4zM308.8 910.4c-2.4 0-4-0.8-5.6-2.4l-71.2-71.2c-3.2-3.2-3.2-8 0-11.2s8-3.2 11.2 0l71.2 71.2c3.2 3.2 3.2 8 0 11.2-1.6 1.6-3.2 2.4-5.6 2.4zM868 792c-4.8 0-8-3.2-8-8v-65.6c0-4.8 3.2-8 8-8s8 3.2 8 8V784c0 4-4 8-8 8zM868 734.4c-8.8 0-16-7.2-16-16v-71.2c0-9.6-8.8-17.6-20-17.6H745.6c-8.8 0-16-7.2-16-16s7.2-16 16-16H832c28.8 0 52 22.4 52 49.6v71.2c0 8.8-7.2 16-16 16zM868 958.4c-4.8 0-8-3.2-8-8v-64.8c0-4.8 3.2-8 8-8s8 3.2 8 8v64.8c0 4-4 8-8 8zM982.4 843.2h-64.8c-4.8 0-8-3.2-8-8s3.2-8 8-8h64.8c4.8 0 8 3.2 8 8s-3.2 8-8 8zM817.6 843.2h-64.8c-4.8 0-8-3.2-8-8s3.2-8 8-8h64.8c4.8 0 8 3.2 8 8s-3.2 8-8 8zM786.4 703.2h-88c-8.8 0-16-7.2-16-16s7.2-16 16-16h84l213.6-133.6c7.2-4.8 17.6-2.4 22.4 4.8 4.8 7.2 2.4 17.6-4.8 22.4l-218.4 136c-2.4 1.6-5.6 2.4-8.8 2.4zM189.6 859.2c-42.4 0-76-34.4-76-76s34.4-76 76-76 76 34.4 76 76-34.4 76-76 76z m0-136.8c-33.6 0-60 27.2-60 60s27.2 60 60 60c33.6 0 60-27.2 60-60s-27.2-60-60-60zM868 893.6c-32 0-58.4-26.4-58.4-58.4s26.4-58.4 58.4-58.4 58.4 26.4 58.4 58.4-26.4 58.4-58.4 58.4z m0-100.8c-23.2 0-42.4 19.2-42.4 42.4s19.2 42.4 42.4 42.4 42.4-19.2 42.4-42.4-19.2-42.4-42.4-42.4z",
    "M759.2 940.8H572.8c-29.6 0-56-16-70.4-40-18.4 24-47.2 40-80 40H264.8c-24 0-43.2-19.2-43.2-43.2V619.2L128 863.2c-3.2 8-12 12-20 9.6L14.4 840c-8-3.2-12.8-12-9.6-20l216.8-681.6c1.6-5.6 5.6-9.6 11.2-10.4l172.8-44c1.6 0 2.4-0.8 4-0.8h195.2c1.6 0 2.4 0 4 0.8L790.4 128c5.6 1.6 9.6 5.6 11.2 10.4l216.8 681.6c2.4 8-1.6 16.8-9.6 20l-92.8 32.8c-8 3.2-16.8-1.6-20-9.6l-93.6-244.8v278.4c0 24-19.2 44-43.2 44z m-236-100v18.4c0 27.2 22.4 49.6 49.6 49.6h186.4c6.4 0 11.2-4.8 11.2-11.2V532c0-8 5.6-14.4 12.8-16 8-1.6 15.2 3.2 17.6 10.4l119.2 311.2 63.2-22.4-208.8-658.4-171.2-41.6H412l-162.4 40.8L40 815.2l63.2 22.4 119.2-310.4c2.4-7.2 10.4-11.2 17.6-10.4 7.2 1.6 12.8 8 12.8 16v364c0 6.4 4.8 11.2 11.2 11.2h159.2c37.6 0 68-30.4 68-68 0-8.8 7.2-16 16-16s16 8 16 16.8zM507.2 473.6c-2.4 0-4.8-0.8-6.4-3.2L356 267.2c-1.6-2.4-1.6-6.4 0-8.8l20.8-31.2-60-40.8c-2.4-1.6-3.2-4-3.2-6.4 0-2.4 0.8-4.8 2.4-6.4l88-80c2.4-1.6 4.8-2.4 8-1.6 2.4 0.8 4.8 3.2 5.6 5.6L515.2 464c0.8 4-0.8 8-4 9.6h-4zM372.8 262.4L488 424.8 405.6 114.4l-71.2 64.8 58.4 39.2c4 2.4 4.8 7.2 2.4 11.2l-22.4 32.8zM507.2 473.6c-0.8 0-2.4 0-3.2-0.8-3.2-1.6-5.6-5.6-4-9.6l97.6-366.4c0.8-2.4 2.4-4.8 5.6-5.6 2.4-0.8 5.6 0 8 1.6l88 80c1.6 1.6 2.4 4 2.4 6.4 0 2.4-1.6 4.8-3.2 6.4l-60 40.8 20.8 31.2c1.6 2.4 1.6 6.4 0 8.8L513.6 470.4c-1.6 2.4-4 3.2-6.4 3.2z m102.4-359.2L526.4 424.8l116-163.2-22.4-32.8c-2.4-4-1.6-8.8 2.4-11.2l58.4-39.2-71.2-64zM507.2 848.8c-4.8 0-8-3.2-8-8v-392c0-4.8 3.2-8 8-8s8 3.2 8 8V840c0 4.8-3.2 8.8-8 8.8zM712 814.4H585.6c-4.8 0-8-3.2-8-8V671.2c0-4.8 3.2-8 8-8H712c4.8 0 8 3.2 8 8v135.2c0 4.8-3.2 8-8 8z m-118.4-16H704V679.2H593.6v119.2zM428.8 814.4H303.2c-4.8 0-8-3.2-8-8V671.2c0-4.8 3.2-8 8-8h126.4c4.8 0 8 3.2 8 8v135.2c-0.8 4.8-4 8-8.8 8z m-117.6-16h110.4V679.2H311.2v119.2z",
    "M580 316c-1.6 0-4-0.8-5.6-2.4-12-11.2-69.6-66.4-69.6-93.6 0-24.8 20-44.8 44.8-44.8 11.2 0 22.4 4 30.4 12 8-7.2 19.2-12 30.4-12 24.8 0 44.8 20 44.8 44.8 0 27.2-58.4 83.2-69.6 93.6-1.6 1.6-4 2.4-5.6 2.4z m-30.4-124.8c-16 0-28.8 12.8-28.8 28.8 0 13.6 32.8 51.2 59.2 76.8 26.4-25.6 59.2-63.2 59.2-76.8 0-16-12.8-28.8-28.8-28.8-9.6 0-18.4 4.8-24 12-1.6 2.4-4 3.2-6.4 3.2-2.4 0-4.8-1.6-6.4-3.2-5.6-7.2-14.4-12-24-12zM514.4 1020c-62.4 0-124.8-16-186.4-31.2-80-20-162.4-41.6-240.8-24.8-8 1.6-16.8-3.2-18.4-11.2l-64-242.4c-1.6-5.6 0-12 4.8-16 62.4-58.4 136.8-120 224-111.2 41.6 4 84 24.8 125.6 61.6 4.8 4 8.8 8 12.8 12 14.4 13.6 28 25.6 44.8 34.4 16 8 35.2 12.8 52.8 16 21.6 4 44 8 66.4 11.2 44.8-32 104.8-62.4 143.2-78.4 25.6-10.4 55.2-20 84.8-10.4 14.4 4.8 28 16.8 35.2 30.4 6.4-6.4 14.4-12 22.4-16.8 22.4-12.8 56-16 80 3.2 8.8 7.2 14.4 16.8 17.6 28 10.4-5.6 22.4-9.6 35.2-11.2 18.4-1.6 38.4 5.6 51.2 19.2 11.2 12 16.8 26.4 14.4 41.6-11.2 86.4-326.4 256-417.6 283.2-29.6 9.6-58.4 12.8-88 12.8z m-366.4-94.4c63.2 0 126.4 16 188.8 32 89.6 22.4 174.4 44 256.8 20 109.6-32.8 388-199.2 395.2-256.8 0.8-6.4-2.4-12-5.6-15.2-6.4-6.4-16-10.4-25.6-9.6-16.8 1.6-32 12-48 24.8-3.2 3.2-6.4 6.4-10.4 8.8-7.2 4-16 1.6-20.8-4.8-4.8-6.4-3.2-16 2.4-21.6 1.6-1.6 4-3.2 5.6-4.8 1.6-2.4 2.4-5.6 2.4-8 0.8-7.2-2.4-14.4-7.2-18.4-12-10.4-32-7.2-44.8 0-16 8.8-28 24-38.4 38.4-0.8 1.6-1.6 2.4-3.2 4-5.6 6.4-15.2 8-22.4 2.4-7.2-5.6-8-15.2-3.2-21.6 0.8-0.8 0.8-1.6 1.6-2.4 2.4-4 1.6-8.8 0.8-12-2.4-8.8-10.4-17.6-19.2-20.8-19.2-6.4-42.4 1.6-62.4 9.6-31.2 12.8-72 32.8-107.2 54.4 37.6 4 75.2 5.6 112.8 6.4 5.6 0 14.4 0 22.4 6.4 6.4 4.8 10.4 12 10.4 20 0 13.6-8.8 26.4-17.6 34.4-107.2 92-275.2 100-390.4 18.4-7.2-4.8-8.8-15.2-4-22.4 4.8-7.2 15.2-8.8 22.4-4 102.4 72 256 64.8 351.2-16.8l4-4c-52.8-0.8-105.6-4.8-157.6-12H536c-24.8-3.2-49.6-7.2-73.6-12-20-4-41.6-8.8-61.6-19.2-20-10.4-36-24.8-51.2-39.2-4-4-8.8-8-12.8-11.2-36.8-32-72.8-50.4-107.2-53.6-71.2-7.2-136 44.8-192 96l58.4 218.4c17.6-2.4 34.4-4 52-4zM742.4 577.6h-336c-28.8 0-52-23.2-52-52V427.2c0-8.8 7.2-16 16-16h407.2c8.8 0 16 7.2 16 16v98.4c0.8 28.8-22.4 52-51.2 52zM387.2 443.2v82.4c0 11.2 8.8 20 20 20h336c11.2 0 20-8.8 20-20V443.2h-376zM371.2 443.2H272.8c-28.8 0-52-23.2-52-52V56c0-28.8 23.2-52 52-52h98.4c8.8 0 16 7.2 16 16v407.2c0 8.8-7.2 16-16 16zM272.8 36c-11.2 0-20 8.8-20 20v336c0 11.2 8.8 20 20 20h82.4v-376H272.8zM699.2 435.2c-4.8 0-8-3.2-8-8 0-61.6-49.6-111.2-111.2-111.2s-111.2 49.6-111.2 111.2c0 4.8-3.2 8-8 8s-8-3.2-8-8c0-70.4 56.8-127.2 127.2-127.2s127.2 56.8 127.2 127.2c0 4.8-4 8-8 8z",
    "M107.2 777.6c-11.2 0-22.4-4-29.6-10.4-8.8-8-12.8-19.2-9.6-30.4 1.6-6.4 5.6-12 8-14.4 15.2-17.6 36.8-23.2 57.6-27.2-0.8-11.2-4.8-23.2-11.2-37.6-10.4-25.6-24.8-49.6-41.6-72-6.4-8-12.8-16-19.2-23.2-21.6-25.6-43.2-52-52.8-85.6-12-41.6 0-88 28.8-120 29.6-31.2 75.2-45.6 117.6-36.8 8.8 1.6 14.4 10.4 12 19.2-1.6 8.8-10.4 14.4-19.2 12-31.2-6.4-65.6 4-87.2 27.2-21.6 23.2-30.4 58.4-21.6 88.8 8 27.2 26.4 49.6 46.4 72.8 6.4 8 13.6 16 20 24.8 18.4 24 34.4 50.4 45.6 79.2 5.6 12.8 11.2 28.8 12.8 45.6 9.6-1.6 19.2-4 26.4-8 33.6-17.6 40-65.6 42.4-110.4 0-8 6.4-14.4 13.6-15.2 8-0.8 15.2 4 17.6 11.2 5.6 17.6 3.2 36 1.6 52-2.4 22.4-3.2 36 5.6 45.6 8.8 8.8 23.2 8.8 44.8 7.2 13.6-0.8 28-1.6 42.4 1.6 8.8 1.6 14.4 10.4 12 19.2s-10.4 14.4-19.2 12c-7.2-0.8-18.4 0-31.2 0-24 1.6-50.4 3.2-70.4-16.8-3.2-3.2-6.4-7.2-8-10.4-8.8 13.6-20 24.8-35.2 33.6-13.6 7.2-28 10.4-43.2 12-5.6 24-20.8 44-41.6 52-4 1.6-8.8 2.4-14.4 2.4z m-8-33.6c2.4 1.6 8 2.4 11.2 1.6 8-3.2 13.6-9.6 17.6-16.8-11.2 2.4-20.8 6.4-28 14.4l-0.8 0.8zM350.4 932c-4.8 0-8.8-0.8-13.6-1.6-29.6-8-42.4-40-42.4-67.2 0-41.6 21.6-78.4 39.2-108 7.2-12.8 16-28 29.6-39.2l9.6-7.2c-4 0-7.2 0-11.2-1.6-12-3.2-22.4-11.2-28-21.6-9.6-16.8-8.8-35.2-7.2-49.6 3.2-28 12.8-48.8 27.2-62.4 11.2-10.4 27.2-15.2 43.2-14.4 12.8 0.8 24.8 7.2 32 16.8 4.8 6.4 8 14.4 9.6 20.8 5.6 16.8 9.6 33.6 12.8 50.4 0.8-0.8 0.8-1.6 1.6-2.4 6.4-11.2 12-22.4 20.8-32.8 4.8-6.4 12.8-15.2 24.8-19.2 12.8-4.8 25.6-2.4 35.2 5.6 2.4-2.4 4.8-4 8-5.6 11.2-6.4 25.6-7.2 38.4-3.2 12.8 4.8 23.2 14.4 28 26.4 4.8 12.8 4 24.8 3.2 36 0 2.4-0.8 5.6-0.8 8-0.8 9.6 2.4 16 4.8 17.6 2.4 0.8 8.8-0.8 14.4-6.4 2.4-2.4 5.6-5.6 8-8.8 4.8-6.4 11.2-12.8 19.2-18.4 7.2-4.8 17.6-3.2 22.4 4 4.8 7.2 3.2 17.6-4 22.4-4 3.2-8 8-12.8 12.8-3.2 4-6.4 7.2-10.4 11.2-12 12-31.2 21.6-49.6 12.8-16-7.2-24.8-24.8-24-48 0-3.2 0.8-6.4 0.8-9.6 0.8-8 1.6-16-0.8-21.6-1.6-3.2-4.8-6.4-8.8-8-4-1.6-8.8-1.6-12 0.8-6.4 3.2-9.6 11.2-12 20.8 0 19.2-2.4 38.4-5.6 56.8-1.6 8-9.6 13.6-17.6 12.8-8.8-0.8-14.4-8.8-13.6-16.8l3.2-36c0.8-5.6 0.8-12.8 2.4-20V632c0-6.4-0.8-8-0.8-8h-3.2c-3.2 0.8-6.4 4-10.4 8.8-6.4 8-12 17.6-17.6 28-7.2 12.8-14.4 25.6-24 36.8 2.4 62.4-11.2 125.6-39.2 181.6-6.4 12.8-14.4 27.2-27.2 38.4-13.6 8.8-28 14.4-41.6 14.4zM424.8 720c-4.8 2.4-8.8 4-13.6 5.6-10.4 4-20 8-27.2 14.4-8.8 7.2-16 19.2-22.4 30.4-16 28-34.4 59.2-34.4 92 0 15.2 6.4 32.8 18.4 36 7.2 1.6 16-0.8 23.2-7.2 8.8-7.2 14.4-17.6 20-28 22.4-44 34.4-93.6 36-143.2z m-42.4-46.4c5.6 0 10.4 2.4 13.6 8 3.2 4.8 3.2 11.2 0.8 15.2 0.8 0 1.6-0.8 2.4-0.8 8.8-4 17.6-7.2 24.8-12.8-2.4-25.6-7.2-52-15.2-76.8-1.6-4-3.2-8.8-4.8-11.2-2.4-3.2-6.4-4-9.6-4.8-6.4-0.8-13.6 1.6-18.4 6.4-8.8 8-14.4 21.6-16.8 42.4-0.8 9.6-1.6 21.6 3.2 29.6 1.6 3.2 5.6 5.6 8.8 6.4 1.6 0 3.2 0.8 4 0 1.6-0.8 4.8-1.6 7.2-1.6zM245.6 536c-8.8 0-16-7.2-16-16v-13.6c0-8.8 7.2-16 16-16s16 7.2 16 16V520c0 9.6-7.2 16-16 16zM666.4 672c-2.4 0-5.6-0.8-8-2.4-5.6-3.2-8.8-8.8-8-15.2L660.8 528c0-2.4 0.8-4.8 2.4-6.4l231.2-408.8c4.8-8 12-14.4 20-17.6 9.6-4 19.2-3.2 28 1.6l61.6 35.2c8 4.8 13.6 12.8 15.2 23.2 1.6 8.8 0 18.4-4.8 26.4l-231.2 408c-0.8 2.4-2.4 4-4.8 4.8l-103.2 74.4c-2.4 2.4-5.6 3.2-8.8 3.2z m25.6-137.6l-7.2 88 72-52 229.6-406.4c1.6-3.2 1.6-5.6 0.8-6.4l-61.6-35.2s-2.4 1.6-4 4.8L692 534.4zM960.8 250.4c-1.6 0-2.4 0-4-0.8L864 197.6c-4-2.4-5.6-7.2-3.2-11.2l39.2-69.6c4-6.4 9.6-12 16-14.4 7.2-3.2 14.4-2.4 20.8 0.8l61.6 35.2c6.4 3.2 10.4 9.6 11.2 17.6 0.8 7.2 0 14.4-4 21.6l-39.2 69.6c-0.8 1.6-2.4 3.2-4.8 4 0.8-0.8 0-0.8-0.8-0.8z m-81.6-63.2l78.4 44.8 35.2-63.2c1.6-3.2 2.4-7.2 2.4-11.2 0-1.6-0.8-4.8-4-5.6l-61.6-35.2c-2.4-1.6-5.6-0.8-7.2 0-3.2 1.6-6.4 4-8 7.2l-35.2 63.2z",
    "M765.6 944H258.4c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16h507.2c8.8 0 16 7.2 16 16v832c0 8.8-7.2 16-16 16z m-491.2-32h475.2V112H274.4v800zM512 835.2c-50.4 0-97.6-19.2-133.6-55.2-35.2-35.2-55.2-83.2-55.2-133.6 0-50.4 19.2-97.6 55.2-133.6 35.2-35.2 83.2-55.2 133.6-55.2 50.4 0 97.6 20 133.6 55.2 35.2 35.2 55.2 83.2 55.2 133.6 0 50.4-19.2 97.6-55.2 133.6s-83.2 55.2-133.6 55.2z m0-360.8c-46.4 0-89.6 17.6-121.6 50.4s-50.4 76-50.4 121.6c0 46.4 17.6 89.6 50.4 121.6s76 50.4 121.6 50.4c46.4 0 89.6-17.6 121.6-50.4 32.8-32.8 50.4-76 50.4-121.6 0-46.4-17.6-89.6-50.4-121.6s-75.2-50.4-121.6-50.4zM195.2 838.4c-4 0-8-1.6-11.2-4.8-102.4-102.4-102.4-269.6 0-372.8 6.4-6.4 16-6.4 22.4 0 6.4 6.4 6.4 16 0 22.4-90.4 90.4-90.4 236.8 0 327.2 6.4 6.4 6.4 16 0 22.4-3.2 4-7.2 5.6-11.2 5.6zM122.4 910.4c-4 0-8-1.6-11.2-4.8C-32 762.4-32 530.4 111.2 387.2c6.4-6.4 16-6.4 22.4 0 6.4 6.4 6.4 16 0 22.4C3.2 540 3.2 752 133.6 882.4c6.4 6.4 6.4 16 0 22.4-2.4 4-7.2 5.6-11.2 5.6zM828.8 838.4c-4 0-8-1.6-11.2-4.8-6.4-6.4-6.4-16 0-22.4 90.4-90.4 90.4-236.8 0-327.2-6.4-6.4-6.4-16 0-22.4 6.4-6.4 16-6.4 22.4 0 102.4 102.4 102.4 269.6 0 372.8-3.2 2.4-7.2 4-11.2 4zM901.6 910.4c-4 0-8-1.6-11.2-4.8-6.4-6.4-6.4-16 0-22.4 130.4-130.4 130.4-342.4 0-472.8-6.4-6.4-6.4-16 0-22.4 6.4-6.4 16-6.4 22.4 0 143.2 143.2 143.2 375.2 0 518.4-3.2 2.4-7.2 4-11.2 4zM512 732.8c-47.2 0-85.6-38.4-85.6-85.6 0-47.2 38.4-85.6 85.6-85.6S597.6 600 597.6 647.2c0 47.2-38.4 85.6-85.6 85.6z m0-155.2c-38.4 0-69.6 31.2-69.6 69.6s31.2 69.6 69.6 69.6c38.4 0 69.6-31.2 69.6-69.6s-31.2-69.6-69.6-69.6zM512 354.4c-47.2 0-85.6-38.4-85.6-85.6 0-47.2 38.4-85.6 85.6-85.6s85.6 38.4 85.6 85.6c0 47.2-38.4 85.6-85.6 85.6z m0-155.2c-38.4 0-69.6 31.2-69.6 69.6s31.2 69.6 69.6 69.6c38.4 0 69.6-31.2 69.6-69.6s-31.2-69.6-69.6-69.6z",
    "M556.8 507.2c-1.6 0-2.4 0-4-0.8-8.8-1.6-13.6-10.4-12-18.4 0.8-2.4 49.6-204 256-223.2 8.8-0.8 16.8 5.6 17.6 14.4 0.8 8.8-5.6 16.8-14.4 17.6C617.6 314.4 574.4 488 572 496c-1.6 6.4-8 11.2-15.2 11.2zM556.8 365.6c-1.6 0-2.4 0-4-0.8-8.8-2.4-13.6-10.4-12-19.2 0.8-2.4 49.6-204 256-223.2 8.8-0.8 16.8 5.6 17.6 14.4 0.8 8.8-5.6 16.8-14.4 17.6-182.4 17.6-225.6 191.2-228 199.2-1.6 7.2-8 12-15.2 12zM467.2 507.2c-7.2 0-13.6-4.8-15.2-12-1.6-8-45.6-181.6-228-199.2-8.8-0.8-15.2-8.8-14.4-17.6s8.8-15.2 17.6-14.4c205.6 19.2 255.2 221.6 256 223.2 2.4 8.8-3.2 17.6-12 19.2-1.6 0.8-2.4 0.8-4 0.8zM467.2 365.6c-7.2 0-13.6-4.8-15.2-12-1.6-7.2-44.8-181.6-228-199.2-8.8-0.8-15.2-8.8-14.4-17.6s8.8-15.2 17.6-14.4c205.6 20 255.2 221.6 256 223.2 2.4 8.8-3.2 17.6-12 19.2-1.6 0.8-2.4 0.8-4 0.8zM515.2 296c-8.8 0-16-7.2-16-16V20c0-8.8 7.2-16 16-16s16 7.2 16 16V280c0 8.8-7.2 16-16 16zM601.6 1020H428.8c-8.8 0-16-7.2-16-16V522.4c0-8.8 7.2-16 16-16h172.8c8.8 0 16 7.2 16 16v481.6c0 8.8-7.2 16-16 16z m-156.8-32h140.8V538.4H444.8v449.6zM501.6 1012h-72.8c-4.8 0-8-3.2-8-8v-54.4c0-2.4 0.8-4.8 3.2-6.4L596.8 800c2.4-1.6 5.6-2.4 8.8-0.8 3.2 1.6 4.8 4 4.8 7.2v115.2c0 2.4-0.8 4.8-3.2 6.4l-100 82.4c-1.6 0.8-4 1.6-5.6 1.6z m-64.8-16h62.4l95.2-78.4v-94.4l-156.8 130.4v42.4zM601.6 1012H501.6c-3.2 0-6.4-2.4-7.2-5.6-0.8-3.2 0-6.4 2.4-8.8l100-82.4c2.4-1.6 5.6-2.4 8.8-0.8 3.2 1.6 4.8 4 4.8 7.2v82.4c-0.8 4.8-4.8 8-8.8 8z m-77.6-16h69.6v-57.6l-69.6 57.6zM428.8 612.8c-0.8 0-2.4 0-3.2-0.8-3.2-1.6-4.8-4-4.8-7.2V522.4c0-4.8 3.2-8 8-8h100c3.2 0 6.4 2.4 7.2 5.6 0.8 3.2 0 6.4-2.4 8.8L433.6 611.2c-1.6 0.8-3.2 1.6-4.8 1.6z m8-82.4v57.6l69.6-57.6h-69.6zM428.8 728c-0.8 0-2.4 0-3.2-0.8-3.2-1.6-4.8-4-4.8-7.2V604.8c0-2.4 0.8-4.8 3.2-6.4l100-82.4c1.6-0.8 3.2-1.6 4.8-1.6h72.8c4.8 0 8 3.2 8 8v54.4c0 2.4-0.8 4.8-3.2 6.4L433.6 725.6c-1.6 1.6-3.2 2.4-4.8 2.4z m8-119.2v94.4l156.8-130.4v-42.4h-62.4l-94.4 78.4zM428.8 957.6c-0.8 0-2.4 0-3.2-0.8-3.2-1.6-4.8-4-4.8-7.2v-115.2c0-2.4 0.8-4.8 3.2-6.4l172.8-143.2c2.4-1.6 5.6-2.4 8.8-0.8 3.2 1.6 4.8 4 4.8 7.2v115.2c0 2.4-0.8 4.8-3.2 6.4l-172.8 143.2c-2.4 0.8-4 1.6-5.6 1.6z m8-119.2v94.4l156.8-130.4V708.8l-156.8 129.6zM428.8 842.4c-0.8 0-2.4 0-3.2-0.8-3.2-1.6-4.8-4-4.8-7.2V720c0-2.4 0.8-4.8 3.2-6.4l172.8-143.2c2.4-1.6 5.6-2.4 8.8-0.8 3.2 1.6 4.8 4 4.8 7.2v115.2c0 2.4-0.8 4.8-3.2 6.4l-172.8 143.2c-2.4 0.8-4 0.8-5.6 0.8z m8-119.2v94.4L593.6 688V593.6L436.8 723.2z",
    "M482.4 1020H367.2c-8.8 0-16-7.2-16-16V632c0-8.8 7.2-16 16-16h115.2c8.8 0 16 7.2 16 16v372c0 8.8-7.2 16-16 16z m-99.2-32h83.2V648H383.2v340zM746.4 586.4H656.8c-8.8 0-16-7.2-16-16V260.8c0-8.8 7.2-16 16-16 58.4 0 105.6 47.2 105.6 105.6v220.8c0 8-7.2 15.2-16 15.2z m-73.6-32h57.6V350.4c0-35.2-24.8-64.8-57.6-72v276zM367.2 586.4H277.6c-8.8 0-16-7.2-16-16V350.4c0-58.4 47.2-105.6 105.6-105.6 8.8 0 16 7.2 16 16v310.4c0 8-7.2 15.2-16 15.2z m-73.6-32h57.6V278.4c-32.8 7.2-57.6 36.8-57.6 72v204zM656.8 1020H541.6c-8.8 0-16-7.2-16-16V632c0-8.8 7.2-16 16-16h115.2c8.8 0 16 7.2 16 16v372c0 8.8-7.2 16-16 16z m-99.2-32h83.2V648H557.6v340zM512 219.2c-59.2 0-107.2-48-107.2-107.2S452.8 4 512 4s107.2 48 107.2 107.2-48 108-107.2 108z m0-183.2c-41.6 0-75.2 33.6-75.2 75.2s33.6 75.2 75.2 75.2 75.2-33.6 75.2-75.2-33.6-75.2-75.2-75.2zM656.8 648H367.2c-8.8 0-16-7.2-16-16V260.8c0-8.8 7.2-16 16-16H456c4 0 8 1.6 11.2 4.8l44.8 44.8 44.8-44.8c3.2-3.2 7.2-4.8 11.2-4.8h88.8c8.8 0 16 7.2 16 16V632c0 8.8-7.2 16-16 16z m-273.6-32h257.6V276.8h-65.6L523.2 328c-6.4 6.4-16 6.4-22.4 0l-51.2-51.2H384V616z",
    "M781.6 707.2C648 707.2 543.2 405.6 543.2 20c0-8.8 7.2-16 16-16h444.8c8.8 0 16 7.2 16 16 0 385.6-104.8 687.2-238.4 687.2zM576 36c3.2 383.2 108 639.2 206.4 639.2s203.2-256 206.4-639.2H576zM878.4 482.4c-0.8 0-1.6 0-2.4-0.8-4-1.6-6.4-5.6-4.8-10.4 34.4-104.8 56-239.2 60.8-388 0-4.8 4-8 8-8 4.8 0 8 4 8 8-4.8 150.4-25.6 286.4-61.6 392.8-1.6 4.8-4.8 6.4-8 6.4zM781.6 1020c-8.8 0-16-7.2-16-16V691.2c0-8.8 7.2-16 16-16s16 7.2 16 16v312.8c0 8.8-7.2 16-16 16zM908 1020H655.2c-8.8 0-16-7.2-16-16s7.2-16 16-16h252.8c8.8 0 16 7.2 16 16s-7.2 16-16 16zM242.4 707.2C108.8 707.2 4 405.6 4 20c0-8.8 7.2-16 16-16h444.8c8.8 0 16 7.2 16 16 0 385.6-104.8 687.2-238.4 687.2zM36 36C39.2 419.2 144 675.2 242.4 675.2s203.2-256 206.4-639.2H36zM338.4 482.4c-0.8 0-1.6 0-2.4-0.8-4-1.6-6.4-5.6-4.8-10.4 34.4-104.8 56-239.2 60.8-388 0-4 4-8 8-8 4.8 0 8 4 8 8-4.8 150.4-25.6 286.4-61.6 392.8-1.6 4.8-4.8 6.4-8 6.4zM242.4 1020c-8.8 0-16-7.2-16-16V691.2c0-8.8 7.2-16 16-16s16 7.2 16 16v312.8c0 8.8-7.2 16-16 16zM368.8 1020H116c-8.8 0-16-7.2-16-16s7.2-16 16-16h252.8c8.8 0 16 7.2 16 16s-7.2 16-16 16z",
    "M971.2 515.2H772.8c-8.8 0-16-7.2-16-16V406.4c0-8.8 7.2-16 16-16h198.4c8.8 0 16 7.2 16 16v92.8c0 8.8-7.2 16-16 16z m-182.4-32h166.4v-60.8H788.8v60.8zM251.2 515.2H52.8c-8.8 0-16-7.2-16-16V406.4c0-8.8 7.2-16 16-16h198.4c8.8 0 16 7.2 16 16v92.8c0 8.8-7.2 16-16 16z m-182.4-32h166.4v-60.8H68.8v60.8zM203.2 1020H100.8c-8.8 0-16-7.2-16-16V499.2c0-8.8 7.2-16 16-16h102.4c8.8 0 16 7.2 16 16v504.8c0 8.8-7.2 16-16 16z m-86.4-32h70.4V515.2h-70.4v472.8zM923.2 1020h-102.4c-8.8 0-16-7.2-16-16V499.2c0-8.8 7.2-16 16-16h102.4c8.8 0 16 7.2 16 16v504.8c0 8.8-7.2 16-16 16z m-86.4-32h70.4V515.2h-70.4v472.8zM922.4 422.4h-103.2c-8 0-15.2-6.4-16-14.4-16-148.8-140.8-261.6-291.2-261.6-150.4 0-275.2 112.8-291.2 261.6-0.8 8-8 14.4-16 14.4H101.6c-4.8 0-8.8-1.6-12-4.8-3.2-3.2-4.8-7.2-4-12C99.2 180 286.4 4 512 4s412.8 176 426.4 401.6c0 4-1.6 8.8-4 12-3.2 3.2-7.2 4.8-12 4.8z m-89.6-32h72C884.8 190.4 715.2 36 512 36S139.2 190.4 119.2 390.4h72C214.4 232 350.4 114.4 512 114.4c161.6 0 297.6 117.6 320.8 276zM512 412c-76 0-137.6-61.6-137.6-137.6 0-8.8 7.2-16 16-16h244c8.8 0 16 7.2 16 16-0.8 76-62.4 137.6-138.4 137.6zM407.2 290.4c8 51.2 52 89.6 104.8 89.6s96.8-39.2 104.8-89.6H407.2zM512 290.4c-8.8 0-16-7.2-16-16v-144c0-8.8 7.2-16 16-16s16 7.2 16 16v144c0 8.8-7.2 16-16 16z",
    "M576 368H448c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16v144c0 8.8-7.2 16-16 16z m-112-32h96V224H464v112zM553.6 480.8H470.4c-8.8 0-16-7.2-16-16V352c0-8.8 7.2-16 16-16h83.2c8.8 0 16 7.2 16 16v112c0 9.6-7.2 16.8-16 16.8z m-67.2-32h51.2V368h-51.2v80.8zM658.4 224H349.6c-8.8 0-16-7.2-16-16V40.8c0-8.8 7.2-16 16-16h308.8c8.8 0 16 7.2 16 16V208c0 8.8-7.2 16-16 16z m-292.8-32h276.8V56.8H365.6V192zM291.2 140.8H224c-8.8 0-16-7.2-16-16s7.2-16 16-16h66.4c8.8 0 16 7.2 16 16s-6.4 16-15.2 16zM226.4 244.8c-6.4 0-12.8-4-15.2-10.4-3.2-8 0.8-17.6 8.8-20.8l62.4-24c8-3.2 17.6 0.8 20.8 8.8 3.2 8-0.8 17.6-8.8 20.8l-62.4 24c-1.6 1.6-3.2 1.6-5.6 1.6zM288.8 60c-1.6 0-4 0-5.6-0.8l-62.4-24c-8-3.2-12-12.8-8.8-20.8 3.2-8 12.8-12 20.8-8.8l62.4 24c8 3.2 12 12.8 8.8 20.8-3.2 6.4-8.8 9.6-15.2 9.6zM783.2 140.8h-66.4c-8.8 0-16-7.2-16-16s7.2-16 16-16h66.4c8.8 0 16 7.2 16 16s-7.2 16-16 16zM719.2 60c-6.4 0-12.8-4-15.2-10.4-3.2-8 0.8-17.6 8.8-20.8l62.4-24c8-3.2 17.6 0.8 20.8 8.8 3.2 8-0.8 17.6-8.8 20.8l-62.4 24c-1.6 1.6-4 1.6-5.6 1.6zM780.8 244.8c-1.6 0-4 0-5.6-0.8l-62.4-24c-8-3.2-12-12.8-8.8-20.8 3.2-8 12.8-12 20.8-8.8l62.4 24c8 3.2 12 12.8 8.8 20.8-2.4 5.6-8.8 9.6-15.2 9.6zM860 1020h-696c-41.6 0-76-34.4-76-76V618.4c0-41.6 34.4-76 76-76h696.8c41.6 0 76 34.4 76 76V944c-0.8 41.6-34.4 76-76.8 76z m-696-445.6c-24 0-44 20-44 44V944c0 24 20 44 44 44h696.8c24 0 44-20 44-44V618.4c0-24-20-44-44-44H164zM664 574.4H360c-5.6 0-10.4-2.4-13.6-7.2-3.2-4.8-3.2-10.4-1.6-15.2l41.6-93.6c2.4-5.6 8-9.6 14.4-9.6h221.6c6.4 0 12 4 14.4 9.6L678.4 552c2.4 4.8 1.6 10.4-1.6 15.2-2.4 4-7.2 7.2-12.8 7.2z m-280-32h256L612 480h-200L384 542.4zM284 574.4H177.6c-8.8 0-16-7.2-16-16v-65.6c0-8.8 7.2-16 16-16h105.6c8.8 0 16 7.2 16 16v65.6c0.8 8.8-6.4 16-15.2 16z m-90.4-32h73.6v-33.6h-73.6v33.6zM295.2 936c-4.8 0-8-3.2-8-8V633.6c0-4.8 3.2-8 8-8s8 3.2 8 8V928c0 4.8-3.2 8-8 8zM603.2 956.8c-96.8 0-175.2-78.4-175.2-175.2s78.4-175.2 175.2-175.2 175.2 78.4 175.2 175.2-78.4 175.2-175.2 175.2z m0-335.2c-88 0-159.2 71.2-159.2 159.2 0 88 71.2 159.2 159.2 159.2s159.2-71.2 159.2-159.2c0.8-88-71.2-159.2-159.2-159.2zM690.4 788.8c-4.8 0-8-3.2-8-8 0-44-36-79.2-79.2-79.2-4.8 0-8-3.2-8-8s3.2-8 8-8c52.8 0 95.2 43.2 95.2 95.2 0 4.8-3.2 8-8 8z",
    "M1004 1020H20c-8.8 0-16-7.2-16-16V285.6c0-76.8 30.4-148.8 85.6-201.6C144 30.4 216.8 1.6 293.6 4c151.2 4 273.6 132.8 273.6 287.2v112.8c0 116 94.4 210.4 210.4 210.4 127.2 0 232.8 99.2 241.6 225.6 0.8 6.4 0.8 11.2 0.8 16v147.2c0 9.6-7.2 16.8-16 16.8z m-968-32h952v-131.2c0-4.8 0-9.6-0.8-14.4-7.2-109.6-99.2-196-209.6-196-133.6 0-242.4-108.8-242.4-242.4V291.2C535.2 154.4 426.4 40 292.8 36 224.8 34.4 160 59.2 112 106.4c-48.8 47.2-76 111.2-76 179.2v702.4zM128 928c-4.8 0-8-3.2-8-8v-78.4c0-4.8 3.2-8 8-8s8 3.2 8 8v78.4c0 4-4 8-8 8zM224 928c-4.8 0-8-3.2-8-8v-78.4c0-4.8 3.2-8 8-8s8 3.2 8 8v78.4c0 4-4 8-8 8zM320 928c-4.8 0-8-3.2-8-8v-78.4c0-4.8 3.2-8 8-8s8 3.2 8 8v78.4c0 4-4 8-8 8zM416 928c-4.8 0-8-3.2-8-8v-78.4c0-4.8 3.2-8 8-8s8 3.2 8 8v78.4c0 4-4 8-8 8zM512 928c-4.8 0-8-3.2-8-8v-78.4c0-4.8 3.2-8 8-8s8 3.2 8 8v78.4c0 4-3.2 8-8 8zM608 928c-4.8 0-8-3.2-8-8v-78.4c0-4.8 3.2-8 8-8s8 3.2 8 8v78.4c0 4-3.2 8-8 8zM704 928c-4.8 0-8-3.2-8-8v-78.4c0-4.8 3.2-8 8-8s8 3.2 8 8v78.4c0 4-3.2 8-8 8zM800 928c-4.8 0-8-3.2-8-8v-78.4c0-4.8 3.2-8 8-8s8 3.2 8 8v78.4c0 4-3.2 8-8 8zM896 928c-4.8 0-8-3.2-8-8v-78.4c0-4.8 3.2-8 8-8s8 3.2 8 8v78.4c0 4-3.2 8-8 8zM1003.2 849.6H20c-4.8 0-8-3.2-8-8s3.2-8 8-8h983.2c4.8 0 8 3.2 8 8s-3.2 8-8 8z",
    "M1004 298.4H20c-4.8 0-8-3.2-8-8V107.2c0-4.8 3.2-8 8-8h984c4.8 0 8 3.2 8 8v183.2c0 4-3.2 8-8 8z m-976-16h968V115.2H28v167.2zM1004 1020H20c-8.8 0-16-7.2-16-16V107.2c0-8.8 7.2-16 16-16h984c8.8 0 16 7.2 16 16v896.8c0 8.8-7.2 16-16 16z m-968-32h952V123.2H36v864.8zM190.4 210.4c-8.8 0-16-7.2-16-16V20c0-8.8 7.2-16 16-16s16 7.2 16 16v174.4c0 8.8-7.2 16-16 16zM833.6 210.4c-8.8 0-16-7.2-16-16V20c0-8.8 7.2-16 16-16s16 7.2 16 16v174.4c0 8.8-7.2 16-16 16zM467.2 534.4H348.8c-4.8 0-8-3.2-8-8V408c0-4.8 3.2-8 8-8h119.2c4.8 0 8 3.2 8 8v119.2c-0.8 4-4 7.2-8.8 7.2z m-110.4-16h103.2V416H356.8v102.4zM675.2 534.4H556.8c-4.8 0-8-3.2-8-8V408c0-4.8 3.2-8 8-8h119.2c4.8 0 8 3.2 8 8v119.2c-0.8 4-4 7.2-8.8 7.2z m-110.4-16h103.2V416H564.8v102.4zM883.2 534.4H764.8c-4.8 0-8-3.2-8-8V408c0-4.8 3.2-8 8-8h119.2c4.8 0 8 3.2 8 8v119.2c-0.8 4-4 7.2-8.8 7.2z m-110.4-16h103.2V416H772.8v102.4zM467.2 714.4H348.8c-4.8 0-8-3.2-8-8V588c0-4.8 3.2-8 8-8h119.2c4.8 0 8 3.2 8 8v119.2c-0.8 4-4 7.2-8.8 7.2z m-110.4-16h103.2V596H356.8v102.4zM259.2 714.4H140.8c-4.8 0-8-3.2-8-8V588c0-4.8 3.2-8 8-8h119.2c4.8 0 8 3.2 8 8v119.2c-0.8 4-4 7.2-8.8 7.2z m-110.4-16h103.2V596H148.8v102.4zM675.2 714.4H556.8c-4.8 0-8-3.2-8-8V588c0-4.8 3.2-8 8-8h119.2c4.8 0 8 3.2 8 8v119.2c-0.8 4-4 7.2-8.8 7.2z m-110.4-16h103.2V596H564.8v102.4zM883.2 714.4H764.8c-4.8 0-8-3.2-8-8V588c0-4.8 3.2-8 8-8h119.2c4.8 0 8 3.2 8 8v119.2c-0.8 4-4 7.2-8.8 7.2z m-110.4-16h103.2V596H772.8v102.4zM467.2 894.4H348.8c-4.8 0-8-3.2-8-8V768c0-4.8 3.2-8 8-8h119.2c4.8 0 8 3.2 8 8v119.2c-0.8 4-4 7.2-8.8 7.2z m-110.4-16h103.2V776H356.8v102.4zM259.2 894.4H140.8c-4.8 0-8-3.2-8-8V768c0-4.8 3.2-8 8-8h119.2c4.8 0 8 3.2 8 8v119.2c-0.8 4-4 7.2-8.8 7.2z m-110.4-16h103.2V776H148.8v102.4zM675.2 894.4H556.8c-4.8 0-8-3.2-8-8V768c0-4.8 3.2-8 8-8h119.2c4.8 0 8 3.2 8 8v119.2c-0.8 4-4 7.2-8.8 7.2z m-110.4-16h103.2V776H564.8v102.4z",
    "M251.2 908H148c-16.8 0-30.4-13.6-30.4-30.4V724.8c0-8.8 7.2-16 16-16h132c8.8 0 16 7.2 16 16v152.8c0 16.8-13.6 30.4-30.4 30.4z m-101.6-32h100v-136H149.6v136zM876 908H772.8c-16.8 0-30.4-13.6-30.4-30.4V724.8c0-8.8 7.2-16 16-16h132c8.8 0 16 7.2 16 16v152.8c0 16.8-13.6 30.4-30.4 30.4z m-101.6-32h100v-136H774.4v136zM941.6 740.8H672.8c-8.8 0-16-7.2-16-16s7.2-16 16-16h252.8V469.6l-114.4-334.4H212.8L98.4 469.6v239.2h252c8.8 0 16 7.2 16 16s-7.2 16-16 16H82.4c-8.8 0-16-7.2-16-16V466.4c0-1.6 0-3.2 0.8-4.8l119.2-347.2c2.4-6.4 8-11.2 15.2-11.2h620.8c7.2 0 12.8 4 15.2 11.2l119.2 347.2c0.8 1.6 0.8 3.2 0.8 4.8v258.4c0 8.8-7.2 16-16 16zM844.8 405.6H179.2c-2.4 0-4.8-1.6-6.4-3.2-1.6-2.4-1.6-4.8-0.8-7.2l71.2-208.8c0.8-3.2 4-5.6 7.2-5.6h522.4c3.2 0 6.4 2.4 7.2 5.6l71.2 208.8c0.8 2.4 0.8 4.8-0.8 7.2-0.8 1.6-3.2 3.2-5.6 3.2z m-654.4-16h642.4l-66.4-192.8H256.8l-66.4 192.8zM204 650.4c-28 0-51.2-23.2-51.2-51.2 0-28 23.2-51.2 51.2-51.2s51.2 23.2 51.2 51.2c-0.8 28-23.2 51.2-51.2 51.2z m0-85.6c-19.2 0-35.2 16-35.2 35.2s16 35.2 35.2 35.2 35.2-16 35.2-35.2-16-35.2-35.2-35.2zM820 650.4c-28 0-51.2-23.2-51.2-51.2 0-28 23.2-51.2 51.2-51.2 28 0 51.2 23.2 51.2 51.2 0 28-22.4 51.2-51.2 51.2z m0-85.6c-19.2 0-35.2 16-35.2 35.2s16 35.2 35.2 35.2 35.2-16 35.2-35.2-15.2-35.2-35.2-35.2zM512 920.8c-4 0-8-1.6-11.2-4-20.8-19.2-200-190.4-200-268 0-68 55.2-123.2 123.2-123.2 32.8 0 64.8 13.6 88 36.8 23.2-23.2 54.4-36.8 88-36.8 68 0 123.2 55.2 123.2 123.2 0 76.8-179.2 248.8-200 268-3.2 2.4-7.2 4-11.2 4zM424 557.6c-50.4 0-91.2 40.8-91.2 91.2 0 45.6 105.6 163.2 178.4 234.4 73.6-71.2 178.4-188.8 178.4-234.4 0-50.4-40.8-91.2-91.2-91.2-29.6 0-57.6 14.4-74.4 38.4-3.2 4-8 6.4-12.8 6.4-5.6 0-10.4-2.4-12.8-6.4-16.8-24-44.8-38.4-74.4-38.4zM1004 433.6h-79.2c-7.2 0-12.8-4-15.2-11.2l-28-81.6c-1.6-4.8-0.8-10.4 2.4-14.4s8-6.4 12.8-6.4h107.2c8.8 0 16 7.2 16 16v81.6c0 8.8-7.2 16-16 16z m-68-32h52V352h-68.8l16.8 49.6zM99.2 433.6H20c-8.8 0-16-7.2-16-16V336c0-8.8 7.2-16 16-16h107.2c4.8 0 10.4 2.4 12.8 6.4s4 9.6 2.4 14.4l-28 81.6c-2.4 7.2-8 11.2-15.2 11.2z m-63.2-32H88l16.8-49.6H36v49.6zM941.6 474.4H82.4c-4.8 0-8-3.2-8-8s3.2-8 8-8h859.2c4.8 0 8 3.2 8 8s-4 8-8 8z",
    "M512 1017.6c-122.4 0-237.6-7.2-324.8-20C56.8 977.6 40 952.8 40 932.8s16.8-44.8 147.2-64.8c87.2-12.8 202.4-20 324.8-20s237.6 7.2 324.8 20c130.4 20 147.2 44.8 147.2 64.8s-16.8 44.8-147.2 64.8c-87.2 12.8-202.4 20-324.8 20zM73.6 932.8c20.8 22.4 183.2 52.8 438.4 52.8s417.6-30.4 438.4-52.8c-20.8-22.4-183.2-52.8-438.4-52.8s-417.6 30.4-438.4 52.8zM968 948.8c-0.8 0-0.8 0 0 0-8.8 0-15.2-6.4-16-14.4-16-22.4-179.2-54.4-440-54.4s-424 32-440 54.4c-0.8 8-7.2 14.4-15.2 14.4-8.8 0-16-6.4-16.8-15.2l-36-496c-0.8-7.2 4-13.6 10.4-16 6.4-2.4 14.4 0 18.4 5.6l118.4 155.2 72-230.4c1.6-6.4 7.2-10.4 13.6-11.2 6.4-0.8 12.8 3.2 16 8.8l118.4 227.2 126.4-358.4c2.4-6.4 8-10.4 15.2-10.4s12.8 4 15.2 10.4l126.4 358.4 118.4-227.2c3.2-5.6 8.8-8.8 16-8.8 6.4 0.8 12 4.8 13.6 11.2l72 230.4 118.4-155.2c4-5.6 12-8 18.4-5.6 6.4 2.4 11.2 8.8 10.4 16l-36 496c-2.4 8.8-9.6 15.2-17.6 15.2zM40 489.6l29.6 408.8c21.6-10.4 57.6-20.8 117.6-29.6 87.2-12.8 202.4-20 324.8-20s237.6 7.2 324.8 20c60 8.8 96 19.2 117.6 29.6l29.6-408.8-104 136.8c-4 4.8-9.6 7.2-15.2 6.4-5.6-0.8-10.4-5.6-12.8-11.2l-69.6-222.4L664.8 624c-3.2 5.6-8.8 8.8-15.2 8.8-6.4-0.8-12-4.8-13.6-10.4L512 271.2 388.8 622.4c-2.4 6.4-8 10.4-13.6 10.4-6.4 0-12-3.2-15.2-8.8L241.6 399.2l-69.6 222.4c-1.6 5.6-6.4 9.6-12.8 11.2-5.6 0.8-12-1.6-15.2-6.4L40 489.6zM512 783.2c-40.8 0-74.4-50.4-74.4-112s33.6-112 74.4-112 74.4 50.4 74.4 112-33.6 112-74.4 112z m0-208c-32 0-58.4 43.2-58.4 96s26.4 96 58.4 96 58.4-43.2 58.4-96-26.4-96-58.4-96zM596 296.8c-3.2 0-6.4-0.8-9.6-3.2L512 240l-74.4 54.4c-5.6 4-13.6 4-19.2 0s-8-11.2-5.6-17.6l28.8-88-74.4-54.4c-5.6-4-8-11.2-5.6-17.6 2.4-6.4 8-11.2 15.2-11.2h92l28.8-88c2.4-6.4 8-11.2 15.2-11.2s12.8 4.8 15.2 11.2l28.8 88H648c7.2 0 12.8 4.8 15.2 11.2 2.4 6.4 0 13.6-5.6 17.6l-74.4 54.4 28.8 88c2.4 6.4 0 13.6-5.6 17.6-4 1.6-7.2 2.4-10.4 2.4z m-171.2-160l44 32c5.6 4 8 11.2 5.6 17.6l-16.8 52 44-32c5.6-4 13.6-4 19.2 0l44 32-16.8-52c-2.4-6.4 0-13.6 5.6-17.6l44-32H544c-7.2 0-12.8-4.8-15.2-11.2L512 74.4l-16.8 52c-2.4 6.4-8 11.2-15.2 11.2h-55.2z",
    "M1004 407.2H20c-8.8 0-16-7.2-16-16V237.6c0-8.8 7.2-16 16-16h984c8.8 0 16 7.2 16 16v153.6c0 8.8-7.2 16-16 16z m-968-32h952V253.6H36v121.6zM938.4 1020H85.6c-8.8 0-16-7.2-16-16V391.2c0-8.8 7.2-16 16-16h853.6c8.8 0 16 7.2 16 16v612.8c-0.8 8.8-8 16-16.8 16z m-836.8-32h821.6V407.2H101.6v580.8zM585.6 1012H438.4c-4.8 0-8-3.2-8-8V237.6c0-4.8 3.2-8 8-8h147.2c4.8 0 8 3.2 8 8v766.4c0 4.8-4 8-8 8z m-139.2-16h131.2V245.6H446.4v750.4zM601.6 189.6c-43.2 0-76.8-4-93.6-20-7.2-6.4-10.4-15.2-10.4-24C497.6 90.4 648.8 4 694.4 4c50.4 0 91.2 40.8 91.2 91.2s-40.8 91.2-91.2 91.2c-7.2 0-17.6 0.8-30.4 0.8-21.6 1.6-43.2 2.4-62.4 2.4zM694.4 36c-40 0-164.8 83.2-164.8 109.6 3.2 8 28.8 16 132.8 10.4 12.8-0.8 24-1.6 32-1.6 32.8 0 59.2-26.4 59.2-59.2s-26.4-59.2-59.2-59.2zM422.4 189.6c-19.2 0-40-0.8-62.4-1.6-12.8-0.8-23.2-0.8-30.4-0.8-50.4 0-91.2-40.8-91.2-91.2S279.2 4 329.6 4c45.6 0 196.8 85.6 196.8 141.6 0 9.6-4 17.6-10.4 24-16.8 16-51.2 20-93.6 20zM329.6 36c-32.8 0-59.2 26.4-59.2 59.2s26.4 59.2 59.2 59.2c8 0 19.2 0.8 32 1.6 104.8 5.6 129.6-2.4 132.8-10.4 0-26.4-124.8-109.6-164.8-109.6z",
    "M1004 678.4H37.6c-8.8 0-16-7.2-16-16s7.2-16 16-16h966.4c8.8 0 16 7.2 16 16s-7.2 16-16 16zM319.2 908.8c-2.4 0-4.8-0.8-6.4-1.6L220 864l-92.8 43.2c-4.8 2.4-10.4 1.6-15.2-0.8-4.8-3.2-7.2-8-7.2-13.6V662.4c0-8.8 7.2-16 16-16h198.4c8.8 0 16 7.2 16 16v229.6c0 5.6-2.4 10.4-7.2 13.6-2.4 2.4-5.6 3.2-8.8 3.2z m-99.2-78.4c2.4 0 4.8 0.8 6.4 1.6l76.8 35.2V678.4H136.8v188.8l76.8-35.2c1.6-0.8 4-1.6 6.4-1.6zM921.6 908.8c-2.4 0-4.8-0.8-6.4-1.6l-92.8-43.2-92.8 43.2c-4.8 2.4-10.4 1.6-15.2-0.8-4.8-3.2-7.2-8-7.2-13.6V662.4c0-8.8 7.2-16 16-16h198.4c8.8 0 16 7.2 16 16v229.6c0 5.6-2.4 10.4-7.2 13.6-3.2 2.4-6.4 3.2-8.8 3.2z m-100-78.4c2.4 0 4.8 0.8 6.4 1.6l76.8 35.2V678.4H738.4v188.8l76.8-35.2c2.4-0.8 4.8-1.6 6.4-1.6zM520.8 945.6c-39.2 0-77.6-13.6-109.6-40.8-3.2-3.2-5.6-7.2-5.6-12V662.4c0-8.8 7.2-16 16-16h198.4c8.8 0 16 7.2 16 16v229.6c0 4.8-2.4 8.8-5.6 12-31.2 28-70.4 41.6-109.6 41.6z m-83.2-60.8c49.6 38.4 117.6 38.4 166.4 0V678.4H437.6v206.4zM20 392.8c-7.2 0-12.8-4.8-15.2-11.2-2.4-8.8 2.4-17.6 10.4-20L939.2 79.2c8.8-2.4 17.6 2.4 20 10.4s-2.4 17.6-10.4 20L24.8 392c-1.6 0.8-3.2 0.8-4.8 0.8zM166.4 588.8c-1.6 0-3.2 0-4-0.8-5.6-1.6-9.6-5.6-11.2-10.4l-67.2-220c-2.4-8.8 2.4-17.6 10.4-20l190.4-58.4c4-1.6 8.8-0.8 12 0.8 4 1.6 6.4 5.6 8 9.6l67.2 220c1.6 5.6 0.8 11.2-3.2 15.2-3.2 4-8.8 6.4-14.4 5.6l-100.8-14.4-76 68c-3.2 3.2-7.2 4.8-11.2 4.8z m-47.2-225.6L174.4 544l63.2-56c3.2-3.2 8-4.8 12.8-4l84 11.2-55.2-180.8-160 48.8zM741.6 412.8c-1.6 0-3.2 0-4-0.8-5.6-1.6-9.6-5.6-11.2-10.4l-67.2-220c-1.6-4-0.8-8.8 0.8-12s5.6-6.4 9.6-8l190.4-58.4c8.8-2.4 17.6 2.4 20 10.4l67.2 220c1.6 5.6 0.8 11.2-3.2 15.2-3.2 4-8.8 6.4-14.4 5.6l-100.8-14.4-76 68c-3.2 3.2-7.2 4.8-11.2 4.8z m-47.2-225.6L749.6 368l63.2-56c3.2-3.2 8-4.8 12.8-4l84 11.2-55.2-180.8-160 48.8zM516 513.6c-22.4 0-45.6-4.8-68-14.4-4-1.6-7.2-5.6-8.8-9.6l-67.2-220c-2.4-8.8 2.4-17.6 10.4-20l190.4-58.4c4-1.6 8.8-0.8 12 0.8 4 1.6 6.4 5.6 8 9.6l67.2 220c1.6 4.8 0.8 9.6-1.6 13.6-32.8 50.4-86.4 78.4-142.4 78.4z m-48.8-40.8c58.4 21.6 123.2 2.4 159.2-48.8l-60-197.6-159.2 48.8 60 197.6z",
    "M1004 1020H20c-8.8 0-16-7.2-16-16V562.4c0-36.8 29.6-66.4 67.2-66.4h882.4c36.8 0 67.2 29.6 67.2 66.4v441.6c-0.8 8.8-8 16-16.8 16z m-968-32h952V562.4c0-19.2-16-34.4-35.2-34.4H71.2c-19.2 0-35.2 16-35.2 34.4v425.6zM885.6 528H138.4c-8.8 0-16-7.2-16-16V69.6c0-36 29.6-65.6 65.6-65.6h648c36 0 65.6 29.6 65.6 65.6V512c0 8.8-7.2 16-16 16z m-731.2-32h716V69.6c0-18.4-15.2-33.6-33.6-33.6h-648c-18.4 0-33.6 15.2-33.6 33.6V496zM329.6 756.8c-12.8 0-24.8-3.2-35.2-8.8-12.8-7.2-22.4-19.2-31.2-29.6-10.4-12-20-24-33.6-28.8-19.2-6.4-40.8 2.4-55.2 12-5.6 3.2-11.2 7.2-16 10.4-12.8 8.8-25.6 17.6-41.6 23.2-35.2 12-76.8-0.8-102.4-31.2-1.6-1.6-1.6-3.2-1.6-4.8V562.4C12.8 529.6 39.2 504 72 504h882.4c32.8 0 58.4 26.4 58.4 58.4v126.4c0 2.4-0.8 4.8-3.2 6.4-1.6 1.6-4 2.4-6.4 1.6-13.6-2.4-29.6 0.8-44.8 8-9.6 4-18.4 9.6-27.2 15.2-12 7.2-24 14.4-36.8 19.2-23.2 8.8-56.8 12-80.8-6.4-4-3.2-7.2-5.6-9.6-8.8-3.2-3.2-6.4-6.4-9.6-8.8-24-16.8-59.2-1.6-73.6 5.6-4.8 2.4-9.6 5.6-15.2 8-20.8 12-43.2 24-68 24-28.8 0.8-53.6-14.4-77.6-28.8-21.6-13.6-42.4-25.6-65.6-27.2-28-1.6-54.4 14.4-80 29.6-4 2.4-8 4.8-11.2 7.2-28 15.2-52.8 23.2-73.6 23.2zM215.2 671.2c6.4 0 12.8 0.8 18.4 3.2 17.6 6.4 29.6 20 40.8 33.6 8.8 10.4 16.8 20 27.2 26.4 28 16 65.6 0.8 91.2-14.4 4-2.4 7.2-4.8 11.2-7.2 28-16.8 56.8-34.4 89.6-32 27.2 1.6 50.4 15.2 72.8 29.6 23.2 13.6 44.8 27.2 68.8 26.4 21.6 0 40.8-11.2 60.8-22.4 4.8-3.2 10.4-5.6 15.2-8 20.8-10.4 60.8-25.6 90.4-4.8 4.8 3.2 8 7.2 12 10.4 3.2 3.2 5.6 5.6 8.8 8 19.2 14.4 46.4 12 65.6 4.8 12-4.8 23.2-11.2 34.4-17.6 8.8-5.6 18.4-11.2 28.8-16 15.2-7.2 30.4-10.4 44.8-9.6V562.4c0-23.2-19.2-42.4-42.4-42.4H71.2c-24 0-43.2 19.2-43.2 42.4v132c20.8 23.2 56 33.6 83.2 24.8 13.6-4.8 24.8-12.8 37.6-20.8 5.6-4 11.2-7.2 16.8-11.2 17.6-10.4 34.4-16 49.6-16zM651.2 231.2c-16.8 0-35.2-6.4-56-18.4-3.2-1.6-5.6-3.2-8.8-5.6-19.2-11.2-39.2-23.2-60-22.4-16.8 0.8-32.8 10.4-48.8 20-18.4 11.2-36.8 22.4-60 22.4-20 0-36.8-9.6-52.8-18.4-4-2.4-7.2-4-11.2-6.4-10.4-5.6-36.8-16.8-54.4-4.8-2.4 1.6-4.8 4-7.2 6.4-2.4 2.4-4.8 4.8-8 7.2-19.2 14.4-44.8 12-63.2 5.6-10.4-4-19.2-9.6-28-14.4-7.2-4-13.6-8-20.8-11.2-12-5.6-24-7.2-33.6-5.6-2.4 0.8-4.8 0-6.4-1.6-1.6-1.6-3.2-4-3.2-6.4V69.6c0-32 25.6-57.6 57.6-57.6h648c32 0 57.6 25.6 57.6 57.6v115.2c0 1.6-0.8 4-1.6 4.8-20 24-52.8 33.6-80 24.8-12-4-22.4-11.2-32-17.6-4-2.4-8-5.6-12-8-11.2-6.4-26.4-13.6-40-8.8-9.6 3.2-16.8 12-24.8 20.8-7.2 8.8-14.4 17.6-24.8 23.2-6.4 5.6-16 7.2-25.6 7.2z m-121.6-61.6c24 0 44.8 12.8 65.6 24.8 3.2 1.6 5.6 3.2 8.8 4.8 19.2 11.2 47.2 22.4 67.2 11.2 8-4 13.6-12 20-19.2 8.8-10.4 17.6-20.8 31.2-25.6 15.2-5.6 34.4-1.6 53.6 10.4 4 2.4 8.8 5.6 12.8 8 9.6 6.4 18.4 12 28 15.2 20 7.2 45.6-0.8 60.8-17.6v-112c0-23.2-18.4-41.6-41.6-41.6h-648c-23.2 0-41.6 18.4-41.6 41.6v100c11.2 0 22.4 2.4 33.6 7.2 8 3.2 15.2 8 22.4 12 8.8 4.8 16.8 10.4 25.6 13.6 13.6 5.6 33.6 7.2 48-3.2 2.4-1.6 4-4 6.4-5.6 3.2-2.4 5.6-5.6 9.6-8 23.2-16 54.4-4.8 70.4 3.2 4 1.6 8 4 12 6.4 15.2 8 29.6 16 45.6 16.8h0.8c17.6 0 33.6-9.6 50.4-20 17.6-10.4 35.2-20.8 56-22.4h2.4zM295.2 420.8c-32.8 0-60-27.2-60-60s27.2-60 60-60 60 27.2 60 60-27.2 60-60 60z m0-104.8c-24 0-44 20-44 44s20 44 44 44 44-20 44-44-20-44-44-44zM512 420.8c-32.8 0-60-27.2-60-60s27.2-60 60-60 60 27.2 60 60-27.2 60-60 60z m0-104.8c-24 0-44 20-44 44s20 44 44 44 44-20 44-44-20-44-44-44zM728.8 420.8c-32.8 0-60-27.2-60-60s27.2-60 60-60 60 27.2 60 60-26.4 60-60 60z m0-104.8c-24 0-44 20-44 44s20 44 44 44 44-20 44-44-19.2-44-44-44z",
    "M1004 905.6H20c-8.8 0-16-7.2-16-16V134.4c0-8.8 7.2-16 16-16h984c8.8 0 16 7.2 16 16v755.2c0 8.8-7.2 16-16 16z m-968-32h952V150.4H36v723.2zM914.4 813.6H109.6c-4.8 0-8-3.2-8-8V218.4c0-4.8 3.2-8 8-8h804.8c4.8 0 8 3.2 8 8v588c0 4-3.2 7.2-8 7.2z m-796.8-16h788.8V226.4H117.6v571.2zM272.8 455.2c-50.4 0-91.2-40.8-91.2-91.2s40.8-91.2 91.2-91.2 91.2 40.8 91.2 91.2-40.8 91.2-91.2 91.2z m0-165.6c-41.6 0-75.2 33.6-75.2 75.2s33.6 75.2 75.2 75.2 75.2-33.6 75.2-75.2-33.6-75.2-75.2-75.2zM914.4 813.6H607.2c-2.4 0-4.8-1.6-6.4-3.2l-125.6-176c-2.4-3.2-1.6-6.4 0-9.6L696 340c1.6-1.6 3.2-3.2 5.6-3.2 2.4 0 4.8 0.8 6.4 2.4L920 541.6c1.6 1.6 2.4 3.2 2.4 5.6v258.4c0 4.8-3.2 8-8 8z m-303.2-16h295.2V550.4L703.2 356.8 491.2 629.6l120 168zM607.2 813.6H109.6c-4.8 0-8-3.2-8-8V692.8c0-2.4 1.6-4.8 3.2-6.4l275.2-199.2c1.6-1.6 4-1.6 5.6-1.6 2.4 0 4 1.6 5.6 3.2l222.4 312c1.6 2.4 1.6 5.6 0.8 8s-4.8 4.8-7.2 4.8z m-489.6-16h473.6l-208-292.8-265.6 192v100.8z",
    "M856.8 381.6c-4 0-8-1.6-11.2-4.8L512 42.4 178.4 376.8c-6.4 6.4-16 6.4-22.4 0-6.4-6.4-6.4-16 0-22.4L500.8 8.8c6.4-6.4 16.8-6.4 22.4 0l344.8 345.6c6.4 6.4 6.4 16 0 22.4-3.2 3.2-7.2 4.8-11.2 4.8zM1004 1020H20c-8.8 0-16-7.2-16-16V365.6c0-8.8 7.2-16 16-16h984c8.8 0 16 7.2 16 16v638.4c0 8.8-7.2 16-16 16z m-968-32h952V381.6H36v606.4zM152 583.2v172h93.6v32.8h-128V583.2H152m0-16h-34.4c-8.8 0-16 7.2-16 16v205.6c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-32.8c0-8.8-7.2-16-16-16H168V583.2c0-8.8-6.4-16-16-16zM388.8 578.4c30.4 0 56 10.4 76.8 30.4 20.8 20 31.2 45.6 31.2 76s-10.4 55.2-31.2 76c-20.8 20-46.4 30.4-76.8 30.4s-56-10.4-76.8-30.4c-20.8-20-31.2-45.6-31.2-76s10.4-55.2 31.2-76c20.8-20 46.4-30.4 76.8-30.4m0 180.8c20 0 37.6-7.2 51.2-21.6 13.6-14.4 20.8-32 20.8-52.8 0-20.8-7.2-38.4-20.8-52.8-13.6-14.4-31.2-21.6-51.2-21.6-20 0-37.6 7.2-51.2 21.6-14.4 14.4-20.8 32-20.8 52.8 0 20.8 7.2 38.4 20.8 52.8 13.6 14.4 31.2 21.6 51.2 21.6m0-196.8c-34.4 0-64 12-88 35.2-24 23.2-36 52.8-36 87.2 0 34.4 12 64 36 87.2 24 23.2 53.6 35.2 88 35.2s64-12 88-35.2c24-23.2 36-52.8 36-87.2 0-34.4-12-64-36-87.2-24-23.2-53.6-35.2-88-35.2z m0 180.8c-16 0-28.8-5.6-40-16.8-11.2-11.2-16.8-24.8-16.8-41.6s5.6-30.4 16.8-41.6c11.2-11.2 24-16.8 40-16.8s28.8 5.6 40 16.8c11.2 11.2 16.8 24.8 16.8 41.6s-5.6 30.4-16.8 41.6c-11.2 11.2-24 16.8-40 16.8zM713.6 583.2L631.2 788.8H592L509.6 583.2h38.4l63.2 153.6 63.2-153.6h39.2m0-16h-38.4c-6.4 0-12 4-14.4 9.6l-48 117.6-48-117.6c-2.4-5.6-8-9.6-14.4-9.6H512c-5.6 0-10.4 2.4-13.6 7.2s-3.2 9.6-1.6 15.2l82.4 205.6c2.4 6.4 8 10.4 15.2 10.4h38.4c6.4 0 12.8-4 15.2-10.4l80-205.6c1.6-4.8 1.6-10.4-1.6-15.2-2.4-4-8-7.2-12.8-7.2zM902.4 583.2V616H793.6v54.4h98.4v31.2H793.6v55.2h112.8v32.8H758.4V583.2h144m0-16h-144c-8.8 0-16 7.2-16 16v205.6c0 8.8 7.2 16 16 16h148c8.8 0 16-7.2 16-16v-32.8c0-8.8-7.2-16-16-16h-96.8v-23.2h82.4c8.8 0 16-7.2 16-16v-31.2c0-8.8-7.2-16-16-16h-82.4V632h93.6c8.8 0 16-7.2 16-16v-32.8c-0.8-8.8-7.2-16-16.8-16z",
    "M1004 799.2H35.2c-8.8 0-16-7.2-16-16s7.2-16 16-16h968.8c8.8 0 16 7.2 16 16s-7.2 16-16 16zM217.6 1020c-6.4 0-12-4-14.4-9.6L103.2 789.6c-2.4-4.8-1.6-10.4 0.8-15.2 3.2-4.8 8-7.2 13.6-7.2h200c5.6 0 10.4 2.4 13.6 7.2 3.2 4.8 3.2 10.4 0.8 15.2L232 1010.4c-2.4 5.6-8 9.6-14.4 9.6z m-75.2-220.8l75.2 165.6 75.2-165.6H142.4zM519.2 1020c-6.4 0-12-4-14.4-9.6L404.8 789.6c-2.4-4.8-1.6-10.4 0.8-15.2 3.2-4.8 8-7.2 13.6-7.2h200c5.6 0 10.4 2.4 13.6 7.2 3.2 4.8 3.2 10.4 0.8 15.2l-100 220.8c-2.4 5.6-8 9.6-14.4 9.6z m-75.2-220.8l75.2 165.6 75.2-165.6H444zM820.8 1020c-6.4 0-12-4-14.4-9.6L706.4 789.6c-2.4-4.8-1.6-10.4 0.8-15.2 3.2-4.8 8-7.2 13.6-7.2h200c5.6 0 10.4 2.4 13.6 7.2 3.2 4.8 3.2 10.4 0.8 15.2l-100 220.8c-2.4 5.6-8 9.6-14.4 9.6z m-75.2-220.8l75.2 165.6 75.2-165.6H745.6zM1004 36H35.2c-8.8 0-16-7.2-16-16s7.2-16 16-16h968.8c8.8 0 16 7.2 16 16s-7.2 16-16 16zM217.6 256.8c-6.4 0-12-4-14.4-9.6L103.2 26.4c-2.4-4.8-1.6-10.4 0.8-15.2 3.2-4.8 8-7.2 13.6-7.2h200c5.6 0 10.4 2.4 13.6 7.2 3.2 4.8 3.2 10.4 0.8 15.2L232.8 247.2c-3.2 5.6-8.8 9.6-15.2 9.6zM142.4 36l75.2 165.6 75.2-165.6H142.4zM519.2 256.8c-6.4 0-12-4-14.4-9.6L404.8 26.4c-2.4-4.8-1.6-10.4 0.8-15.2 3.2-4.8 8-7.2 13.6-7.2h200c5.6 0 10.4 2.4 13.6 7.2 3.2 4.8 3.2 10.4 0.8 15.2L534.4 247.2c-3.2 5.6-8.8 9.6-15.2 9.6zM444 36l75.2 165.6 75.2-165.6H444zM820.8 256.8c-6.4 0-12-4-14.4-9.6L706.4 26.4c-2.4-4.8-1.6-10.4 1.6-15.2 3.2-4.8 8-7.2 13.6-7.2h200c5.6 0 10.4 2.4 13.6 7.2 3.2 4.8 3.2 10.4 0.8 15.2l-100 220.8c-3.2 5.6-8.8 9.6-15.2 9.6zM745.6 36l75.2 165.6L896 36H745.6zM20 531.2c-7.2 0-13.6-4.8-15.2-12-2.4-8.8 3.2-17.6 12-19.2l934.4-233.6c8.8-2.4 17.6 3.2 19.2 12 2.4 8.8-3.2 17.6-12 19.2L24 531.2h-4zM260.8 700c-4.8 0-8.8-1.6-12-5.6L88 505.6c-4-4-4.8-9.6-3.2-15.2 1.6-5.6 5.6-9.6 11.2-10.4l192.8-48c4.8-1.6 10.4 0 14.4 3.2s5.6 8.8 5.6 14.4l-31.2 236.8c-0.8 6.4-5.6 11.2-11.2 13.6h-5.6zM128.8 504.8l120.8 141.6 24-177.6-144.8 36zM552 627.2c-4.8 0-8.8-1.6-12-5.6L378.4 432.8c-4-4-4.8-9.6-3.2-15.2 1.6-5.6 5.6-9.6 11.2-10.4l192.8-48c4.8-1.6 10.4 0 14.4 3.2s5.6 8.8 5.6 14.4L568 613.6c-0.8 6.4-5.6 11.2-11.2 13.6H552zM420 432l120.8 141.6 24-177.6L420 432zM842.4 554.4c-4.8 0-8.8-1.6-12-5.6L669.6 360c-4-4-4.8-9.6-3.2-15.2 1.6-5.6 5.6-9.6 11.2-10.4l192.8-48c4.8-1.6 10.4 0 14.4 3.2s5.6 8.8 5.6 14.4l-31.2 236.8c-0.8 6.4-5.6 11.2-11.2 13.6h-5.6zM710.4 359.2l120.8 141.6 24-177.6-144.8 36z",
    "M895.2 1020H117.6c-8.8 0-16-7.2-16-16V20c0-8.8 7.2-16 16-16h777.6c8.8 0 16 7.2 16 16v984c0 8.8-7.2 16-16 16z m-761.6-32h745.6V36H133.6v952zM506.4 713.6c-1.6 0-4-0.8-5.6-2.4-8.8-8-209.6-198.4-209.6-278.4 0-67.2 54.4-121.6 121.6-121.6 36 0 70.4 16 93.6 43.2 23.2-27.2 56.8-43.2 93.6-43.2 67.2 0 121.6 54.4 121.6 121.6 0 79.2-200.8 270.4-209.6 278.4-1.6 1.6-3.2 2.4-5.6 2.4zM413.6 326.4c-58.4 0-105.6 47.2-105.6 105.6 0 59.2 138.4 204 199.2 261.6 60-57.6 199.2-203.2 199.2-261.6 0-58.4-47.2-105.6-105.6-105.6-34.4 0-67.2 16.8-86.4 44.8-3.2 4-10.4 4-12.8 0-21.6-28-53.6-44.8-88-44.8zM1004 243.2h-108.8c-8.8 0-16-7.2-16-16V93.6c0-8.8 7.2-16 16-16h108.8c8.8 0 16 7.2 16 16v132.8c0 9.6-7.2 16.8-16 16.8z m-92.8-32h76.8V109.6h-76.8v101.6zM1004 477.6h-108.8c-8.8 0-16-7.2-16-16V328c0-8.8 7.2-16 16-16h108.8c8.8 0 16 7.2 16 16v132.8c0 9.6-7.2 16.8-16 16.8z m-92.8-32h76.8V344h-76.8v101.6zM1004 712h-108.8c-8.8 0-16-7.2-16-16V562.4c0-8.8 7.2-16 16-16h108.8c8.8 0 16 7.2 16 16V696c0 8.8-7.2 16-16 16z m-92.8-32h76.8V578.4h-76.8V680zM1004 946.4h-108.8c-8.8 0-16-7.2-16-16V796.8c0-8.8 7.2-16 16-16h108.8c8.8 0 16 7.2 16 16v132.8c0 9.6-7.2 16.8-16 16.8z m-92.8-32h76.8v-100.8h-76.8v100.8zM212.8 146.4H20c-8.8 0-16-7.2-16-16s7.2-16 16-16h192.8c8.8 0 16 7.2 16 16s-7.2 16-16 16zM212.8 272H20c-8.8 0-16-7.2-16-16s7.2-16 16-16h192.8c8.8 0 16 7.2 16 16s-7.2 16-16 16zM212.8 784H20c-8.8 0-16-7.2-16-16s7.2-16 16-16h192.8c8.8 0 16 7.2 16 16s-7.2 16-16 16zM212.8 909.6H20c-8.8 0-16-7.2-16-16s7.2-16 16-16h192.8c8.8 0 16 7.2 16 16s-7.2 16-16 16z",
    "M893.6 1020H130.4c-19.2 0-37.6-8-50.4-22.4-12.8-14.4-19.2-33.6-16.8-52L128 301.6c3.2-35.2 32.8-60.8 67.2-60.8h632.8c35.2 0 64 26.4 67.2 60.8l64.8 644c1.6 19.2-4 38.4-17.6 52-11.2 14.4-29.6 22.4-48.8 22.4zM195.2 272.8c-18.4 0-33.6 13.6-36 32l-64.8 644c-0.8 10.4 2.4 20 8.8 28 7.2 8 16 12 26.4 12h763.2c10.4 0 20-4 26.4-12s10.4-17.6 8.8-28l-64-644c-1.6-18.4-17.6-32-36-32H195.2zM568.8 850.4c-1.6 0-4-0.8-5.6-2.4 0 0-26.4-24.8-57.6-57.6-3.2-3.2-3.2-8 0-11.2 3.2-3.2 8-3.2 11.2 0 22.4 24 42.4 43.2 51.2 52 50.4-48 162.4-166.4 162.4-213.6 0-47.2-38.4-85.6-85.6-85.6-19.2 0-36.8 6.4-52 17.6-3.2 2.4-8.8 2.4-11.2-1.6-1.6-4-0.8-8.8 2.4-12 17.6-13.6 39.2-20.8 61.6-20.8 56 0 101.6 45.6 101.6 101.6 0 66.4-166.4 224-173.6 230.4-0.8 2.4-2.4 3.2-4.8 3.2zM700 372.8c-8.8 0-16-7.2-16-16V208c0-95.2-77.6-172-172-172S340 113.6 340 208v148.8c0 8.8-7.2 16-16 16s-16-7.2-16-16V208C308 96 399.2 4 512 4S716 96 716 208v148.8c0 8.8-7.2 16-16 16zM455.2 850.4c-1.6 0-4-0.8-5.6-2.4-7.2-6.4-173.6-164-173.6-230.4 0-56 45.6-101.6 101.6-101.6 29.6 0 57.6 12.8 76.8 35.2 19.2-22.4 47.2-35.2 76.8-35.2 56 0 101.6 45.6 101.6 101.6 0 66.4-166.4 224-173.6 230.4 0 1.6-2.4 2.4-4 2.4z m-76.8-319.2c-47.2 0-85.6 38.4-85.6 85.6 0 48 112.8 165.6 162.4 213.6 50.4-48 162.4-166.4 162.4-213.6 0-47.2-38.4-85.6-85.6-85.6-28 0-54.4 13.6-70.4 36.8-3.2 4-10.4 4-12.8 0-16-23.2-42.4-36.8-70.4-36.8z",
    "M776 468H646.4c-8.8 0-16-7.2-16-16s7.2-16 16-16h108l-75.2-272c-20.8-75.2-89.6-128-168-128s-147.2 52.8-168 128l-75.2 272H376c8.8 0 16 7.2 16 16s-7.2 16-16 16H248c-4.8 0-9.6-2.4-12.8-6.4-3.2-4-4-8.8-2.4-13.6l80-292C337.6 66.4 419.2 4 512 4c92.8 0 174.4 62.4 198.4 151.2l80 292c1.6 4.8 0 9.6-2.4 13.6-2.4 4.8-7.2 7.2-12 7.2zM512 266.4c-51.2 0-92.8-41.6-92.8-92.8S460.8 80.8 512 80.8s92.8 41.6 92.8 92.8S563.2 266.4 512 266.4z m0-169.6c-42.4 0-76.8 34.4-76.8 76.8s34.4 76.8 76.8 76.8 76.8-34.4 76.8-76.8-34.4-76.8-76.8-76.8zM856.8 1020H167.2c-8.8 0-16-7.2-16-16 0-173.6 85.6-330.4 218.4-398.4 4-1.6 8-2.4 12-0.8h260.8c4-0.8 7.2-0.8 11.2 0.8 132.8 68 218.4 224.8 218.4 398.4 0.8 8.8-6.4 16-15.2 16z m-672.8-32h656c-4.8-153.6-80.8-289.6-196-352h-264c-115.2 62.4-191.2 198.4-196 352zM646.4 636H377.6c-8.8 0-16-7.2-16-16V312c0-8.8 7.2-16 16-16h268.8c8.8 0 16 7.2 16 16v308c0 8.8-7.2 16-16 16z m-252.8-32h236.8V328H393.6v276z",
    "M1004 894.4H20c-8.8 0-16-7.2-16-16V145.6c0-8.8 7.2-16 16-16h984c8.8 0 16 7.2 16 16v732c0 9.6-7.2 16.8-16 16.8z m-968-32h952V161.6H36v700.8zM335.2 712.8c-1.6 0-4-0.8-5.6-2.4-8.8-8-208.8-197.6-208.8-277.6 0-67.2 54.4-121.6 121.6-121.6 36 0 69.6 16 92.8 43.2 23.2-27.2 56.8-43.2 92.8-43.2 67.2 0 121.6 54.4 121.6 121.6 0 79.2-200 269.6-208.8 277.6-1.6 1.6-4 2.4-5.6 2.4zM242.4 327.2c-58.4 0-105.6 47.2-105.6 105.6 0 58.4 138.4 203.2 198.4 260.8 60-57.6 198.4-202.4 198.4-260.8 0-58.4-47.2-105.6-105.6-105.6-34.4 0-66.4 16.8-86.4 44.8-3.2 4-10.4 4-12.8 0-20-28-52-44.8-86.4-44.8zM895.2 318.4H653.6c-4.8 0-8-3.2-8-8s3.2-8 8-8h241.6c4.8 0 8 3.2 8 8s-3.2 8-8 8zM895.2 520H653.6c-4.8 0-8-3.2-8-8s3.2-8 8-8h241.6c4.8 0 8 3.2 8 8s-3.2 8-8 8zM895.2 721.6H653.6c-4.8 0-8-3.2-8-8s3.2-8 8-8h241.6c4.8 0 8 3.2 8 8s-3.2 8-8 8z",
    "M189.6 492c-41.6 0-76-34.4-76-76s34.4-76 76-76 76 34.4 76 76-34.4 76-76 76z m0-119.2c-24 0-44 20-44 44s20 44 44 44 44-20 44-44-20-44-44-44zM189.6 724.8c-60 0-108.8-48.8-108.8-108.8s48.8-108.8 108.8-108.8S297.6 556 297.6 616s-48.8 108.8-108 108.8z m0-185.6c-42.4 0-76.8 34.4-76.8 76.8s34.4 76.8 76.8 76.8 76.8-34.4 76.8-76.8-35.2-76.8-76.8-76.8zM189.6 314.4c-68.8 0-108.8-152.8-108.8-201.6C80.8 52.8 129.6 4 189.6 4s108.8 48.8 108.8 108.8c-0.8 48.8-40 201.6-108.8 201.6z m0-278.4c-42.4 0-76.8 34.4-76.8 76.8 0 54.4 43.2 169.6 76.8 169.6s76.8-115.2 76.8-169.6c-0.8-42.4-35.2-76.8-76.8-76.8zM189.6 1020c-76.8 0-138.4-62.4-138.4-138.4s62.4-138.4 138.4-138.4c76.8 0 138.4 62.4 138.4 138.4s-62.4 138.4-138.4 138.4z m0-245.6c-59.2 0-106.4 48-106.4 106.4s48 106.4 106.4 106.4c59.2 0 106.4-48 106.4-106.4s-48-106.4-106.4-106.4zM189.6 372.8c-8.8 0-16-7.2-16-16v-57.6c0-8.8 7.2-16 16-16s16 7.2 16 16v57.6c0 8.8-7.2 16-16 16zM189.6 539.2c-8.8 0-16-7.2-16-16v-47.2c0-8.8 7.2-16 16-16s16 7.2 16 16v47.2c0 8.8-7.2 16-16 16zM189.6 774.4c-8.8 0-16-7.2-16-16v-50.4c0-8.8 7.2-16 16-16s16 7.2 16 16v50.4c0 8.8-7.2 16-16 16zM392 128.8H281.6c-8.8 0-16-7.2-16-16s7.2-16 16-16H392c8.8 0 16 7.2 16 16s-7.2 16-16 16zM754.4 492c-41.6 0-76-34.4-76-76s34.4-76 76-76 76 34.4 76 76-34.4 76-76 76z m0-119.2c-24 0-44 20-44 44s20 44 44 44 44-20 44-44-20-44-44-44zM754.4 724.8c-60 0-108.8-48.8-108.8-108.8s48.8-108.8 108.8-108.8 108.8 48.8 108.8 108.8-48.8 108.8-108.8 108.8z m0-185.6c-42.4 0-76.8 34.4-76.8 76.8s34.4 76.8 76.8 76.8 76.8-34.4 76.8-76.8-34.4-76.8-76.8-76.8zM754.4 314.4c-68.8 0-108.8-152.8-108.8-201.6C645.6 52.8 694.4 4 754.4 4s108.8 48.8 108.8 108.8c0 48.8-40 201.6-108.8 201.6z m0-278.4c-42.4 0-76.8 34.4-76.8 76.8 0 54.4 43.2 169.6 76.8 169.6s76.8-115.2 76.8-169.6c0-42.4-34.4-76.8-76.8-76.8zM754.4 1020c-76.8 0-138.4-62.4-138.4-138.4s62.4-138.4 138.4-138.4 138.4 62.4 138.4 138.4-61.6 138.4-138.4 138.4z m0-245.6c-59.2 0-106.4 48-106.4 106.4s48 106.4 106.4 106.4 106.4-48 106.4-106.4-48-106.4-106.4-106.4zM754.4 372.8c-8.8 0-16-7.2-16-16v-57.6c0-8.8 7.2-16 16-16s16 7.2 16 16v57.6c0 8.8-7.2 16-16 16zM754.4 539.2c-8.8 0-16-7.2-16-16v-47.2c0-8.8 7.2-16 16-16s16 7.2 16 16v47.2c0 8.8-7.2 16-16 16zM754.4 774.4c-8.8 0-16-7.2-16-16v-50.4c0-8.8 7.2-16 16-16s16 7.2 16 16v50.4c0 8.8-7.2 16-16 16zM957.6 128.8h-110.4c-8.8 0-16-7.2-16-16s7.2-16 16-16h110.4c8.8 0 16 7.2 16 16s-7.2 16-16 16z",
    "M441.6 224.8c-8.8 0-16-7.2-16-16v-160c0-7.2-5.6-12.8-12.8-12.8H84c-7.2 0-12.8 5.6-12.8 12.8v160c0 8.8-7.2 16-16 16s-16-7.2-16-16v-160C39.2 24 59.2 4 84 4h328.8c24.8 0 44.8 20 44.8 44.8v160c0 8.8-7.2 16-16 16zM412.8 1020H84c-24.8 0-44.8-20-44.8-44.8V453.6c0-8.8 7.2-16 16-16s16 7.2 16 16v521.6c0 7.2 5.6 12.8 12.8 12.8h328.8c7.2 0 12.8-5.6 12.8-12.8V453.6c0-8.8 7.2-16 16-16s16 7.2 16 16v521.6c0 24.8-20 44.8-44.8 44.8zM248.8 576C113.6 576 4 466.4 4 331.2s109.6-244 244.8-244c135.2 0 244.8 109.6 244.8 244S383.2 576 248.8 576z m0-456.8c-117.6 0-212.8 95.2-212.8 212S131.2 544 248.8 544s212.8-96 212.8-212.8-96-212-212.8-212zM248.8 474.4c-79.2 0-143.2-64-143.2-143.2s64-143.2 143.2-143.2c79.2 0 143.2 64 143.2 143.2s-64 143.2-143.2 143.2z m0-270.4c-70.4 0-127.2 56.8-127.2 127.2s56.8 127.2 127.2 127.2S376 401.6 376 331.2s-56.8-127.2-127.2-127.2zM987.2 979.2H569.6c-17.6 0-32.8-14.4-32.8-32.8V541.6c0-17.6 14.4-32.8 32.8-32.8h417.6c17.6 0 32.8 14.4 32.8 32.8v404.8c0 18.4-14.4 32.8-32.8 32.8zM569.6 541.6l-0.8 405.6 418.4 0.8s0.8 0 0.8-0.8V541.6H569.6zM553.6 885.6h-112c-8.8 0-16-7.2-16-16V619.2c0-8.8 7.2-16 16-16h111.2c8.8 0 16 7.2 16 16v250.4c0.8 8.8-6.4 16-15.2 16z m-96-32h79.2V635.2h-79.2v218.4zM311.2 912.8H186.4c-8 0-14.4-5.6-16-12.8l-16.8-85.6c-0.8-4.8 0-9.6 3.2-13.6s8-5.6 12.8-5.6H328c4.8 0 9.6 2.4 12.8 5.6 3.2 4 4 8.8 3.2 13.6l-16.8 85.6c-1.6 8-8 12.8-16 12.8z m-142.4-101.6l16.8 85.6h125.6l16.8-85.6H168.8zM861.6 812H696c-8.8 0-16.8-7.2-16.8-16.8V692.8c0-8.8 7.2-16.8 16.8-16.8h165.6c8.8 0 16.8 7.2 16.8 16.8v103.2c-0.8 8.8-8 16-16.8 16zM696 692l-0.8 104 166.4 0.8s0.8 0 0.8-0.8V692.8L696 692z",
    "M911.2 784.8H314.4c-4 0-8-1.6-11.2-4l-68-63.2c-3.2-3.2-4.8-7.2-4.8-12V469.6c0-4.8 1.6-8.8 4.8-12l68-63.2c3.2-2.4 7.2-4 11.2-4h312.8l75.2-62.4c3.2-2.4 6.4-4 10.4-4H912c8.8 0 16 7.2 16 16v428.8c-0.8 8.8-8 16-16.8 16z m-591.2-32h575.2V356H718.4l-75.2 62.4c-3.2 2.4-6.4 4-10.4 4H320l-58.4 54.4v222.4l58.4 53.6zM20 761.6c-4 0-7.2-1.6-10.4-4-4-3.2-5.6-7.2-5.6-12V429.6c0-4.8 2.4-9.6 5.6-12s8.8-4 12.8-3.2L167.2 440 248 454.4c8 1.6 12.8 8 12.8 16v236c0 8-5.6 14.4-12.8 16l-225.6 40c-0.8-0.8-1.6-0.8-2.4-0.8z m16-313.6v278.4l193.6-34.4V483.2L36 448zM783.2 670.4H501.6c-4.8 0-8-3.2-8-8V476.8c0-4.8 3.2-8 8-8h281.6c4.8 0 8 3.2 8 8v185.6c0 4.8-3.2 8-8 8z m-273.6-16h265.6V484.8H509.6v169.6zM986.4 452h-2.4l-74.4-11.2c-8-0.8-13.6-8-13.6-16V332.8c0-8 5.6-14.4 13.6-16l75.2-11.2c6.4-0.8 12.8 1.6 16 7.2 27.2 42.4 27.2 88.8 0 131.2-4 5.6-8.8 8-14.4 8z m-59.2-40.8l50.4 7.2c13.6-26.4 13.6-52.8 0-79.2l-50.4 7.2v64.8zM328 349.6H75.2c-27.2 0-49.6-22.4-49.6-49.6V288c0-27.2 22.4-49.6 49.6-49.6H328c8.8 0 16 7.2 16 16v78.4c0 9.6-7.2 16.8-16 16.8zM75.2 271.2c-9.6 0-17.6 8-17.6 17.6v12c0 9.6 8 17.6 17.6 17.6H312V272H75.2zM382.4 422.4H328c-8.8 0-16-7.2-16-16V255.2c0-8.8 7.2-16 16-16h290.4c4 0 8 1.6 10.4 4L723.2 328c3.2 3.2 5.6 7.2 5.6 12s-2.4 8.8-5.6 12L672 395.2c-6.4 5.6-16.8 4.8-22.4-2.4-5.6-6.4-4.8-16.8 2.4-22.4l36.8-30.4-76-68.8H344v119.2h39.2c8.8 0 16 7.2 16 16s-8 16-16.8 16zM382.4 414.4c-4.8 0-8-3.2-8-8V308.8c0-4.8 3.2-8 8-8h198.4c2.4 0 4 0.8 5.6 2.4l80 73.6c3.2 3.2 3.2 8 0.8 11.2-3.2 3.2-8 3.2-11.2 0.8l-78.4-71.2H390.4v89.6c0 3.2-3.2 7.2-8 7.2zM378.4 532.8h-32c-4.8 0-8-3.2-8-8s3.2-8 8-8h32c4.8 0 8 3.2 8 8s-3.2 8-8 8zM378.4 622.4h-32c-4.8 0-8-3.2-8-8s3.2-8 8-8h32c4.8 0 8 3.2 8 8s-3.2 8-8 8zM164.8 728c-1.6 0-4-0.8-4.8-1.6-1.6-1.6-3.2-4-3.2-6.4V455.2c0-2.4 0.8-4.8 3.2-6.4 1.6-1.6 4-2.4 6.4-1.6l80.8 14.4c4 0.8 6.4 4 6.4 8v236c0 4-2.4 7.2-6.4 8L165.6 728h-0.8z m8-263.2v245.6l64.8-12V476l-64.8-11.2z",
    "M808 619.2H217.6c-6.4 0-12.8-4-15.2-10.4l-60.8-174.4c-1.6-4.8-0.8-10.4 2.4-14.4s8-6.4 12.8-6.4h712c4.8 0 10.4 2.4 12.8 6.4s4 9.6 2.4 14.4l-60.8 174.4c-2.4 6.4-8.8 10.4-15.2 10.4z m-579.2-32h567.2l49.6-142.4H179.2l49.6 142.4zM845.6 444.8H180c-8.8 0-16-7.2-16-16C164 256 288 112 455.2 84.8c-2.4-6.4-3.2-12.8-3.2-20 0-33.6 27.2-60.8 60.8-60.8s60.8 27.2 60.8 60.8c0 7.2-0.8 13.6-3.2 20 168 27.2 291.2 171.2 291.2 344 0 8.8-7.2 16-16 16z m-648.8-32h632.8c-8-157.6-128.8-284.8-287.2-299.2-6.4-0.8-12-4.8-13.6-10.4s-0.8-12.8 4-16.8c5.6-5.6 8.8-12.8 8.8-20.8 0-16-12.8-28.8-28.8-28.8s-28.8 12.8-28.8 28.8c0 8 3.2 15.2 8.8 20.8 4.8 4 6.4 11.2 4 16.8-2.4 5.6-7.2 10.4-13.6 10.4C324.8 128 204 255.2 196.8 412.8zM773.6 372.8c-4 0-7.2-2.4-8-6.4C740 258.4 648 179.2 536.8 168.8l-24-2.4-24 2.4c-4.8 0-8-3.2-8.8-7.2 0-4 3.2-8 7.2-8.8l24.8-2.4h1.6l24.8 2.4C656 164 754.4 248 781.6 362.4c0.8 4-1.6 8.8-5.6 9.6-0.8 0.8-1.6 0.8-2.4 0.8zM48.8 1020c-1.6 0-2.4 0-4-0.8-8.8-2.4-13.6-11.2-11.2-19.2l131.2-501.6c2.4-8.8 11.2-13.6 19.2-11.2 8.8 2.4 13.6 11.2 11.2 19.2L64.8 1008c-2.4 7.2-8.8 12-16 12zM975.2 1020c-7.2 0-13.6-4.8-15.2-12l-131.2-501.6c-2.4-8.8 3.2-17.6 11.2-19.2 8.8-2.4 17.6 3.2 19.2 11.2l131.2 501.6c2.4 8.8-3.2 17.6-11.2 19.2-1.6 0.8-3.2 0.8-4 0.8zM502.4 900.8c-8.8 0-16-7.2-16-16V603.2c0-8.8 7.2-16 16-16s16 7.2 16 16v281.6c0 8.8-7.2 16-16 16z",
    "M512 987.2c-4 0-8-1.6-11.2-4C480.8 964 4 512.8 4 324 4 165.6 132.8 37.6 290.4 37.6 376 37.6 457.6 76 512 142.4 566.4 76 647.2 36.8 733.6 36.8c158.4 0 286.4 128.8 286.4 286.4 0 48-28.8 113.6-88.8 200.8-4.8 7.2-15.2 8.8-22.4 4-7.2-4.8-8.8-15.2-4-22.4 55.2-80 83.2-141.6 83.2-182.4 0-140.8-114.4-254.4-254.4-254.4-82.4 0-160.8 40.8-208 108-3.2 4-8 6.4-12.8 6.4-5.6 0-10.4-2.4-12.8-6.4-48-68-125.6-108-208-108-141.6 0-256 114.4-256 254.4 0 160 404 556 476 625.6 19.2-18.4 60.8-59.2 112-112 6.4-6.4 16-6.4 22.4 0 6.4 6.4 6.4 16 0 22.4-70.4 72.8-123.2 122.4-124 123.2-2.4 3.2-6.4 4.8-10.4 4.8zM940 331.2c-4.8 0-8-3.2-8-8 0-109.6-88.8-198.4-198.4-198.4-4.8 0-8-3.2-8-8s3.2-8 8-8c118.4 0 214.4 96 214.4 214.4 0 4.8-3.2 8-8 8zM754.4 987.2c-4 0-8-1.6-11.2-4-26.4-24.8-254.4-242.4-254.4-340 0-84.8 68.8-153.6 153.6-153.6 43.2 0 83.2 18.4 112 48.8 28.8-31.2 69.6-48.8 112-48.8 84.8 0 153.6 68.8 153.6 153.6 0 96.8-228.8 316-254.4 340-3.2 2.4-7.2 4-11.2 4zM641.6 520.8c-67.2 0-121.6 54.4-121.6 121.6 0 67.2 159.2 235.2 233.6 306.4 74.4-72 233.6-240 233.6-306.4 0-67.2-54.4-121.6-121.6-121.6-39.2 0-76.8 19.2-99.2 51.2-3.2 4-8 6.4-12.8 6.4s-10.4-2.4-12.8-6.4c-22.4-32-59.2-51.2-99.2-51.2z",
    "M512 1020c-4.8 0-9.6-2.4-12.8-6.4L116.8 519.2c-4-5.6-4.8-13.6 0-19.2l56.8-77.6L11.2 320.8c-4-2.4-7.2-7.2-7.2-12.8s1.6-10.4 5.6-13.6l233.6-195.2c4-3.2 9.6-4.8 15.2-3.2 4.8 1.6 8.8 5.6 10.4 11.2l258.4 891.2c2.4 7.2-1.6 15.2-8 18.4-2.4 2.4-4.8 3.2-7.2 3.2zM148.8 508.8L473.6 928 244.8 140.8 47.2 305.6l156.8 98.4c4 2.4 6.4 6.4 7.2 10.4s0 8.8-2.4 12.8l-60 81.6zM512 1020c-2.4 0-4.8-0.8-7.2-1.6-7.2-3.2-10.4-11.2-8-18.4L755.2 108c1.6-4.8 5.6-9.6 10.4-11.2 4.8-1.6 10.4-0.8 15.2 3.2l233.6 195.2c4 3.2 6.4 8 5.6 13.6s-3.2 9.6-7.2 12.8l-161.6 100.8 56.8 77.6c4 5.6 4 13.6 0 19.2l-383.2 495.2c-3.2 3.2-8 5.6-12.8 5.6zM779.2 140.8L550.4 928l324-419.2-60-81.6c-2.4-3.2-4-8-2.4-12.8s3.2-8 7.2-10.4L976 305.6 779.2 140.8zM389.6 168c-14.4 0-20-4.8-24-7.2-23.2-17.6-25.6-61.6-25.6-75.2 0-13.6 1.6-57.6 25.6-75.2 8-5.6 30.4-22.4 128 30.4 4.8 2.4 8 7.2 8 12.8 0.8 5.6-1.6 10.4-5.6 13.6-4.8 5.6-8 12-8 19.2 0 7.2 3.2 13.6 8.8 18.4 4 3.2 6.4 8.8 5.6 13.6-0.8 5.6-4 9.6-8 12.8C439.2 160.8 408 168 389.6 168z m0-132c-2.4 0-4 0-4.8 0.8-4.8 4-12 21.6-12 49.6s7.2 45.6 12 49.6c4.8 3.2 29.6 0 76.8-24-4-8-5.6-16-5.6-24.8s2.4-17.6 5.6-24.8c-37.6-20.8-61.6-26.4-72-26.4zM634.4 168c-18.4 0-49.6-8-104-37.6-4.8-2.4-8-7.2-8-12.8-0.8-5.6 1.6-10.4 5.6-13.6 5.6-4.8 8.8-11.2 8.8-18.4 0-7.2-3.2-13.6-8.8-18.4-4-3.2-6.4-8.8-5.6-13.6 0.8-5.6 4-9.6 8-12.8 97.6-53.6 120.8-36 128-30.4 23.2 17.6 25.6 61.6 25.6 75.2 0 13.6-1.6 57.6-25.6 75.2-4 3.2-10.4 7.2-24 7.2z m-72.8-56.8c48 24 72.8 27.2 77.6 24 4.8-4 12-21.6 12-49.6s-7.2-45.6-12-49.6c-4.8-2.4-29.6 0-77.6 24 4 8 5.6 16 5.6 24.8 0.8 10.4-1.6 18.4-5.6 26.4zM512 141.6c-30.4 0-56-24.8-56-56s24.8-56 56-56 56 24.8 56 56-25.6 56-56 56z m0-79.2c-12.8 0-24 10.4-24 24 0 12.8 10.4 24 24 24 12.8 0 24-10.4 24-24s-11.2-24-24-24z",
    "M903.2 974.4c-4 0-8-1.6-11.2-4.8l-144.8-144H330.4c-8.8 0-16-7.2-16-16V284.8c0-8.8 7.2-16 16-16h673.6c8.8 0 16 7.2 16 16v524.8c0 8.8-7.2 16-16 16h-84.8v132c0 6.4-4 12-9.6 14.4-2.4 1.6-4 2.4-6.4 2.4zM346.4 793.6h407.2c4 0 8 1.6 11.2 4.8l122.4 121.6v-109.6c0-8.8 7.2-16 16-16h84.8V300.8H346.4v492.8zM120.8 755.2c-2.4 0-4-0.8-6.4-1.6-5.6-2.4-9.6-8-9.6-14.4V607.2H20c-8.8 0-16-7.2-16-16V65.6c0-8.8 7.2-16 16-16h673.6c8.8 0 16 7.2 16 16v218.4c0 8.8-7.2 16-16 16H346.4v290.4c0 8.8-7.2 16-16 16h-53.6l-144.8 144c-3.2 3.2-7.2 4.8-11.2 4.8zM36 575.2h84.8c8.8 0 16 7.2 16 16v109.6l122.4-121.6c3.2-3.2 7.2-4.8 11.2-4.8h44.8V284.8c0-8.8 7.2-16 16-16h347.2V81.6H36v493.6zM667.2 716c-1.6 0-4-0.8-5.6-2.4-7.2-6.4-176.8-167.2-176.8-235.2 0-57.6 46.4-104 104-104 30.4 0 58.4 13.6 78.4 36 20-22.4 48-36 78.4-36 57.6 0 104 46.4 104 104 0 67.2-169.6 228-176.8 235.2-1.6 1.6-3.2 2.4-5.6 2.4z m-78.4-324.8c-48.8 0-88 39.2-88 88S616 648 667.2 697.6c51.2-48.8 166.4-169.6 166.4-218.4 0-48.8-39.2-88-88-88-28.8 0-55.2 13.6-72 37.6-1.6 1.6-4 3.2-6.4 3.2-2.4 0-4.8-1.6-6.4-3.2-16.8-24-43.2-37.6-72-37.6z",
    "M400.8 197.6C264 197.6 4 177.6 4 100.8S263.2 4 400.8 4 796.8 24 796.8 100.8 537.6 197.6 400.8 197.6z m0-161.6c-100.8 0-195.2 8-265.6 23.2C52.8 76.8 36 96 36 100.8s16.8 24 98.4 41.6c71.2 15.2 164.8 23.2 265.6 23.2s195.2-8 265.6-23.2c82.4-17.6 98.4-36.8 98.4-41.6s-16.8-24-98.4-41.6c-70.4-15.2-164.8-23.2-264.8-23.2zM400.8 1020C264 1020 4 1000 4 923.2V100.8c0-8.8 7.2-16 16-16s16 7.2 16 16c0 4 16.8 24 98.4 41.6 71.2 15.2 164.8 23.2 265.6 23.2s195.2-8 265.6-23.2c82.4-17.6 98.4-36.8 98.4-41.6 0-8.8 7.2-16 16-16s16 7.2 16 16v822.4c0.8 76.8-258.4 96.8-395.2 96.8zM36 142.4v780.8c0 4 16.8 24 98.4 41.6 71.2 15.2 164.8 23.2 265.6 23.2s195.2-8 265.6-23.2c82.4-17.6 98.4-36.8 98.4-41.6V142.4c-73.6 42.4-256.8 55.2-364.8 55.2-106.4 0-289.6-12.8-363.2-55.2zM965.6 803.2H780.8c-8.8 0-16-7.2-16-16V231.2c0-8.8 7.2-16 16-16h184.8c29.6 0 54.4 24.8 54.4 54.4v480c0 29.6-24.8 53.6-54.4 53.6z m-168.8-32h168.8c12 0 22.4-10.4 22.4-22.4v-480c0-12-10.4-22.4-22.4-22.4H796.8v524.8zM470.4 732c-1.6 0-4-0.8-5.6-2.4 0 0-32.8-31.2-70.4-71.2-3.2-3.2-3.2-8 0.8-11.2s8-3.2 11.2 0.8c28 30.4 52.8 54.4 64 64.8 53.6-52 176-179.2 176-231.2 0-51.2-41.6-92.8-92.8-92.8-24 0-46.4 8.8-64 25.6-3.2 3.2-8 3.2-11.2 0-3.2-3.2-3.2-8 0-11.2 20.8-19.2 47.2-30.4 75.2-30.4 60 0 108.8 48.8 108.8 108.8 0 71.2-178.4 240.8-186.4 248-1.6 1.6-4 2.4-5.6 2.4zM331.2 732c-1.6 0-4-0.8-5.6-2.4-8-7.2-186.4-176-186.4-248 0-60 48.8-108.8 108.8-108.8 32 0 62.4 14.4 82.4 37.6 20.8-24 51.2-37.6 82.4-37.6 60 0 108.8 48.8 108.8 108.8 0 71.2-178.4 240.8-186.4 248 0 1.6-2.4 2.4-4 2.4zM248 388.8c-51.2 0-92.8 41.6-92.8 92.8 0 52 121.6 179.2 176 231.2 53.6-52 176-179.2 176-231.2 0-51.2-41.6-92.8-92.8-92.8-30.4 0-58.4 14.4-76 39.2-2.4 2.4-4.8 4-7.2 4-2.4 0-4.8-1.6-6.4-3.2-17.6-24.8-46.4-40-76.8-40z",
    "M111.2 756.8c-3.2 0-6.4-0.8-8.8-3.2-4-3.2-7.2-8-7.2-12.8V283.2c0-5.6 2.4-10.4 7.2-12.8 4-3.2 9.6-4 14.4-1.6l329.6 119.2c6.4 2.4 10.4 8 10.4 15.2v218.4c0 6.4-4 12.8-10.4 15.2L116 756c-1.6 0.8-3.2 0.8-4.8 0.8z m16-450.4v412l297.6-108V413.6L127.2 306.4zM175.2 657.6c-3.2 0-6.4-2.4-7.2-5.6-1.6-4 0.8-8.8 4.8-10.4l201.6-72.8c4-1.6 8.8 0.8 10.4 4.8 1.6 4-0.8 8.8-4.8 10.4l-201.6 72.8c-1.6 0.8-2.4 0.8-3.2 0.8zM111.2 619.2C52 619.2 4 571.2 4 512s48-107.2 107.2-107.2c8.8 0 16 7.2 16 16v181.6c0 9.6-7.2 16.8-16 16.8z m-16-180c-33.6 7.2-59.2 37.6-59.2 72.8s25.6 65.6 59.2 72.8V439.2zM912.8 756.8c-1.6 0-4 0-5.6-0.8l-329.6-120c-6.4-2.4-10.4-8-10.4-15.2V402.4c0-6.4 4-12.8 10.4-15.2l329.6-119.2c4.8-1.6 10.4-0.8 14.4 1.6 4 3.2 7.2 8 7.2 12.8v457.6c0 5.6-2.4 10.4-7.2 12.8-2.4 3.2-5.6 4-8.8 4zM599.2 610.4l297.6 108V306.4L599.2 413.6v196.8zM848.8 657.6c-0.8 0-1.6 0-2.4-0.8L644.8 584c-4-1.6-6.4-6.4-4.8-10.4 1.6-4 6.4-6.4 10.4-4.8l201.6 72.8c4 1.6 6.4 6.4 4.8 10.4-1.6 3.2-4.8 5.6-8 5.6zM912.8 619.2c-8.8 0-16-7.2-16-16V420.8c0-8.8 7.2-16 16-16 59.2 0 107.2 48 107.2 107.2s-48 107.2-107.2 107.2z m16-180v146.4c33.6-7.2 59.2-37.6 59.2-72.8s-25.6-66.4-59.2-73.6zM583.2 636.8H440.8c-8.8 0-16-7.2-16-16V403.2c0-8.8 7.2-16 16-16h142.4c8.8 0 16 7.2 16 16v218.4c0 8-7.2 15.2-16 15.2z m-126.4-32h110.4V419.2H456.8v185.6z",
    "M512 987.2c-4 0-8-1.6-11.2-4C480.8 964 4 512.8 4 324 4 165.6 132.8 37.6 290.4 37.6 376 37.6 457.6 76 512 142.4 566.4 76 647.2 36.8 733.6 36.8c158.4 0 286.4 128.8 286.4 286.4 0 187.2-476.8 640-496.8 659.2-3.2 3.2-7.2 4.8-11.2 4.8zM290.4 68.8C150.4 68.8 36 183.2 36 323.2c0 160 404 556 476 625.6 72-69.6 476-466.4 476-625.6 0-140.8-114.4-254.4-254.4-254.4-82.4 0-160.8 40.8-208 108-3.2 4-8 6.4-12.8 6.4s-10.4-2.4-12.8-6.4C451.2 109.6 373.6 68.8 290.4 68.8zM940 331.2c-4.8 0-8-3.2-8-8 0-109.6-88.8-198.4-198.4-198.4-4.8 0-8-3.2-8-8s3.2-8 8-8c118.4 0 214.4 96 214.4 214.4 0 4.8-3.2 8-8 8z",
    "M865.6 1020H158.4c-8.8 0-16-7.2-16-16V484.8H20c-6.4 0-12.8-4-15.2-10.4-2.4-6.4-0.8-12.8 4-17.6L501.6 8c6.4-5.6 15.2-5.6 21.6 0l492 448.8c4.8 4.8 6.4 11.2 4 17.6-2.4 6.4-8 10.4-15.2 10.4h-122.4v519.2c0 8.8-7.2 16-16 16z m-691.2-32h675.2V468.8c0-8.8 7.2-16 16-16h97.6L512 41.6 61.6 452.8h97.6c8.8 0 16 7.2 16 16v519.2zM512 877.6c-1.6 0-4-0.8-5.6-2.4-7.2-7.2-179.2-169.6-179.2-238.4 0-57.6 47.2-104.8 104.8-104.8 30.4 0 59.2 13.6 79.2 36 20-23.2 48.8-36 79.2-36 57.6 0 104.8 47.2 104.8 104.8 0 68-172 231.2-179.2 238.4 0 1.6-2.4 2.4-4 2.4z m-79.2-329.6c-48.8 0-88.8 40-88.8 88.8 0 49.6 116.8 172 168.8 221.6 52-49.6 168.8-172 168.8-221.6 0-48.8-40-88.8-88.8-88.8-28.8 0-56 14.4-72.8 37.6-1.6 2.4-4 3.2-6.4 3.2-2.4 0-4.8-1.6-6.4-3.2-18.4-23.2-45.6-37.6-74.4-37.6z",
    "M680.8 738.4c-49.6 0-104.8-4.8-169.6-15.2-39.2-6.4-85.6-15.2-131.2-30.4-10.4-3.2-20-7.2-29.6-11.2-16.8-6.4-32.8-12-48.8-16.8-48-13.6-100-13.6-149.6-13.6H40.8c-5.6 0-10.4-2.4-13.6-7.2-37.6-56.8-21.6-186.4-9.6-281.6 3.2-25.6 6.4-48 7.2-62.4 0-5.6 4-11.2 9.6-13.6 5.6-2.4 12-1.6 16.8 2.4 1.6 1.6 197.6 156 432.8 42.4 12-5.6 21.6-4 27.2-1.6 20 8 29.6 33.6 40 60 5.6 14.4 11.2 28.8 16.8 36.8 20.8 28.8 42.4 59.2 72 78.4 48.8 32 115.2 30.4 168.8 29.6l115.2-2.4c17.6 0 37.6-0.8 56 7.2 20 8 39.2 27.2 39.2 52.8 0 24.8-19.2 43.2-34.4 54.4-60.8 47.2-140.8 77.6-230.4 88-23.2 2.4-48 4-73.6 4zM50.4 619.2H152c52 0 105.6 0 158.4 14.4 17.6 4.8 35.2 11.2 52 17.6 9.6 4 19.2 7.2 28.8 10.4 43.2 15.2 88 23.2 125.6 28.8 95.2 15.2 168 18.4 236 11.2 84-9.6 158.4-37.6 214.4-80.8 14.4-11.2 21.6-20.8 21.6-29.6 0-9.6-9.6-18.4-19.2-22.4-12.8-4.8-28.8-4.8-43.2-4.8l-115.2 2.4c-57.6 0.8-129.6 2.4-187.2-35.2-34.4-22.4-59.2-56.8-80.8-86.4-8-12-14.4-28-20.8-44-4.8-12.8-16-40.8-22.4-42.4 0 0-0.8 0-1.6 0.8-204.8 99.2-381.6 9.6-444-30.4-1.6 11.2-3.2 23.2-4.8 36.8C40 443.2 24.8 568 50.4 619.2zM294.4 738.4H40.8c-8.8 0-16-7.2-16-16V635.2c0-8.8 7.2-16 16-16H152c45.6 0 96.8 0 145.6 11.2 7.2 1.6 12 8 12 15.2v76c0.8 9.6-6.4 16.8-15.2 16.8z m-237.6-32h221.6v-47.2c-42.4-8-86.4-8-126.4-8H56.8v55.2zM508 484c-2.4 0-5.6-1.6-6.4-4-2.4-4-1.6-8.8 2.4-11.2l52.8-33.6c4-2.4 8.8-1.6 11.2 2.4 2.4 4 1.6 8.8-2.4 11.2L512 482.4c-1.6 0.8-3.2 1.6-4 1.6zM560 548.8c-2.4 0-4.8-0.8-6.4-3.2-2.4-3.2-2.4-8.8 1.6-11.2l48.8-39.2c3.2-2.4 8.8-2.4 11.2 1.6 2.4 3.2 2.4 8.8-1.6 11.2l-48.8 39.2c-0.8 0.8-3.2 1.6-4.8 1.6z",
    "M869.6 241.6c-4.8 0-10.4-2.4-12.8-7.2-14.4-20.8-86.4-128-77.6-171.2 4-19.2 16-36 32-47.2s36.8-14.4 56-10.4c17.6 4 32.8 13.6 43.2 27.2 15.2-8 32.8-10.4 50.4-7.2 40 8.8 65.6 48 57.6 88-8.8 42.4-109.6 106.4-140.8 124.8-2.4 2.4-4.8 3.2-8 3.2z m-17.6-205.6c-8 0-16 2.4-23.2 7.2-9.6 6.4-16 16-18.4 27.2-4 18.4 28.8 80.8 64 133.6 53.6-34.4 108.8-78.4 112.8-96 4.8-23.2-9.6-45.6-32.8-50.4-13.6-3.2-28 0.8-37.6 10.4-4 3.2-8.8 4.8-14.4 4-4.8-0.8-9.6-4.8-11.2-9.6-5.6-12.8-16.8-22.4-30.4-24.8-3.2-1.6-6.4-1.6-8.8-1.6zM244.8 528c-3.2 0-7.2-0.8-9.6-3.2-4-3.2-6.4-8-6.4-12.8V332c0-7.2 4.8-13.6 12-15.2l483.2-113.6c4.8-0.8 9.6 0 13.6 3.2s6.4 8 6.4 12.8V400c0 7.2-4.8 13.6-12 15.2L248.8 528h-4z m16-183.2v148L712 385.6V238.4L260.8 344.8zM244.8 915.2c-8.8 0-16-7.2-16-16V512c0-7.2 4.8-13.6 12-15.2l483.2-113.6c4.8-0.8 9.6 0 13.6 3.2s6.4 8 6.4 12.8v387.2c0 8.8-7.2 16-16 16s-16-7.2-16-16V419.2L260.8 524.8v374.4c0 8.8-7.2 16-16 16zM111.2 1020c-52.8 0-95.2-24-104.8-64-12-49.6 34.4-102.4 105.6-120 71.2-17.6 136.8 8.8 148.8 58.4 6.4 24.8-2.4 51.2-24 74.4-20 21.6-48.8 37.6-81.6 44.8-15.2 4.8-30.4 6.4-44 6.4z m43.2-156.8c-11.2 0-23.2 1.6-35.2 4-52 12.8-89.6 49.6-82.4 80.8 7.2 31.2 57.6 47.2 110.4 35.2 27.2-6.4 50.4-19.2 65.6-36 13.6-15.2 20-31.2 16-45.6-5.6-23.2-36.8-38.4-74.4-38.4zM592.8 900.8c-52.8 0-95.2-24-104.8-64-6.4-24.8 2.4-51.2 24-74.4 20-21.6 48.8-37.6 81.6-44.8 71.2-16.8 136.8 8.8 148.8 58.4 12 49.6-34.4 102.4-105.6 120-15.2 3.2-29.6 4.8-44 4.8zM636.8 744c-11.2 0-23.2 1.6-35.2 4-27.2 6.4-50.4 19.2-65.6 36-13.6 15.2-20 31.2-16 45.6 7.2 31.2 57.6 47.2 110.4 35.2 52-12.8 89.6-49.6 82.4-80.8-7.2-25.6-38.4-40-76-40z",
    "M386.4 820.8c-4 0-8-1.6-11.2-4.8L234.4 672.8c-4.8-4.8-5.6-12-3.2-17.6L490.4 59.2c0.8-3.2 3.2-5.6 5.6-7.2 0.8-1.6 1.6-3.2 2.4-4C516.8 21.6 547.2 4.8 580 4h0.8c32 0 62.4 16 80.8 41.6 16 23.2 23.2 53.6 21.6 92-0.8 8.8-4.8 16.8-9.6 24 8 23.2 24.8 42.4 46.4 52.8 24 11.2 53.6 13.6 81.6 7.2 4.8-0.8 9.6 0 13.6 3.2s6.4 7.2 6.4 12.8c0 6.4-0.8 12.8-1.6 18.4-0.8 4.8-1.6 9.6-1.6 13.6 0 36 24.8 71.2 58.4 84 8 3.2 12.8 12 9.6 20.8-0.8 1.6-1.6 3.2-1.6 4.8-2.4 6.4-4 13.6-10.4 20.8l-31.2 39.2c-1.6 2.4-4 4.8-4.8 6.4-0.8 1.6-0.8 4-0.8 6.4-0.8 15.2 1.6 30.4 5.6 44.8 0.8 1.6 1.6 4 2.4 5.6l4 4c2.4 2.4 5.6 4 8 7.2 2.4 3.2 4 5.6 6.4 8 0.8 1.6 2.4 3.2 3.2 4 2.4 2.4 6.4 4 11.2 6.4 20 8 50.4 17.6 75.2 8.8 0.8 0 1.6-0.8 2.4-0.8 8-2.4 16.8 0.8 20 8.8 3.2 8 0 17.6-8 20.8l-574.4 249.6c-2.4 0.8-4.8 1.6-7.2 1.6zM264.8 657.6l125.6 128 498.4-216.8c-8-2.4-15.2-4.8-22.4-8-8-3.2-16-7.2-23.2-14.4-2.4-3.2-4.8-5.6-6.4-8-0.8-1.6-2.4-3.2-3.2-4-0.8-0.8-2.4-2.4-4-3.2-3.2-2.4-7.2-5.6-10.4-9.6-4-4.8-5.6-10.4-7.2-15.2-5.6-18.4-8-36.8-7.2-56 0-5.6 0.8-11.2 3.2-16.8 2.4-6.4 6.4-11.2 9.6-15.2l31.2-39.2c0.8-0.8 1.6-1.6 1.6-3.2-38.4-20.8-64-63.2-64.8-107.2 0-4 0-8.8 0.8-12.8-28.8 3.2-56.8-1.6-81.6-12.8-32.8-16-56.8-44.8-65.6-80.8-1.6-4.8 0-10.4 3.2-13.6 6.4-8 8-11.2 8-12 1.6-30.4-3.2-54.4-15.2-71.2-12-17.6-33.6-28-55.2-28h-0.8c-21.6 0-43.2 12-55.2 29.6l-0.8 0.8c-0.8 2.4-3.2 6.4-7.2 9.6L264.8 657.6zM386.4 820.8c-4 0-8-1.6-11.2-4.8L234.4 672.8c-4.8-4.8-5.6-12-3.2-17.6L490.4 59.2c3.2-8 12.8-12 20.8-8 8 3.2 12 12.8 8 20.8L264.8 657.6l125.6 128 564-245.6c8-3.2 17.6 0 20.8 8 3.2 8 0 17.6-8 20.8l-574.4 249.6c-1.6 1.6-4 2.4-6.4 2.4zM276 1020c-13.6 0-28-4.8-40-13.6-13.6-10.4-24-25.6-33.6-47.2-7.2-18.4-12.8-36.8-15.2-56.8l-0.8-4.8c-0.8-6.4-1.6-12.8-3.2-17.6-3.2-8.8-11.2-16-20.8-20-9.6-4-20.8-4.8-34.4-3.2-4.8 0.8-8.8 1.6-13.6 2.4-13.6 2.4-28.8 4.8-44.8 1.6-23.2-5.6-42.4-23.2-57.6-53.6-4-7.2-7.2-15.2-8-24.8-1.6-16 6.4-28.8 12-38.4 10.4-16.8 18.4-24 32-27.2l192-70.4c5.6-2.4 12.8-0.8 16.8 4l140.8 143.2c4.8 4.8 5.6 12 3.2 17.6l-78.4 175.2-0.8 2.4c-3.2 11.2-11.2 20-22.4 25.6-7.2 4-15.2 5.6-23.2 5.6zM139.2 824c12.8 0 24.8 2.4 35.2 6.4 18.4 7.2 32.8 21.6 39.2 38.4 3.2 8.8 4 17.6 4.8 24.8l0.8 4.8c2.4 16.8 6.4 32.8 12.8 48 6.4 16 14.4 27.2 23.2 33.6 9.6 7.2 21.6 9.6 29.6 5.6 3.2-1.6 5.6-4 5.6-5.6 0-0.8 0.8-2.4 0.8-3.2L368 808 241.6 680 58.4 746.4c-0.8 0-0.8 0-1.6 0.8-4 0.8-6.4 1.6-12.8 12.8-4 6.4-8 13.6-8 19.2 0 4 2.4 8.8 4.8 13.6 7.2 14.4 19.2 32.8 36.8 36.8 9.6 2.4 20 0 32-1.6 4.8-0.8 10.4-1.6 15.2-2.4 4.8-1.6 9.6-1.6 14.4-1.6zM554.4 235.2c-5.6 0-11.2 0-16.8-0.8-8.8-0.8-15.2-8.8-13.6-17.6 0.8-8.8 9.6-15.2 17.6-13.6 51.2 6.4 97.6-25.6 107.2-74.4 4-22.4-2.4-47.2-17.6-65.6-14.4-16.8-34.4-27.2-56-26.4-25.6 1.6-54.4 19.2-60 50.4-4 25.6 9.6 48.8 32.8 56 12 3.2 23.2 0.8 33.6-6.4 8.8-8.8 12.8-26.4 5.6-36.8-1.6-1.6-3.2-2.4-4.8-3.2 3.2 4.8 3.2 12 0 17.6-4.8 7.2-14.4 9.6-22.4 4.8-7.2-4.8-12-12-12-20.8-0.8-12 7.2-23.2 15.2-28.8 14.4-10.4 36-3.2 48 9.6l0.8 0.8c19.2 25.6 11.2 62.4-8.8 80.8l-1.6 1.6c-17.6 12.8-39.2 17.6-60.8 12h-0.8c-38.4-11.2-61.6-49.6-55.2-92 7.2-43.2 45.6-75.2 90.4-77.6h1.6c30.4 0 59.2 13.6 80 37.6 21.6 25.6 31.2 60 24.8 92.8-13.6 59.2-65.6 100-127.2 100zM920 580.8c-6.4 0-12.8-0.8-19.2-1.6-32.8-5.6-61.6-25.6-76.8-55.2-31.2-58.4-11.2-131.2 46.4-168.8 7.2-4.8 17.6-2.4 22.4 4.8 4.8 7.2 3.2 17.6-4.8 22.4-43.2 28.8-58.4 83.2-35.2 127.2 11.2 20 31.2 34.4 54.4 38.4 22.4 4 44-1.6 60-16 18.4-17.6 29.6-50.4 13.6-78.4-12.8-21.6-38.4-31.2-60-21.6-11.2 5.6-18.4 14.4-21.6 26.4-0.8 12 7.2 28.8 19.2 32 2.4 0 4.8 0 6.4-0.8-5.6-1.6-10.4-6.4-11.2-12.8-1.6-8.8 4.8-16.8 13.6-18.4 8.8-1.6 16.8 1.6 22.4 8 8 8.8 8.8 22.4 6.4 32-4 17.6-25.6 25.6-43.2 23.2h-1.6c-31.2-7.2-48-40.8-44.8-68v-1.6c5.6-21.6 19.2-38.4 39.2-48.8h0.8c36.8-16 79.2-1.6 100.8 34.4 21.6 37.6 12.8 87.2-20 117.6-18.4 16.8-42.4 25.6-67.2 25.6zM760 261.6c-53.6 0-103.2-36-120.8-92-2.4-8.8 1.6-17.6 10.4-20 8.8-2.4 17.6 1.6 20 10.4 13.6 42.4 57.6 80 111.2 67.2 21.6-5.6 40-20.8 50.4-42.4 9.6-20.8 10.4-44 0.8-64-12-22.4-40-41.6-70.4-33.6-24 7.2-39.2 29.6-36 53.6 2.4 12.8 9.6 22.4 20 28 11.2 4 28.8 0.8 35.2-10.4 0.8-2.4 0.8-4 0.8-6.4-3.2 4.8-8.8 8-15.2 7.2-8.8-0.8-15.2-8.8-13.6-17.6 0.8-8.8 6.4-16 13.6-20 10.4-5.6 24-3.2 32.8 1.6 15.2 8.8 17.6 31.2 11.2 48 0 0.8 0 0.8-0.8 1.6-14.4 28.8-51.2 36.8-76.8 26.4-0.8 0-1.6-0.8-1.6-0.8-19.2-11.2-32-28.8-36-50.4v-0.8c-5.6-40 18.4-77.6 59.2-89.6 41.6-11.2 87.2 9.6 108 50.4 13.6 28.8 13.6 62.4 0 92-14.4 30.4-40 52-72 60-11.2 0-20.8 1.6-30.4 1.6zM905.6 390.4c-12 0-24-1.6-35.2-6.4-61.6-22.4-95.2-90.4-76.8-156.8 2.4-8.8 11.2-13.6 19.2-11.2 8.8 2.4 13.6 11.2 11.2 19.2-13.6 50.4 11.2 101.6 56.8 118.4 20.8 7.2 44.8 4.8 64.8-8 19.2-12 32-31.2 35.2-53.6 2.4-25.6-10.4-57.6-40.8-67.2-24-7.2-48.8 3.2-59.2 24.8-4.8 12-4 24 1.6 35.2 7.2 9.6 23.2 16 35.2 10.4 1.6-1.6 3.2-3.2 4-4.8-5.6 2.4-12 1.6-16.8-2.4-6.4-5.6-8-16-2.4-22.4 5.6-7.2 13.6-10.4 22.4-9.6 12 1.6 21.6 11.2 26.4 20 8 16-2.4 36-16 46.4-0.8 0-0.8 0.8-1.6 0.8-28 16-63.2 2.4-78.4-20.8 0-0.8-0.8-0.8-0.8-1.6-10.4-20-11.2-41.6-3.2-62.4v-0.8c16.8-36.8 57.6-54.4 97.6-42.4 40.8 13.6 67.2 56 63.2 101.6-4 32-22.4 60-50.4 76.8-16 11.2-36 16.8-56 16.8zM692.8 440c-3.2 0-6.4 0-8.8-0.8-29.6-2.4-56-17.6-72-42.4-22.4-36-18.4-81.6 9.6-109.6 28-26.4 68-28.8 96-6.4 15.2 13.6 23.2 31.2 22.4 51.2v0.8c-3.2 23.2-25.6 48.8-52.8 47.2-14.4-2.4-29.6-12.8-28.8-25.6 0-8 4-18.4 11.2-23.2 4.8-3.2 10.4-4 16.8-0.8 4 1.6 5.6 6.4 4 10.4s-6.4 5.6-10.4 4c-0.8-0.8-0.8 0-1.6 0-1.6 0.8-4 5.6-4 9.6 0 3.2 7.2 8.8 14.4 9.6 16.8 0.8 32.8-16.8 35.2-32.8 0-15.2-5.6-28-16.8-38.4-21.6-17.6-52.8-15.2-74.4 5.6-25.6 25.6-23.2 64-7.2 88.8 13.6 20 35.2 32.8 60 34.4 26.4 2.4 51.2-7.2 68.8-25.6 36.8-39.2 36-100.8-1.6-142.4-3.2-3.2-2.4-8 0.8-11.2 3.2-3.2 8-2.4 11.2 0.8 42.4 48.8 43.2 119.2 0.8 164-19.2 22.4-44.8 32.8-72.8 32.8zM524 1020c-8 0-15.2-6.4-16-14.4-1.6-18.4-4-29.6-5.6-41.6-2.4-12-4-24-6.4-43.2-0.8-6.4-1.6-13.6-4-18.4-2.4-4.8-7.2-9.6-12.8-15.2-9.6-8.8-22.4-17.6-36-27.2 0 2.4 0.8 4.8 0 7.2-0.8 8.8-5.6 15.2-8.8 19.2-8.8 11.2-12.8 22.4-13.6 32-0.8 12 2.4 24 6.4 36.8 2.4 7.2 4 15.2 5.6 22.4 1.6 8.8-4 16.8-12.8 18.4-8.8 1.6-16.8-4-18.4-12.8-1.6-6.4-3.2-12.8-5.6-20-4.8-15.2-8.8-31.2-8-48.8 1.6-16 8-32 20-48l0.8-0.8c0.8-0.8 1.6-1.6 1.6-2.4 0-0.8-0.8-0.8-0.8-1.6-8.8-19.2-21.6-36-36.8-49.6-6.4-5.6-7.2-16-1.6-22.4 5.6-6.4 16-7.2 22.4-1.6 12 9.6 28 20.8 45.6 31.2 21.6 14.4 44.8 28.8 60.8 44 6.4 5.6 14.4 13.6 20 24 4.8 9.6 5.6 20.8 6.4 28.8 1.6 18.4 4 29.6 5.6 41.6 2.4 12 4 24 6.4 43.2 0.8 8.8-5.6 16.8-14.4 17.6 0.8 1.6 0 1.6 0 1.6z",
    "M480 400c-41.6 0-81.6-17.6-109.6-48s-42.4-71.2-39.2-112.8l16.8-220.8c0.8-8.8 8-15.2 16.8-14.4 8.8 0.8 15.2 8 14.4 16.8l-16.8 220.8c-2.4 32.8 8.8 64 31.2 88.8a118.056 118.056 0 0 0 172.8 0c22.4-24 33.6-55.2 31.2-88.8L580.8 20.8c-0.8-8.8 5.6-16.8 14.4-16.8 8.8-0.8 16.8 5.6 16.8 14.4L629.6 240c3.2 41.6-11.2 82.4-39.2 112.8C561.6 382.4 521.6 400 480 400zM480 1020c-20.8 0-40.8-8.8-56.8-26.4-24.8-26.4-37.6-67.2-34.4-110.4L423.2 376c0-4.8 3.2-9.6 7.2-12 4-2.4 9.6-3.2 13.6-1.6 8.8 3.2 17.6 4.8 26.4 5.6 3.2 0 5.6 0.8 8.8 0.8h3.2c10.4 0 22.4-1.6 33.6-4.8 4.8-1.6 9.6-0.8 13.6 2.4 4 2.4 6.4 7.2 7.2 12l34.4 505.6c3.2 43.2-9.6 84-34.4 110.4-16 16.8-35.2 25.6-56.8 25.6z m-25.6-622.4l-32.8 488c-2.4 33.6 8 67.2 25.6 86.4 7.2 7.2 18.4 16 33.6 16s26.4-8.8 33.6-16c18.4-19.2 28-52.8 25.6-86.4l-32.8-487.2c-8 1.6-16 1.6-24 1.6h-0.8c-4.8 0-8.8 0-13.6-0.8-5.6 0-10.4-0.8-14.4-1.6zM480 400c-8.8 0-16-7.2-16-16V24c0-8.8 7.2-16 16-16s16 7.2 16 16v360c0 8.8-7.2 16-16 16zM881.6 393.6c-76.8 0-138.4-85.6-138.4-191.2s62.4-191.2 138.4-191.2 138.4 85.6 138.4 191.2-62.4 191.2-138.4 191.2z m0-351.2c-59.2 0-106.4 71.2-106.4 159.2s48 159.2 106.4 159.2c59.2 0 106.4-71.2 106.4-159.2s-48-159.2-106.4-159.2zM881.6 1013.6c-20.8 0-40.8-8.8-56.8-26.4-24.8-26.4-37.6-67.2-34.4-110.4l34.4-510.4c0-5.6 3.2-10.4 8-12.8 4.8-2.4 10.4-3.2 15.2-0.8 21.6 11.2 44.8 11.2 66.4 0 4.8-2.4 10.4-2.4 15.2 0.8 4.8 2.4 8 7.2 8 12.8l34.4 510.4c3.2 43.2-9.6 84-34.4 110.4-16 16.8-35.2 26.4-56 26.4z m-26.4-623.2l-32.8 488.8c-2.4 33.6 8 67.2 25.6 86.4 7.2 7.2 18.4 16 33.6 16 15.2 0 26.4-8.8 33.6-16 18.4-19.2 28-52.8 25.6-86.4l-32.8-488.8c-17.6 4-35.2 4-52.8 0zM129.6 1020H20c-8.8 0-16-7.2-16-16V20c0-4.8 1.6-8.8 5.6-12 3.2-3.2 8-4.8 12.8-4C229.6 27.2 213.6 471.2 208 616.8c-0.8 12.8-0.8 22.4-0.8 28 0 8.8-7.2 16-16 16h-44.8v343.2c-0.8 8.8-8 16-16.8 16z m-93.6-32h77.6V644.8c0-8.8 7.2-16 16-16h44.8c0-4 0-8 0.8-12.8C191.2 186.4 112 62.4 36 39.2v948.8z",
    "M1004 476h-440c-8.8 0-16-7.2-16-16v-440c0-8.8 7.2-16 16-16h440c8.8 0 16 7.2 16 16v440c0 8.8-7.2 16-16 16z m-424-32h408v-408h-408v408zM784 391.2c-1.6 0-4-0.8-5.6-2.4-16-15.2-156-148.8-156-207.2 0-51.2 41.6-92 92-92 26.4 0 51.2 11.2 68.8 31.2 17.6-19.2 42.4-31.2 68.8-31.2 51.2 0 92 41.6 92 92 0 58.4-140 192.8-156 207.2 0 1.6-1.6 2.4-4 2.4z m-68.8-286.4c-42.4 0-76 34.4-76 76 0 42.4 100 147.2 145.6 190.4 44.8-43.2 145.6-148.8 145.6-190.4 0-42.4-34.4-76-76-76-24.8 0-48 12-62.4 32.8-3.2 4-10.4 4-12.8 0-16-20.8-39.2-32.8-64-32.8zM460 476h-440c-8.8 0-16-7.2-16-16v-440c0-8.8 7.2-16 16-16h440c8.8 0 16 7.2 16 16v440c0 8.8-7.2 16-16 16z m-424-32h408v-408h-408v408zM460 1020h-440c-8.8 0-16-7.2-16-16v-440c0-8.8 7.2-16 16-16h440c8.8 0 16 7.2 16 16v440c0 8.8-7.2 16-16 16z m-424-32h408v-408h-408v408zM1004 1020h-440c-8.8 0-16-7.2-16-16v-440c0-8.8 7.2-16 16-16h440c8.8 0 16 7.2 16 16v440c0 8.8-7.2 16-16 16z m-424-32h408v-408h-408v408zM300 340.8h-120c-4.8 0-8-3.2-8-8V147.2c0-4.8 3.2-8 8-8h41.6c4.8 0 8 3.2 8 8V288h71.2c4.8 0 8 3.2 8 8v36.8c-0.8 4-4 8-8.8 8z m-112-16h104.8V304h-71.2c-4.8 0-8-3.2-8-8V155.2h-25.6v169.6zM257.6 884.8h-35.2c-3.2 0-6.4-1.6-7.2-4.8l-74.4-185.6c-0.8-2.4-0.8-5.6 0.8-7.2 1.6-2.4 4-3.2 6.4-3.2h44.8c3.2 0 6.4 1.6 7.2 4.8l40 99.2 40-99.2c1.6-3.2 4-4.8 7.2-4.8h44.8c2.4 0 4.8 1.6 6.4 3.2 1.6 2.4 1.6 4.8 0.8 7.2L264.8 880c-1.6 3.2-4 4.8-7.2 4.8z m-29.6-16h24L320 699.2h-27.2l-45.6 112.8c-1.6 3.2-4 4.8-7.2 4.8s-6.4-1.6-7.2-4.8l-45.6-112.8H160l68 169.6zM852.8 884.8H716c-4.8 0-8-3.2-8-8V691.2c0-4.8 3.2-8 8-8h133.6c4.8 0 8 3.2 8 8V728c0 4.8-3.2 8-8 8H764.8v22.4h75.2c4.8 0 8 3.2 8 8v35.2c0 4.8-3.2 8-8 8h-75.2v22.4h87.2c4.8 0 8 3.2 8 8v36.8c0.8 4.8-3.2 8-7.2 8z m-128.8-16h120.8V848h-88c-4.8 0-8-3.2-8-8v-38.4c0-4.8 3.2-8 8-8h75.2v-19.2h-75.2c-4.8 0-8-3.2-8-8V728c0-4.8 3.2-8 8-8h84v-20.8H724v169.6z",
    "M810.4 1020H52c-8.8 0-16-7.2-16-16V20c0-8.8 7.2-16 16-16h564.8c4.8 0 8.8 1.6 12 4.8l192.8 208c2.4 3.2 4 7.2 4 11.2v191.2c0 4-1.6 8-4.8 11.2l-294.4 296-27.2 103.2 103.2-27.2 196.8-196.8c4.8-4.8 11.2-5.6 17.6-3.2 5.6 2.4 9.6 8 9.6 14.4v388c0 8-7.2 15.2-16 15.2z m-742.4-32h725.6V654.4l-172.8 172.8c-1.6 1.6-4.8 3.2-7.2 4L480 867.2c-5.6 1.6-11.2 0-15.2-4s-5.6-9.6-4-15.2l36-133.6c0.8-2.4 2.4-4.8 4-7.2l293.6-293.6V234.4l-184-198.4H68v952zM810.4 236H617.6c-4.8 0-8-3.2-8-8v-208c0-3.2 2.4-6.4 4.8-7.2 3.2-1.6 6.4-0.8 8.8 2.4l192.8 208c2.4 2.4 2.4 5.6 1.6 8.8-1.6 2.4-4 4-7.2 4z m-184.8-16H792L625.6 40.8v179.2zM248 891.2c-0.8 0-1.6 0-2.4-0.8-3.2-0.8-4.8-3.2-5.6-6.4L228.8 800c-12.8 27.2-28 53.6-45.6 77.6-2.4 3.2-7.2 4.8-11.2 1.6-3.2-2.4-4.8-7.2-1.6-11.2 22.4-31.2 40.8-64.8 55.2-100.8 1.6-3.2 4.8-5.6 8-4.8 3.2 0.8 6.4 3.2 7.2 7.2l13.6 96c15.2-17.6 28-37.6 37.6-59.2 1.6-3.2 5.6-5.6 8.8-4.8 4 0.8 6.4 4 6.4 8l-0.8 34.4c13.6-13.6 24-29.6 31.2-47.2 1.6-3.2 4-4.8 8-4.8 3.2 0 6.4 2.4 7.2 5.6l7.2 20.8c2.4-1.6 5.6-1.6 8 0l21.6 12.8c1.6-1.6 4-2.4 6.4-3.2 4-0.8 8 0.8 9.6 4l4.8 9.6c1.6 4 0 8.8-4 10.4-4 1.6-8.8 0-10.4-4l-0.8-0.8c-2.4 1.6-5.6 1.6-8 0l-21.6-12.8c0 0.8 0 0.8-0.8 1.6-0.8 3.2-4 5.6-7.2 5.6s-6.4-2.4-8-5.6l-5.6-15.2c-10.4 18.4-24 34.4-40.8 47.2-2.4 1.6-5.6 2.4-8.8 0.8-2.4-1.6-4.8-4-4.8-7.2v-18.4c-10.4 16.8-22.4 32-36 45.6-0.8 1.6-3.2 2.4-5.6 2.4zM460.8 205.6H190.4c-4.8 0-8-3.2-8-8s3.2-8 8-8h269.6c4.8 0 8 3.2 8 8s-3.2 8-7.2 8zM670.4 404.8H192c-4.8 0-8-3.2-8-8s3.2-8 8-8h478.4c4.8 0 8 3.2 8 8s-3.2 8-8 8zM670.4 561.6H192c-4.8 0-8-3.2-8-8s3.2-8 8-8h478.4c4.8 0 8 3.2 8 8s-3.2 8-8 8zM476 867.2c-4 0-8-1.6-11.2-4.8-4-4-5.6-9.6-4-15.2l36-133.6c0.8-2.4 2.4-4.8 4-7.2l361.6-361.6c6.4-6.4 16-6.4 22.4 0l97.6 97.6c3.2 3.2 4.8 7.2 4.8 11.2s-1.6 8-4.8 11.2l-361.6 361.6c-1.6 1.6-4.8 3.2-7.2 4L480 866.4c-0.8 0.8-2.4 0.8-4 0.8z m50.4-140.8l-27.2 103.2 103.2-27.2 347.2-347.2-75.2-75.2-348 346.4z",
    "M257.6 1020c-12 0-24-4.8-32.8-13.6L17.6 799.2c-18.4-18.4-18.4-48 0-66.4l356-356c40-40 92-65.6 148-72.8 48.8-6.4 94.4-29.6 129.6-64l105.6-105.6c6.4-6.4 16-6.4 22.4 0l110.4 110.4c6.4 6.4 6.4 16 0 22.4L784 373.6c-34.4 34.4-57.6 80.8-64 129.6-7.2 56-33.6 108-72.8 148l-356 356c-9.6 8-21.6 12.8-33.6 12.8zM768 168L673.6 262.4c-40 40-92 65.6-148 72.8-48.8 6.4-94.4 29.6-129.6 64L40 756c-5.6 5.6-5.6 15.2 0 20.8L247.2 984c5.6 5.6 15.2 5.6 20.8 0L624 628c34.4-34.4 57.6-80.8 64-129.6 7.2-55.2 33.6-108 72.8-148L856 256 768 168zM285.6 817.6c-23.2 0-43.2-7.2-57.6-21.6-42.4-42.4-19.2-135.2 51.2-206.4 71.2-71.2 163.2-94.4 206.4-51.2 42.4 42.4 19.2 135.2-51.2 206.4-48 47.2-104 72.8-148.8 72.8z m140.8-284.8c-40 0-92 24.8-136 68.8-64.8 64.8-88 147.2-51.2 183.2 36 36 118.4 13.6 183.2-51.2 64.8-64.8 88-147.2 51.2-183.2-11.2-12-28-17.6-47.2-17.6zM883.2 156.8c-4 0-8-1.6-11.2-4.8-6.4-6.4-6.4-16 0-22.4l77.6-77.6c6.4-6.4 16-6.4 22.4 0 6.4 6.4 6.4 16 0 22.4l-77.6 77.6c-3.2 3.2-7.2 4.8-11.2 4.8zM928.8 197.6c-6.4 0-12-3.2-14.4-9.6-4-8 0-17.6 8-20.8l75.2-33.6c8-4 17.6 0 20.8 8 4 8 0 17.6-8 20.8l-75.2 33.6c-1.6 0.8-4 1.6-6.4 1.6zM842.4 111.2c-2.4 0-4.8-0.8-6.4-1.6-8-4-12-12.8-8-20.8l33.6-75.2c4-8 12.8-12 20.8-8s12 12.8 8 20.8l-33.6 75.2c-2.4 6.4-8 9.6-14.4 9.6zM796.8 345.6c-2.4 0-4-0.8-5.6-2.4L680.8 232.8c-3.2-3.2-3.2-8 0-11.2l81.6-81.6c3.2-3.2 8-3.2 11.2 0l110.4 110.4c3.2 3.2 3.2 8 0 11.2l-81.6 81.6c-0.8 1.6-3.2 2.4-5.6 2.4zM697.6 227.2l99.2 99.2 70.4-70.4L768 156.8l-70.4 70.4z",
    "M512 220.8c-35.2 0-63.2-28.8-63.2-64 0-16 10.4-53.6 20-81.6C491.2 6.4 500 5.6 508.8 4.8c8-0.8 16.8 4 19.2 16.8 8.8 52 23.2 77.6 33.6 96 7.2 13.6 13.6 24.8 13.6 39.2 0 35.2-28 64-63.2 64z m-7.2-155.2C493.6 98.4 480 144 480 156c0 17.6 14.4 32 31.2 32s31.2-14.4 31.2-32c0-5.6-3.2-12-9.6-24-7.2-13.6-18.4-33.6-28-66.4zM512 275.2c-8.8 0-16-7.2-16-16v-53.6c0-8.8 7.2-16 16-16s16 7.2 16 16v53.6c0 8.8-7.2 16-16 16zM1004 1020H20c-8.8 0-16-7.2-16-16V618.4v-5.6-162.4c0-8.8 7.2-16 16-16h983.2c8.8 0 16 7.2 16 16v553.6c0.8 8.8-6.4 16-15.2 16z m-968-32h951.2V618.4 616v-3.2V608 466.4H36V988zM588.8 466.4H435.2c-4.8 0-8.8-1.6-12-5.6-86.4-96.8-86.4-130.4-86.4-141.6 0-57.6 46.4-104.8 104-104.8 27.2 0 52.8 10.4 72 28.8 19.2-18.4 44.8-28.8 72-28.8 56.8 0 104 47.2 104 104.8 0 11.2 0 44-86.4 142.4-4.8 3.2-8.8 4.8-13.6 4.8z m-146.4-32h139.2c66.4-76 73.6-106.4 73.6-115.2 0-40-32-72.8-72-72.8-23.2 0-44.8 11.2-58.4 30.4-3.2 4-8 7.2-12.8 7.2s-10.4-2.4-12.8-7.2c-13.6-19.2-35.2-30.4-58.4-30.4-39.2 0-72 32.8-72 72.8 0 9.6 7.2 39.2 73.6 115.2zM905.6 720c-44.8 0-82.4-27.2-98.4-66.4-16 39.2-54.4 66.4-98.4 66.4-44 0-82.4-27.2-98.4-66.4-16 39.2-54.4 66.4-98.4 66.4-44.8 0-82.4-27.2-98.4-66.4-16 39.2-54.4 66.4-98.4 66.4-44.8 0-82.4-27.2-98.4-66.4-16 39.2-54.4 66.4-98.4 66.4-58.4 0-106.4-48-106.4-107.2v-6.4c0-4.8 4-8 8.8-7.2 4.8 0 8 4 7.2 8.8v5.6C28 663.2 68.8 704 118.4 704s90.4-40.8 90.4-91.2v-0.8-0.8c0.8-4 4-8 8-8 2.4 0 4 0.8 5.6 2.4 1.6 1.6 2.4 4 2.4 5.6v0.8c0 50.4 40.8 91.2 90.4 91.2s90.4-40.8 90.4-91.2v-0.8-0.8c0.8-4 4-8 8-8 2.4 0 4 0.8 5.6 2.4 1.6 1.6 2.4 4 2.4 5.6v0.8C421.6 663.2 462.4 704 512 704c49.6 0 90.4-40.8 90.4-91.2v-0.8-0.8c0.8-4 4-8 8-8 4.8 0 8 3.2 8 8v0.8c0 50.4 40.8 91.2 90.4 91.2 49.6 0 90.4-40.8 90.4-91.2v-0.8-0.8c0.8-4 4-8 8-8 4.8 0 8 3.2 8 8v0.8c0 50.4 40.8 91.2 90.4 91.2s90.4-40.8 90.4-91.2v-5.6c0-4.8 3.2-8 7.2-8.8 4 0 8 3.2 8.8 7.2v6.4c0 61.6-48 109.6-106.4 109.6z",
    "M944.8 1020h-27.2c-41.6 0-75.2-33.6-75.2-75.2V485.6c0-8.8 7.2-16 16-16h145.6c8.8 0 16 7.2 16 16v459.2c0 41.6-33.6 75.2-75.2 75.2z m-70.4-518.4v443.2c0 24 19.2 43.2 43.2 43.2h27.2c24 0 43.2-19.2 43.2-43.2V501.6h-113.6zM931.2 1020H141.6c-76 0-137.6-61.6-137.6-137.6V20c0-8.8 7.2-16 16-16h838.4c8.8 0 16 7.2 16 16v911.2c0 31.2 25.6 56.8 56.8 56.8 8.8 0 16 7.2 16 16s-7.2 16-16 16zM36 36v846.4c0 58.4 47.2 105.6 105.6 105.6H864c-12.8-15.2-20.8-35.2-20.8-56.8V36H36zM677.6 179.2H201.6c-4.8 0-8-3.2-8-8s3.2-8 8-8h476c4.8 0 8 3.2 8 8s-4 8-8 8zM677.6 327.2H201.6c-4.8 0-8-3.2-8-8s3.2-8 8-8h476c4.8 0 8 3.2 8 8s-4 8-8 8zM677.6 474.4H201.6c-4.8 0-8-3.2-8-8s3.2-8 8-8h476c4.8 0 8 3.2 8 8s-4 8-8 8zM496 892c-1.6 0-4-0.8-5.6-2.4 0 0-26.4-25.6-56.8-57.6-3.2-3.2-3.2-8 0.8-11.2 3.2-3.2 8-3.2 11.2 0.8 21.6 23.2 41.6 43.2 51.2 52 44-42.4 141.6-144.8 141.6-185.6 0-40.8-33.6-74.4-74.4-74.4-19.2 0-36.8 7.2-51.2 20.8-3.2 3.2-8 3.2-11.2 0-3.2-3.2-3.2-8 0-11.2 16.8-16 39.2-24.8 62.4-24.8 49.6 0 90.4 40.8 90.4 90.4 0 57.6-136 188-152 202.4-2.4 0-4.8 0.8-6.4 0.8zM382.4 892c-1.6 0-4-0.8-5.6-2.4-15.2-14.4-152-144.8-152-202.4 0-49.6 40.8-90.4 90.4-90.4 25.6 0 50.4 11.2 67.2 30.4 16.8-19.2 41.6-30.4 67.2-30.4 49.6 0 90.4 40.8 90.4 90.4 0 57.6-136 188-152 202.4-1.6 1.6-3.2 2.4-5.6 2.4z m-67.2-278.4c-40.8 0-74.4 33.6-74.4 74.4 0 41.6 97.6 143.2 141.6 185.6 44-42.4 141.6-144.8 141.6-185.6 0-40.8-33.6-74.4-74.4-74.4-24 0-46.4 12-60.8 31.2-3.2 4-10.4 4-12.8 0-13.6-19.2-36-31.2-60.8-31.2z",
    "M328.8 800.8c-8.8 0-16-7.2-16-16V350.4c0-8 5.6-14.4 12.8-16l669.6-127.2c4.8-0.8 9.6 0 12.8 3.2 4 3.2 5.6 7.2 5.6 12v434.4c0 8.8-7.2 16-16 16s-16-7.2-16-16V241.6L344.8 363.2v421.6c0 8.8-7.2 16-16 16zM328.8 366.4c-4 0-7.2-1.6-10.4-4-4-3.2-5.6-7.2-5.6-12V147.2c0-8 5.6-14.4 12.8-16L995.2 4c4.8-0.8 9.6 0 12.8 3.2 4 3.2 5.6 7.2 5.6 12v202.4c0 8-5.6 14.4-12.8 16l-668.8 128c-0.8 0-2.4 0.8-3.2 0.8z m16-205.6v169.6l637.6-121.6V39.2L344.8 160.8zM845.6 888.8c-4 0-8-1.6-11.2-4-26.4-24.8-157.6-151.2-157.6-212 0-55.2 44.8-100 100-100 25.6 0 50.4 9.6 68.8 27.2 18.4-17.6 43.2-27.2 68.8-27.2 55.2 0 100 44.8 100 100 0 60-131.2 187.2-157.6 212-3.2 2.4-7.2 4-11.2 4z m-68-284.8c-37.6 0-68 30.4-68 68 0 34.4 79.2 123.2 136.8 178.4 56.8-55.2 136.8-144.8 136.8-178.4 0-37.6-30.4-68-68-68-22.4 0-42.4 10.4-55.2 28.8-3.2 4-8 6.4-12.8 6.4-5.6 0-10.4-2.4-12.8-6.4-14.4-18.4-35.2-28.8-56.8-28.8zM178.4 1020c-4 0-8-1.6-11.2-4-26.4-24.8-157.6-151.2-157.6-212C9.6 748.8 54.4 704 109.6 704c25.6 0 50.4 9.6 68.8 27.2 18.4-17.6 43.2-27.2 68.8-27.2 55.2 0 100 44.8 100 100 0 60-131.2 187.2-157.6 212-4 2.4-8 4-11.2 4z m-68.8-284.8c-37.6 0-68 30.4-68 68 0 34.4 79.2 123.2 136.8 178.4 56.8-55.2 136.8-144.8 136.8-178.4 0-37.6-30.4-68-68-68-22.4 0-42.4 10.4-55.2 28.8-3.2 4-8 6.4-12.8 6.4s-10.4-2.4-12.8-6.4c-14.4-17.6-35.2-28.8-56.8-28.8z",
    "M652.8 1020H371.2c-6.4 0-12-3.2-14.4-8.8-2.4-5.6-1.6-12 1.6-16.8l52.8-66.4c-46.4-40-75.2-105.6-75.2-176.8 0-38.4 8-76 24-108.8 28.8-60.8 28-126.4-3.2-188-2.4-4.8-2.4-11.2 0.8-15.2 3.2-4.8 8-8 13.6-8h282.4c5.6 0 10.4 3.2 13.6 8s3.2 10.4 0.8 15.2c-31.2 62.4-32 127.2-3.2 188 16 32.8 24 70.4 24 108.8 0 70.4-28.8 136.8-75.2 176.8l52.8 66.4c4 4.8 4.8 11.2 1.6 16.8-3.2 5.6-8.8 8.8-15.2 8.8z m-248.8-32h216l-42.4-52.8c-2.4-3.2-4-8-3.2-12 0.8-4 3.2-8 6.4-11.2 46.4-32 75.2-93.6 75.2-160.8 0-33.6-7.2-66.4-20.8-94.4-29.6-63.2-32-128.8-7.2-193.6h-232c25.6 64 23.2 130.4-7.2 193.6-13.6 28.8-20.8 61.6-20.8 94.4 0 66.4 28.8 128 75.2 160.8 4 2.4 6.4 6.4 6.4 11.2s-0.8 8.8-3.2 12l-42.4 52.8zM553.6 880.8c-2.4 0-4.8-0.8-6.4-3.2-2.4-4-1.6-8.8 1.6-11.2 31.2-22.4 51.2-66.4 51.2-115.2 0-24.8-5.6-49.6-15.2-70.4-25.6-53.6-35.2-112.8-26.4-170.4 0.8-4 4.8-7.2 8.8-6.4 4 0.8 7.2 4.8 6.4 8.8-8 54.4 0.8 110.4 24.8 161.6 11.2 23.2 16.8 49.6 16.8 77.6 0 53.6-22.4 103.2-57.6 128-0.8 0-2.4 0.8-4 0.8zM512 404c-28 0-53.6-16-66.4-39.2-26.4 8-55.2 0.8-75.2-19.2s-26.4-48.8-19.2-75.2c-24-12.8-39.2-38.4-39.2-66.4s16-53.6 39.2-66.4c-8-26.4-0.8-55.2 19.2-75.2s48.8-26.4 75.2-19.2c12.8-24 38.4-39.2 66.4-39.2s53.6 16 66.4 39.2c26.4-8 55.2-0.8 75.2 19.2s26.4 48.8 19.2 75.2c24 12.8 39.2 38.4 39.2 66.4 0 28-16 53.6-39.2 66.4 8 26.4 0.8 55.2-19.2 75.2s-48.8 26.4-75.2 19.2c-12.8 24-38.4 39.2-66.4 39.2z m-57.6-76.8c2.4 0 4 0.8 6.4 1.6 4.8 1.6 8 5.6 9.6 10.4 4.8 19.2 22.4 32.8 42.4 32.8s37.6-13.6 42.4-32.8c1.6-4.8 4.8-8.8 9.6-10.4 4.8-1.6 9.6-1.6 14.4 0.8 16.8 10.4 39.2 7.2 52.8-6.4 14.4-14.4 16.8-36 6.4-52.8-2.4-4-3.2-9.6-0.8-14.4 1.6-4.8 5.6-8 10.4-9.6 19.2-4.8 32.8-22.4 32.8-42.4s-13.6-37.6-32.8-42.4c-4.8-1.6-8.8-4.8-10.4-9.6-1.6-4.8-1.6-9.6 0.8-14.4 10.4-16.8 7.2-39.2-6.4-52.8-14.4-14.4-36-16.8-52.8-6.4-4 2.4-9.6 3.2-14.4 0.8s-8-5.6-9.6-10.4c-4.8-19.2-22.4-32.8-42.4-32.8s-37.6 13.6-42.4 32.8c-1.6 4.8-4.8 8.8-9.6 10.4s-9.6 1.6-14.4-0.8c-16.8-10.4-39.2-7.2-52.8 6.4-14.4 14.4-16.8 36-6.4 52.8 2.4 4 3.2 9.6 0.8 14.4-1.6 4.8-5.6 8-10.4 9.6-20 5.6-33.6 22.4-33.6 42.4s13.6 37.6 32.8 42.4c4.8 1.6 8.8 4.8 10.4 9.6 1.6 4.8 1.6 9.6-0.8 14.4-10.4 16.8-7.2 39.2 6.4 52.8 14.4 14.4 36 16.8 52.8 6.4 3.2-1.6 5.6-2.4 8.8-2.4zM512 260.8c-31.2 0-56.8-25.6-56.8-56.8s25.6-56.8 56.8-56.8 56.8 25.6 56.8 56.8-25.6 56.8-56.8 56.8z m0-97.6c-22.4 0-40.8 18.4-40.8 40.8s18.4 40.8 40.8 40.8 40.8-18.4 40.8-40.8-18.4-40.8-40.8-40.8zM512 463.2c-8.8 0-16-7.2-16-16v-59.2c0-8.8 7.2-16 16-16s16 7.2 16 16v59.2c0 8.8-7.2 16-16 16z",
    "M750.4 1020H273.6c-8.8 0-16-7.2-16-16V20c0-8.8 7.2-16 16-16h476.8c8.8 0 16 7.2 16 16v984c0 8.8-7.2 16-16 16z m-460.8-32h444.8V36H289.6v952zM273.6 1020H20c-8.8 0-16-7.2-16-16V372.8c0-8.8 7.2-16 16-16h253.6c8.8 0 16 7.2 16 16v631.2c0 8.8-7.2 16-16 16z m-237.6-32h221.6V388.8H36v599.2zM1004 1020H750.4c-8.8 0-16-7.2-16-16V372.8c0-8.8 7.2-16 16-16h253.6c8.8 0 16 7.2 16 16v631.2c0 8.8-7.2 16-16 16z m-237.6-32h221.6V388.8H766.4v599.2zM664.8 1012H359.2c-4.8 0-8-3.2-8-8V696.8c0-4.8 3.2-8 8-8H664c4.8 0 8 3.2 8 8v307.2c0.8 4.8-3.2 8-7.2 8z m-297.6-16H656V704.8H367.2v291.2zM512 1012c-4.8 0-8-3.2-8-8V696.8c0-4.8 3.2-8 8-8s8 3.2 8 8v307.2c0 4.8-3.2 8-8 8zM376 92.8v61.6h-12.8v-24h-23.2v24h-12.8v-61.6h12.8v25.6h23.2v-25.6H376m0-16h-12.8c-4.8 0-8.8 1.6-12 4.8-3.2-3.2-7.2-4.8-12-4.8h-12.8c-8.8 0-16 7.2-16 16v61.6c0 8.8 7.2 16 16 16h12.8c4.8 0 8.8-1.6 12-4.8 3.2 3.2 7.2 4.8 12 4.8H376c8.8 0 16-7.2 16-16v-61.6c0-8.8-7.2-16-16-16zM439.2 91.2c8.8 0 16 3.2 22.4 8.8 5.6 6.4 8.8 13.6 8.8 22.4s-3.2 16.8-8.8 22.4c-5.6 6.4-13.6 8.8-22.4 8.8s-16-3.2-22.4-8.8c-5.6-6.4-8.8-13.6-8.8-22.4s3.2-16.8 8.8-22.4c6.4-5.6 13.6-8.8 22.4-8.8m0 51.2c4.8 0 8.8-1.6 12.8-5.6 3.2-4 4.8-8.8 4.8-13.6 0-5.6-1.6-10.4-4.8-14.4-3.2-4-7.2-5.6-12.8-5.6-4.8 0-8.8 1.6-12.8 5.6-3.2 4-4.8 8.8-4.8 14.4s1.6 10.4 4.8 13.6c3.2 4 8 5.6 12.8 5.6m0-67.2c-12.8 0-24.8 4.8-33.6 13.6S392 109.6 392 122.4s4.8 24.8 13.6 33.6 20.8 13.6 33.6 13.6 24.8-4.8 33.6-13.6 13.6-20.8 13.6-33.6-4.8-24.8-13.6-33.6c-9.6-8.8-20.8-13.6-33.6-13.6z m0 51.2c-0.8 0-0.8 0 0 0-0.8-0.8-1.6-1.6-1.6-4s0.8-3.2 0.8-3.2l0.8-0.8c0.8 0.8 0.8 1.6 0.8 3.2 0.8 3.2 0 4-0.8 4.8zM546.4 92.8V104h-16.8v49.6h-12.8V104h-16.8v-12h46.4m0-15.2h-46.4c-8.8 0-16 7.2-16 16V104c0 8.8 7.2 16 16 16h0.8v33.6c0 8.8 7.2 16 16 16h12.8c8.8 0 16-7.2 16-16V120h0.8c8.8 0 16-7.2 16-16v-12c0-8-7.2-15.2-16-15.2zM623.2 92.8v12h-29.6v12.8h26.4v12h-26.4v12.8H624v12h-43.2v-61.6h42.4m0-16h-42.4c-8.8 0-16 7.2-16 16v61.6c0 8.8 7.2 16 16 16H624c8.8 0 16-7.2 16-16v-12c0-4-1.6-8-4-10.4v-14.4-3.2c2.4-2.4 3.2-6.4 3.2-9.6v-12c0-8.8-7.2-16-16-16zM672.8 92.8v49.6h24.8v12h-38.4v-61.6h13.6m0-16h-12.8c-8.8 0-16 7.2-16 16v61.6c0 8.8 7.2 16 16 16h38.4c8.8 0 16-7.2 16-16v-12c0-8.8-7.2-16-16-16h-8.8v-33.6c-0.8-8.8-8-16-16.8-16zM187.2 552H105.6c-4.8 0-8-3.2-8-8V462.4c0-4.8 3.2-8 8-8h81.6c4.8 0 8 3.2 8 8V544c0 4-3.2 8-8 8z m-73.6-16h65.6v-65.6h-65.6V536zM187.2 736.8H105.6c-4.8 0-8-3.2-8-8V647.2c0-4.8 3.2-8 8-8h81.6c4.8 0 8 3.2 8 8v81.6c0 4.8-3.2 8-8 8z m-73.6-16h65.6v-65.6h-65.6v65.6zM187.2 922.4H105.6c-4.8 0-8-3.2-8-8v-81.6c0-4.8 3.2-8 8-8h81.6c4.8 0 8 3.2 8 8v81.6c0 4.8-3.2 8-8 8z m-73.6-16h65.6v-65.6h-65.6v65.6zM918.4 552h-81.6c-4.8 0-8-3.2-8-8V462.4c0-4.8 3.2-8 8-8h81.6c4.8 0 8 3.2 8 8V544c0 4-4 8-8 8z m-73.6-16h65.6v-65.6h-65.6V536zM918.4 736.8h-81.6c-4.8 0-8-3.2-8-8V647.2c0-4.8 3.2-8 8-8h81.6c4.8 0 8 3.2 8 8v81.6c0 4.8-4 8-8 8z m-73.6-16h65.6v-65.6h-65.6v65.6zM918.4 922.4h-81.6c-4.8 0-8-3.2-8-8v-81.6c0-4.8 3.2-8 8-8h81.6c4.8 0 8 3.2 8 8v81.6c0 4.8-4 8-8 8z m-73.6-16h65.6v-65.6h-65.6v65.6zM656 386.4H573.6c-4.8 0-8-3.2-8-8V296c0-4.8 3.2-8 8-8H656c4.8 0 8 3.2 8 8v81.6c0 4.8-4 8.8-8 8.8z m-74.4-16H648V304h-65.6v66.4zM656 571.2H573.6c-4.8 0-8-3.2-8-8V481.6c0-4.8 3.2-8 8-8H656c4.8 0 8 3.2 8 8v81.6c0 4.8-4 8-8 8z m-74.4-16H648v-65.6h-65.6v65.6zM450.4 386.4H368c-4.8 0-8-3.2-8-8V296c0-4.8 3.2-8 8-8h81.6c4.8 0 8 3.2 8 8v81.6c0.8 4.8-3.2 8.8-7.2 8.8z m-74.4-16h65.6V304H376v66.4zM450.4 571.2H368c-4.8 0-8-3.2-8-8V481.6c0-4.8 3.2-8 8-8h81.6c4.8 0 8 3.2 8 8v81.6c0.8 4.8-3.2 8-7.2 8z m-74.4-16h65.6v-65.6H376v65.6z",
    "M798.4 957.6H225.6c-22.4 0-40-17.6-40-40V156.8c0-22.4 17.6-40 40-40h572.8c22.4 0 40 17.6 40 40v760.8c0 22.4-17.6 40-40 40zM225.6 148.8c-4 0-8 3.2-8 8v760.8c0 4 3.2 8 8 8h572.8c4 0 8-3.2 8-8V156.8c0-4-3.2-8-8-8H225.6zM644 148.8h-264c-8.8 0-16-7.2-16-16V20c0-8.8 7.2-16 16-16h263.2c8.8 0 16 7.2 16 16v112.8c0.8 8.8-6.4 16-15.2 16z m-248-32h231.2V36H396v80.8zM706.4 831.2H317.6c-4.8 0-8-3.2-8-8v-312c0-108 87.2-195.2 195.2-195.2h14.4c108 0 195.2 87.2 195.2 195.2v312c0 4.8-3.2 8-8 8z m-380.8-16h372.8v-304c0-99.2-80.8-179.2-179.2-179.2h-14.4c-99.2 0-179.2 80.8-179.2 179.2v304zM400.8 1020H306.4c-8.8 0-16-7.2-16-16v-62.4c0-8.8 7.2-16 16-16H400c8.8 0 16 7.2 16 16v62.4c0.8 8.8-6.4 16-15.2 16z m-78.4-32H384v-30.4h-61.6v30.4zM706.4 1020H612.8c-8.8 0-16-7.2-16-16v-62.4c0-8.8 7.2-16 16-16h93.6c8.8 0 16 7.2 16 16v62.4c0 8.8-7.2 16-16 16z m-77.6-32h61.6v-30.4h-61.6v30.4z",
    "M512 1020c-4 0-8-1.6-11.2-4-15.2-14.4-380-360-380-505.6C120.8 387.2 220.8 288 343.2 288c64.8 0 126.4 28.8 168.8 77.6 42.4-48.8 104-77.6 168.8-77.6 122.4 0 222.4 100 222.4 222.4 0 144.8-364.8 491.2-380 505.6-3.2 2.4-7.2 4-11.2 4zM343.2 320c-104.8 0-190.4 85.6-190.4 190.4 0 105.6 249.6 367.2 359.2 472 109.6-105.6 359.2-367.2 359.2-472 0-104.8-85.6-190.4-190.4-190.4-61.6 0-120 30.4-156 80.8-3.2 4-8 6.4-12.8 6.4-5.6 0-10.4-2.4-12.8-6.4C463.2 349.6 404.8 320 343.2 320zM812 366.4c-8.8 0-16-7.2-16-16C796 168 676.8 36 512 36S228 168 228 350.4c0 8.8-7.2 16-16 16s-16-7.2-16-16C196 149.6 328.8 4 512 4s316 145.6 316 346.4c0 8.8-7.2 16-16 16zM546.4 804.8h-68.8c-4.8 0-8-3.2-8-8v-136c-24.8-14.4-40-41.6-40-70.4 0-44.8 36.8-81.6 81.6-81.6s81.6 36.8 81.6 81.6c0 28.8-15.2 55.2-40 70.4v136c1.6 4-2.4 8-6.4 8z m-60.8-16h52.8V656c0-3.2 1.6-5.6 4-7.2 21.6-11.2 35.2-33.6 35.2-58.4 0-36-29.6-65.6-65.6-65.6-36 0-65.6 29.6-65.6 65.6 0 24.8 13.6 47.2 35.2 58.4 2.4 1.6 4 4 4 7.2v132.8z",
    "M512 542.4c-4 0-8-1.6-11.2-4-21.6-20.8-212-202.4-212-284.8 0-72 58.4-129.6 129.6-129.6 35.2 0 68.8 14.4 93.6 39.2 24-24.8 57.6-39.2 93.6-39.2 72 0 129.6 58.4 129.6 129.6 0 81.6-190.4 264-212 284-3.2 3.2-7.2 4.8-11.2 4.8zM418.4 156c-54.4 0-97.6 44-97.6 97.6 0 48.8 112.8 175.2 191.2 250.4 78.4-76 191.2-201.6 191.2-250.4 0-54.4-44-97.6-97.6-97.6-32 0-61.6 15.2-80 41.6-3.2 4-8 6.4-12.8 6.4s-10.4-2.4-12.8-6.4c-19.2-26.4-49.6-41.6-81.6-41.6zM655.2 260.8c-4 0-8-3.2-8-8-0.8-22.4-19.2-40.8-41.6-40.8-4.8 0-8-3.2-8-8s3.2-8 8-8c31.2 0 56.8 25.6 57.6 56.8 0 4-3.2 7.2-8 8zM822.4 900c-12.8 0-26.4-0.8-39.2-3.2C706.4 884.8 640 839.2 584 760c-19.2-27.2-29.6-62.4-31.2-99.2l-22.4-15.2c-4.8-3.2-7.2-8.8-7.2-14.4s4-10.4 8.8-13.6l25.6-12c12.8-50.4 42.4-87.2 81.6-100 24-8 50.4-5.6 73.6 7.2C744 530.4 768 564.8 777.6 608c21.6 92.8 48.8 208 224 198.4 7.2 0 13.6 4 16 10.4s0 13.6-5.6 18.4c-2.4 3.2-84 64.8-189.6 64.8zM572 635.2l5.6 4c4.8 3.2 7.2 8 7.2 13.6-0.8 33.6 8 64.8 24.8 88.8 50.4 72 109.6 113.6 177.6 124 63.2 9.6 121.6-9.6 160-28-150.4-16-179.2-138.4-199.2-221.6-8-34.4-26.4-60.8-49.6-74.4-15.2-8.8-32-10.4-48-4.8-29.6 9.6-52.8 41.6-62.4 84-0.8 4.8-4 8.8-8.8 11.2l-7.2 3.2zM201.6 900c-105.6 0-187.2-62.4-191.2-64.8-5.6-4-8-12-5.6-18.4 2.4-6.4 8.8-10.4 16-10.4 175.2 9.6 201.6-105.6 224-198.4 10.4-43.2 33.6-77.6 64.8-95.2 23.2-12.8 48.8-16 73.6-7.2 39.2 12.8 68.8 49.6 81.6 100l25.6 12c5.6 2.4 8.8 7.2 8.8 13.6s-2.4 11.2-7.2 14.4l-22.4 15.2c-0.8 36.8-12 72-31.2 99.2-55.2 79.2-122.4 125.6-199.2 136.8-11.2 2.4-24.8 3.2-37.6 3.2z m-124.8-62.4c38.4 18.4 96.8 38.4 160 28 67.2-10.4 127.2-52 177.6-124 16.8-24 25.6-56 24.8-88.8 0-5.6 2.4-10.4 7.2-13.6l5.6-4-8-3.2c-4.8-2.4-8-6.4-8.8-11.2-8.8-42.4-32-74.4-62.4-84-16-5.6-32.8-3.2-48 4.8-23.2 12.8-41.6 40-49.6 74.4-19.2 83.2-48 205.6-198.4 221.6zM678.4 637.6c-16.8 0-31.2-13.6-31.2-31.2s13.6-31.2 31.2-31.2c16.8 0 31.2 13.6 31.2 31.2s-13.6 31.2-31.2 31.2z m0-46.4c-8 0-15.2 7.2-15.2 15.2s7.2 15.2 15.2 15.2 15.2-7.2 15.2-15.2-6.4-15.2-15.2-15.2zM342.4 637.6c-16.8 0-31.2-13.6-31.2-31.2s13.6-31.2 31.2-31.2c16.8 0 31.2 13.6 31.2 31.2s-13.6 31.2-31.2 31.2z m0-46.4c-8 0-15.2 7.2-15.2 15.2s7.2 15.2 15.2 15.2 15.2-7.2 15.2-15.2-6.4-15.2-15.2-15.2z",
    "M1004 1020H20c-8.8 0-16-7.2-16-16V389.6c0-8.8 7.2-16 16-16s16 7.2 16 16v598.4h952V389.6c0-8.8 7.2-16 16-16s16 7.2 16 16v614.4c0 8.8-7.2 16-16 16zM1004 1012H20c-3.2 0-6.4-2.4-7.2-5.6s0-7.2 2.4-8.8L424 690.4c3.2-2.4 6.4-2.4 9.6 0l77.6 58.4 78.4-58.4c3.2-2.4 6.4-2.4 9.6 0l408.8 307.2c2.4 2.4 4 5.6 2.4 8.8s-3.2 5.6-6.4 5.6z m-960-16h936L595.2 706.4l-78.4 58.4c-3.2 2.4-6.4 2.4-9.6 0l-77.6-58.4-385.6 289.6zM512 775.2c-3.2 0-6.4-0.8-9.6-3.2L10.4 402.4c-4-3.2-6.4-8-6.4-12.8s2.4-9.6 6.4-12.8L502.4 7.2c5.6-4 13.6-4 19.2 0l492 369.6c4 3.2 6.4 8 6.4 12.8s-2.4 9.6-6.4 12.8L521.6 772c-3.2 1.6-6.4 3.2-9.6 3.2zM46.4 389.6L512 739.2l465.6-349.6L512 40 46.4 389.6zM432 576c-0.8 0-2.4 0-3.2-0.8-20-8.8-194.4-88-213.6-144C198.4 384 224 331.2 272 315.2c24.8-8.8 52-6.4 74.4 6.4 9.6-24 29.6-42.4 54.4-51.2 23.2-8 48-6.4 69.6 4 22.4 10.4 38.4 29.6 46.4 52 19.2 55.2-68 225.6-78.4 244.8-0.8 3.2-4 4.8-6.4 4.8zM301.6 325.6c-8 0-16.8 1.6-24.8 4-39.2 13.6-60 56.8-46.4 96 13.6 40 141.6 105.6 197.6 131.2 28-55.2 87.2-186.4 73.6-225.6-6.4-19.2-20-34.4-38.4-43.2-18.4-8.8-38.4-9.6-57.6-3.2-23.2 8-40.8 27.2-48 50.4-0.8 2.4-2.4 4.8-4.8 5.6-2.4 0.8-4.8 0.8-7.2-0.8-12.8-8.8-28-14.4-44-14.4zM640 513.6c-3.2 0-6.4-1.6-7.2-4.8-6.4-16-59.2-159.2-39.2-201.6 8.8-17.6 24-31.2 42.4-37.6 18.4-6.4 39.2-5.6 56.8 3.2 18.4 8.8 32.8 25.6 38.4 44.8 19.2-7.2 40.8-6.4 59.2 2.4 36.8 17.6 52 62.4 34.4 99.2-20.8 42.4-165.6 88.8-182.4 94.4H640z m20.8-232.8c-6.4 0-12.8 0.8-19.2 3.2-14.4 4.8-26.4 16-33.6 29.6-14.4 28.8 20 135.2 36.8 181.6 47.2-15.2 151.2-55.2 165.6-84 14.4-28.8 1.6-64-27.2-77.6-16.8-8-36.8-8-53.6 1.6-2.4 1.6-4.8 1.6-7.2 0-2.4-0.8-4-3.2-4.8-5.6-3.2-18.4-15.2-35.2-32-43.2-8-3.2-16-5.6-24.8-5.6z",
    "M405.6 1020h-6.4c-17.6-1.6-32-8.8-46.4-16-11.2-5.6-21.6-11.2-32-12.8-16-2.4-33.6 4-52 11.2-8.8 3.2-17.6 6.4-26.4 8.8-23.2 6.4-54.4 6.4-73.6-8-10.4-8-16-20-16-32.8 0-166.4 36.8-323.2 102.4-440.8C323.2 408 414.4 341.6 512 341.6S700.8 408 768.8 529.6c66.4 118.4 102.4 274.4 102.4 440.8 0 4.8-2.4 9.6-6.4 12.8-40 29.6-89.6 39.2-136 26.4-4-0.8-8-2.4-11.2-3.2-7.2-2.4-14.4-4.8-21.6-5.6-14.4-1.6-28.8 2.4-44.8 7.2-19.2 5.6-39.2 11.2-60.8 8-15.2-2.4-28.8-9.6-40.8-16-12-6.4-23.2-12-34.4-12.8-16-1.6-32 6.4-49.6 15.2-17.6 8-37.6 17.6-60 17.6z m-92-61.6c4 0 8 0 12 0.8 16 2.4 28.8 8.8 42.4 16 12 6.4 23.2 12 34.4 12.8 16 1.6 32-6.4 49.6-15.2 20-9.6 41.6-20 66.4-18.4 17.6 1.6 32 9.6 46.4 16.8 11.2 5.6 20.8 11.2 31.2 12.8 14.4 2.4 30.4-2.4 47.2-7.2 18.4-5.6 36.8-10.4 57.6-8 9.6 0.8 19.2 4 27.2 6.4 3.2 0.8 7.2 2.4 10.4 3.2 34.4 9.6 71.2 3.2 101.6-16.8-2.4-324.8-148.8-588-328-588-180.8 0-328 267.2-328 596.8 0 3.2 0.8 5.6 4 7.2 8.8 6.4 28.8 8 45.6 2.4 8-2.4 15.2-4.8 24-8 17.6-6.4 36-13.6 56-13.6zM640.8 418.4c-3.2 0-6.4-0.8-9.6-3.2-38.4-27.2-78.4-41.6-119.2-41.6s-81.6 13.6-119.2 41.6c-4 3.2-10.4 4-15.2 1.6-4.8-1.6-8.8-6.4-9.6-11.2-13.6-58.4-28.8-100-39.2-124.8-15.2-34.4-8.8-74.4 15.2-101.6 20.8-24 51.2-37.6 83.2-37.6 33.6 0 65.6 16 85.6 41.6 20.8-25.6 52-41.6 85.6-41.6 32 0 61.6 13.6 83.2 37.6 24 27.2 30.4 68 15.2 101.6-10.4 24-26.4 65.6-39.2 124.8-0.8 5.6-4.8 9.6-9.6 11.2-3.2 1.6-4.8 1.6-7.2 1.6zM512 341.6c40.8 0 80.8 12 118.4 34.4 12.8-49.6 26.4-85.6 36-108 10.4-23.2 6.4-49.6-9.6-68-15.2-16.8-36-26.4-59.2-26.4-30.4 0-58.4 18.4-71.2 46.4-2.4 5.6-8 9.6-14.4 9.6s-12-4-14.4-9.6c-12.8-28-40.8-46.4-71.2-46.4-22.4 0-44 9.6-59.2 26.4-16 18.4-20 44.8-9.6 68 9.6 22.4 23.2 58.4 36 108 37.6-22.4 77.6-34.4 118.4-34.4zM280 984.8h-1.6c-4-0.8-7.2-4.8-6.4-9.6 1.6-9.6 40.8-242.4 103.2-348.8 2.4-4 7.2-4.8 11.2-3.2 4 2.4 4.8 7.2 3.2 11.2C328 739.2 288 976 287.2 978.4c0 4-4 6.4-7.2 6.4zM754.4 1006.4c-4 0-7.2-2.4-8-6.4 0-2.4-40.8-239.2-100.8-343.2-2.4-4-0.8-8.8 3.2-11.2 4-2.4 8.8-0.8 11.2 3.2 61.6 106.4 101.6 338.4 103.2 348.8 0.8 4-2.4 8.8-6.4 9.6-1.6-0.8-1.6-0.8-2.4-0.8zM574.4 996.8c-4.8 0-8-4-8-8 0-2.4 0.8-206.4-21.6-296-0.8-4 1.6-8.8 5.6-9.6 4-0.8 8.8 1.6 9.6 5.6 23.2 91.2 22.4 291.2 22.4 300 0 4.8-3.2 8-8 8zM456 996.8c-4 0-8-3.2-8-8 0-8.8-0.8-208.8 22.4-300 0.8-4 5.6-7.2 9.6-5.6 4 0.8 7.2 5.6 5.6 9.6-22.4 89.6-21.6 293.6-21.6 296 0 4.8-3.2 8-8 8zM619.2 173.6c-8.8 0-16-7.2-16-16V20c0-8.8 7.2-16 16-16s16 7.2 16 16v137.6c0 8.8-7.2 16-16 16zM404.8 173.6c-8.8 0-16-7.2-16-16V20c0-8.8 7.2-16 16-16s16 7.2 16 16v137.6c0 8.8-7.2 16-16 16z",
    "M327.2 1020c-58.4 0-116-8.8-172-16.8-29.6-4-62.4-9.6-90.4-28.8-5.6-4-10.4-8-15.2-13.6-13.6-14.4-20-35.2-17.6-55.2 2.4-20.8 13.6-40 31.2-52.8l113.6-80c36-25.6 85.6-60 142.4-57.6 11.2 0.8 22.4 2.4 33.6 4.8 20 4 39.2 7.2 54.4 0 12.8-6.4 21.6-20.8 30.4-32.8l227.2-344.8c54.4-83.2 111.2-170.4 144-266.4 5.6-16 17.6-28 32.8-32 22.4-6.4 34.4 8.8 40 16 51.2 64.8 100 135.2 110.4 216.8 4 34.4-0.8 71.2-14.4 104-3.2 8-4.8 16-5.6 24.8l-30.4 599.2c-0.8 8.8-7.2 15.2-16 15.2h-64c-8.8 0-15.2-6.4-16-15.2l-25.6-514.4c-15.2 4.8-30.4 14.4-44 27.2-36.8 35.2-55.2 88-72 134.4l-42.4 121.6c-16 45.6-34.4 97.6-68 139.2-45.6 56.8-120 92.8-208 103.2-20.8 3.2-40 4-58.4 4z m549.6-32h33.6l29.6-584c0.8-12 3.2-24 8-35.2 11.2-28 16-59.2 12.8-88-8.8-73.6-55.2-140-103.2-200.8-1.6-1.6-4-4.8-4.8-5.6h-1.6c-4.8 1.6-8.8 5.6-10.4 11.2-33.6 100-92 188.8-148.8 274.4L463.2 705.6c-9.6 15.2-22.4 33.6-42.4 44-24.8 12-51.2 7.2-74.4 3.2-10.4-1.6-20-4-28.8-4-41.6-1.6-80 22.4-122.4 52l-113.6 80c-9.6 7.2-16 17.6-17.6 29.6-1.6 11.2 2.4 21.6 9.6 29.6 3.2 3.2 6.4 6.4 10.4 8.8 21.6 15.2 51.2 19.2 76.8 23.2 72.8 10.4 147.2 21.6 220.8 13.6 80-8.8 146.4-41.6 187.2-91.2 30.4-37.6 46.4-84 62.4-129.6l42.4-121.6c17.6-49.6 37.6-106.4 80-147.2 19.2-18.4 40.8-31.2 63.2-36.8 5.6-1.6 11.2-2.4 15.2-3.2 4.8-0.8 8.8 0.8 12.8 3.2 3.2 3.2 5.6 7.2 5.6 12l26.4 516.8zM451.2 196c-75.2 0-133.6-13.6-140-48.8-4.8-26.4 20.8-52.8 76-77.6 48-21.6 112-40 182.4-52 131.2-22.4 277.6-21.6 287.2 35.2 4.8 26.4-20.8 52.8-76 77.6-48 21.6-112 40-182.4 52-49.6 8.8-101.6 13.6-147.2 13.6z m264.8-160c-37.6 0-84.8 4-140 13.6-67.2 12-129.6 29.6-174.4 49.6-50.4 22.4-58.4 39.2-58.4 43.2 2.4 15.2 91.2 36.8 250.4 8.8 67.2-12 129.6-29.6 174.4-49.6 50.4-22.4 58.4-39.2 58.4-43.2-2.4-9.6-40-22.4-110.4-22.4z",
    "M824 1020H200c-8.8 0-16-7.2-16-16V20c0-8.8 7.2-16 16-16h624c8.8 0 16 7.2 16 16v984c0 8.8-7.2 16-16 16z m-608-32h592V36H216v952zM824 860H200c-4.8 0-8-3.2-8-8V122.4c0-4.8 3.2-8 8-8h624c4.8 0 8 3.2 8 8v729.6c0 4.8-4 8-8 8z m-616-16h608V130.4H208v713.6zM512 616.8c-1.6 0-4-0.8-5.6-2.4-7.2-7.2-179.2-169.6-179.2-238.4 0-57.6 47.2-104.8 104.8-104.8 30.4 0 59.2 13.6 79.2 36 20-23.2 48.8-36 79.2-36 57.6 0 104.8 47.2 104.8 104.8 0 68-172 231.2-179.2 238.4 0 1.6-2.4 2.4-4 2.4z m-79.2-329.6C384 287.2 344 327.2 344 376c0 49.6 116.8 172 168.8 221.6 52-49.6 168.8-172 168.8-221.6 0-48.8-40-88.8-88.8-88.8-28.8 0-56 14.4-72.8 37.6-3.2 2.4-5.6 3.2-8 3.2-2.4 0-4.8-1.6-6.4-3.2-16.8-23.2-44-37.6-72.8-37.6z",
    "M499.2 801.6c-160 0-289.6-130.4-289.6-289.6s130.4-289.6 289.6-289.6S788.8 352 788.8 512s-129.6 289.6-289.6 289.6z m0-547.2c-142.4 0-257.6 116-257.6 257.6 0 142.4 116 257.6 257.6 257.6S756.8 654.4 756.8 512c0-142.4-116-257.6-257.6-257.6zM499.2 721.6C384 721.6 289.6 627.2 289.6 512c0-115.2 94.4-209.6 209.6-209.6S708.8 396.8 708.8 512c0 115.2-94.4 209.6-209.6 209.6z m0-403.2C392 318.4 305.6 405.6 305.6 512c0 106.4 87.2 193.6 193.6 193.6S692.8 618.4 692.8 512c0-106.4-87.2-193.6-193.6-193.6zM106.4 432.8C50.4 432.8 4 370.4 4 292.8c0-76.8 45.6-140 102.4-140s102.4 62.4 102.4 140-46.4 140-102.4 140z m0-247.2c-38.4 0-70.4 49.6-70.4 108s32 108 70.4 108 70.4-49.6 70.4-108-32.8-108-70.4-108zM106.4 870.4c-16 0-31.2-7.2-43.2-20-18.4-19.2-28-49.6-25.6-81.6l24-359.2c0-5.6 3.2-10.4 8-12.8 4.8-2.4 10.4-3.2 15.2-0.8 14.4 7.2 28.8 7.2 42.4 0 4.8-2.4 10.4-2.4 15.2 0.8 4.8 2.4 8 7.2 8 12.8l24 359.2c2.4 32-7.2 62.4-25.6 81.6-11.2 12.8-26.4 20-42.4 20zM92 432L69.6 771.2c-1.6 22.4 4.8 44.8 16.8 57.6 4 4.8 11.2 9.6 20 9.6s16-5.6 20-9.6c12-12.8 18.4-35.2 16.8-57.6L120 432c-8.8 1.6-18.4 1.6-28 0zM910.4 437.6c-30.4 0-60-12.8-80.8-35.2-20.8-22.4-31.2-52.8-28.8-83.2l12-156c0.8-8.8 8-15.2 16.8-14.4 8.8 0.8 15.2 8 14.4 16.8L832 322.4c-1.6 21.6 5.6 42.4 20.8 59.2 15.2 16 35.2 24.8 56.8 24.8s42.4-8.8 56.8-24.8c15.2-16 22.4-36.8 20.8-59.2L976 166.4c-0.8-8.8 5.6-16.8 14.4-16.8 8.8-0.8 16.8 5.6 16.8 14.4l12 156c2.4 30.4-8 60.8-28.8 83.2-20.8 21.6-49.6 34.4-80 34.4zM910.4 875.2c-16 0-31.2-7.2-43.2-20-18.4-19.2-28-49.6-25.6-81.6l24-357.6c0-4.8 3.2-9.6 7.2-12 4-2.4 9.6-3.2 14.4-1.6 5.6 1.6 11.2 3.2 17.6 4h8c7.2 0 15.2-0.8 22.4-3.2 4.8-1.6 9.6-0.8 13.6 2.4 4 2.4 6.4 7.2 7.2 12l24 356.8c2.4 32-7.2 62.4-25.6 81.6-13.6 12-28 19.2-44 19.2zM896 436.8l-23.2 338.4c-1.6 22.4 4.8 44.8 16.8 57.6 4 4.8 11.2 9.6 20 9.6s16-5.6 20-9.6c12-12.8 18.4-35.2 16.8-57.6l-23.2-338.4c-4 0.8-8 0.8-12.8 0.8h-0.8-0.8c-3.2 0-6.4 0-9.6-0.8h-3.2zM910.4 437.6c-8.8 0-16-7.2-16-16V168c0-8.8 7.2-16 16-16s16 7.2 16 16v253.6c0 8.8-7.2 16-16 16z",
    "M514.4 1014.4c-4 0-8-1.6-11.2-4C475.2 984 336 849.6 336 785.6c0-57.6 47.2-104.8 105.6-104.8 27.2 0 53.6 10.4 72.8 29.6 19.2-18.4 45.6-29.6 72.8-29.6 58.4 0 105.6 47.2 105.6 104.8 0 64-139.2 198.4-167.2 224.8-3.2 3.2-7.2 4-11.2 4z m-73.6-301.6c-40.8 0-73.6 32.8-73.6 72.8 0 36.8 85.6 132 146.4 191.2 60.8-59.2 146.4-154.4 146.4-191.2 0-40-32.8-72.8-73.6-72.8-24 0-46.4 12-60 31.2-3.2 4-8 6.4-12.8 6.4s-9.6-2.4-12.8-6.4c-13.6-20-36-31.2-60-31.2zM512 750.4c-8.8 0-16-7.2-16-16V642.4c0-8.8 7.2-16 16-16s16 7.2 16 16v92c0 8.8-7.2 16-16 16zM512 644C232 644 4 497.6 4 318.4 4 144.8 227.2 9.6 512 9.6s508 136 508 308.8c0 179.2-228 325.6-508 325.6z m0-602.4C244.8 41.6 36 163.2 36 318.4 36 480 249.6 612 512 612s476-132 476-293.6c0-155.2-208.8-276.8-476-276.8z",
    "M1004 298.4H20c-4.8 0-8-3.2-8-8V107.2c0-4.8 3.2-8 8-8h984c4.8 0 8 3.2 8 8v183.2c0 4-3.2 8-8 8z m-976-16h968V115.2H28v167.2zM1004 1020H20c-8.8 0-16-7.2-16-16V107.2c0-8.8 7.2-16 16-16h984c8.8 0 16 7.2 16 16v896.8c0 8.8-7.2 16-16 16z m-968-32h952V123.2H36v864.8zM158.4 210.4c-8.8 0-16-7.2-16-16V20c0-8.8 7.2-16 16-16s16 7.2 16 16v174.4c0 8.8-7.2 16-16 16zM291.2 210.4c-8.8 0-16-7.2-16-16V20c0-8.8 7.2-16 16-16s16 7.2 16 16v174.4c0 8.8-7.2 16-16 16zM732.8 210.4c-8.8 0-16-7.2-16-16V20c0-8.8 7.2-16 16-16s16 7.2 16 16v174.4c0 8.8-7.2 16-16 16zM865.6 210.4c-8.8 0-16-7.2-16-16V20c0-8.8 7.2-16 16-16s16 7.2 16 16v174.4c0 8.8-7.2 16-16 16zM744.8 1012c-0.8 0-2.4 0-3.2-0.8-3.2-1.6-4.8-4-4.8-7.2V744.8c0-4.8 3.2-8 8-8h259.2c3.2 0 6.4 1.6 7.2 4.8 1.6 3.2 0.8 6.4-1.6 8.8l-259.2 259.2c-1.6 1.6-3.2 2.4-5.6 2.4z m8-259.2v232l232-232h-232zM512 832.8c-50.4 0-92-13.6-123.2-40.8-32-27.2-48-60.8-48-100.8 0-44 16.8-80 49.6-108-23.2-24-34.4-52.8-34.4-84.8 0-35.2 15.2-64.8 45.6-88.8 29.6-23.2 67.2-35.2 111.2-35.2s81.6 12 111.2 35.2c30.4 24 45.6 53.6 45.6 88.8 0 32-11.2 60-33.6 84 32.8 28 49.6 64.8 49.6 108 0 40-16 73.6-48 100.8-33.6 28-75.2 41.6-125.6 41.6zM411.2 422.4c-26.4 20.8-39.2 45.6-39.2 76s12 56.8 36 79.2c1.6 1.6 2.4 4 2.4 6.4 0 2.4-1.6 4.8-3.2 5.6-33.6 25.6-50.4 59.2-50.4 101.6 0 35.2 13.6 64.8 42.4 88.8 28.8 24 66.4 36.8 112.8 36.8 46.4 0 84-12 112.8-36.8 28.8-24 42.4-53.6 42.4-88.8 0-42.4-16-75.2-50.4-101.6-1.6-1.6-3.2-4-3.2-5.6 0-2.4 0.8-4.8 2.4-6.4 24-22.4 35.2-48 35.2-79.2 0-30.4-12.8-56-39.2-76.8-26.4-20.8-60.8-32-100.8-32-39.2 0.8-73.6 12-100 32.8zM512 753.6c-18.4 0-35.2-5.6-51.2-16-16.8-11.2-24.8-27.2-24.8-48.8 0-20.8 8-37.6 24-48.8 15.2-10.4 32.8-16 52-16 19.2 0 36.8 5.6 52 16 16 11.2 24 28 24 48.8 0 20.8-8 37.6-24.8 48.8-16 10.4-32.8 16-51.2 16zM512 640c-16 0-29.6 4-42.4 13.6-12 8-17.6 20-17.6 36s5.6 27.2 17.6 35.2c12.8 8.8 27.2 12.8 41.6 12.8 15.2 0 28.8-4 42.4-12.8 12-8 17.6-19.2 17.6-35.2 0-16-5.6-27.2-17.6-36C541.6 644.8 528 640 512 640z m0-73.6c-17.6 0-32.8-5.6-45.6-16.8-13.6-11.2-20-25.6-20-42.4 0-16.8 6.4-31.2 20-42.4 12.8-11.2 28-16.8 46.4-16.8 17.6 0 33.6 5.6 46.4 16.8 13.6 11.2 20 25.6 20 42.4 0 16.8-7.2 31.2-20 42.4-14.4 11.2-29.6 16.8-47.2 16.8z m-35.2-28.8c10.4 8.8 21.6 12.8 35.2 12.8 13.6 0 25.6-4 35.2-12.8 9.6-8 14.4-18.4 14.4-30.4s-4.8-22.4-14.4-30.4c-10.4-8.8-21.6-12.8-36-12.8-14.4 0-25.6 4-36 12.8-9.6 8-14.4 18.4-14.4 30.4 0.8 12.8 5.6 22.4 16 30.4z",
    "M581.6 273.6c-3.2 0-6.4-0.8-9.6-3.2l-68.8-49.6-68.8 49.6c-5.6 4-13.6 4-18.4 0-5.6-4-8-11.2-5.6-17.6l26.4-79.2-68.8-49.6c-5.6-4-8-11.2-5.6-17.6 2.4-6.4 8-11.2 15.2-11.2h84.8l26.4-80c2.4-6.4 8-11.2 15.2-11.2s12.8 4.8 15.2 11.2l26.4 80h84.8c7.2 0 12.8 4.8 15.2 11.2 2.4 6.4 0 13.6-5.6 17.6l-68.8 48.8 26.4 79.2c2.4 6.4 0 13.6-5.6 17.6-4 2.4-7.2 4-10.4 4z m-78.4-88c3.2 0 6.4 0.8 9.6 3.2l38.4 27.2-14.4-44c-2.4-6.4 0-13.6 5.6-18.4l37.6-27.2h-46.4c-7.2 0-12.8-4.8-15.2-11.2L504 70.4l-14.4 44.8c-2.4 6.4-8 11.2-15.2 11.2h-46.4l37.6 27.2c5.6 4 8 11.2 5.6 18.4L456 216l38.4-27.2c2.4-2.4 5.6-3.2 8.8-3.2zM503.2 473.6c-4 0-8-1.6-11.2-4.8l-206.4-200c-6.4-6.4-6.4-16 0-22.4 6.4-6.4 16-6.4 22.4 0l179.2 173.6V201.6c0-8.8 7.2-16 16-16s16 7.2 16 16v256c0 6.4-4 12-9.6 14.4-1.6 0.8-4 1.6-6.4 1.6zM843.2 466.4c-1.6 0-4 0-5.6-0.8-6.4-2.4-10.4-8.8-10.4-16l5.6-83.2-79.2-30.4c-6.4-2.4-10.4-8.8-10.4-16 0.8-7.2 5.6-12.8 12-14.4l82.4-20.8 5.6-83.2c0.8-7.2 5.6-12.8 12-14.4 6.4-1.6 13.6 0.8 17.6 7.2l45.6 70.4 82.4-20.8c6.4-1.6 13.6 0.8 17.6 7.2s3.2 13.6-1.6 18.4l-53.6 64.8 45.6 70.4c4 5.6 3.2 13.6-0.8 18.4-4 5.6-12 7.2-18.4 4.8l-79.2-31.2-54.4 64.8c-4 2.4-8 4.8-12.8 4.8z m-32-143.2l43.2 16.8c6.4 2.4 10.4 8.8 10.4 16l-3.2 46.4 30.4-36c4.8-5.6 12-7.2 18.4-4.8l44 16.8-24.8-39.2c-4-5.6-3.2-13.6 0.8-19.2l29.6-35.2-45.6 11.2c-6.4 1.6-13.6-0.8-17.6-7.2l-25.6-39.2-3.2 46.4c-0.8 7.2-5.6 12.8-12 14.4l-44.8 12.8zM629.6 508.8c-3.2 0-6.4-0.8-8.8-3.2-5.6-4-8-10.4-6.4-16.8l60.8-279.2c1.6-8.8 10.4-14.4 19.2-12 8.8 1.6 14.4 10.4 12 19.2l-52.8 241.6 187.2-117.6c7.2-4.8 17.6-2.4 22.4 4.8 4.8 7.2 2.4 17.6-4.8 22.4L638.4 506.4c-2.4 1.6-5.6 2.4-8.8 2.4zM816.8 930.4c-2.4 0-4 0-6.4-1.6-6.4-2.4-10.4-8.8-9.6-16l6.4-83.2-78.4-32c-6.4-2.4-10.4-8.8-9.6-16s5.6-12.8 12-14.4l82.4-20 6.4-83.2c0.8-7.2 5.6-12.8 12-14.4 6.4-1.6 13.6 0.8 17.6 7.2l44.8 71.2 82.4-20c6.4-1.6 13.6 1.6 17.6 7.2 4 5.6 3.2 13.6-1.6 18.4l-54.4 64 44.8 71.2c4 5.6 3.2 13.6-1.6 18.4-4.8 5.6-12 7.2-18.4 4.8l-78.4-32-55.2 64c-4 4-8.8 6.4-12.8 6.4z m-30.4-144l43.2 17.6c6.4 2.4 10.4 8.8 9.6 16l-3.2 46.4 30.4-36c4.8-5.6 12-7.2 18.4-4.8l43.2 17.6-24.8-39.2c-4-5.6-3.2-13.6 1.6-19.2l30.4-35.2-45.6 11.2c-6.4 1.6-13.6-1.6-17.6-7.2l-24.8-40-3.2 46.4c-0.8 7.2-5.6 12.8-12 14.4l-45.6 12zM828 776c-4 0-7.2-1.6-10.4-4L620 607.2c-4.8-4-7.2-11.2-4.8-16.8s7.2-10.4 13.6-11.2l288-25.6c8.8-0.8 16.8 5.6 17.6 14.4 0.8 8.8-5.6 16.8-14.4 17.6L670.4 608l168.8 140.8c6.4 5.6 8 16 2.4 22.4-4.8 3.2-8.8 4.8-13.6 4.8zM90.4 629.6c-2.4 0-4.8-0.8-7.2-1.6-6.4-3.2-9.6-9.6-8.8-16.8L88 528.8l-75.2-38.4C6.4 487.2 3.2 480.8 4 473.6c0.8-7.2 6.4-12 13.6-13.6l84-12.8 13.6-82.4c0.8-7.2 6.4-12 13.6-13.6 7.2-0.8 13.6 2.4 16.8 8.8l38.4 74.4 84-12.8c7.2-0.8 13.6 2.4 16.8 8.8 3.2 6.4 1.6 13.6-3.2 18.4l-60 59.2 38.4 74.4c3.2 6.4 2.4 13.6-3.2 18.4-4.8 4.8-12 6.4-18.4 3.2l-76-38.4-60 59.2c-3.2 3.2-8 4.8-12 4.8zM72 484l41.6 20.8c6.4 3.2 9.6 9.6 8.8 16.8l-8 46.4 33.6-32.8c4.8-4.8 12-5.6 18.4-3.2l41.6 21.6-20.8-41.6c-3.2-6.4-1.6-13.6 3.2-18.4l32.8-32.8-46.4 7.2c-7.2 0.8-13.6-2.4-16.8-8.8l-21.6-41.6-7.2 46.4c-0.8 7.2-6.4 12-13.6 13.6l-45.6 6.4zM224.8 730.4c-4.8 0-9.6-2.4-12.8-6.4-4.8-7.2-4-16.8 3.2-22.4l201.6-146.4-218.4-34.4c-8.8-1.6-14.4-9.6-13.6-18.4 1.6-8.8 9.6-14.4 18.4-13.6l256 40.8c6.4 0.8 11.2 5.6 12.8 12s-0.8 12.8-6.4 16.8L234.4 727.2c-3.2 2.4-6.4 3.2-9.6 3.2zM300 1020c-3.2 0-5.6-0.8-8-2.4-5.6-3.2-8.8-10.4-7.2-17.6l19.2-81.6-72.8-43.2c-5.6-3.2-8.8-10.4-7.2-17.6 1.6-6.4 7.2-12 14.4-12l84.8-7.2 19.2-81.6c1.6-6.4 7.2-12 14.4-12 7.2-0.8 13.6 3.2 16 9.6l32.8 76.8 84.8-7.2c7.2-0.8 13.6 3.2 16 9.6 2.4 6.4 0.8 13.6-4 18.4l-64 54.4 32.8 76.8c2.4 6.4 0.8 13.6-4 18.4-5.6 4.8-12.8 5.6-18.4 1.6L376 960l-64 55.2c-4.8 3.2-8.8 4.8-12 4.8z m-10.4-146.4l40 24c6.4 3.2 8.8 10.4 7.2 17.6l-10.4 44.8 36-30.4c5.6-4.8 12.8-4.8 18.4-1.6l40.8 24-18.4-42.4c-2.4-6.4-0.8-13.6 4-18.4l35.2-30.4-46.4 4c-7.2 0.8-13.6-3.2-16-9.6l-18.4-43.2-10.4 45.6c-1.6 6.4-7.2 12-14.4 12l-47.2 4zM600 921.6c-7.2 0-13.6-4.8-15.2-12l-62.4-240L408 856.8c-4.8 7.2-14.4 9.6-21.6 5.6-7.2-4.8-9.6-14.4-5.6-21.6l133.6-219.2c3.2-5.6 9.6-8.8 16-7.2 6.4 0.8 11.2 5.6 12.8 12l72 276.8c2.4 8.8-3.2 17.6-11.2 19.2-0.8-0.8-2.4-0.8-4-0.8z",
    "M894.4 714.4H129.6c-8.8 0-16-7.2-16-16V129.6c0-8.8 7.2-16 16-16h765.6c8.8 0 16 7.2 16 16v569.6c-0.8 8.8-8 15.2-16.8 15.2z m-748.8-32h733.6V145.6H145.6v536.8zM815.2 627.2H208.8c-4.8 0-8-3.2-8-8V208.8c0-4.8 3.2-8 8-8h606.4c4.8 0 8 3.2 8 8v410.4c0 4.8-3.2 8-8 8z m-598.4-16h590.4V216.8H216.8v394.4zM1004 910.4H20c-5.6 0-11.2-3.2-13.6-8-3.2-4.8-3.2-11.2 0-16l109.6-196c3.2-4.8 8-8 13.6-8h765.6c5.6 0 11.2 3.2 13.6 8l109.6 196c2.4 4.8 2.4 11.2 0 16-3.2 5.6-8.8 8-14.4 8z m-956.8-32h929.6l-91.2-164H138.4L47.2 878.4zM562.4 546.4c-1.6 0-4-0.8-5.6-2.4 0 0-24-22.4-51.2-52-3.2-3.2-3.2-8 0.8-11.2 3.2-3.2 8-3.2 11.2 0.8 19.2 20 36 37.6 44.8 45.6 39.2-38.4 124.8-128 124.8-164s-29.6-64.8-64.8-64.8c-16.8 0-32.8 6.4-44.8 18.4-3.2 3.2-8 3.2-11.2 0-3.2-3.2-3.2-8 0-11.2 15.2-14.4 35.2-22.4 56-22.4 44.8 0 80.8 36.8 80.8 80.8 0 51.2-121.6 168-135.2 180.8-1.6 0.8-3.2 1.6-5.6 1.6zM461.6 546.4c-1.6 0-4-0.8-5.6-2.4-13.6-12.8-135.2-128.8-135.2-180.8 0-44.8 36.8-80.8 80.8-80.8 23.2 0 44.8 9.6 60 26.4 15.2-16.8 36.8-26.4 60-26.4 44.8 0 80.8 36.8 80.8 80.8 0 51.2-121.6 168-135.2 180.8-1.6 1.6-4 2.4-5.6 2.4z m-60-248.8c-36 0-64.8 29.6-64.8 64.8 0 36 85.6 126.4 124.8 164 39.2-38.4 124.8-128 124.8-164s-29.6-64.8-64.8-64.8c-20.8 0-40.8 10.4-53.6 28-3.2 4-10.4 4-12.8 0-12-17.6-32-28-53.6-28z",
    "M512 1020c-5.6 0-11.2-3.2-13.6-8-12.8-20.8-308-514.4-308-686.4C189.6 148.8 334.4 4 512 4s322.4 144.8 322.4 322.4c0 171.2-296 665.6-308 686.4-3.2 4-8.8 7.2-14.4 7.2z m0-984c-160 0-290.4 130.4-290.4 290.4 0 142.4 231.2 545.6 290.4 646.4 59.2-100.8 290.4-504 290.4-646.4 0-160-130.4-290.4-290.4-290.4zM512 567.2c-1.6 0-4-0.8-5.6-2.4-8-8-198.4-187.2-198.4-263.2 0-64 52-116 116-116 33.6 0 66.4 15.2 88 40.8 21.6-25.6 54.4-40.8 88-40.8 64 0 116 52 116 116 0 75.2-190.4 256-198.4 263.2-1.6 1.6-4 2.4-5.6 2.4zM424 202.4c-55.2 0-100 44.8-100 100s130.4 192 188 246.4c56.8-54.4 188-191.2 188-246.4 0-55.2-44.8-100-100-100-32 0-62.4 16-81.6 42.4-1.6 1.6-4 3.2-6.4 3.2-2.4 0-4.8-1.6-6.4-3.2-19.2-27.2-49.6-42.4-81.6-42.4z",
    "M288 464h-32v-32h32v32z m160-104v560c0 22-18 40-40 40H232c-22 0-40-18-40-40V360c0-19.8 14.6-36.3 33.5-39.5V216c0-2.3 0.2-4.7 0.6-7.2 0.1-0.8 0.3-1.7 0.5-2.5 0.7-3.4 1.8-7 3.1-10.7 4.8-13.1 13.4-27.8 24.3-42.6 2.3-3.2 4.8-6.3 7.3-9.5 6.8-8.4 14.2-16.7 22.1-24.6 2-2 4-3.9 6-5.8 3-2.9 6.1-5.7 9.2-8.4 2.1-1.8 4.1-3.6 6.2-5.3 4.2-3.5 8.4-6.7 12.6-9.8 3.2-2.3 6.4-4.5 9.5-6.6 18-11.6 35.7-18.9 50.5-18.9 22 0 40 18 40 40v217.1c17.5 4.2 30.6 20.1 30.6 38.8z m-190.5-40h128V104c0-4.3-3.7-8-8-8-13.6 0-43.4 16.5-74 48.1-13.9 14.3-26.2 30-34.6 44.1-9 15-11.3 24.5-11.3 27.8v104zM416 920V464h-95v-32h95v-72c0-4.3-3.7-8-8-8H232c-4.3 0-8 3.7-8 8v560c0 4.3 3.7 8 8 8h176c4.3 0 8-3.7 8-8z m376-216h-72V448h-32v256h-72c-22 0-40 18-40 40v176c0 22 18 40 40 40h176c22 0 40-18 40-40V744c0-22-18-40-40-40z m8 216c0 4.3-3.7 8-8 8H616c-4.3 0-8-3.7-8-8V744c0-4.3 3.7-8 8-8h176c4.3 0 8 3.7 8 8v176z m-47.9-688.6h-96v-32h96v32z m0-66.9h-96v-32h96v32z m0 267.5h-96v-32h96v32z m-16-334.3h-64v-32h64v32z m16 200.6h-96v-32h96v32z m0 66.8h-96v-32h96v32z",
    "M250.4 1020h-1.6c-8-0.8-15.2-4-20-10.4l-93.6-120.8L14.4 795.2C8 790.4 4.8 783.2 4 776c-0.8-8 2.4-15.2 8-20.8l4-4.8c7.2-7.2 17.6-9.6 27.2-6.4l108 33.6c61.6-120 228-328.8 396.8-498.4 108.8-108.8 201.6-184 276-224 90.4-48.8 135.2-32.8 156.8-12 21.6 21.6 36.8 66.4-12 156.8-40 74.4-115.2 167.2-224 276-168.8 169.6-377.6 335.2-497.6 396.8l33.6 108c3.2 9.6 0 20-6.4 27.2l-4 4c-6.4 4.8-12.8 8-20 8zM44 777.6L155.2 864l4.8 4.8 86.4 111.2-31.2-101.6c-4-12.8 1.6-26.4 13.6-32 116.8-58.4 324.8-224 493.6-392.8 106.4-106.4 180-196.8 218.4-268 30.4-56.8 36.8-99.2 17.6-119.2-19.2-19.2-61.6-13.6-119.2 17.6-72 38.4-161.6 112-268 218.4-169.6 168-335.2 376-393.6 492.8-5.6 12-19.2 17.6-32 13.6L44 777.6zM448.8 422.4c-3.2 0-6.4-0.8-8.8-3.2l-352.8-248c-4-2.4-6.4-7.2-6.4-12-0.8-4.8 1.6-9.6 4.8-12.8L152 80c3.2-3.2 8.8-5.6 13.6-4.8l524.8 78.4c6.4 0.8 11.2 5.6 12.8 11.2 1.6 6.4 0 12.8-4.8 16.8-40 33.6-82.4 73.6-127.2 118.4-36 36-72.8 75.2-109.6 115.2-4 5.6-8 7.2-12.8 7.2zM121.6 156.8l325.6 228.8c33.6-36.8 68-72.8 101.6-106.4 36-36 70.4-68 103.2-96.8l-482.4-72-48 46.4zM515.2 161.6h-2.4L384 141.6c-5.6-0.8-11.2-4.8-12.8-11.2-1.6-5.6 0-12 4-16L478.4 12c10.4-10.4 28-10.4 38.4 0l58.4 58.4c10.4 10.4 10.4 27.2 0 38.4l-48 48c-4 3.2-8 4.8-12 4.8z m-95.2-46.4L509.6 128l39.2-39.2-51.2-51.2-77.6 77.6zM865.6 943.2h-1.6c-4.8-0.8-8.8-3.2-12-6.4L604.8 584c-4.8-6.4-4-16 2.4-20.8 40.8-36.8 79.2-73.6 115.2-109.6 44.8-44.8 84.8-88 118.4-127.2 4-4.8 10.4-7.2 16.8-4.8 6.4 1.6 10.4 7.2 11.2 12.8l78.4 524.8c0.8 4.8-0.8 10.4-4.8 13.6l-66.4 66.4c-2.4 2.4-6.4 4-10.4 4zM639.2 576.8l228.8 325.6 47.2-47.2-72-482.4c-28.8 32.8-61.6 67.2-96.8 103.2-34.4 33.6-70.4 67.2-107.2 100.8zM897.6 653.6c-1.6 0-3.2 0-4.8-0.8-5.6-1.6-9.6-7.2-11.2-12.8l-19.2-128.8c-0.8-4.8 0.8-10.4 4.8-13.6l48-48c10.4-10.4 28-10.4 38.4 0l58.4 58.4c4.8 4.8 8 12 8 19.2 0 7.2-2.4 13.6-8 19.2l-103.2 103.2c-2.4 2.4-7.2 4-11.2 4z m-2.4-139.2l13.6 89.6 76.8-76.8-51.2-51.2-39.2 38.4zM270.4 760.8c-2.4 0-4-0.8-5.6-2.4-3.2-3.2-3.2-8 0-11.2l560.8-560.8c3.2-3.2 8-3.2 11.2 0s3.2 8 0 11.2L276 759.2c-0.8 0.8-3.2 1.6-5.6 1.6z",
    "M319.2 1020c-12.8 0-25.6-1.6-39.2-4.8-52-12-105.6-46.4-165.6-105.6C55.2 849.6 20 796 8.8 744c-14.4-64 6.4-124 61.6-180 42.4-42.4 101.6-78.4 166.4-103.2 16-5.6 28.8-18.4 34.4-34.4 8-21.6 20-40 35.2-55.2 36-36 88.8-52 148-44 56.8 8 113.6 37.6 159.2 83.2 45.6 45.6 75.2 102.4 83.2 159.2 8 59.2-7.2 111.2-44 148-15.2 15.2-34.4 27.2-55.2 35.2-16 5.6-28 18.4-34.4 34.4-24 64.8-60.8 124-103.2 166.4-44 44-91.2 66.4-140.8 66.4zM424 357.6c-38.4 0-71.2 12.8-95.2 36.8-12 12-21.6 27.2-28 44-8.8 24.8-28.8 44-52.8 53.6-60.8 22.4-116 56.8-155.2 96-48 48-64.8 96.8-52.8 149.6 10.4 45.6 42.4 94.4 97.6 149.6 55.2 55.2 104 87.2 149.6 97.6 52.8 12 102.4-5.6 149.6-52.8 39.2-39.2 72.8-93.6 96-155.2 9.6-24.8 28.8-44 53.6-52.8 16.8-6.4 32-15.2 44-28 28.8-28.8 41.6-72 34.4-120.8-7.2-50.4-33.6-100.8-74.4-141.6-40.8-40.8-91.2-67.2-141.6-74.4-8-0.8-16.8-1.6-24.8-1.6zM625.6 464.8h-0.8c-4.8 0-8.8-2.4-12-6.4a329.68 329.68 0 0 0-47.2-47.2c-3.2-3.2-5.6-7.2-6.4-12 0-4.8 1.6-8.8 4.8-12l209.6-209.6c3.2-3.2 7.2-4.8 11.2-4.8 4 0 8 1.6 11.2 4.8l49.6 49.6c6.4 6.4 6.4 16 0 22.4L636.8 460c-3.2 3.2-7.2 4.8-11.2 4.8z m-26.4-67.2c4.8 4 9.6 8.8 14.4 13.6 4.8 4.8 8.8 9.6 13.6 14.4L812.8 240l-27.2-27.2-186.4 184.8zM833.6 256c-4 0-8-1.6-11.2-4.8l-49.6-49.6c-3.2-3.2-4.8-8-4.8-12.8l8-79.2c0.8-5.6 4-10.4 8.8-12.8l141.6-69.6c6.4-3.2 13.6-1.6 18.4 3.2l49.6 49.6c4.8 4.8 6.4 12 3.2 18.4L928 239.2c-2.4 4.8-7.2 8-12.8 8.8l-80 8h-1.6z m-32.8-72l39.2 39.2 63.2-6.4 60.8-122.4-33.6-33.6-123.2 60.8-6.4 62.4zM1004 178.4c-4 0-8-1.6-11.2-4.8l-37.6-37.6c-6.4-6.4-6.4-16 0-22.4 6.4-6.4 16-6.4 22.4 0l37.6 37.6c6.4 6.4 6.4 16 0 22.4-3.2 3.2-7.2 4.8-11.2 4.8zM976.8 229.6c-4 0-8-1.6-11.2-4.8l-37.6-37.6c-6.4-6.4-6.4-16 0-22.4 6.4-6.4 16-6.4 22.4 0l37.6 37.6c6.4 6.4 6.4 16 0 22.4-3.2 3.2-7.2 4.8-11.2 4.8zM899.2 73.6c-4 0-8-1.6-11.2-4.8l-37.6-37.6c-6.4-6.4-6.4-16 0-22.4 6.4-6.4 16-6.4 22.4 0l37.6 37.6c6.4 6.4 6.4 16 0 22.4-3.2 3.2-7.2 4.8-11.2 4.8zM848 101.6c-4 0-8-1.6-11.2-4.8l-37.6-37.6c-6.4-6.4-6.4-16 0-22.4 6.4-6.4 16-6.4 22.4 0l37.6 37.6c6.4 6.4 6.4 16 0 22.4-2.4 3.2-6.4 4.8-11.2 4.8zM339.2 787.2c-25.6 0-50.4-10.4-68.8-28.8s-28.8-42.4-28.8-68.8 10.4-50.4 28.8-68.8 42.4-28.8 68.8-28.8c25.6 0 50.4 10.4 68.8 28.8s28.8 42.4 28.8 68.8-10.4 50.4-28.8 68.8-43.2 28.8-68.8 28.8z m0-178.4c-21.6 0-41.6 8.8-57.6 24-15.2 15.2-24 36-24 57.6s8.8 41.6 24 57.6c15.2 15.2 36 24 57.6 24s41.6-8.8 57.6-24c15.2-15.2 24-36 24-57.6s-8.8-41.6-24-57.6c-15.2-15.2-36-24-57.6-24zM293.6 914.4c-2.4 0-4-0.8-5.6-2.4L112 736c-3.2-3.2-3.2-8 0-11.2s8-3.2 11.2 0l176 176c3.2 3.2 3.2 8 0 11.2-1.6 1.6-4 2.4-5.6 2.4z",
    "M980 1020H44c-8.8 0-16-7.2-16-16V20c0-8.8 7.2-16 16-16h936.8c8.8 0 16 7.2 16 16v984c-0.8 8.8-8 16-16.8 16z m-920-32h904.8V36H60v952zM865.6 800H158.4c-4.8 0-8-3.2-8-8V132.8c0-4.8 3.2-8 8-8h706.4c4.8 0 8 3.2 8 8V792c0.8 4.8-3.2 8-7.2 8z m-699.2-16h690.4V140.8H166.4V784zM751.2 647.2H634.4c-4.8 0-8-3.2-8-8s3.2-8 8-8h106.4L670.4 376C651.2 304.8 585.6 254.4 512 254.4c-73.6 0-139.2 49.6-158.4 120.8l-70.4 255.2h106.4c4.8 0 8 3.2 8 8s-3.2 8-8 8H272.8c-2.4 0-4.8-0.8-6.4-3.2-1.6-1.6-2.4-4.8-1.6-7.2l72.8-265.6c21.6-78.4 92.8-132.8 174.4-132.8 80.8 0 152.8 54.4 174.4 132.8l72.8 265.6c0.8 2.4 0 4.8-1.6 7.2-1.6 3.2-3.2 4-6.4 4zM512 471.2c-47.2 0-85.6-38.4-85.6-85.6 0-47.2 38.4-85.6 85.6-85.6 47.2 0 85.6 38.4 85.6 85.6 0 48-38.4 85.6-85.6 85.6z m0-154.4c-38.4 0-69.6 31.2-69.6 69.6S473.6 456 512 456s69.6-31.2 69.6-69.6-31.2-69.6-69.6-69.6zM634.4 800H389.6c-4.8 0-8-3.2-8-8V512c0-4.8 3.2-8 8-8h244.8c4.8 0 8 3.2 8 8v280c0 4.8-4 8-8 8z m-236.8-16h228.8V520H397.6v264z",
    "M435.2 902.4c-12.8 0-24-4.8-33.6-13.6L135.2 622.4c-18.4-18.4-18.4-48 0-66.4l420.8-420.8c8.8-8.8 20.8-13.6 33.6-13.6s24 4.8 33.6 13.6l267.2 267.2c18.4 18.4 18.4 48 0 66.4l-420.8 420.8c-10.4 8-21.6 12.8-34.4 12.8z m153.6-748.8c-4 0-8 1.6-10.4 4L157.6 578.4c-5.6 5.6-5.6 15.2 0 21.6l267.2 267.2c5.6 5.6 15.2 5.6 21.6 0l420.8-420.8c5.6-5.6 5.6-15.2 0-21.6L599.2 157.6c-2.4-3.2-6.4-4-10.4-4zM572.8 612.8c-58.4 0-173.6-4-204-34.4-16-16-24.8-37.6-24.8-60s8.8-44 24.8-60c16.8-16.8 40.8-25.6 64.8-24.8-0.8-24 8-47.2 24.8-64.8 33.6-33.6 87.2-33.6 120.8 0 38.4 38.4 34.4 216 33.6 236 0 4-3.2 8-8 8h-32zM429.6 449.6c-18.4 0-36 7.2-48.8 20-12.8 12.8-20 30.4-20 48.8s7.2 36 20 48.8c27.2 27.2 159.2 30.4 216.8 29.6 0.8-57.6-2.4-189.6-29.6-216.8-27.2-27.2-71.2-27.2-97.6 0-16 16-23.2 38.4-19.2 60.8 0.8 2.4 0 4.8-2.4 7.2-1.6 1.6-4.8 2.4-7.2 2.4-4-0.8-8-0.8-12-0.8zM781.6 332.8c-4 0-8-1.6-11.2-4.8L696 253.6c-4-4-5.6-10.4-4-15.2L752.8 16c1.6-5.6 5.6-9.6 11.2-11.2 5.6-1.6 11.2 0 15.2 4l236 236c4 4 5.6 9.6 4 15.2-1.6 5.6-5.6 9.6-11.2 11.2l-222.4 60.8c-0.8 0.8-2.4 0.8-4 0.8z m-56.8-95.2l61.6 61.6 187.2-51.2L776 50.4l-51.2 187.2zM256 1020c-4 0-8-1.6-11.2-4.8L8.8 779.2c-4-4-5.6-9.6-4-15.2 1.6-5.6 5.6-9.6 11.2-11.2l222.4-60.8c5.6-1.6 11.2 0 15.2 4l74.4 74.4c4 4 5.6 10.4 4 15.2L271.2 1008c-1.6 5.6-5.6 9.6-11.2 11.2-0.8 0.8-2.4 0.8-4 0.8zM50.4 776L248 973.6l51.2-187.2-61.6-61.6L50.4 776z",
    "M873.6 1020H150.4c-8.8 0-16-7.2-16-16V20c0-8.8 7.2-16 16-16h722.4c8.8 0 16 7.2 16 16v984c0.8 8.8-6.4 16-15.2 16z m-707.2-32h690.4V36H166.4v952zM512 335.2c-1.6 0-4-0.8-5.6-2.4-11.2-10.4-112-106.4-112-149.6 0-37.6 30.4-68 68-68 18.4 0 36 8 48.8 20.8 12.8-13.6 30.4-20.8 48.8-20.8 37.6 0 68 30.4 68 68 0 42.4-100 138.4-112 149.6 0 2.4-2.4 2.4-4 2.4z m-48.8-203.2c-28.8 0-52 23.2-52 52 0 26.4 60 92.8 100.8 132.8 41.6-40 100.8-106.4 100.8-132.8 0-28.8-23.2-52-52-52-16.8 0-32.8 8-42.4 22.4-1.6 2.4-4 3.2-6.4 3.2-2.4 0-4.8-1.6-6.4-3.2-9.6-14.4-25.6-22.4-42.4-22.4zM403.2 398.4H240c-4.8 0-8-3.2-8-8s3.2-8 8-8h163.2c4.8 0 8 3.2 8 8s-4 8-8 8zM469.6 506.4H240c-4.8 0-8-3.2-8-8s3.2-8 8-8h229.6c4.8 0 8 3.2 8 8s-4 8-8 8zM532 615.2H240c-4.8 0-8-3.2-8-8s3.2-8 8-8h292c4.8 0 8 3.2 8 8s-3.2 8-8 8zM421.6 894.4H260c-4.8 0-8-3.2-8-8s3.2-8 8-8h161.6c4.8 0 8 3.2 8 8s-3.2 8-8 8zM444 809.6H238.4c-4.8 0-8-3.2-8-8s3.2-8 8-8h205.6c4.8 0 8 3.2 8 8s-4 8-8 8zM764 894.4H602.4c-4.8 0-8-3.2-8-8s3.2-8 8-8h161.6c4.8 0 8 3.2 8 8s-4 8-8 8zM785.6 809.6H580c-4.8 0-8-3.2-8-8s3.2-8 8-8h205.6c4.8 0 8 3.2 8 8s-3.2 8-8 8z",
    "M1004 900H20c-8.8 0-16-7.2-16-16V267.2c0-8.8 7.2-16 16-16h984c8.8 0 16 7.2 16 16v616.8c0 8.8-7.2 16-16 16z m-968-32h952V283.2H36v584.8zM512 798.4c-122.4 0-222.4-100-222.4-222.4S389.6 353.6 512 353.6 734.4 453.6 734.4 576 634.4 798.4 512 798.4z m0-428.8c-113.6 0-206.4 92.8-206.4 206.4S398.4 782.4 512 782.4c113.6 0 206.4-92.8 206.4-206.4S625.6 369.6 512 369.6zM630.4 584c-4.8 0-8-3.2-8-8 0-60.8-49.6-110.4-110.4-110.4-4.8 0-8-3.2-8-8s3.2-8 8-8c69.6 0 126.4 56.8 126.4 126.4 0 4-3.2 8-8 8zM708 283.2h-392c-5.6 0-10.4-3.2-13.6-8-3.2-4.8-3.2-10.4-0.8-16l65.6-128c2.4-5.6 8-8.8 14.4-8.8h261.6c6.4 0 11.2 3.2 14.4 8.8l65.6 128c2.4 4.8 2.4 11.2-0.8 16-4 5.6-8.8 8-14.4 8z m-365.6-32h340l-48.8-96H391.2l-48.8 96zM221.6 283.2h-152c-8.8 0-16-7.2-16-16V173.6c0-8.8 7.2-16 16-16h152c8.8 0 16 7.2 16 16v93.6c0 9.6-7.2 16-16 16z m-136-32h120v-61.6h-120v61.6z",
    "M996.11 346.15H876.43l-34.21-160.14c-12.27-63.05-67.8-108.8-132-108.8H313.79c-64.21 0-119.73 45.75-131.9 108.31l-34.32 160.63H27.89C13.05 346.15 1 358.2 1 373.04v35.86c0 31.06 22.69 56.94 52.39 61.9l-16.5 313.21a26.942 26.942 0 0 0 7.35 19.93 26.87 26.87 0 0 0 19.51 8.39h17.93v26.89c0 59.32 48.26 107.58 107.58 107.58s107.58-48.26 107.58-107.58v-26.89h430.32v26.89c0 59.32 48.26 107.58 107.58 107.58s107.58-48.26 107.58-107.58v-26.89h17.93c7.37 0 14.43-3.03 19.51-8.39a26.888 26.888 0 0 0 7.35-19.93l-16.5-313.21c29.7-4.96 52.39-30.83 52.39-61.9v-35.86c0-14.84-12.05-26.89-26.89-26.89zM234.6 196.27c7.35-37.82 40.67-65.28 79.2-65.28h396.42c38.52 0 71.84 27.46 79.3 65.77l35.6 166.66-0.42-0.42-40.2 40.2c-15.25 15.25-35.51 23.64-57.06 23.64H278.65c-21.55 0-41.81-8.39-57.06-23.64l-25.7-25.7 38.71-181.23z m8.45 642.95c0 29.66-24.13 53.79-53.79 53.79s-53.79-24.13-53.79-53.79v-26.89h107.58v26.89z m645.48 0c0 29.66-24.13 53.79-53.79 53.79s-53.79-24.13-53.79-53.79v-26.89h107.58v26.89z m80.68-430.32c0 4.94-4.03 8.96-8.96 8.96h-17.93c-7.37 0-14.43 3.03-19.51 8.39a26.888 26.888 0 0 0-7.35 19.93l16.44 312.35H92.1l16.44-312.35c0.39-7.37-2.28-14.57-7.35-19.93s-12.13-8.39-19.51-8.39H63.75c-4.94 0-8.96-4.03-8.96-8.96v-8.96h89.65l-1.09 1.09 40.2 40.2c25.41 25.41 59.18 39.4 95.09 39.4h448.77c35.91 0 69.69-13.99 95.09-39.4l40.2-40.2-1.09-1.09h107.58v8.96zM402.53 571.22L205.3 517.43c-8.05-2.17-16.74-0.49-23.39 4.57a26.899 26.899 0 0 0-10.58 21.38v143.44c0 14.85 12.05 26.89 26.89 26.89h179.3c12.82 0 23.87-9.05 26.37-21.62l17.93-89.65c2.77-13.85-5.65-27.49-19.29-31.22z m-47.05 88.7H225.12v-81.33l139.04 37.93-8.68 43.4zM842.09 522c-6.64-5.06-15.29-6.74-23.39-4.57l-197.23 53.79c-13.64 3.73-22.06 17.37-19.3 31.22l17.93 89.65c2.5 12.57 13.55 21.62 26.37 21.62h179.3c14.85 0 26.89-12.05 26.89-26.89V543.38c0.01-8.39-3.9-16.29-10.57-21.38z m-43.21 137.92H668.52l-8.68-43.41 139.04-37.93v81.34zM431.32 247.54h143.44c14.85 0 26.89-12.05 26.89-26.89s-12.05-26.89-26.89-26.89H431.32c-14.85 0-26.89 12.05-26.89 26.89s12.04 26.89 26.89 26.89z",
    "M93.6 1020c-4 0-8-1.6-11.2-4.8l-63.2-62.4c-3.2-3.2-4.8-7.2-4.8-11.2 0-4 1.6-8 4.8-11.2l40.8-40.8-40.8-40.8c-6.4-6.4-6.4-16 0-22.4l63.2-62.4c3.2-3.2 7.2-4.8 11.2-4.8 4 0 8 1.6 11.2 4.8l40 40 14.4-14.4c-87.2-127.2-72-302.4 36.8-412 60.8-60.8 141.6-94.4 227.2-94.4 47.2 0 92.8 10.4 136 29.6 8 4 11.2 13.6 8 21.6-4 8-13.6 11.2-21.6 8-38.4-17.6-79.2-27.2-122.4-27.2-77.6 0-149.6 30.4-204.8 84.8C116.8 502.4 105.6 665.6 192 780.8c4.8 6.4 4 15.2-1.6 20.8l-35.2 36c-3.2 3.2-7.2 4.8-11.2 4.8-4 0-8-1.6-11.2-4.8l-40-40-40 40 40.8 40.8c6.4 6.4 6.4 16 0 22.4l-40.8 40.8 40 40 40-40c6.4-6.4 16.8-6.4 22.4 0l40 40 40-40-40.8-40.8c-6.4-6.4-6.4-16 0-22.4l36-36c5.6-5.6 14.4-6.4 20.8-1.6 49.6 36.8 108.8 56 170.4 56 77.6 0 149.6-30.4 204.8-84.8 110.4-110.4 112-292.8 4.8-406.4-6.4-6.4-5.6-16.8 0.8-22.4 8-7.2 17.6-7.2 24-0.8 119.2 125.6 117.6 328-4.8 450.4C590.4 894.4 509.6 928 424 928c-64 0-125.6-18.4-178.4-54.4l-15.2 15.2 40.8 40.8c6.4 6.4 6.4 16 0 22.4l-63.2 62.4c-3.2 3.2-7.2 4.8-11.2 4.8-4 0-8-1.6-11.2-4.8l-40-40-40 40c-4 4-8 5.6-12 5.6zM688.8 924.8c-45.6 0-89.6-9.6-131.2-28-8-4-12-12.8-8-20.8s12.8-12 20.8-8c37.6 16.8 76.8 25.6 118.4 25.6 159.2 0 289.6-130.4 289.6-290.4v-2.4C976 456 868.8 333.6 728 314.4c-8-0.8-13.6-8-13.6-16V190.4c0-6.4 4-12 9.6-14.4 6.4-2.4 12.8-0.8 17.6 3.2l42.4 42.4 40-40L686.4 42.4 547.2 181.6l40 40 42.4-42.4c4.8-4.8 11.2-5.6 17.6-3.2 5.6 2.4 9.6 8 9.6 14.4v108c0 8-5.6 14.4-13.6 16C503.2 336.8 400.8 456 399.2 599.2v2.4c0 74.4 28 144.8 79.2 199.2 6.4 6.4 5.6 16.8-0.8 22.4-6.4 6.4-16.8 5.6-22.4-0.8C398.4 762.4 368 684 368 601.6v-3.2c1.6-154.4 109.6-284 258.4-313.6v-56L599.2 256c-3.2 3.2-7.2 4.8-11.2 4.8-4 0-8-1.6-11.2-4.8l-63.2-62.4c-6.4-6.4-6.4-16 0-22.4L674.4 8.8c6.4-6.4 16.8-6.4 22.4 0l160.8 161.6c3.2 3.2 4.8 7.2 4.8 11.2 0 4-1.6 8-4.8 11.2L795.2 256c-3.2 3.2-7.2 4.8-11.2 4.8-4 0-8-1.6-11.2-4.8l-26.4-26.4v55.2c149.6 28 261.6 160 263.2 314.4v3.2c0 177.6-144 322.4-320.8 322.4zM650.4 832h-3.2l-3.2-0.8c-8.8-1.6-14.4-9.6-12.8-18.4 1.6-8.8 9.6-14.4 18.4-12.8l3.2 0.8c8.8 1.6 14.4 9.6 12.8 18.4-0.8 8-7.2 12.8-15.2 12.8zM688.8 828c-12 0-24.8-0.8-36.8-3.2l-2.4-0.8c-4-0.8-7.2-4.8-6.4-9.6 0.8-4 4.8-7.2 9.6-6.4l2.4 0.8c11.2 1.6 22.4 2.4 33.6 2.4 115.2 0 208.8-94.4 208.8-209.6 0-4.8 3.2-8 8-8s8 3.2 8 8c-0.8 124.8-101.6 226.4-224.8 226.4zM904.8 609.6c-4.8 0-8-3.2-8-8v-2.4c-1.6-114.4-95.2-207.2-208-207.2-47.2 0-92 16-129.6 45.6-49.6 40-78.4 98.4-79.2 161.6v2.4c0 4.8-3.2 8-8 8s-8-3.2-8-8v-3.2c0.8-68 32-131.2 84.8-173.6 40-32 88-48.8 140-48.8 122.4 0 223.2 100 224 223.2v3.2c0 4-3.2 7.2-8 7.2zM557.6 783.2c-1.6 0-3.2-0.8-4.8-1.6-56-43.2-88-108.8-88-179.2 0-4.8 3.2-8 8-8s8 3.2 8 8c0 65.6 29.6 126.4 82.4 166.4 3.2 2.4 4 8 1.6 11.2-2.4 1.6-4.8 3.2-7.2 3.2zM424 831.2c-60 0-116-23.2-158.4-66.4-88-88-88-231.2 0-319.2 42.4-42.4 98.4-66.4 158.4-66.4 13.6 0 27.2 1.6 40.8 4 4 0.8 7.2 4.8 6.4 9.6-0.8 4-4.8 7.2-9.6 6.4-12.8-2.4-25.6-3.2-38.4-3.2-56 0-108 21.6-147.2 61.6-81.6 81.6-81.6 215.2 0 296.8 39.2 39.2 92 61.6 147.2 61.6 56 0 108-21.6 147.2-61.6 81.6-81.6 81.6-215.2 0-296.8-5.6-6.4-12-12-19.2-16.8-3.2-2.4-4-8-1.6-11.2 2.4-3.2 8-4 11.2-1.6 7.2 5.6 13.6 12 20.8 18.4 88 88 88 231.2 0 319.2-41.6 42.4-98.4 65.6-157.6 65.6z",
    "M1004 1020H20c-8.8 0-16-7.2-16-16v-584c0-8.8 7.2-16 16-16h984c8.8 0 16 7.2 16 16v584c0 8.8-7.2 16-16 16z m-968-32h952v-552H36v552zM1004 436H20c-7.2 0-14.4-5.6-16-12.8-1.6-7.2 2.4-15.2 8.8-17.6C352.8 249.6 496.8 14.4 498.4 12c3.2-4.8 8-8 13.6-8s11.2 3.2 13.6 8c1.6 2.4 146.4 237.6 484.8 393.6 7.2 3.2 10.4 10.4 8.8 17.6-0.8 7.2-8 12.8-15.2 12.8z m-915.2-32h845.6C683.2 272.8 552.8 107.2 512 48.8c-40.8 58.4-171.2 224-423.2 355.2zM1004 1012h-77.6c-4.8 0-8-3.2-8-8 0-103.2 28-187.2 66.4-208.8-73.6-24-128-180-128-375.2 0-4.8 3.2-8 8-8h140c4.8 0 8 3.2 8 8v584c-0.8 4.8-4 8-8.8 8z m-69.6-16h61.6v-188.8c-30.4 11.2-60 84-61.6 188.8z m-61.6-568c1.6 185.6 56.8 342.4 123.2 353.6V428h-123.2zM97.6 1012H20c-4.8 0-8-3.2-8-8v-584c0-4.8 3.2-8 8-8H160c4.8 0 8 3.2 8 8 0 195.2-55.2 352-128 375.2 38.4 21.6 66.4 105.6 66.4 208.8-0.8 4.8-4 8-8.8 8z m-69.6-16h61.6c-1.6-104.8-31.2-177.6-61.6-188.8v188.8z m0-568v353.6c67.2-12 122.4-168 123.2-353.6H28zM512 1012h-77.6c-4.8 0-8-3.2-8-8 0-103.2 28-187.2 66.4-208.8-73.6-24-128-180-128-375.2 0-4.8 3.2-8 8-8H512c4.8 0 8 3.2 8 8v584c0 4.8-3.2 8-8 8z m-69.6-16H504v-188.8c-30.4 11.2-60 84-61.6 188.8z m-61.6-568c1.6 185.6 56.8 342.4 123.2 353.6V428H380.8zM589.6 1012H512c-4.8 0-8-3.2-8-8v-584c0-4.8 3.2-8 8-8h140c4.8 0 8 3.2 8 8 0 195.2-55.2 352-128 375.2 38.4 21.6 66.4 105.6 66.4 208.8-0.8 4.8-4 8-8.8 8z m-69.6-16h61.6c-1.6-104.8-31.2-177.6-61.6-188.8v188.8z m0-568v353.6c67.2-12 122.4-168 123.2-353.6H520z",
    "M512 1020C232 1020 4 792 4 512S232 4 512 4 1020 232 1020 512 792 1020 512 1020z m0-984C249.6 36 36 249.6 36 512s213.6 476 476 476 476-213.6 476-476S774.4 36 512 36zM284.8 636.8c-15.2 0-28-3.2-36.8-9.6-16.8-13.6-6.4-35.2 4.8-57.6 8.8-17.6 18.4-37.6 18.4-57.6 0-19.2-9.6-39.2-18.4-57.6-11.2-23.2-21.6-44.8-5.6-57.6 41.6-33.6 179.2 28 220.8 47.2 2.4 0.8 4 4 4.8 6.4s-0.8 5.6-2.4 7.2c-16.8 12.8-27.2 32.8-27.2 54.4s9.6 41.6 27.2 54.4c2.4 1.6 3.2 4.8 3.2 7.2s-2.4 4.8-4.8 6.4c-32.8 15.2-125.6 56.8-184 56.8z m0-234.4c-12 0-20.8 2.4-26.4 6.4-6.4 4.8 1.6 20.8 9.6 38.4 9.6 20 20 41.6 19.2 64.8 0 24-11.2 46.4-20 64.8-9.6 20-15.2 32.8-8.8 37.6 24.8 20 112.8-7.2 192.8-44-15.2-16-24-36.8-24-58.4 0-22.4 8.8-43.2 24-58.4-61.6-28.8-128-51.2-166.4-51.2zM739.2 636.8c-58.4 0-151.2-41.6-184-56.8-2.4-0.8-4-4-4.8-6.4 0-2.4 0.8-5.6 3.2-7.2 16.8-12.8 27.2-32.8 27.2-54.4s-9.6-41.6-27.2-54.4c-2.4-1.6-3.2-4.8-3.2-7.2 0-2.4 2.4-4.8 4.8-6.4 40.8-19.2 178.4-80.8 220.8-47.2 16 12.8 5.6 34.4-5.6 57.6-8.8 18.4-18.4 38.4-18.4 57.6 0 20 10.4 40 18.4 57.6 11.2 22.4 21.6 44 4.8 57.6-8 7.2-20.8 9.6-36 9.6z m-165.6-66.4c80 36.8 168 64 192.8 44 6.4-4.8 0.8-17.6-8.8-37.6-8.8-18.4-20-40.8-20-64.8 0-22.4 10.4-44.8 19.2-64.8 8-16.8 16-33.6 9.6-38.4-24.8-20-112.8 7.2-192.8 44 15.2 16 24 36.8 24 58.4-0.8 23.2-9.6 44-24 59.2zM512 596.8c-46.4 0-84.8-38.4-84.8-84.8S465.6 427.2 512 427.2 596.8 464.8 596.8 512 558.4 596.8 512 596.8z m0-153.6c-37.6 0-68.8 31.2-68.8 68.8s31.2 68.8 68.8 68.8 68.8-31.2 68.8-68.8-31.2-68.8-68.8-68.8zM997.6 596.8H771.2c-3.2 0-6.4-1.6-7.2-4.8-2.4-4.8-4.8-9.6-7.2-15.2-8.8-18.4-20-40.8-20-64.8 0-22.4 10.4-44.8 19.2-64.8 2.4-5.6 4.8-10.4 7.2-15.2 1.6-3.2 4-4.8 7.2-4.8h227.2c4 0 7.2 3.2 8 6.4 4 25.6 6.4 52 6.4 78.4 0 26.4-2.4 52-6.4 78.4 0 4-4 6.4-8 6.4z m-220.8-16h214.4c3.2-23.2 4.8-45.6 4.8-68.8 0-23.2-1.6-46.4-4.8-68.8H776c-1.6 4-3.2 7.2-5.6 11.2-8.8 18.4-18.4 38.4-17.6 57.6 0 20 9.6 40 18.4 57.6 2.4 4 4 8 5.6 11.2zM252.8 596.8H26.4c-4 0-7.2-3.2-8-6.4-4-25.6-6.4-52-6.4-78.4 0-25.6 2.4-52 6.4-78.4 0.8-4 4-6.4 8-6.4h227.2c3.2 0 6.4 1.6 7.2 4.8 2.4 4.8 4.8 10.4 7.2 15.2 9.6 20 20 41.6 19.2 64.8 0 24-11.2 46.4-20 64.8-2.4 5.6-4.8 10.4-7.2 15.2-1.6 3.2-4 4.8-7.2 4.8z m-220-16h214.4c1.6-3.2 3.2-7.2 5.6-11.2 8.8-17.6 18.4-37.6 18.4-57.6 0-19.2-9.6-39.2-18.4-57.6-1.6-4-4-8-5.6-11.2H32.8c-3.2 23.2-4.8 45.6-4.8 68.8 0 23.2 1.6 46.4 4.8 68.8zM512 1012c-25.6 0-52-2.4-78.4-6.4-4-0.8-6.4-4-6.4-8V586.4c0-3.2 1.6-6.4 4.8-7.2 13.6-6.4 24.8-11.2 29.6-13.6 2.4-1.6 5.6-0.8 8 0.8 12 9.6 26.4 14.4 42.4 14.4s29.6-4.8 42.4-14.4c2.4-1.6 5.6-2.4 8-0.8 4.8 2.4 16 7.2 29.6 13.6 3.2 1.6 4.8 4 4.8 7.2v412c0 4-3.2 7.2-6.4 8-26.4 3.2-52.8 5.6-78.4 5.6z m-68.8-20.8c45.6 6.4 92 6.4 137.6 0v-400c-8.8-4-16-7.2-20.8-9.6-14.4 9.6-30.4 15.2-48 15.2s-33.6-4.8-48-15.2c-4.8 2.4-12 5.6-20.8 9.6v400zM464.8 459.2c-0.8 0-2.4 0-3.2-0.8-4.8-2.4-16-7.2-29.6-13.6-3.2-1.6-4.8-4-4.8-7.2V26.4c0-4 3.2-7.2 6.4-8 52-8 104.8-8 156 0 4 0.8 6.4 4 6.4 8v412c0 3.2-1.6 6.4-4.8 7.2-14.4 6.4-24.8 11.2-29.6 13.6-2.4 1.6-5.6 0.8-8-0.8-12-9.6-26.4-14.4-42.4-14.4s-29.6 4.8-42.4 14.4c0 0-1.6 0.8-4 0.8z m47.2-32c17.6 0 33.6 4.8 48 15.2 4.8-2.4 12-5.6 20.8-9.6v-400c-45.6-6.4-92-6.4-137.6 0V432c8.8 4 16 7.2 20.8 9.6 14.4-9.6 30.4-14.4 48-14.4z",
    "M672 360c-4.8 0-9.6-2.4-12.8-5.6L534.4 200.8c-2.4-3.2-4-7.2-3.2-12s2.4-8 5.6-10.4l52-41.6c7.2-5.6 16.8-4.8 22.4 2.4l36 44L728 116.8l-36-44c-2.4-3.2-4-7.2-3.2-12s2.4-8 5.6-10.4L746.4 8c7.2-5.6 16.8-4.8 22.4 2.4l124.8 153.6c2.4 3.2 4 7.2 3.2 12s-2.4 8-5.6 10.4L682.4 356c-3.2 2.4-7.2 4-10.4 4zM569.6 192.8l104.8 128.8 184.8-150.4L754.4 42.4l-27.2 22.4 36 44c2.4 3.2 4 7.2 3.2 12s-2.4 8-5.6 10.4L655.2 217.6c-7.2 5.6-16.8 4.8-22.4-2.4l-36-44-27.2 21.6zM434.4 718.4h-3.2c-4.8-0.8-8.8-4-11.2-8.8-8.8-18.4-20-35.2-32.8-51.2-12.8-16-27.2-30.4-44-42.4-4-3.2-6.4-7.2-6.4-12.8s2.4-9.6 5.6-12.8l546.4-443.2c34.4-28 84.8-22.4 112.8 12 13.6 16.8 20 37.6 17.6 59.2-2.4 21.6-12.8 40.8-29.6 54.4L444 714.4c-2.4 2.4-6.4 4-9.6 4z m-56-116c12 10.4 23.2 22.4 33.6 35.2 10.4 12.8 19.2 25.6 27.2 40l531.2-431.2c10.4-8 16-20 17.6-32.8 1.6-12.8-2.4-25.6-10.4-35.2-16.8-20.8-47.2-24-68-7.2L378.4 602.4zM275.2 1020c-73.6 0-152-36-207.2-104-47.2-58.4-70.4-131.2-63.2-200 5.6-56 31.2-105.6 72.8-138.4 94.4-76.8 244-49.6 333.6 60 47.2 58.4 70.4 131.2 63.2 200-5.6 56-31.2 105.6-72.8 138.4-35.2 29.6-80 44-126.4 44z m-70.4-454.4c-39.2 0-76.8 12-107.2 36.8-33.6 28-56 69.6-60.8 116.8-6.4 60 14.4 124.8 56.8 176.8 78.4 96 208 121.6 288.8 55.2 34.4-28 56-69.6 60.8-117.6 6.4-60-14.4-124.8-56.8-176.8-48-59.2-116.8-91.2-181.6-91.2zM239.2 911.2c-28.8 0-64.8-20.8-94.4-57.6-26.4-32.8-40.8-69.6-38.4-98.4 1.6-13.6 6.4-24 15.2-31.2 28-22.4 81.6-1.6 122.4 48.8 26.4 32.8 40.8 70.4 38.4 98.4-1.6 13.6-6.4 24-15.2 31.2-8 6.4-17.6 8.8-28 8.8zM149.6 731.2c-7.2 0-12.8 1.6-17.6 5.6-5.6 4.8-8.8 11.2-9.6 20.8-2.4 24 11.2 57.6 34.4 86.4 33.6 41.6 79.2 62.4 100 46.4 5.6-4 8.8-11.2 9.6-20.8 2.4-24-11.2-57.6-34.4-86.4-26.4-32-59.2-52-82.4-52z",
    "M980 1020H44c-8.8 0-16-7.2-16-16V20c0-8.8 7.2-16 16-16h936.8c8.8 0 16 7.2 16 16v984c-0.8 8.8-8 16-16.8 16z m-920-32h904.8V36H60v952zM867.2 801.6H156.8c-4.8 0-8-3.2-8-8V131.2c0-4.8 3.2-8 8-8h710.4c4.8 0 8 3.2 8 8v662.4c0 4.8-4 8-8 8z m-702.4-16h694.4V139.2H164.8v646.4zM725.6 745.6H644c-4.8 0-8-3.2-8-8V454.4c0-4.8 3.2-8 8-8h15.2c40.8 0 74.4 33.6 74.4 74.4v216.8c0 4-3.2 8-8 8z m-73.6-16h65.6V520.8c0-32-26.4-58.4-58.4-58.4h-7.2v267.2zM380 745.6H298.4c-4.8 0-8-3.2-8-8V520.8c0-40.8 33.6-74.4 74.4-74.4h15.2c4.8 0 8 3.2 8 8v283.2c0 4-4 8-8 8z m-73.6-16h65.6V462.4h-7.2c-32 0-58.4 26.4-58.4 58.4v208.8zM512 409.6c-50.4 0-91.2-40.8-91.2-91.2S461.6 226.4 512 226.4s91.2 40.8 91.2 91.2S562.4 409.6 512 409.6z m0-167.2c-41.6 0-75.2 33.6-75.2 75.2s33.6 75.2 75.2 75.2 75.2-33.6 75.2-75.2-33.6-75.2-75.2-75.2zM644 801.6h-264c-4.8 0-8-3.2-8-8V454.4c0-4.8 3.2-8 8-8h80.8c2.4 0 4 0.8 5.6 2.4l45.6 45.6 45.6-45.6c1.6-1.6 3.2-2.4 5.6-2.4h80.8c4.8 0 8 3.2 8 8v339.2c0 4.8-3.2 8-8 8z m-256-16h248V462.4h-69.6l-48.8 48.8c-3.2 3.2-8 3.2-11.2 0l-48.8-48.8h-69.6v323.2zM512 732c-2.4 0-4-0.8-5.6-2.4l-44.8-44.8c-1.6-1.6-2.4-4-2.4-6.4L480 482.4c0-3.2 2.4-5.6 5.6-6.4 3.2-0.8 6.4 0 8 1.6l18.4 17.6 18.4-17.6c2.4-2.4 5.6-2.4 8-1.6 3.2 0.8 4.8 4 5.6 6.4l20.8 196c0 2.4-0.8 4.8-2.4 6.4l-44.8 44.8c-1.6 1.6-3.2 2.4-5.6 2.4z m-36-56L512 712l36-36-19.2-176-12 11.2c-3.2 3.2-8 3.2-11.2 0l-12-11.2-17.6 176z",
    "M732.8 1020H291.2c-40.8 0-74.4-33.6-74.4-74.4V526.4c0-25.6 17.6-47.2 41.6-52.8l274.4-62.4c30.4-7.2 56-25.6 72-52 16-27.2 20-58.4 12-88.8-15.2-56-72-91.2-128.8-81.6-31.2 5.6-57.6 23.2-74.4 48.8-17.6 26.4-23.2 57.6-16 88 1.6 8.8-3.2 16.8-12 19.2l-148.8 33.6c-4.8 0.8-9.6 0-13.6-3.2s-6.4-8-6.4-12.8v-64.8C217.6 136 349.6 4 512 4s294.4 132 294.4 294.4v647.2c0 40.8-32.8 74.4-73.6 74.4zM508 155.2c64 0 123.2 43.2 140.8 106.4 10.4 38.4 5.6 79.2-15.2 113.6-20.8 34.4-53.6 58.4-92.8 67.2l-274.4 62.4c-10.4 2.4-16.8 11.2-16.8 21.6v419.2c0 23.2 19.2 42.4 42.4 42.4h440.8c23.2 0 42.4-19.2 42.4-42.4V298.4C774.4 153.6 656.8 36 512 36S249.6 153.6 249.6 298.4v44.8l114.4-26.4c-4-33.6 4-68 23.2-96.8 22.4-33.6 56-56 96-63.2 8-0.8 16.8-1.6 24.8-1.6zM512 911.2c-1.6 0-4-0.8-5.6-2.4-7.2-7.2-179.2-169.6-179.2-238.4 0-57.6 47.2-104.8 104.8-104.8 30.4 0 59.2 13.6 79.2 36 20-23.2 48.8-36 79.2-36 57.6 0 104.8 47.2 104.8 104.8 0 68-172 231.2-179.2 238.4 0 1.6-2.4 2.4-4 2.4z m-79.2-329.6c-48.8 0-88.8 40-88.8 88.8 0 49.6 116.8 172 168.8 221.6 52-49.6 168.8-172 168.8-221.6 0-48.8-40-88.8-88.8-88.8-28.8 0-56 14.4-72.8 37.6-1.6 2.4-4 3.2-6.4 3.2-2.4 0-4.8-1.6-6.4-3.2-18.4-23.2-45.6-37.6-74.4-37.6z",
    "M830.438563 406.554436l-45.588291 0 0-14.005992c0-33.098839-26.928303-60.027142-60.027142-60.027142L124.554784 332.521303c-33.098839 0-60.027142 26.928303-60.027142 60.027142l0 188.083679c0 91.385337 35.920094 185.921433 98.55155 259.367189 66.428945 77.902254 152.231123 120.803343 241.599524 120.803343l40.017412 0c89.369424 0 175.170578-42.902112 241.600547-120.803343 42.819225-50.212612 73.14388-110.284779 88.050382-172.468027l56.090483 0c71.951729 0 130.48996-58.537208 130.48996-130.487913C960.928522 465.091644 902.391315 406.554436 830.438563 406.554436zM655.847176 814.033941c-58.70196 68.838831-133.690862 106.750279-211.150024 106.750279l-40.017412 0c-77.460186 0-152.448064-37.911448-211.150024-106.750279-56.55097-66.316381-88.983637-151.387919-88.983637-233.401818l0-188.083679c0-11.033287 8.975419-20.008706 20.008706-20.008706l126.699634 0 0 97.419773-73.886801 0c-11.050684 0-20.008706 8.958022-20.008706 20.008706l0 190.085266c0 11.050684 8.958022 20.008706 20.008706 20.008706L367.452883 700.06219c11.050684 0 20.008706-8.958022 20.008706-20.008706L387.461589 489.968218c0-11.050684-8.958022-20.008706-20.008706-20.008706l-76.289524 0 0-97.419773 433.659771 0c11.032264 0 20.008706 8.975419 20.008706 20.008706l0 34.014698 0 154.068981C744.831836 662.647045 712.400193 747.717559 655.847176 814.033941zM347.444177 509.976924l0 150.066831L197.377346 660.043754 197.377346 509.976924 347.444177 509.976924zM830.438563 627.513874l-45.588291 0 0-46.88175L784.850272 446.572872l45.588291 0c49.885154 0 90.471524 40.585347 90.471524 90.471524C920.91111 586.92955 880.32474 627.513874 830.438563 627.513874zM245.986437 162.269757c0.76748 0.665149 18.817578 16.601096 18.817578 44.189432 0 14.413268-3.50687 21.300119-8.362458 30.832216-5.506411 10.810207-12.360516 24.26566-12.360516 46.989197 0 11.050684 8.958022 20.008706 20.008706 20.008706 11.050684 0 20.008706-8.958022 20.008706-20.008706 0-13.117762 3.356444-19.706831 8.000208-28.826536 5.668093-11.128455 12.721743-24.975834 12.721743-48.994877 0-46.855144-31.787984-73.745584-33.141818-74.867128 0 0-15.661701-15.129582-27.598568-4.605901-17.507746 15.435551 2.059915 35.414581 2.059915 35.414581L245.986437 162.269757zM434.128445 234.942917c0 38.401612-29.996175 54.088896-31.101345 54.653761 0 0-19.268856 13.372565-10.128685 29.04757 9.140171 15.676028 27.550473 6.977925 27.550473 6.977925 2.191922-1.060145 53.699016-26.703175 53.699016-90.680279 0-31.127951-16.331967-49.709145-29.452799-64.639183-10.538007-11.990079-16.499789-19.266809-16.499789-29.399587 0-31.937386 14.552437-37.551244 15.172561-37.773302-0.524956 0.188288-0.828878 0.23536-0.828878 0.23536s22.959921-9.784854 18.339694-28.264741c-4.620227-18.479887-28.138874-10.534937-28.138874-10.534937-16.550954 4.180206-44.562938 24.962531-44.562938 76.337619 0 25.712615 14.670118 42.405809 26.458605 55.818283C426.721755 210.473619 434.128445 219.675188 434.128445 234.942917zM551.793308 162.40074c0.187265 0.155543 18.665105 16.249079 18.665105 44.058448 0 14.413268-3.507894 21.300119-8.363482 30.832216-5.506411 10.810207-12.359492 24.26566-12.359492 46.989197 0 11.050684 8.959046 20.008706 20.008706 20.008706 11.04966 0 20.008706-8.958022 20.008706-20.008706 0-13.117762 3.355421-19.706831 8.001231-28.826536 5.66707-11.128455 12.720719-24.975834 12.720719-48.994877 0-46.855144-31.79003-73.745584-33.143864-74.867128-8.507768-7.055696-21.123087-5.870708-28.17469 2.635013C542.104645 142.734842 543.28554 155.349137 551.793308 162.40074z",
    "M903.631412 792.763706H118.092711c-15.461511 0-28.033021-12.535384-28.03302-28.105271a28.033021 28.033021 0 0 1 28.03302-28.03302h785.538701c15.497636 0 28.033021 12.535384 28.03302 28.03302 0 15.569886-12.571509 28.105271-28.03302 28.105271z m-56.138291-325.052988a27.93187 27.93187 0 0 1-39.665279 0c-10.945883-10.945883-10.945883-28.647146 0-39.665279l39.665279-39.66528a28.061921 28.061921 0 0 1 39.665279 0c10.945883 11.018133 10.945883 28.719396 0 39.66528l-39.665279 39.665279z m-62.171171 212.81253c-26.082269-127.918719-138.683977-224.372539-274.441826-224.372539s-248.395682 96.453821-274.369576 224.372539H177.44613c21.530516-158.155366 162.454244-280.51083 333.433994-280.51083s311.903478 122.31934 333.433994 280.51083h-58.992168z m-274.441826-336.649121c-15.497636 0-28.033021-12.535384-28.03302-28.033021V259.702815a28.033021 28.033021 0 0 1 56.066041 0v56.138291c-0.036125 15.497636-12.571509 28.033021-28.033021 28.033021z m-336.649121 123.836591l-39.665279-39.665279c-10.945883-10.945883-10.945883-28.647146 0-39.66528a28.061921 28.061921 0 0 1 39.665279 0l39.665279 39.66528c10.945883 11.018133 10.945883 28.719396 0 39.665279a27.93187 27.93187 0 0 1-39.665279 0z",
    "M522.666667 832a32 32 0 0 1 0 64h-213.333334a32 32 0 0 1 0-64h213.333334z m192 0a32 32 0 0 1 0 64h-64a32 32 0 0 1 0-64h64z m-362.666667-128a32 32 0 0 1 0 64h-149.333333a32 32 0 0 1 0-64h149.333333z m469.333333 0a32 32 0 0 1 0 64h-341.333333a32 32 0 0 1 0-64h341.333333zM504.576 117.333333c170.858667 0 309.333333 138.496 309.333333 309.333334 0 53.12-13.44 104.213333-38.378666 149.354666L906.666667 576a32 32 0 0 1 0 64h-256a32 32 0 0 1 0-64h48.533333l3.818667-5.013333A244.053333 244.053333 0 0 0 749.909333 426.666667c0-125.077333-93.589333-228.266667-214.250666-243.413334l-1.898667-0.234666 1.152 9.173333c0.746667 6.997333 1.237333 14.058667 1.493333 21.141333l0.170667 10.666667c0 149.333333-109.610667 273.088-252.949333 295.168l-5.973334 0.832 2.026667 4.842667a244.906667 244.906667 0 0 0 26.026667 45.482666l4.245333 5.674667H522.666667a32 32 0 0 1 0 64h-405.333334a32 32 0 0 1 0-64h116.309334a307.541333 307.541333 0 0 1-30.122667-77.994667 32 32 0 0 1 28.586667-39.253333l2.794666-0.106667 3.008 0.021334c129.621333 0 234.666667-105.066667 234.666667-234.666667 0-22.442667-3.136-44.458667-9.258667-65.557333a32 32 0 0 1 26.965334-40.704l2.816-0.213334 4.565333-0.106666 6.912-0.085334z",
]

export const SS_LINE = <div style={{ width: '100%', borderBottom: '1px solid var(--lightdark)' }} />
export const BOTTOM_BAR_HEIGHT = 35
export const NAV_BAR_HEIGHT = 35
// SIGNIN PAGE 
export const PUNCHLINE = `
Wedding & Event Planning Made Simple
Celebrations Made Memorable`
// export const PUNCHLINE = 'Creating Moments, Celebrating Love'

// MainMenu
export const MAIN_MENU_DEFAULT_CATEGORY = 'Home' // Home

// Homepage 
export const MENU_WEDDING_COLOR = '#f77f7f'
export const MENU_EVENT_COLOR = '#f77f7f'//'rgb(255, 189, 69)' //'rgb(254, 197, 94)'//'rgb(127, 163, 247)'//'rgb(165, 193, 247)'
export const MENU_GUEST_COLOR = '#f77f7f'//'rgb(255, 189, 69)' //'rgb(254, 197, 94)'//'rgb(127, 163, 247)'//'rgb(165, 193, 247)'
export const MENU_COLOR_MAP = {
    'Home': {
        color: MENU_WEDDING_COLOR,
    },
    'Wedding': {
        color: MENU_WEDDING_COLOR,//#f77f7f,
        background: 'linear-gradient(0deg, #ffffff, rgb(255, 255, 255))'
    },
    'Event': {
        color: MENU_WEDDING_COLOR,//'rgb(165, 193, 247)'
        background: 'linear-gradient(0deg, #ffffff, rgb(255, 255, 255))'
    },
    'Pricelist': {
        color: '#f77f7f'//'#191919',
    },
    'Promo': {
        color: '#f77f7f'//'#191919',
    },
    'Project': {
        color: '#f77f7f'//'#191919',
    },
    'Guest': {
        color: MENU_WEDDING_COLOR,//#f77f7f,
        background: 'linear-gradient(0deg, #ffffff, rgb(255, 255, 255))'
    },
    'Discover': {
        color: MENU_WEDDING_COLOR
    },
    'Tools': {
        color: MENU_WEDDING_COLOR
    },
    'Market': {
        color: MENU_WEDDING_COLOR
    }
}

// vendortype services and styles , will be depcrated soon
export const PHOTOGRAPHER_SERVICES = [
    'Back-Up Equipment',
    'Bridal Prep Shots',
    'Images on USB',
    'Images on DVD',
    'Large Group Shots',
    'Last-Minute Orders',
    'Online Proofing',
    'Online Shop',
    'Physical Shop / Studio',
    'Personal Online Gallery',
    'Photo Printing',
    'Pre-Wedding Consultation',
    'Pre-Wedding Venue Visit',
    'Second Shooter Available',
    'Stay Through Dancing',
    'Stay Through Speeches',
    'Wedding Albums',
    'Digital Editing / Airbrushing',
    'Flexible Hours on the Day',
]
export const PHOTOGRAPHER_STYLES = [
    'Artistic',
    'Modern',
    'Documentary',
    'Traditional',
    'Dramatic'
]
export const VIDEOGRAPHER_SERVICES = [
    'Audio Retouching',
    'Back-Up Equipment',
    'Bridal Prep Shots',
    'Complete Footage on DVD or USB',
    'Digital Editing',
    'Drone Footage',
    'Engagement Shoots',
    'Flexible Hours on the Day',
    'Last-Minute Orders',
    'Musical Overlay',
    'Pre-Wedding Consultation',
    'Second Shooter Available',
    'Short Edit (>15 min)',
    'Long Edit (>1 Hour)',
    'Stay Through Dancing',
    'Stay Through Speeches',
    'Steadycam',
    'Wedding Highlights Film',
    'Marryoke',
    'Same-Day Highlight Film',
    'Dollies and Gliders',
    'Physical Shop / Studio',
]
export const VIDEOGRAPHER_STYLES = [
    'Artistic',
    'Dramatic',
    'Reportage',
    'Documentary',
    'Modern',
    'Vintage',
    'Lifestyle',
    'Marryoke'
]

export const SUCCESS_UPDATE = 'Successfully Updated'
export const FAILURE_UPDATE = 'Update Failed'
export const NOSUCHUSER_UPDATE = 'No Such User Exist'
export const INCORRECTFILETYPE_UPDATE = 'Incorrect File Type'

// vendor and user login message
export const LOGIN_ERROR_MSG = {
    "IDORPW_INCORRECT": 'Incorrect ID or Password.',
    "EMAILORPW_INCORRECT": 'Incorrect Email or Password.',
    'FIELDS_INCOMPLETE': 'Please fill in all fields.',
    'SUCCESS_LOGIN': 'Successfully logged in.',
    'ERROR_MSG': 'ERROR',
    'HVNT_VERIFY': 'Please verify your email.'
}

// for userlogin page              
export const TAG_OBJ_MAP = {
    'Search': {
        'title': '1. Search',
        'txt': 'Search and discover leading vendors for event/wedding in the country based on your styles and budget.',
        'img': first,
        'svg': discover
    },
    'Compare': {
        'title': '2. Compare',
        'txt': 'Compare your selected vendor by using our tools.',
        'img': fav,
        'svg': compare
    },
    'Message & Quote': {
        'title': '3. Message & Quote',
        'txt': 'Message vendors directly, and accept quote from vendors with just one click.',
        'img': msg,
        'svg': planning
    },
    'RSVP Website & Guestlist': {
        'title': '4. RSVP Website & Guestlist',
        'txt': 'Create a website for your wedding/event, and collect responses from our guest list tool.',
        'img': rsvp,
        'svg': invitationrsvp
    },
    'Budget Tool': {
        'title': '5. Budget Tool',
        'txt': 'Keep track of your spending and overall budget throughout the planning process.',
        'img': budget,
        'svg': finance
    },
    'Timeline Itinerary': {
        'title': '6. Timeline Itinerary',
        'txt': 'What happens when? Construct a timeline itinerary for your wedding/event.',
        'img': timelineimg,
        'svg': timeline
    },
    'Marketplace SG': {
        'title': '7. Marketplace SG',
        'txt': 'A consumer to consumer wedding marketplace.',
        'img': timelineimg,
        'svg': market
    },
    'Wedding/Event Checklist': {
        'title': '8. Wedding/Event Checklist',
        'txt': "Use our checklist template to kick start your wedding/event planning!",
        'img': timelineimg,
        'svg': checklist
    },
    'Seating Chart': {
        'title': '9. Seating Chart',
        'txt': 'Create seating plan using our seating chart tool, export or import as excel to continue editing.',
        'img': timelineimg,
        'svg': seatchart
    },
    'Host & Join': {
        'title': '10. Host & Join',
        'txt': 'Host your wedding/event for interested party to attend or join a stranger wedding/event.',
        'img': host,
        'svg': host1
    }
}

// RESET PW MESSAGE
export const USER_RESET_PW_MSG = {
    'SUCCESS_RESETCHECK': '',
    'FAILURE_RESETCHECK': '',
    'SUCCESS_RESET': 'Your password has been changed successfully.',
    'FAILURE_RESET': 'Please verify your password and token is still valid.',
}

// Vendor profile review category message
export const REMOVAL_REVIEW_SUCCESS_MSG = 'Thank You, we have recieved your request. We will get back to you shortly.'
export const REMOVAL_IN_PROCESS = 'Request is currectly processing.'
export const POPUP_FORM_MOBILE = '100%'

// Vendor profile project
export const PATTERN_DIM = { width: 230, height: 232 }

//ProjectGallery
export const EXPAND_ICON = <Icon size={15} icon={chevronDown} />
export const EXPAND_RIGHT_ICON = <Icon size={15} icon={chevronRight} />

//Create project
export const COUNTRIES = ["", "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia &amp; Herzegovina", "Botswana", "Brazil", "British Virgin Islands", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central Arfrican Republic", "Chad", "Chile", "China", "Colombia", "Congo", "Cook Islands", "Costa Rica", "Cote D Ivoire", "Croatia", "Cuba", "Curacao", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands", "Faroe Islands", "Fiji", "Finland", "France", "French Polynesia", "French West Indies", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kosovo", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauro", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea", "Norway", "Oman", "Pakistan", "Palau", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russia", "Rwanda", "Saint Pierre &amp; Miquelon", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka", "St Kitts &amp; Nevis", "St Lucia", "St Vincent", "Sudan", "Suriname", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor L'Este", "Togo", "Tonga", "Trinidad &amp; Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks &amp; Caicos", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States of America", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Virgin Islands (US)", "Yemen", "Zambia", "Zimbabwe"]

// Quote
export const ARCHIVE_ICON = <Icon size={15} icon={archive} />

// Fontsize
export const aa_fs = 46
export const a_fs = 30
export const b_fs = 24
export const c_fs = 20
export const d_fs = 16
export const e_fs = 14
export const f_fs = 12
export const g_fs = 9
export const h_fs = 7
export const i_fs = 6

export const FS_LH_MAP = {
    6: '10px',
    7: '13px',
    9: '18px',
    12: '20px',
    14: '22px',
    16: '24px',
    20: '28px',
    24: '32px',
    30: '38px',
    38: '46px',
    46: '54px',
    56: '64px',
    68: '76px',
}

export const FS_LS_MAP = {
    6: 1,
    7: 1,
    9: 1,
    12: 1,
    14: 1,
    16: 1,
    20: 2,
    24: 2,
    30: 2,
    38: 2,
    46: 2,
    56: 3,
    68: 3,
}

export const FF_PAIRING = {
    'Indie Flower': ['Lato'],
    'Dancing Script': ['Lato'],
    'Amatic SC': ['Lato'],
    'Caveat': ['Lato'],
    'Cinzel': ['Lato'],
    'Patrick Hand': ['Lato'],
    'Satisfy': ['Lato'],
    'Courgette': ['Lato'],
    'Nanum Myeongjo': ['Lato'],
    'Special Elite': ['Lato'],
    'Lobster Two': ['Lato'],
    'Kalam': ['Lato'],
    'Kaushan Script': ['Lato'],
    'Great Vibes': ['Lato'],
    'Viga': ['Lato'],
    'Sacramento': ['Lato'],
    'Gloria Hallelujah': ['Lato'],
    'Parisienne': ['Lato'],
    'Montserrat Alternates': ['Lato'],
    'Cookie': ['Lato'],
    'Poiret One': ['Lato'],
    'Advent Pro': ['Lato'],
    'BenchNine': ['Lato'],
    'PT Mono': ['Lato'],
    'Josefin Slab': ['Lato'],
    'Handlee': ['Lato'],
    'Merienda': ['Lato'],
    'Neucha': ['Lato'],
    'Marck Script': ['Lato'],
    'Architects Daughter': ['Lato'],
    'Unica One': ['Lato'],
    'Aclonica': ['Lato'],
    'Nanum Gothic Coding': ['Lato'],
    'Tangerine': ['Lato'],
    'Playball': ['Lato'],
    'Bad Script': ['Lato'],
    'Montserrat': ['Lato'],
    'Raleway': ['Lato'],
    'Kaisei HarunoUmi': ['Lato'],
    'WindSong': ['Lato'],
    'MonteCarlo': ['Lato'],
    'Bodoni Moda': ['Lato'],
    'ABeeZee': ['Lato'],
    'Abel': ['Lato'],
    'Allison': ['Lato'],
    'Andika': ['Lato'],
    'Andika New Basic': ['Lato'],
    'Arimo': ['Lato'],
    'Atkinson Hyperlegible': ['Lato'],
    'Big Shoulders Inline Display': ['Lato'],
    'Brawler': ['Lato'],
    'Bree Serif': ['Lato'],
    'Brygada 1918': ['Lato'],
    'Bubblegum Sans': ['Lato'],
    'Castoro': ['Lato'],
    'Commissioner': ['Lato'],
    'Fuggles': ['Lato'],
    'Glory': ['Lato'],
    'Gowun Batang': ['Lato'],
    'Gowun Dodum': ['Lato'],
    'Hahmlet': ['Lato'],
    'Imbue': ['Lato'],
    'Imprima': ['Lato'],
    'Inter': ['Lato'],
    'JetBrains Mono': ['Lato'],
    'Kaisei Decol': ['Lato'],
    'Kaisei Opti': ['Lato'],
    'Kaisei Tokumin': ['Lato'],
    'Kiwi Maru': ['Lato'],
    'Kosugi Maru': ['Lato'],
    'Kumbh Sans': ['Lato'],
    'Lato': ['Lato'],
    'Lexend': ['Lato'],
    'MuseoModerno': ['Lato'],
    'New Tegomin': ['Lato'],
    'Open Sans': ['Lato'],
    'Otomanopee One': ['Lato'],
    'Petrona': ['Lato'],
    'Philosopher': ['Lato'],
    'Piazzolla': ['Lato'],
    'Poppins': ['Lato'],
    'Roboto': ['Lato'],
    'Roboto Mono': ['Lato'],
    'Roboto Slab': ['Lato'],
    'Share Tech Mono': ['Lato'],
    'Shippori Mincho': ['Lato'],
    'Source Sans Pro': ['Lato'],
    'Texturina': ['Lato'],
    'Thasadith': ['Lato'],
    'Tomorrow': ['Lato'],
    'Trispace': ['Lato'],
    'Varela': ['Lato'],
    'Varta': ['Lato'],
    'Yomogi': ['Lato'],
    'Yrsa': ['Lato'],
    'Yusei Magic': ['Lato'],
    'Playfair Display': ['Lato']
}

// export const ENGLISH_FF = [
//     'Indie Flower',
//     'Dancing Script',
//     'Amatic SC',
//     'Caveat',
//     'Cinzel',
//     'Patrick Hand',
//     'Satisfy',
//     'Courgette',
//     'Nanum Myeongjo',
//     'Special Elite',
//     'Lobster Two',
//     'Kalam',
//     'Kaushan Script',
//     'Great Vibes',
//     'Viga',
//     'Sacramento',
//     'Gloria Hallelujah',
//     'Parisienne',
//     'Montserrat Alternates',
//     'Cookie',
//     'Poiret One',
//     'Advent Pro',
//     'BenchNine',
//     'PT Mono',
//     'Josefin Slab',
//     'Handlee',
//     'Merienda',
//     'Neucha',
//     'Marck Script',
//     'Architects Daughter',
//     'Unica One',
//     'Aclonica',
//     'Nanum Gothic Coding',
//     'Tangerine',
//     'Playball',
//     'Bad Script',
//     'Raleway',
//     'Kaisei HarunoUmi',
//     'WindSong',
//     'Bodoni Moda',
//     'ABeeZee',
//     'Abel',
//     'Allison',
//     'Andika',
//     'Andika New Basic',
//     'Arimo',
//     'Atkinson Hyperlegible',
//     'Big Shoulders Inline Display',
//     'Brawler',
//     'Bree Serif',
//     'Brygada 1918',
//     'Bubblegum Sans',
//     'Castoro',
//     'Commissioner',
//     'Fuggles',
//     'Glory',
//     'Gowun Batang',
//     'Gowun Dodum',
//     'Hahmlet',
//     'Imbue',
//     'Imprima',
//     'Inter',
//     'JetBrains Mono',
//     'Kaisei Decol',
//     'Kaisei Opti',
//     'Kaisei Tokumin',
//     'Kiwi Maru',
//     'Klee One',
//     'Kosugi Maru',
//     'Kumbh Sans',
//     'Lato',
//     'Lexend',
//     'MonteCarlo',
//     'Montserrat',
//     'MuseoModerno',
//     'New Tegomin',
//     'Open Sans',
//     'Otomanopee One',
//     'Petrona',
//     'Philosopher',
//     'Piazzolla',
//     'Poppins',
//     'Roboto',
//     'Roboto Mono',
//     'Roboto Slab',
//     'Share Tech Mono',
//     'Shippori Mincho',
//     'Source Sans Pro',
//     'Texturina',
//     'Thasadith',
//     'Tomorrow',
//     'Trispace',
//     'Varela',
//     'Varta',
//     'Yomogi',
//     'Yrsa',
//     'Yusei Magic',
//     'Playfair Display',
// ]

export const ENGLISH_FF = [
    'Acme',
    'Alex Brush',
    'Allura',
    'Almendra Display',
    'Amarante',
    'Anonymous Pro',
    'Antic Slab',
    'Arizonia',
    'Asap',
    'Bad Script',
    'Baloo 2',
    'Bellota Text',
    'Berkshire Swash',
    'Bodoni Moda',
    'Charmonman',
    'Cinzel',
    'Clicker Script',
    'Comic Neue',
    'Cormorant',
    'Cormorant SC',
    'Cormorant Upright',
    'Crete Round',
    'Dancing Script',
    'Encode Sans Semi Condensed',
    'Euphoria Script',
    'Flamenco',
    'Forum',
    'Gabriela',
    'Give You Glory',
    'Great Vibes',
    'Hammersmith One',
    'Homemade Apple',
    'Italianno',
    'Josefin Sans',
    'Josefin Slab',
    'Jura',
    'Kaushan Script',
    'KoHo',
    'La Belle Aurore',
    'Lato',
    'Lavishly Yours',
    'League Gothic',
    'Libre Baskerville',
    'Libre Bodoni',
    'Lobster',
    'Marck Script',
    'Montez',
    'Montserrat',
    'Mulish',
    'Open Sans',
    'Oregano',
    'Pacifico',
    'Parisienne',
    'Philosopher',
    'Pinyon Script',
    'Playball',
    'Playfair Display',
    'Playfair Display SC',
    'Poiret One',
    'Quicksand',
    'Rancho',
    'Roboto',
    'Roboto Condensed',
    'Roboto Flex',
    'Rochester',
    'Rouge Script',
    'Satisfy',
    'Sofia',
    'Square Peg',
    'Srisakdi',
    'Stylish',
    'Tangerine',
    'Unica One',
    'Updock',
    'Vast Shadow',
    'Vidaloka',
    'Water Brush',
    'Whisper',
    'Yeseva One',
    'Yesteryear',

]

export const MANDRAIN_FF = [
    'Liu Jian Mao Cao',
    'Ma Shan Zheng',
    'ZCOOL QingKe HuangYou',
    'ZCOOL KuaiLe',
    'Zhi Mang Xing',
    'Long Cang',
]

export const PC_WT_MAP = { // PC = PROJECTCARD
    'WEB': 220,
    'TABLET': 220,
    'MOBILE': 170,
}

export const TTCOLOR_CARD_MAP = {
    0: ['#FFFFFF', '#FFFFF8', '#fcf8e8', '#FFF7EE'],
    1: ['#FFFFFF', '#FFFFF8', '#fcf8e8', '#FFF7EE', '#ffecc7', '#faf4f4', '#f8f8f8', '#ECD7D0'],
    2: ['#FFFFFF', '#FFFFF8', '#fcf8e8', '#FFF7EE', '#ffecc7', '#faf4f4', '#f8f8f8', '#ECD7D0'],
    3: ['#FFFFFF', '#FFFFF8', '#fcf8e8', '#FFF7EE', '#ffecc7', '#faf4f4', '#f8f8f8', '#ECD7D0'],
}

export const TEMPLATETYPECOLORS_OPENINGBGCOLOR_MAP = {
    'white': '#fff6f4',
    '#FFFFF8': '#fff6f4',
    '#fcf8e8': '#fff6f4',
    '#FFF7EE': '#fff6f4',
    '#ffecc7': '#fff6f4',
    '#faf4f4': '#fff6f4',
    '#f8f8f8': '#fff6f4',
    '#ECD7D0': '#fff6f4',
}

export const GB_LOADING_TIME = 2000 // 2s

// export const BOXSHADOW_CARD = 'rgba(0, 0, 0, 0.2) 0px 1px 3px 0px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 6px 6px 6px'
export const BOXSHADOW_CARD = 'rgb(4 17 29 / 25%) 0px 0px 8px 0px'


// 'Budgetestimator': {
//     name: 'Budget Estimator',
//     url: '/budgetestimator',
//     icon: CALCULATOR_LARGE,
//     iconlarge: CALCULATOR_LARGE,
// },
// 'Hashtaggenerator': {
//     name: 'Hashtag Generator',
//     url: '/hashtag',
//     icon: HASHTAG_LARGE,
//     iconlarge: HASHTAG_LARGE,
// }


export const PLOBJ = guestbookbool
    ? { // planning object

        'community': {
            name: 'Community',
            fullname: 'Community',
            url: '/',
            toolurl: '/tools/community',
            purpose:['Wedding', 'Event'],
            txt: `Join our vibrant wedding community to ask questions, share experiences, give feedback, and suggest features for your wedding or our app. Connect with us on the social media platforms below.`,
            
            icon: iconwrapper(PLANNING_COMMUNICATION_ICON, { width: 40, height: 40 }),
            iconlarge: iconwrapper(PLANNING_COMMUNICATION_ICON, { width: 30, height: 30 }),
            iconwithoutcss: iconwrapper(PLANNING_COMMUNICATION_ICON, { width: 'inherit', height: 'inherit' }),
        },
        'comparevenue': {
            name: 'Compare' + '\n' + 'Venue',
            fullname: 'Compare Venues',
            url: '/compare/weddingvenue',
            toolurl: '/tools/comparevenue',
            purpose:['Wedding'],
            txt: 'Compare Venues assists couples in Singapore like you in smartly and budget-friendly comparing and selecting venues, ensuring you get the most out of your special day without overspending.',
            
            icon: iconwrapper(PLANNING_VENUECOMPARE_ICON, { width: 40, height: 40 }),
            iconlarge: iconwrapper(PLANNING_VENUECOMPARE_ICON, { width: 30, height: 30 }),
            iconwithoutcss: iconwrapper(PLANNING_VENUECOMPARE_ICON, { width: 'inherit', height: 'inherit' }),
        },
        'preweddinglocationcurate': {
            name: 'Pre-Wedding' + '\n' + 'Location' + '\n' + 'Curate',
            fullname: 'Pre-Wedding Location Curate',
            url: '/map',
            toolurl: '/tools/preweddinglocationcurate',
            purpose:['Wedding'],
            txt: 'Pre-Wedding Location Curate is a map-based tool for couples seeking perfect pre-wedding photoshoot locations in Singapore. It helps couples discover picturesque spots and connects them with experienced photographers and videographers who have taken pictures there.',
            
            icon: iconwrapper(MAPGPS_ICON, { width: 40, height: 40 }),
            iconlarge: iconwrapper(MAPGPS_ICON, { width: 30, height: 30 }),
            iconwithoutcss: iconwrapper(MAPGPS_ICON, { width: 'inherit', height: 'inherit' }),
        },
        'auspiciousdate': {
            name: 'Auspicious' + `\n` + 'Date',
            fullname: 'Auscipious Date',
            url: '/budgetbuilder',
            toolurl: '/tools/budget',
            purpose:['Wedding'],
            txt: 'Find auspicious dates, ensuring a harmonious and lucky start to your journey of love and commitment.',
            
            icon: iconwrapper(DATETIME_ICON, { width: 40, height: 40 }),
            iconlarge: iconwrapper(DATETIME_ICON, { width: 30, height: 30 }),
            iconwithoutcss: iconwrapper(DATETIME_ICON, { width: 'inherit', height: 'inherit' }),
        },
        'checklist': {
            name: 'Checklist',
            fullname: 'Checklist',
            url: '/checklistbuilder',
            toolurl: '/tools/checklist',
            purpose:['Wedding'],
            txt: 'Our checklist app helps you plan your big day with ease. With a comprehensive list of tasks and timelines, you can stay organized and on track throughout the planning process.',
            
            icon: iconwrapper(PLANNING_CHECKLIST_ICON, { width: 40, height: 40 }),
            iconlarge: iconwrapper(PLANNING_CHECKLIST_ICON, { width: 30, height: 30 }),
            iconwithoutcss: iconwrapper(PLANNING_CHECKLIST_ICON, { width: 'inherit', height: 'inherit' }),
        },
        'budget': {
            name: 'Budget' + `\n` + 'Tracker',
            fullname: 'Budget Tracker',
            url: '/budgetbuilder',
            toolurl: '/tools/budget',
            purpose:['Wedding'],
            txt: 'Our budget tracker app helps you stay on top of your finances with ease. Set a budget, track expenses, and monitor your progress all in one place. With customizable categories you can reach your financial goals and manage your money like a pro.',
            
            icon: iconwrapper(PLANNING_BUDGET_ICON, { width: 40, height: 40 }),
            iconlarge: iconwrapper(PLANNING_BUDGET_ICON, { width: 30, height: 30 }),
            iconwithoutcss: iconwrapper(PLANNING_BUDGET_ICON, { width: 'inherit', height: 'inherit' }),
        },
        'itinerary': {
            name: `Timeline` + '\n' + `Itinerary`,
            fullname: `Timeline Itinerary`,
            url: '/itinerarybuilder',
            toolurl: '/tools/itinerary',
            purpose:['Wedding'],
            txt: `Create a personalized wedding day timeline for you and your guests with Timeline Itinerary. Add all events, share with ease, and customize it to suit your needs, ensuring a stress-free wedding day.`,
            
            icon: iconwrapper(PLANNING_TIMELINE_ICON, { width: 40, height: 40 }),
            iconlarge: iconwrapper(PLANNING_TIMELINE_ICON, { width: 30, height: 30 }),
            iconwithoutcss: iconwrapper(PLANNING_TIMELINE_ICON, { width: 'inherit', height: 'inherit' }),
        },
        'invitation': {
            name: `Site Builder` + '\n' + `& Guest List`,
            fullname: `Site Builder & Guest List`,
            url: '/invitationbuilder',
            toolurl: '/tools/invitation',
            purpose:['Wedding'],
            txt: `Organize your dream wedding with our essential Wedding Site Builder and Guest List app. Create a stunning website to share wedding details and manage RSVPs, meal preferences, and guest details with ease, ensuring a stress-free planning process.`,
            
            icon: iconwrapper(PLANNING_INVITE_ICON, { width: 40, height: 40 }),
            iconlarge: iconwrapper(PLANNING_INVITE_ICON, { width: 30, height: 30 }),
            iconwithoutcss: iconwrapper(PLANNING_INVITE_ICON, { width: 'inherit', height: 'inherit' }),
        },
        'seatingchart': {
            name: `Seating` + '\n' + `Chart`,
            fullname: `Seating Chart`,
            url: '/seatingchartbuilder',
            toolurl: '/tools/seatingchart',
            purpose:['Wedding'],
            txt: 'Our Seating Chart app is an essential tool for organizing your wedding reception, both online and offline. Create and manage a personalized seating chart with ease, ensuring a smooth and enjoyable reception for everyone.',
            
            icon: iconwrapper(PLANNING_SEATING_ICON, { width: 40, height: 40 }),
            iconlarge: iconwrapper(PLANNING_SEATING_ICON, { width: 30, height: 30 }),
            iconwithoutcss: iconwrapper(PLANNING_SEATING_ICON, { width: 'inherit', height: 'inherit' }),
        },
        // 'guestbook': {
        //     name: 'Guest' + `\n` + 'Book',
        //     fullname: `Guest Book`,
        //     url: '/guestbookbuilder',
        //     toolurl: '/tools/guestbook',
        //     txt: 'Our Digital Guestbook allows guests to leave messages, photos, and audio, creating an interactive keepsake that you can cherish forever. Capture memories of your special day with ease.',
        //     icon: iconwrapper(PLANNING_GUESTBOOK_ICON, { width: 40, height: 40 }),
        //     iconlarge: iconwrapper(PLANNING_GUESTBOOK_ICON, { width: 30, height: 30 }),
        //     iconwithoutcss:iconwrapper(PLANNING_GUESTBOOK_ICON, { width: 'inherit', height: 'inherit' }),
        // },
        'guestbook': {
            name: 'Guest' + `\n` + 'Book',
            fullname: `Guest Book`,
            url: '/guestbookbuilder',
            toolurl: '/tools/guestbook',
            purpose:['Wedding'],
            txt: 'Let your guests doodle, sketch, and leave notes on your digital guestbook. All creations are saved and printable as a timeless keepsake for the you.',
            
            icon: iconwrapper(PLANNING_GUESTBOOK_ICON, { width: 40, height: 40 }),
            iconlarge: iconwrapper(PLANNING_GUESTBOOK_ICON, { width: 30, height: 30 }),
            iconwithoutcss: iconwrapper(PLANNING_GUESTBOOK_ICON, { width: 'inherit', height: 'inherit' }),
            extradom: <button
                style={{ backgroundColor: '#ffffff', border: '1px solid var(--maindark)', borderRadius: 100, padding: '5px 20px', fontSize: 'Lato', fontWeight: 'normal', fontSize: '14px', width: 150, placeItems: 'center', placeContent: 'center', placeSelf: 'center' }}
                onClick={() => {
                    //  window.open(WEBSITE_URL + '/guestbook-how-it-works', "_blank"); 
                    window.open(
                        `${window.location.origin}/guestbook-how-it-works`,
                        "_blank"
                    );
                }}
            >
                How It Works?
            </button>
        },
        'qr': {
            name: 'QR',
            fullname: 'QR',
            url: '/qrbuilder',
            toolurl: '/tools/qr',
            purpose:['Wedding'],
            txt: 'With our QR Creator, you can easily create and customize QR codes for your wedding. Share important information with guests, such as your wedding website, seating chart, and timeline itinerary, with just a scan.',
            
            icon: iconwrapper(PLANNING_QR_ICON, { width: 40, height: 40 }),
            iconlarge: iconwrapper(PLANNING_QR_ICON, { width: 30, height: 30 }),
            iconwithoutcss: iconwrapper(PLANNING_QR_ICON, { width: 'inherit', height: 'inherit' }),
        },
    }
    : { // planning object
        'community': {
            name: 'Community',
            fullname: 'Community',
            url: '/',
            toolurl: '/tools/community',
            purpose:['Wedding', 'Event'],
            txt: `Join our vibrant wedding community to ask questions, share experiences, give feedback, and suggest features for your wedding or our app. Connect with us on the social media platforms below.`,
            
            icon: iconwrapper(PLANNING_COMMUNICATION_ICON, { width: 40, height: 40 }),
            iconlarge: iconwrapper(PLANNING_COMMUNICATION_ICON, { width: 30, height: 30 }),
            iconwithoutcss: iconwrapper(PLANNING_COMMUNICATION_ICON, { width: 'inherit', height: 'inherit' }),

        },
        'comparevenue': {
            name: 'Compare' + '\n' + 'Venue',
            fullname: 'Compare Venues',
            url: '/compare/weddingvenue',
            toolurl: '/tools/comparevenue',
            purpose:['Wedding'],
            txt: 'Compare Venues assists couples in Singapore like you in smartly and budget-friendly comparing and selecting venues, ensuring you get the most out of your special day without overspending.',
            
            icon: iconwrapper(PLANNING_VENUECOMPARE_ICON, { width: 40, height: 40 }),
            iconlarge: iconwrapper(PLANNING_VENUECOMPARE_ICON, { width: 30, height: 30 }),
            iconwithoutcss: iconwrapper(PLANNING_VENUECOMPARE_ICON, { width: 'inherit', height: 'inherit' }),

        },
        'preweddinglocationcurate': {
            name: 'Pre-Wedding' + '\n' + 'Location' + '\n' + 'Curate',
            fullname: 'Pre-Wedding Location Curate',
            url: '/map',
            toolurl: '/tools/preweddinglocationcurate',
            purpose:['Wedding'],
            txt: 'Pre-Wedding Location Curate is a map-based tool for couples seeking perfect pre-wedding photoshoot locations in Singapore. It helps couples discover picturesque spots and connects them with experienced photographers and videographers who have taken pictures there.',
            
            icon: iconwrapper(MAPGPS_ICON, { width: 40, height: 40 }),
            iconlarge: iconwrapper(MAPGPS_ICON, { width: 30, height: 30 }),
            iconwithoutcss: iconwrapper(MAPGPS_ICON, { width: 'inherit', height: 'inherit' }),

        },
        'auspiciousdate': {
            name: 'Auspicious' + `\n` + 'Date',
            fullname: 'Auscipious Date',
            url: '/budgetbuilder',
            toolurl: '/tools/budget',
            purpose:['Wedding'],
            txt: 'Our checklist app helps you plan your big day with ease. With a comprehensive list of tasks and timelines, you can stay organized and on track throughout the planning process.',
            
            icon: iconwrapper(DATETIME_ICON, { width: 40, height: 40 }),
            iconlarge: iconwrapper(DATETIME_ICON, { width: 30, height: 30 }),
            iconwithoutcss: iconwrapper(DATETIME_ICON, { width: 'inherit', height: 'inherit' }),

        },
        'checklist': {
            name: 'Checklist',
            fullname: 'Checklist',
            url: '/checklistbuilder',
            toolurl: '/tools/checklist',
            purpose:['Wedding'],
            txt: 'Our checklist app helps you plan your big day with ease. With a comprehensive list of tasks and timelines, you can stay organized and on track throughout the planning process.',
            icon: iconwrapper(PLANNING_CHECKLIST_ICON, { width: 40, height: 40 }),
            iconlarge: iconwrapper(PLANNING_CHECKLIST_ICON, { width: 30, height: 30 }),
            iconwithoutcss: iconwrapper(PLANNING_CHECKLIST_ICON, { width: 'inherit', height: 'inherit' }),

        },
        'budget': {
            name: 'Budget' + `\n` + 'Tracker',
            fullname: 'Budget Tracker',
            url: '/budgetbuilder',
            toolurl: '/tools/budget',
            purpose:['Wedding'],
            txt: 'Our budget tracker app helps you stay on top of your finances with ease. Set a budget, track expenses, and monitor your progress all in one place. With customizable categories you can reach your financial goals and manage your money like a pro.',
            icon: iconwrapper(PLANNING_BUDGET_ICON, { width: 40, height: 40 }),
            iconlarge: iconwrapper(PLANNING_BUDGET_ICON, { width: 30, height: 30 }),
            iconwithoutcss: iconwrapper(PLANNING_GUESTBOOK_ICON, { width: 'inherit', height: 'inherit' }),

        },
        'itinerary': {
            name: `Timeline
        Itinerary`,
            fullname: `Timeline` + '\n' + `Itinerary`,
            url: '/itinerarybuilder',
            toolurl: '/tools/itinerary',
            purpose:['Wedding'],
            txt: `Create a personalized wedding day timeline for you and your guests with Timeline Itinerary. Add all events, share with ease, and customize it to suit your needs, ensuring a stress-free wedding day.`,
            icon: iconwrapper(PLANNING_TIMELINE_ICON, { width: 40, height: 40 }),
            iconlarge: iconwrapper(PLANNING_TIMELINE_ICON, { width: 30, height: 30 }),
            iconwithoutcss: iconwrapper(PLANNING_TIMELINE_ICON, { width: 'inherit', height: 'inherit' }),

        },
        'invitation': {
            name: `Site Builder,` + '\n' + `Guest List`,
            fullname: `Site Builder, Guest List`,
            url: '/invitationbuilder',
            toolurl: '/tools/invitation',
            purpose:['Wedding'],
            txt: `Organize your dream wedding with our essential Wedding Site Builder and Guest List app. Create a stunning website to share wedding details and manage RSVPs, meal preferences, and guest details with ease, ensuring a stress-free planning process.`,
            icon: iconwrapper(PLANNING_INVITE_ICON, { width: 40, height: 40 }),
            iconlarge: iconwrapper(PLANNING_INVITE_ICON, { width: 30, height: 30 }),
            iconwithoutcss: iconwrapper(PLANNING_INVITE_ICON, { width: 'inherit', height: 'inherit' }),

        },
        'seatingchart': {
            name: `Seating` + '\n' + `Chart`,
            fullname: `Seating Chart`,
            url: '/seatingchartbuilder',
            toolurl: '/tools/seatingchart',
            purpose:['Wedding'],
            txt: 'Our Seating Chart app is an essential tool for organizing your wedding reception, both online and offline. Create and manage a personalized seating chart with ease, ensuring a smooth and enjoyable reception for everyone.',
            icon: iconwrapper(PLANNING_SEATING_ICON, { width: 40, height: 40 }),
            iconlarge: iconwrapper(PLANNING_SEATING_ICON, { width: 30, height: 30 }),
            iconwithoutcss: iconwrapper(PLANNING_SEATING_ICON, { width: 'inherit', height: 'inherit' }),

        },
        'qr': {
            name: 'QR',
            fullname: 'QR',
            url: '/qrbuilder',
            toolurl: '/tools/qr',
            purpose:['Wedding'],
            txt: 'With our QR Creator, you can easily create and customize QR codes for your wedding. Share important information with guests, such as your wedding website, seating chart, and timeline itinerary, with just a scan.',
            icon: iconwrapper(PLANNING_QR_ICON, { width: 40, height: 40 }),
            iconlarge: iconwrapper(PLANNING_QR_ICON, { width: 30, height: 30 }),
            iconwithoutcss: iconwrapper(PLANNING_QR_ICON, { width: 'inherit', height: 'inherit' }),

        },
        'guestbook': {
            name: 'Draw' + `\n` + 'Book',
            fullname: 'Draw Book',
            url: '/guestbookbuilder',
            toolurl: '/tools/drawbook',
            purpose:['Wedding'],
            txt: 'A drawbook for your guests to draw and leave messages for you.',
            icon: iconwrapper(PLANNING_QR_ICON, { width: 40, height: 40 }),
            iconlarge: iconwrapper(PLANNING_QR_ICON, { width: 30, height: 30 }),
            iconwithoutcss: iconwrapper(PLANNING_QR_ICON, { width: 'inherit', height: 'inherit' }),

        }

    }

export const emojiPattern = String.raw`(?:🧑🏻‍❤️‍💋‍🧑🏼|🧑🏻‍❤️‍💋‍🧑🏽|🧑🏻‍❤️‍💋‍🧑🏾|🧑🏻‍❤️‍💋‍🧑🏿|🧑🏼‍❤️‍💋‍🧑🏻|🧑🏼‍❤️‍💋‍🧑🏽|🧑🏼‍❤️‍💋‍🧑🏾|🧑🏼‍❤️‍💋‍🧑🏿|🧑🏽‍❤️‍💋‍🧑🏻|🧑🏽‍❤️‍💋‍🧑🏼|🧑🏽‍❤️‍💋‍🧑🏾|🧑🏽‍❤️‍💋‍🧑🏿|🧑🏾‍❤️‍💋‍🧑🏻|🧑🏾‍❤️‍💋‍🧑🏼|🧑🏾‍❤️‍💋‍🧑🏽|🧑🏾‍❤️‍💋‍🧑🏿|🧑🏿‍❤️‍💋‍🧑🏻|🧑🏿‍❤️‍💋‍🧑🏼|🧑🏿‍❤️‍💋‍🧑🏽|🧑🏿‍❤️‍💋‍🧑🏾|👩🏻‍❤️‍💋‍👨🏻|👩🏻‍❤️‍💋‍👨🏼|👩🏻‍❤️‍💋‍👨🏽|👩🏻‍❤️‍💋‍👨🏾|👩🏻‍❤️‍💋‍👨🏿|👩🏼‍❤️‍💋‍👨🏻|👩🏼‍❤️‍💋‍👨🏼|👩🏼‍❤️‍💋‍👨🏽|👩🏼‍❤️‍💋‍👨🏾|👩🏼‍❤️‍💋‍👨🏿|👩🏽‍❤️‍💋‍👨🏻|👩🏽‍❤️‍💋‍👨🏼|👩🏽‍❤️‍💋‍👨🏽|👩🏽‍❤️‍💋‍👨🏾|👩🏽‍❤️‍💋‍👨🏿|👩🏾‍❤️‍💋‍👨🏻|👩🏾‍❤️‍💋‍👨🏼|👩🏾‍❤️‍💋‍👨🏽|👩🏾‍❤️‍💋‍👨🏾|👩🏾‍❤️‍💋‍👨🏿|👩🏿‍❤️‍💋‍👨🏻|👩🏿‍❤️‍💋‍👨🏼|👩🏿‍❤️‍💋‍👨🏽|👩🏿‍❤️‍💋‍👨🏾|👩🏿‍❤️‍💋‍👨🏿|👨🏻‍❤️‍💋‍👨🏻|👨🏻‍❤️‍💋‍👨🏼|👨🏻‍❤️‍💋‍👨🏽|👨🏻‍❤️‍💋‍👨🏾|👨🏻‍❤️‍💋‍👨🏿|👨🏼‍❤️‍💋‍👨🏻|👨🏼‍❤️‍💋‍👨🏼|👨🏼‍❤️‍💋‍👨🏽|👨🏼‍❤️‍💋‍👨🏾|👨🏼‍❤️‍💋‍👨🏿|👨🏽‍❤️‍💋‍👨🏻|👨🏽‍❤️‍💋‍👨🏼|👨🏽‍❤️‍💋‍👨🏽|👨🏽‍❤️‍💋‍👨🏾|👨🏽‍❤️‍💋‍👨🏿|👨🏾‍❤️‍💋‍👨🏻|👨🏾‍❤️‍💋‍👨🏼|👨🏾‍❤️‍💋‍👨🏽|👨🏾‍❤️‍💋‍👨🏾|👨🏾‍❤️‍💋‍👨🏿|👨🏿‍❤️‍💋‍👨🏻|👨🏿‍❤️‍💋‍👨🏼|👨🏿‍❤️‍💋‍👨🏽|👨🏿‍❤️‍💋‍👨🏾|👨🏿‍❤️‍💋‍👨🏿|👩🏻‍❤️‍💋‍👩🏻|👩🏻‍❤️‍💋‍👩🏼|👩🏻‍❤️‍💋‍👩🏽|👩🏻‍❤️‍💋‍👩🏾|👩🏻‍❤️‍💋‍👩🏿|👩🏼‍❤️‍💋‍👩🏻|👩🏼‍❤️‍💋‍👩🏼|👩🏼‍❤️‍💋‍👩🏽|👩🏼‍❤️‍💋‍👩🏾|👩🏼‍❤️‍💋‍👩🏿|👩🏽‍❤️‍💋‍👩🏻|👩🏽‍❤️‍💋‍👩🏼|👩🏽‍❤️‍💋‍👩🏽|👩🏽‍❤️‍💋‍👩🏾|👩🏽‍❤️‍💋‍👩🏿|👩🏾‍❤️‍💋‍👩🏻|👩🏾‍❤️‍💋‍👩🏼|👩🏾‍❤️‍💋‍👩🏽|👩🏾‍❤️‍💋‍👩🏾|👩🏾‍❤️‍💋‍👩🏿|👩🏿‍❤️‍💋‍👩🏻|👩🏿‍❤️‍💋‍👩🏼|👩🏿‍❤️‍💋‍👩🏽|👩🏿‍❤️‍💋‍👩🏾|👩🏿‍❤️‍💋‍👩🏿|🏴󠁧󠁢󠁥󠁮󠁧󠁿|🏴󠁧󠁢󠁳󠁣󠁴󠁿|🏴󠁧󠁢󠁷󠁬󠁳󠁿|🧑🏻‍🤝‍🧑🏻|🧑🏻‍🤝‍🧑🏼|🧑🏻‍🤝‍🧑🏽|🧑🏻‍🤝‍🧑🏾|🧑🏻‍🤝‍🧑🏿|🧑🏼‍🤝‍🧑🏻|🧑🏼‍🤝‍🧑🏼|🧑🏼‍🤝‍🧑🏽|🧑🏼‍🤝‍🧑🏾|🧑🏼‍🤝‍🧑🏿|🧑🏽‍🤝‍🧑🏻|🧑🏽‍🤝‍🧑🏼|🧑🏽‍🤝‍🧑🏽|🧑🏽‍🤝‍🧑🏾|🧑🏽‍🤝‍🧑🏿|🧑🏾‍🤝‍🧑🏻|🧑🏾‍🤝‍🧑🏼|🧑🏾‍🤝‍🧑🏽|🧑🏾‍🤝‍🧑🏾|🧑🏾‍🤝‍🧑🏿|🧑🏿‍🤝‍🧑🏻|🧑🏿‍🤝‍🧑🏼|🧑🏿‍🤝‍🧑🏽|🧑🏿‍🤝‍🧑🏾|🧑🏿‍🤝‍🧑🏿|👩🏻‍🤝‍👩🏼|👩🏻‍🤝‍👩🏽|👩🏻‍🤝‍👩🏾|👩🏻‍🤝‍👩🏿|👩🏼‍🤝‍👩🏻|👩🏼‍🤝‍👩🏽|👩🏼‍🤝‍👩🏾|👩🏼‍🤝‍👩🏿|👩🏽‍🤝‍👩🏻|👩🏽‍🤝‍👩🏼|👩🏽‍🤝‍👩🏾|👩🏽‍🤝‍👩🏿|👩🏾‍🤝‍👩🏻|👩🏾‍🤝‍👩🏼|👩🏾‍🤝‍👩🏽|👩🏾‍🤝‍👩🏿|👩🏿‍🤝‍👩🏻|👩🏿‍🤝‍👩🏼|👩🏿‍🤝‍👩🏽|👩🏿‍🤝‍👩🏾|👩🏻‍🤝‍👨🏼|👩🏻‍🤝‍👨🏽|👩🏻‍🤝‍👨🏾|👩🏻‍🤝‍👨🏿|👩🏼‍🤝‍👨🏻|👩🏼‍🤝‍👨🏽|👩🏼‍🤝‍👨🏾|👩🏼‍🤝‍👨🏿|👩🏽‍🤝‍👨🏻|👩🏽‍🤝‍👨🏼|👩🏽‍🤝‍👨🏾|👩🏽‍🤝‍👨🏿|👩🏾‍🤝‍👨🏻|👩🏾‍🤝‍👨🏼|👩🏾‍🤝‍👨🏽|👩🏾‍🤝‍👨🏿|👩🏿‍🤝‍👨🏻|👩🏿‍🤝‍👨🏼|👩🏿‍🤝‍👨🏽|👩🏿‍🤝‍👨🏾|👨🏻‍🤝‍👨🏼|👨🏻‍🤝‍👨🏽|👨🏻‍🤝‍👨🏾|👨🏻‍🤝‍👨🏿|👨🏼‍🤝‍👨🏻|👨🏼‍🤝‍👨🏽|👨🏼‍🤝‍👨🏾|👨🏼‍🤝‍👨🏿|👨🏽‍🤝‍👨🏻|👨🏽‍🤝‍👨🏼|👨🏽‍🤝‍👨🏾|👨🏽‍🤝‍👨🏿|👨🏾‍🤝‍👨🏻|👨🏾‍🤝‍👨🏼|👨🏾‍🤝‍👨🏽|👨🏾‍🤝‍👨🏿|👨🏿‍🤝‍👨🏻|👨🏿‍🤝‍👨🏼|👨🏿‍🤝‍👨🏽|👨🏿‍🤝‍👨🏾|🧑🏻‍❤️‍🧑🏼|🧑🏻‍❤️‍🧑🏽|🧑🏻‍❤️‍🧑🏾|🧑🏻‍❤️‍🧑🏿|🧑🏼‍❤️‍🧑🏻|🧑🏼‍❤️‍🧑🏽|🧑🏼‍❤️‍🧑🏾|🧑🏼‍❤️‍🧑🏿|🧑🏽‍❤️‍🧑🏻|🧑🏽‍❤️‍🧑🏼|🧑🏽‍❤️‍🧑🏾|🧑🏽‍❤️‍🧑🏿|🧑🏾‍❤️‍🧑🏻|🧑🏾‍❤️‍🧑🏼|🧑🏾‍❤️‍🧑🏽|🧑🏾‍❤️‍🧑🏿|🧑🏿‍❤️‍🧑🏻|🧑🏿‍❤️‍🧑🏼|🧑🏿‍❤️‍🧑🏽|🧑🏿‍❤️‍🧑🏾|👩🏻‍❤️‍👨🏻|👩🏻‍❤️‍👨🏼|👩🏻‍❤️‍👨🏽|👩🏻‍❤️‍👨🏾|👩🏻‍❤️‍👨🏿|👩🏼‍❤️‍👨🏻|👩🏼‍❤️‍👨🏼|👩🏼‍❤️‍👨🏽|👩🏼‍❤️‍👨🏾|👩🏼‍❤️‍👨🏿|👩🏽‍❤️‍👨🏻|👩🏽‍❤️‍👨🏼|👩🏽‍❤️‍👨🏽|👩🏽‍❤️‍👨🏾|👩🏽‍❤️‍👨🏿|👩🏾‍❤️‍👨🏻|👩🏾‍❤️‍👨🏼|👩🏾‍❤️‍👨🏽|👩🏾‍❤️‍👨🏾|👩🏾‍❤️‍👨🏿|👩🏿‍❤️‍👨🏻|👩🏿‍❤️‍👨🏼|👩🏿‍❤️‍👨🏽|👩🏿‍❤️‍👨🏾|👩🏿‍❤️‍👨🏿|👨🏻‍❤️‍👨🏻|👨🏻‍❤️‍👨🏼|👨🏻‍❤️‍👨🏽|👨🏻‍❤️‍👨🏾|👨🏻‍❤️‍👨🏿|👨🏼‍❤️‍👨🏻|👨🏼‍❤️‍👨🏼|👨🏼‍❤️‍👨🏽|👨🏼‍❤️‍👨🏾|👨🏼‍❤️‍👨🏿|👨🏽‍❤️‍👨🏻|👨🏽‍❤️‍👨🏼|👨🏽‍❤️‍👨🏽|👨🏽‍❤️‍👨🏾|👨🏽‍❤️‍👨🏿|👨🏾‍❤️‍👨🏻|👨🏾‍❤️‍👨🏼|👨🏾‍❤️‍👨🏽|👨🏾‍❤️‍👨🏾|👨🏾‍❤️‍👨🏿|👨🏿‍❤️‍👨🏻|👨🏿‍❤️‍👨🏼|👨🏿‍❤️‍👨🏽|👨🏿‍❤️‍👨🏾|👨🏿‍❤️‍👨🏿|👩🏻‍❤️‍👩🏻|👩🏻‍❤️‍👩🏼|👩🏻‍❤️‍👩🏽|👩🏻‍❤️‍👩🏾|👩🏻‍❤️‍👩🏿|👩🏼‍❤️‍👩🏻|👩🏼‍❤️‍👩🏼|👩🏼‍❤️‍👩🏽|👩🏼‍❤️‍👩🏾|👩🏼‍❤️‍👩🏿|👩🏽‍❤️‍👩🏻|👩🏽‍❤️‍👩🏼|👩🏽‍❤️‍👩🏽|👩🏽‍❤️‍👩🏾|👩🏽‍❤️‍👩🏿|👩🏾‍❤️‍👩🏻|👩🏾‍❤️‍👩🏼|👩🏾‍❤️‍👩🏽|👩🏾‍❤️‍👩🏾|👩🏾‍❤️‍👩🏿|👩🏿‍❤️‍👩🏻|👩🏿‍❤️‍👩🏼|👩🏿‍❤️‍👩🏽|👩🏿‍❤️‍👩🏾|👩🏿‍❤️‍👩🏿|👩‍❤️‍💋‍👨|👨‍❤️‍💋‍👨|👩‍❤️‍💋‍👩|👨‍👩‍👧‍👦|👨‍👩‍👦‍👦|👨‍👩‍👧‍👧|👨‍👨‍👧‍👦|👨‍👨‍👦‍👦|👨‍👨‍👧‍👧|👩‍👩‍👧‍👦|👩‍👩‍👦‍👦|👩‍👩‍👧‍👧|🧑‍🤝‍🧑|👩‍❤️‍👨|👨‍❤️‍👨|👩‍❤️‍👩|👨‍👩‍👦|👨‍👩‍👧|👨‍👨‍👦|👨‍👨‍👧|👩‍👩‍👦|👩‍👩‍👧|👨‍👦‍👦|👨‍👧‍👦|👨‍👧‍👧|👩‍👦‍👦|👩‍👧‍👦|👩‍👧‍👧|👁️‍🗨️|🧔🏻‍♂️|🧔🏼‍♂️|🧔🏽‍♂️|🧔🏾‍♂️|🧔🏿‍♂️|🧔🏻‍♀️|🧔🏼‍♀️|🧔🏽‍♀️|🧔🏾‍♀️|🧔🏿‍♀️|👨🏻‍🦰|👨🏼‍🦰|👨🏽‍🦰|👨🏾‍🦰|👨🏿‍🦰|👨🏻‍🦱|👨🏼‍🦱|👨🏽‍🦱|👨🏾‍🦱|👨🏿‍🦱|👨🏻‍🦳|👨🏼‍🦳|👨🏽‍🦳|👨🏾‍🦳|👨🏿‍🦳|👨🏻‍🦲|👨🏼‍🦲|👨🏽‍🦲|👨🏾‍🦲|👨🏿‍🦲|👩🏻‍🦰|👩🏼‍🦰|👩🏽‍🦰|👩🏾‍🦰|👩🏿‍🦰|🧑🏻‍🦰|🧑🏼‍🦰|🧑🏽‍🦰|🧑🏾‍🦰|🧑🏿‍🦰|👩🏻‍🦱|👩🏼‍🦱|👩🏽‍🦱|👩🏾‍🦱|👩🏿‍🦱|🧑🏻‍🦱|🧑🏼‍🦱|🧑🏽‍🦱|🧑🏾‍🦱|🧑🏿‍🦱|👩🏻‍🦳|👩🏼‍🦳|👩🏽‍🦳|👩🏾‍🦳|👩🏿‍🦳|🧑🏻‍🦳|🧑🏼‍🦳|🧑🏽‍🦳|🧑🏾‍🦳|🧑🏿‍🦳|👩🏻‍🦲|👩🏼‍🦲|👩🏽‍🦲|👩🏾‍🦲|👩🏿‍🦲|🧑🏻‍🦲|🧑🏼‍🦲|🧑🏽‍🦲|🧑🏾‍🦲|🧑🏿‍🦲|👱🏻‍♀️|👱🏼‍♀️|👱🏽‍♀️|👱🏾‍♀️|👱🏿‍♀️|👱🏻‍♂️|👱🏼‍♂️|👱🏽‍♂️|👱🏾‍♂️|👱🏿‍♂️|🙍🏻‍♂️|🙍🏼‍♂️|🙍🏽‍♂️|🙍🏾‍♂️|🙍🏿‍♂️|🙍🏻‍♀️|🙍🏼‍♀️|🙍🏽‍♀️|🙍🏾‍♀️|🙍🏿‍♀️|🙎🏻‍♂️|🙎🏼‍♂️|🙎🏽‍♂️|🙎🏾‍♂️|🙎🏿‍♂️|🙎🏻‍♀️|🙎🏼‍♀️|🙎🏽‍♀️|🙎🏾‍♀️|🙎🏿‍♀️|🙅🏻‍♂️|🙅🏼‍♂️|🙅🏽‍♂️|🙅🏾‍♂️|🙅🏿‍♂️|🙅🏻‍♀️|🙅🏼‍♀️|🙅🏽‍♀️|🙅🏾‍♀️|🙅🏿‍♀️|🙆🏻‍♂️|🙆🏼‍♂️|🙆🏽‍♂️|🙆🏾‍♂️|🙆🏿‍♂️|🙆🏻‍♀️|🙆🏼‍♀️|🙆🏽‍♀️|🙆🏾‍♀️|🙆🏿‍♀️|💁🏻‍♂️|💁🏼‍♂️|💁🏽‍♂️|💁🏾‍♂️|💁🏿‍♂️|💁🏻‍♀️|💁🏼‍♀️|💁🏽‍♀️|💁🏾‍♀️|💁🏿‍♀️|🙋🏻‍♂️|🙋🏼‍♂️|🙋🏽‍♂️|🙋🏾‍♂️|🙋🏿‍♂️|🙋🏻‍♀️|🙋🏼‍♀️|🙋🏽‍♀️|🙋🏾‍♀️|🙋🏿‍♀️|🧏🏻‍♂️|🧏🏼‍♂️|🧏🏽‍♂️|🧏🏾‍♂️|🧏🏿‍♂️|🧏🏻‍♀️|🧏🏼‍♀️|🧏🏽‍♀️|🧏🏾‍♀️|🧏🏿‍♀️|🙇🏻‍♂️|🙇🏼‍♂️|🙇🏽‍♂️|🙇🏾‍♂️|🙇🏿‍♂️|🙇🏻‍♀️|🙇🏼‍♀️|🙇🏽‍♀️|🙇🏾‍♀️|🙇🏿‍♀️|🤦🏻‍♂️|🤦🏼‍♂️|🤦🏽‍♂️|🤦🏾‍♂️|🤦🏿‍♂️|🤦🏻‍♀️|🤦🏼‍♀️|🤦🏽‍♀️|🤦🏾‍♀️|🤦🏿‍♀️|🤷🏻‍♂️|🤷🏼‍♂️|🤷🏽‍♂️|🤷🏾‍♂️|🤷🏿‍♂️|🤷🏻‍♀️|🤷🏼‍♀️|🤷🏽‍♀️|🤷🏾‍♀️|🤷🏿‍♀️|🧑🏻‍⚕️|🧑🏼‍⚕️|🧑🏽‍⚕️|🧑🏾‍⚕️|🧑🏿‍⚕️|👨🏻‍⚕️|👨🏼‍⚕️|👨🏽‍⚕️|👨🏾‍⚕️|👨🏿‍⚕️|👩🏻‍⚕️|👩🏼‍⚕️|👩🏽‍⚕️|👩🏾‍⚕️|👩🏿‍⚕️|🧑🏻‍🎓|🧑🏼‍🎓|🧑🏽‍🎓|🧑🏾‍🎓|🧑🏿‍🎓|👨🏻‍🎓|👨🏼‍🎓|👨🏽‍🎓|👨🏾‍🎓|👨🏿‍🎓|👩🏻‍🎓|👩🏼‍🎓|👩🏽‍🎓|👩🏾‍🎓|👩🏿‍🎓|🧑🏻‍🏫|🧑🏼‍🏫|🧑🏽‍🏫|🧑🏾‍🏫|🧑🏿‍🏫|👨🏻‍🏫|👨🏼‍🏫|👨🏽‍🏫|👨🏾‍🏫|👨🏿‍🏫|👩🏻‍🏫|👩🏼‍🏫|👩🏽‍🏫|👩🏾‍🏫|👩🏿‍🏫|🧑🏻‍⚖️|🧑🏼‍⚖️|🧑🏽‍⚖️|🧑🏾‍⚖️|🧑🏿‍⚖️|👨🏻‍⚖️|👨🏼‍⚖️|👨🏽‍⚖️|👨🏾‍⚖️|👨🏿‍⚖️|👩🏻‍⚖️|👩🏼‍⚖️|👩🏽‍⚖️|👩🏾‍⚖️|👩🏿‍⚖️|🧑🏻‍🌾|🧑🏼‍🌾|🧑🏽‍🌾|🧑🏾‍🌾|🧑🏿‍🌾|👨🏻‍🌾|👨🏼‍🌾|👨🏽‍🌾|👨🏾‍🌾|👨🏿‍🌾|👩🏻‍🌾|👩🏼‍🌾|👩🏽‍🌾|👩🏾‍🌾|👩🏿‍🌾|🧑🏻‍🍳|🧑🏼‍🍳|🧑🏽‍🍳|🧑🏾‍🍳|🧑🏿‍🍳|👨🏻‍🍳|👨🏼‍🍳|👨🏽‍🍳|👨🏾‍🍳|👨🏿‍🍳|👩🏻‍🍳|👩🏼‍🍳|👩🏽‍🍳|👩🏾‍🍳|👩🏿‍🍳|🧑🏻‍🔧|🧑🏼‍🔧|🧑🏽‍🔧|🧑🏾‍🔧|🧑🏿‍🔧|👨🏻‍🔧|👨🏼‍🔧|👨🏽‍🔧|👨🏾‍🔧|👨🏿‍🔧|👩🏻‍🔧|👩🏼‍🔧|👩🏽‍🔧|👩🏾‍🔧|👩🏿‍🔧|🧑🏻‍🏭|🧑🏼‍🏭|🧑🏽‍🏭|🧑🏾‍🏭|🧑🏿‍🏭|👨🏻‍🏭|👨🏼‍🏭|👨🏽‍🏭|👨🏾‍🏭|👨🏿‍🏭|👩🏻‍🏭|👩🏼‍🏭|👩🏽‍🏭|👩🏾‍🏭|👩🏿‍🏭|🧑🏻‍💼|🧑🏼‍💼|🧑🏽‍💼|🧑🏾‍💼|🧑🏿‍💼|👨🏻‍💼|👨🏼‍💼|👨🏽‍💼|👨🏾‍💼|👨🏿‍💼|👩🏻‍💼|👩🏼‍💼|👩🏽‍💼|👩🏾‍💼|👩🏿‍💼|🧑🏻‍🔬|🧑🏼‍🔬|🧑🏽‍🔬|🧑🏾‍🔬|🧑🏿‍🔬|👨🏻‍🔬|👨🏼‍🔬|👨🏽‍🔬|👨🏾‍🔬|👨🏿‍🔬|👩🏻‍🔬|👩🏼‍🔬|👩🏽‍🔬|👩🏾‍🔬|👩🏿‍🔬|🧑🏻‍💻|🧑🏼‍💻|🧑🏽‍💻|🧑🏾‍💻|🧑🏿‍💻|👨🏻‍💻|👨🏼‍💻|👨🏽‍💻|👨🏾‍💻|👨🏿‍💻|👩🏻‍💻|👩🏼‍💻|👩🏽‍💻|👩🏾‍💻|👩🏿‍💻|🧑🏻‍🎤|🧑🏼‍🎤|🧑🏽‍🎤|🧑🏾‍🎤|🧑🏿‍🎤|👨🏻‍🎤|👨🏼‍🎤|👨🏽‍🎤|👨🏾‍🎤|👨🏿‍🎤|👩🏻‍🎤|👩🏼‍🎤|👩🏽‍🎤|👩🏾‍🎤|👩🏿‍🎤|🧑🏻‍🎨|🧑🏼‍🎨|🧑🏽‍🎨|🧑🏾‍🎨|🧑🏿‍🎨|👨🏻‍🎨|👨🏼‍🎨|👨🏽‍🎨|👨🏾‍🎨|👨🏿‍🎨|👩🏻‍🎨|👩🏼‍🎨|👩🏽‍🎨|👩🏾‍🎨|👩🏿‍🎨|🧑🏻‍✈️|🧑🏼‍✈️|🧑🏽‍✈️|🧑🏾‍✈️|🧑🏿‍✈️|👨🏻‍✈️|👨🏼‍✈️|👨🏽‍✈️|👨🏾‍✈️|👨🏿‍✈️|👩🏻‍✈️|👩🏼‍✈️|👩🏽‍✈️|👩🏾‍✈️|👩🏿‍✈️|🧑🏻‍🚀|🧑🏼‍🚀|🧑🏽‍🚀|🧑🏾‍🚀|🧑🏿‍🚀|👨🏻‍🚀|👨🏼‍🚀|👨🏽‍🚀|👨🏾‍🚀|👨🏿‍🚀|👩🏻‍🚀|👩🏼‍🚀|👩🏽‍🚀|👩🏾‍🚀|👩🏿‍🚀|🧑🏻‍🚒|🧑🏼‍🚒|🧑🏽‍🚒|🧑🏾‍🚒|🧑🏿‍🚒|👨🏻‍🚒|👨🏼‍🚒|👨🏽‍🚒|👨🏾‍🚒|👨🏿‍🚒|👩🏻‍🚒|👩🏼‍🚒|👩🏽‍🚒|👩🏾‍🚒|👩🏿‍🚒|👮🏻‍♂️|👮🏼‍♂️|👮🏽‍♂️|👮🏾‍♂️|👮🏿‍♂️|👮🏻‍♀️|👮🏼‍♀️|👮🏽‍♀️|👮🏾‍♀️|👮🏿‍♀️|🕵🏻‍♂️|🕵🏼‍♂️|🕵🏽‍♂️|🕵🏾‍♂️|🕵🏿‍♂️|🕵🏻‍♀️|🕵🏼‍♀️|🕵🏽‍♀️|🕵🏾‍♀️|🕵🏿‍♀️|💂🏻‍♂️|💂🏼‍♂️|💂🏽‍♂️|💂🏾‍♂️|💂🏿‍♂️|💂🏻‍♀️|💂🏼‍♀️|💂🏽‍♀️|💂🏾‍♀️|💂🏿‍♀️|👷🏻‍♂️|👷🏼‍♂️|👷🏽‍♂️|👷🏾‍♂️|👷🏿‍♂️|👷🏻‍♀️|👷🏼‍♀️|👷🏽‍♀️|👷🏾‍♀️|👷🏿‍♀️|👳🏻‍♂️|👳🏼‍♂️|👳🏽‍♂️|👳🏾‍♂️|👳🏿‍♂️|👳🏻‍♀️|👳🏼‍♀️|👳🏽‍♀️|👳🏾‍♀️|👳🏿‍♀️|🤵🏻‍♂️|🤵🏼‍♂️|🤵🏽‍♂️|🤵🏾‍♂️|🤵🏿‍♂️|🤵🏻‍♀️|🤵🏼‍♀️|🤵🏽‍♀️|🤵🏾‍♀️|🤵🏿‍♀️|👰🏻‍♂️|👰🏼‍♂️|👰🏽‍♂️|👰🏾‍♂️|👰🏿‍♂️|👰🏻‍♀️|👰🏼‍♀️|👰🏽‍♀️|👰🏾‍♀️|👰🏿‍♀️|👩🏻‍🍼|👩🏼‍🍼|👩🏽‍🍼|👩🏾‍🍼|👩🏿‍🍼|👨🏻‍🍼|👨🏼‍🍼|👨🏽‍🍼|👨🏾‍🍼|👨🏿‍🍼|🧑🏻‍🍼|🧑🏼‍🍼|🧑🏽‍🍼|🧑🏾‍🍼|🧑🏿‍🍼|🧑🏻‍🎄|🧑🏼‍🎄|🧑🏽‍🎄|🧑🏾‍🎄|🧑🏿‍🎄|🦸🏻‍♂️|🦸🏼‍♂️|🦸🏽‍♂️|🦸🏾‍♂️|🦸🏿‍♂️|🦸🏻‍♀️|🦸🏼‍♀️|🦸🏽‍♀️|🦸🏾‍♀️|🦸🏿‍♀️|🦹🏻‍♂️|🦹🏼‍♂️|🦹🏽‍♂️|🦹🏾‍♂️|🦹🏿‍♂️|🦹🏻‍♀️|🦹🏼‍♀️|🦹🏽‍♀️|🦹🏾‍♀️|🦹🏿‍♀️|🧙🏻‍♂️|🧙🏼‍♂️|🧙🏽‍♂️|🧙🏾‍♂️|🧙🏿‍♂️|🧙🏻‍♀️|🧙🏼‍♀️|🧙🏽‍♀️|🧙🏾‍♀️|🧙🏿‍♀️|🧚🏻‍♂️|🧚🏼‍♂️|🧚🏽‍♂️|🧚🏾‍♂️|🧚🏿‍♂️|🧚🏻‍♀️|🧚🏼‍♀️|🧚🏽‍♀️|🧚🏾‍♀️|🧚🏿‍♀️|🧛🏻‍♂️|🧛🏼‍♂️|🧛🏽‍♂️|🧛🏾‍♂️|🧛🏿‍♂️|🧛🏻‍♀️|🧛🏼‍♀️|🧛🏽‍♀️|🧛🏾‍♀️|🧛🏿‍♀️|🧜🏻‍♂️|🧜🏼‍♂️|🧜🏽‍♂️|🧜🏾‍♂️|🧜🏿‍♂️|🧜🏻‍♀️|🧜🏼‍♀️|🧜🏽‍♀️|🧜🏾‍♀️|🧜🏿‍♀️|🧝🏻‍♂️|🧝🏼‍♂️|🧝🏽‍♂️|🧝🏾‍♂️|🧝🏿‍♂️|🧝🏻‍♀️|🧝🏼‍♀️|🧝🏽‍♀️|🧝🏾‍♀️|🧝🏿‍♀️|💆🏻‍♂️|💆🏼‍♂️|💆🏽‍♂️|💆🏾‍♂️|💆🏿‍♂️|💆🏻‍♀️|💆🏼‍♀️|💆🏽‍♀️|💆🏾‍♀️|💆🏿‍♀️|💇🏻‍♂️|💇🏼‍♂️|💇🏽‍♂️|💇🏾‍♂️|💇🏿‍♂️|💇🏻‍♀️|💇🏼‍♀️|💇🏽‍♀️|💇🏾‍♀️|💇🏿‍♀️|🚶🏻‍♂️|🚶🏼‍♂️|🚶🏽‍♂️|🚶🏾‍♂️|🚶🏿‍♂️|🚶🏻‍♀️|🚶🏼‍♀️|🚶🏽‍♀️|🚶🏾‍♀️|🚶🏿‍♀️|🧍🏻‍♂️|🧍🏼‍♂️|🧍🏽‍♂️|🧍🏾‍♂️|🧍🏿‍♂️|🧍🏻‍♀️|🧍🏼‍♀️|🧍🏽‍♀️|🧍🏾‍♀️|🧍🏿‍♀️|🧎🏻‍♂️|🧎🏼‍♂️|🧎🏽‍♂️|🧎🏾‍♂️|🧎🏿‍♂️|🧎🏻‍♀️|🧎🏼‍♀️|🧎🏽‍♀️|🧎🏾‍♀️|🧎🏿‍♀️|🧑🏻‍🦯|🧑🏼‍🦯|🧑🏽‍🦯|🧑🏾‍🦯|🧑🏿‍🦯|👨🏻‍🦯|👨🏼‍🦯|👨🏽‍🦯|👨🏾‍🦯|👨🏿‍🦯|👩🏻‍🦯|👩🏼‍🦯|👩🏽‍🦯|👩🏾‍🦯|👩🏿‍🦯|🧑🏻‍🦼|🧑🏼‍🦼|🧑🏽‍🦼|🧑🏾‍🦼|🧑🏿‍🦼|👨🏻‍🦼|👨🏼‍🦼|👨🏽‍🦼|👨🏾‍🦼|👨🏿‍🦼|👩🏻‍🦼|👩🏼‍🦼|👩🏽‍🦼|👩🏾‍🦼|👩🏿‍🦼|🧑🏻‍🦽|🧑🏼‍🦽|🧑🏽‍🦽|🧑🏾‍🦽|🧑🏿‍🦽|👨🏻‍🦽|👨🏼‍🦽|👨🏽‍🦽|👨🏾‍🦽|👨🏿‍🦽|👩🏻‍🦽|👩🏼‍🦽|👩🏽‍🦽|👩🏾‍🦽|👩🏿‍🦽|🏃🏻‍♂️|🏃🏼‍♂️|🏃🏽‍♂️|🏃🏾‍♂️|🏃🏿‍♂️|🏃🏻‍♀️|🏃🏼‍♀️|🏃🏽‍♀️|🏃🏾‍♀️|🏃🏿‍♀️|🧖🏻‍♂️|🧖🏼‍♂️|🧖🏽‍♂️|🧖🏾‍♂️|🧖🏿‍♂️|🧖🏻‍♀️|🧖🏼‍♀️|🧖🏽‍♀️|🧖🏾‍♀️|🧖🏿‍♀️|🧗🏻‍♂️|🧗🏼‍♂️|🧗🏽‍♂️|🧗🏾‍♂️|🧗🏿‍♂️|🧗🏻‍♀️|🧗🏼‍♀️|🧗🏽‍♀️|🧗🏾‍♀️|🧗🏿‍♀️|🏌🏻‍♂️|🏌🏼‍♂️|🏌🏽‍♂️|🏌🏾‍♂️|🏌🏿‍♂️|🏌🏻‍♀️|🏌🏼‍♀️|🏌🏽‍♀️|🏌🏾‍♀️|🏌🏿‍♀️|🏄🏻‍♂️|🏄🏼‍♂️|🏄🏽‍♂️|🏄🏾‍♂️|🏄🏿‍♂️|🏄🏻‍♀️|🏄🏼‍♀️|🏄🏽‍♀️|🏄🏾‍♀️|🏄🏿‍♀️|🚣🏻‍♂️|🚣🏼‍♂️|🚣🏽‍♂️|🚣🏾‍♂️|🚣🏿‍♂️|🚣🏻‍♀️|🚣🏼‍♀️|🚣🏽‍♀️|🚣🏾‍♀️|🚣🏿‍♀️|🏊🏻‍♂️|🏊🏼‍♂️|🏊🏽‍♂️|🏊🏾‍♂️|🏊🏿‍♂️|🏊🏻‍♀️|🏊🏼‍♀️|🏊🏽‍♀️|🏊🏾‍♀️|🏊🏿‍♀️|🏋🏻‍♂️|🏋🏼‍♂️|🏋🏽‍♂️|🏋🏾‍♂️|🏋🏿‍♂️|🏋🏻‍♀️|🏋🏼‍♀️|🏋🏽‍♀️|🏋🏾‍♀️|🏋🏿‍♀️|🚴🏻‍♂️|🚴🏼‍♂️|🚴🏽‍♂️|🚴🏾‍♂️|🚴🏿‍♂️|🚴🏻‍♀️|🚴🏼‍♀️|🚴🏽‍♀️|🚴🏾‍♀️|🚴🏿‍♀️|🚵🏻‍♂️|🚵🏼‍♂️|🚵🏽‍♂️|🚵🏾‍♂️|🚵🏿‍♂️|🚵🏻‍♀️|🚵🏼‍♀️|🚵🏽‍♀️|🚵🏾‍♀️|🚵🏿‍♀️|🤸🏻‍♂️|🤸🏼‍♂️|🤸🏽‍♂️|🤸🏾‍♂️|🤸🏿‍♂️|🤸🏻‍♀️|🤸🏼‍♀️|🤸🏽‍♀️|🤸🏾‍♀️|🤸🏿‍♀️|🤽🏻‍♂️|🤽🏼‍♂️|🤽🏽‍♂️|🤽🏾‍♂️|🤽🏿‍♂️|🤽🏻‍♀️|🤽🏼‍♀️|🤽🏽‍♀️|🤽🏾‍♀️|🤽🏿‍♀️|🤾🏻‍♂️|🤾🏼‍♂️|🤾🏽‍♂️|🤾🏾‍♂️|🤾🏿‍♂️|🤾🏻‍♀️|🤾🏼‍♀️|🤾🏽‍♀️|🤾🏾‍♀️|🤾🏿‍♀️|🤹🏻‍♂️|🤹🏼‍♂️|🤹🏽‍♂️|🤹🏾‍♂️|🤹🏿‍♂️|🤹🏻‍♀️|🤹🏼‍♀️|🤹🏽‍♀️|🤹🏾‍♀️|🤹🏿‍♀️|🧘🏻‍♂️|🧘🏼‍♂️|🧘🏽‍♂️|🧘🏾‍♂️|🧘🏿‍♂️|🧘🏻‍♀️|🧘🏼‍♀️|🧘🏽‍♀️|🧘🏾‍♀️|🧘🏿‍♀️|😶‍🌫️|🕵️‍♂️|🕵️‍♀️|🏌️‍♂️|🏌️‍♀️|🏋️‍♂️|🏋️‍♀️|🏳️‍🌈|🏳️‍⚧️|⛹🏻‍♂️|⛹🏼‍♂️|⛹🏽‍♂️|⛹🏾‍♂️|⛹🏿‍♂️|⛹🏻‍♀️|⛹🏼‍♀️|⛹🏽‍♀️|⛹🏾‍♀️|⛹🏿‍♀️|😮‍💨|😵‍💫|❤️‍🔥|❤️‍🩹|🧔‍♂️|🧔‍♀️|👨‍🦰|👨‍🦱|👨‍🦳|👨‍🦲|👩‍🦰|🧑‍🦰|👩‍🦱|🧑‍🦱|👩‍🦳|🧑‍🦳|👩‍🦲|🧑‍🦲|👱‍♀️|👱‍♂️|🙍‍♂️|🙍‍♀️|🙎‍♂️|🙎‍♀️|🙅‍♂️|🙅‍♀️|🙆‍♂️|🙆‍♀️|💁‍♂️|💁‍♀️|🙋‍♂️|🙋‍♀️|🧏‍♂️|🧏‍♀️|🙇‍♂️|🙇‍♀️|🤦‍♂️|🤦‍♀️|🤷‍♂️|🤷‍♀️|🧑‍⚕️|👨‍⚕️|👩‍⚕️|🧑‍🎓|👨‍🎓|👩‍🎓|🧑‍🏫|👨‍🏫|👩‍🏫|🧑‍⚖️|👨‍⚖️|👩‍⚖️|🧑‍🌾|👨‍🌾|👩‍🌾|🧑‍🍳|👨‍🍳|👩‍🍳|🧑‍🔧|👨‍🔧|👩‍🔧|🧑‍🏭|👨‍🏭|👩‍🏭|🧑‍💼|👨‍💼|👩‍💼|🧑‍🔬|👨‍🔬|👩‍🔬|🧑‍💻|👨‍💻|👩‍💻|🧑‍🎤|👨‍🎤|👩‍🎤|🧑‍🎨|👨‍🎨|👩‍🎨|🧑‍✈️|👨‍✈️|👩‍✈️|🧑‍🚀|👨‍🚀|👩‍🚀|🧑‍🚒|👨‍🚒|👩‍🚒|👮‍♂️|👮‍♀️|💂‍♂️|💂‍♀️|👷‍♂️|👷‍♀️|👳‍♂️|👳‍♀️|🤵‍♂️|🤵‍♀️|👰‍♂️|👰‍♀️|👩‍🍼|👨‍🍼|🧑‍🍼|🧑‍🎄|🦸‍♂️|🦸‍♀️|🦹‍♂️|🦹‍♀️|🧙‍♂️|🧙‍♀️|🧚‍♂️|🧚‍♀️|🧛‍♂️|🧛‍♀️|🧜‍♂️|🧜‍♀️|🧝‍♂️|🧝‍♀️|🧞‍♂️|🧞‍♀️|🧟‍♂️|🧟‍♀️|💆‍♂️|💆‍♀️|💇‍♂️|💇‍♀️|🚶‍♂️|🚶‍♀️|🧍‍♂️|🧍‍♀️|🧎‍♂️|🧎‍♀️|🧑‍🦯|👨‍🦯|👩‍🦯|🧑‍🦼|👨‍🦼|👩‍🦼|🧑‍🦽|👨‍🦽|👩‍🦽|🏃‍♂️|🏃‍♀️|👯‍♂️|👯‍♀️|🧖‍♂️|🧖‍♀️|🧗‍♂️|🧗‍♀️|🏄‍♂️|🏄‍♀️|🚣‍♂️|🚣‍♀️|🏊‍♂️|🏊‍♀️|⛹️‍♂️|⛹️‍♀️|🚴‍♂️|🚴‍♀️|🚵‍♂️|🚵‍♀️|🤸‍♂️|🤸‍♀️|🤼‍♂️|🤼‍♀️|🤽‍♂️|🤽‍♀️|🤾‍♂️|🤾‍♀️|🤹‍♂️|🤹‍♀️|🧘‍♂️|🧘‍♀️|👨‍👦|👨‍👧|👩‍👦|👩‍👧|🐕‍🦺|🐻‍❄️|🏴‍☠️|🐈‍⬛|🇦🇨|🇦🇩|🇦🇪|🇦🇫|🇦🇬|🇦🇮|🇦🇱|🇦🇲|🇦🇴|🇦🇶|🇦🇷|🇦🇸|🇦🇹|🇦🇺|🇦🇼|🇦🇽|🇦🇿|🇧🇦|🇧🇧|🇧🇩|🇧🇪|🇧🇫|🇧🇬|🇧🇭|🇧🇮|🇧🇯|🇧🇱|🇧🇲|🇧🇳|🇧🇴|🇧🇶|🇧🇷|🇧🇸|🇧🇹|🇧🇻|🇧🇼|🇧🇾|🇧🇿|🇨🇦|🇨🇨|🇨🇩|🇨🇫|🇨🇬|🇨🇭|🇨🇮|🇨🇰|🇨🇱|🇨🇲|🇨🇳|🇨🇴|🇨🇵|🇨🇷|🇨🇺|🇨🇻|🇨🇼|🇨🇽|🇨🇾|🇨🇿|🇩🇪|🇩🇬|🇩🇯|🇩🇰|🇩🇲|🇩🇴|🇩🇿|🇪🇦|🇪🇨|🇪🇪|🇪🇬|🇪🇭|🇪🇷|🇪🇸|🇪🇹|🇪🇺|🇫🇮|🇫🇯|🇫🇰|🇫🇲|🇫🇴|🇫🇷|🇬🇦|🇬🇧|🇬🇩|🇬🇪|🇬🇫|🇬🇬|🇬🇭|🇬🇮|🇬🇱|🇬🇲|🇬🇳|🇬🇵|🇬🇶|🇬🇷|🇬🇸|🇬🇹|🇬🇺|🇬🇼|🇬🇾|🇭🇰|🇭🇲|🇭🇳|🇭🇷|🇭🇹|🇭🇺|🇮🇨|🇮🇩|🇮🇪|🇮🇱|🇮🇲|🇮🇳|🇮🇴|🇮🇶|🇮🇷|🇮🇸|🇮🇹|🇯🇪|🇯🇲|🇯🇴|🇯🇵|🇰🇪|🇰🇬|🇰🇭|🇰🇮|🇰🇲|🇰🇳|🇰🇵|🇰🇷|🇰🇼|🇰🇾|🇰🇿|🇱🇦|🇱🇧|🇱🇨|🇱🇮|🇱🇰|🇱🇷|🇱🇸|🇱🇹|🇱🇺|🇱🇻|🇱🇾|🇲🇦|🇲🇨|🇲🇩|🇲🇪|🇲🇫|🇲🇬|🇲🇭|🇲🇰|🇲🇱|🇲🇲|🇲🇳|🇲🇴|🇲🇵|🇲🇶|🇲🇷|🇲🇸|🇲🇹|🇲🇺|🇲🇻|🇲🇼|🇲🇽|🇲🇾|🇲🇿|🇳🇦|🇳🇨|🇳🇪|🇳🇫|🇳🇬|🇳🇮|🇳🇱|🇳🇴|🇳🇵|🇳🇷|🇳🇺|🇳🇿|🇴🇲|🇵🇦|🇵🇪|🇵🇫|🇵🇬|🇵🇭|🇵🇰|🇵🇱|🇵🇲|🇵🇳|🇵🇷|🇵🇸|🇵🇹|🇵🇼|🇵🇾|🇶🇦|🇷🇪|🇷🇴|🇷🇸|🇷🇺|🇷🇼|🇸🇦|🇸🇧|🇸🇨|🇸🇩|🇸🇪|🇸🇬|🇸🇭|🇸🇮|🇸🇯|🇸🇰|🇸🇱|🇸🇲|🇸🇳|🇸🇴|🇸🇷|🇸🇸|🇸🇹|🇸🇻|🇸🇽|🇸🇾|🇸🇿|🇹🇦|🇹🇨|🇹🇩|🇹🇫|🇹🇬|🇹🇭|🇹🇯|🇹🇰|🇹🇱|🇹🇲|🇹🇳|🇹🇴|🇹🇷|🇹🇹|🇹🇻|🇹🇼|🇹🇿|🇺🇦|🇺🇬|🇺🇲|🇺🇳|🇺🇸|🇺🇾|🇺🇿|🇻🇦|🇻🇨|🇻🇪|🇻🇬|🇻🇮|🇻🇳|🇻🇺|🇼🇫|🇼🇸|🇽🇰|🇾🇪|🇾🇹|🇿🇦|🇿🇲|🇿🇼|👋🏻|👋🏼|👋🏽|👋🏾|👋🏿|🤚🏻|🤚🏼|🤚🏽|🤚🏾|🤚🏿|🖐🏻|🖐🏼|🖐🏽|🖐🏾|🖐🏿|🖖🏻|🖖🏼|🖖🏽|🖖🏾|🖖🏿|👌🏻|👌🏼|👌🏽|👌🏾|👌🏿|🤌🏻|🤌🏼|🤌🏽|🤌🏾|🤌🏿|🤏🏻|🤏🏼|🤏🏽|🤏🏾|🤏🏿|🤞🏻|🤞🏼|🤞🏽|🤞🏾|🤞🏿|🤟🏻|🤟🏼|🤟🏽|🤟🏾|🤟🏿|🤘🏻|🤘🏼|🤘🏽|🤘🏾|🤘🏿|🤙🏻|🤙🏼|🤙🏽|🤙🏾|🤙🏿|👈🏻|👈🏼|👈🏽|👈🏾|👈🏿|👉🏻|👉🏼|👉🏽|👉🏾|👉🏿|👆🏻|👆🏼|👆🏽|👆🏾|👆🏿|🖕🏻|🖕🏼|🖕🏽|🖕🏾|🖕🏿|👇🏻|👇🏼|👇🏽|👇🏾|👇🏿|👍🏻|👍🏼|👍🏽|👍🏾|👍🏿|👎🏻|👎🏼|👎🏽|👎🏾|👎🏿|👊🏻|👊🏼|👊🏽|👊🏾|👊🏿|🤛🏻|🤛🏼|🤛🏽|🤛🏾|🤛🏿|🤜🏻|🤜🏼|🤜🏽|🤜🏾|🤜🏿|👏🏻|👏🏼|👏🏽|👏🏾|👏🏿|🙌🏻|🙌🏼|🙌🏽|🙌🏾|🙌🏿|👐🏻|👐🏼|👐🏽|👐🏾|👐🏿|🤲🏻|🤲🏼|🤲🏽|🤲🏾|🤲🏿|🙏🏻|🙏🏼|🙏🏽|🙏🏾|🙏🏿|💅🏻|💅🏼|💅🏽|💅🏾|💅🏿|🤳🏻|🤳🏼|🤳🏽|🤳🏾|🤳🏿|💪🏻|💪🏼|💪🏽|💪🏾|💪🏿|🦵🏻|🦵🏼|🦵🏽|🦵🏾|🦵🏿|🦶🏻|🦶🏼|🦶🏽|🦶🏾|🦶🏿|👂🏻|👂🏼|👂🏽|👂🏾|👂🏿|🦻🏻|🦻🏼|🦻🏽|🦻🏾|🦻🏿|👃🏻|👃🏼|👃🏽|👃🏾|👃🏿|👶🏻|👶🏼|👶🏽|👶🏾|👶🏿|🧒🏻|🧒🏼|🧒🏽|🧒🏾|🧒🏿|👦🏻|👦🏼|👦🏽|👦🏾|👦🏿|👧🏻|👧🏼|👧🏽|👧🏾|👧🏿|🧑🏻|🧑🏼|🧑🏽|🧑🏾|🧑🏿|👱🏻|👱🏼|👱🏽|👱🏾|👱🏿|👨🏻|👨🏼|👨🏽|👨🏾|👨🏿|🧔🏻|🧔🏼|🧔🏽|🧔🏾|🧔🏿|👩🏻|👩🏼|👩🏽|👩🏾|👩🏿|🧓🏻|🧓🏼|🧓🏽|🧓🏾|🧓🏿|👴🏻|👴🏼|👴🏽|👴🏾|👴🏿|👵🏻|👵🏼|👵🏽|👵🏾|👵🏿|🙍🏻|🙍🏼|🙍🏽|🙍🏾|🙍🏿|🙎🏻|🙎🏼|🙎🏽|🙎🏾|🙎🏿|🙅🏻|🙅🏼|🙅🏽|🙅🏾|🙅🏿|🙆🏻|🙆🏼|🙆🏽|🙆🏾|🙆🏿|💁🏻|💁🏼|💁🏽|💁🏾|💁🏿|🙋🏻|🙋🏼|🙋🏽|🙋🏾|🙋🏿|🧏🏻|🧏🏼|🧏🏽|🧏🏾|🧏🏿|🙇🏻|🙇🏼|🙇🏽|🙇🏾|🙇🏿|🤦🏻|🤦🏼|🤦🏽|🤦🏾|🤦🏿|🤷🏻|🤷🏼|🤷🏽|🤷🏾|🤷🏿|👮🏻|👮🏼|👮🏽|👮🏾|👮🏿|🕵🏻|🕵🏼|🕵🏽|🕵🏾|🕵🏿|💂🏻|💂🏼|💂🏽|💂🏾|💂🏿|🥷🏻|🥷🏼|🥷🏽|🥷🏾|🥷🏿|👷🏻|👷🏼|👷🏽|👷🏾|👷🏿|🤴🏻|🤴🏼|🤴🏽|🤴🏾|🤴🏿|👸🏻|👸🏼|👸🏽|👸🏾|👸🏿|👳🏻|👳🏼|👳🏽|👳🏾|👳🏿|👲🏻|👲🏼|👲🏽|👲🏾|👲🏿|🧕🏻|🧕🏼|🧕🏽|🧕🏾|🧕🏿|🤵🏻|🤵🏼|🤵🏽|🤵🏾|🤵🏿|👰🏻|👰🏼|👰🏽|👰🏾|👰🏿|🤰🏻|🤰🏼|🤰🏽|🤰🏾|🤰🏿|🤱🏻|🤱🏼|🤱🏽|🤱🏾|🤱🏿|👼🏻|👼🏼|👼🏽|👼🏾|👼🏿|🎅🏻|🎅🏼|🎅🏽|🎅🏾|🎅🏿|🤶🏻|🤶🏼|🤶🏽|🤶🏾|🤶🏿|🦸🏻|🦸🏼|🦸🏽|🦸🏾|🦸🏿|🦹🏻|🦹🏼|🦹🏽|🦹🏾|🦹🏿|🧙🏻|🧙🏼|🧙🏽|🧙🏾|🧙🏿|🧚🏻|🧚🏼|🧚🏽|🧚🏾|🧚🏿|🧛🏻|🧛🏼|🧛🏽|🧛🏾|🧛🏿|🧜🏻|🧜🏼|🧜🏽|🧜🏾|🧜🏿|🧝🏻|🧝🏼|🧝🏽|🧝🏾|🧝🏿|💆🏻|💆🏼|💆🏽|💆🏾|💆🏿|💇🏻|💇🏼|💇🏽|💇🏾|💇🏿|🚶🏻|🚶🏼|🚶🏽|🚶🏾|🚶🏿|🧍🏻|🧍🏼|🧍🏽|🧍🏾|🧍🏿|🧎🏻|🧎🏼|🧎🏽|🧎🏾|🧎🏿|🏃🏻|🏃🏼|🏃🏽|🏃🏾|🏃🏿|💃🏻|💃🏼|💃🏽|💃🏾|💃🏿|🕺🏻|🕺🏼|🕺🏽|🕺🏾|🕺🏿|🕴🏻|🕴🏼|🕴🏽|🕴🏾|🕴🏿|🧖🏻|🧖🏼|🧖🏽|🧖🏾|🧖🏿|🧗🏻|🧗🏼|🧗🏽|🧗🏾|🧗🏿|🏇🏻|🏇🏼|🏇🏽|🏇🏾|🏇🏿|🏂🏻|🏂🏼|🏂🏽|🏂🏾|🏂🏿|🏌🏻|🏌🏼|🏌🏽|🏌🏾|🏌🏿|🏄🏻|🏄🏼|🏄🏽|🏄🏾|🏄🏿|🚣🏻|🚣🏼|🚣🏽|🚣🏾|🚣🏿|🏊🏻|🏊🏼|🏊🏽|🏊🏾|🏊🏿|🏋🏻|🏋🏼|🏋🏽|🏋🏾|🏋🏿|🚴🏻|🚴🏼|🚴🏽|🚴🏾|🚴🏿|🚵🏻|🚵🏼|🚵🏽|🚵🏾|🚵🏿|🤸🏻|🤸🏼|🤸🏽|🤸🏾|🤸🏿|🤽🏻|🤽🏼|🤽🏽|🤽🏾|🤽🏿|🤾🏻|🤾🏼|🤾🏽|🤾🏾|🤾🏿|🤹🏻|🤹🏼|🤹🏽|🤹🏾|🤹🏿|🧘🏻|🧘🏼|🧘🏽|🧘🏾|🧘🏿|🛀🏻|🛀🏼|🛀🏽|🛀🏾|🛀🏿|🛌🏻|🛌🏼|🛌🏽|🛌🏾|🛌🏿|👭🏻|👭🏼|👭🏽|👭🏾|👭🏿|👫🏻|👫🏼|👫🏽|👫🏾|👫🏿|👬🏻|👬🏼|👬🏽|👬🏾|👬🏿|💏🏻|💏🏼|💏🏽|💏🏾|💏🏿|💑🏻|💑🏼|💑🏽|💑🏾|💑🏿|#️⃣|0️⃣|1️⃣|2️⃣|3️⃣|4️⃣|5️⃣|6️⃣|7️⃣|8️⃣|9️⃣|✋🏻|✋🏼|✋🏽|✋🏾|✋🏿|✌🏻|✌🏼|✌🏽|✌🏾|✌🏿|☝🏻|☝🏼|☝🏽|☝🏾|☝🏿|✊🏻|✊🏼|✊🏽|✊🏾|✊🏿|✍🏻|✍🏼|✍🏽|✍🏾|✍🏿|⛹🏻|⛹🏼|⛹🏽|⛹🏾|⛹🏿|😀|😃|😄|😁|😆|😅|🤣|😂|🙂|🙃|😉|😊|😇|🥰|😍|🤩|😘|😗|😚|😙|🥲|😋|😛|😜|🤪|😝|🤑|🤗|🤭|🤫|🤔|🤐|🤨|😐|😑|😶|😏|😒|🙄|😬|🤥|😌|😔|😪|🤤|😴|😷|🤒|🤕|🤢|🤮|🤧|🥵|🥶|🥴|😵|🤯|🤠|🥳|🥸|😎|🤓|🧐|😕|😟|🙁|😮|😯|😲|😳|🥺|😦|😧|😨|😰|😥|😢|😭|😱|😖|😣|😞|😓|😩|😫|🥱|😤|😡|😠|🤬|😈|👿|💀|💩|🤡|👹|👺|👻|👽|👾|🤖|😺|😸|😹|😻|😼|😽|🙀|😿|😾|🙈|🙉|🙊|💋|💌|💘|💝|💖|💗|💓|💞|💕|💟|💔|🧡|💛|💚|💙|💜|🤎|🖤|🤍|💯|💢|💥|💫|💦|💨|🕳|💣|💬|🗨|🗯|💭|💤|👋|🤚|🖐|🖖|👌|🤌|🤏|🤞|🤟|🤘|🤙|👈|👉|👆|🖕|👇|👍|👎|👊|🤛|🤜|👏|🙌|👐|🤲|🤝|🙏|💅|🤳|💪|🦾|🦿|🦵|🦶|👂|🦻|👃|🧠|🫀|🫁|🦷|🦴|👀|👁|👅|👄|👶|🧒|👦|👧|🧑|👱|👨|🧔|👩|🧓|👴|👵|🙍|🙎|🙅|🙆|💁|🙋|🧏|🙇|🤦|🤷|👮|🕵|💂|🥷|👷|🤴|👸|👳|👲|🧕|🤵|👰|🤰|🤱|👼|🎅|🤶|🦸|🦹|🧙|🧚|🧛|🧜|🧝|🧞|🧟|💆|💇|🚶|🧍|🧎|🏃|💃|🕺|🕴|👯|🧖|🧗|🤺|🏇|🏂|🏌|🏄|🚣|🏊|🏋|🚴|🚵|🤸|🤼|🤽|🤾|🤹|🧘|🛀|🛌|👭|👫|👬|💏|💑|👪|🗣|👤|👥|🫂|👣|🦰|🦱|🦳|🦲|🐵|🐒|🦍|🦧|🐶|🐕|🦮|🐩|🐺|🦊|🦝|🐱|🐈|🦁|🐯|🐅|🐆|🐴|🐎|🦄|🦓|🦌|🦬|🐮|🐂|🐃|🐄|🐷|🐖|🐗|🐽|🐏|🐑|🐐|🐪|🐫|🦙|🦒|🐘|🦣|🦏|🦛|🐭|🐁|🐀|🐹|🐰|🐇|🐿|🦫|🦔|🦇|🐻|🐨|🐼|🦥|🦦|🦨|🦘|🦡|🐾|🦃|🐔|🐓|🐣|🐤|🐥|🐦|🐧|🕊|🦅|🦆|🦢|🦉|🦤|🪶|🦩|🦚|🦜|🐸|🐊|🐢|🦎|🐍|🐲|🐉|🦕|🦖|🐳|🐋|🐬|🦭|🐟|🐠|🐡|🦈|🐙|🐚|🐌|🦋|🐛|🐜|🐝|🪲|🐞|🦗|🪳|🕷|🕸|🦂|🦟|🪰|🪱|🦠|💐|🌸|💮|🏵|🌹|🥀|🌺|🌻|🌼|🌷|🌱|🪴|🌲|🌳|🌴|🌵|🌾|🌿|🍀|🍁|🍂|🍃|🍇|🍈|🍉|🍊|🍋|🍌|🍍|🥭|🍎|🍏|🍐|🍑|🍒|🍓|🫐|🥝|🍅|🫒|🥥|🥑|🍆|🥔|🥕|🌽|🌶|🫑|🥒|🥬|🥦|🧄|🧅|🍄|🥜|🌰|🍞|🥐|🥖|🫓|🥨|🥯|🥞|🧇|🧀|🍖|🍗|🥩|🥓|🍔|🍟|🍕|🌭|🥪|🌮|🌯|🫔|🥙|🧆|🥚|🍳|🥘|🍲|🫕|🥣|🥗|🍿|🧈|🧂|🥫|🍱|🍘|🍙|🍚|🍛|🍜|🍝|🍠|🍢|🍣|🍤|🍥|🥮|🍡|🥟|🥠|🥡|🦀|🦞|🦐|🦑|🦪|🍦|🍧|🍨|🍩|🍪|🎂|🍰|🧁|🥧|🍫|🍬|🍭|🍮|🍯|🍼|🥛|🫖|🍵|🍶|🍾|🍷|🍸|🍹|🍺|🍻|🥂|🥃|🥤|🧋|🧃|🧉|🧊|🥢|🍽|🍴|🥄|🔪|🏺|🌍|🌎|🌏|🌐|🗺|🗾|🧭|🏔|🌋|🗻|🏕|🏖|🏜|🏝|🏞|🏟|🏛|🏗|🧱|🪨|🪵|🛖|🏘|🏚|🏠|🏡|🏢|🏣|🏤|🏥|🏦|🏨|🏩|🏪|🏫|🏬|🏭|🏯|🏰|💒|🗼|🗽|🕌|🛕|🕍|🕋|🌁|🌃|🏙|🌄|🌅|🌆|🌇|🌉|🎠|🎡|🎢|💈|🎪|🚂|🚃|🚄|🚅|🚆|🚇|🚈|🚉|🚊|🚝|🚞|🚋|🚌|🚍|🚎|🚐|🚑|🚒|🚓|🚔|🚕|🚖|🚗|🚘|🚙|🛻|🚚|🚛|🚜|🏎|🏍|🛵|🦽|🦼|🛺|🚲|🛴|🛹|🛼|🚏|🛣|🛤|🛢|🚨|🚥|🚦|🛑|🚧|🛶|🚤|🛳|🛥|🚢|🛩|🛫|🛬|🪂|💺|🚁|🚟|🚠|🚡|🛰|🚀|🛸|🛎|🧳|🕰|🕛|🕧|🕐|🕜|🕑|🕝|🕒|🕞|🕓|🕟|🕔|🕠|🕕|🕡|🕖|🕢|🕗|🕣|🕘|🕤|🕙|🕥|🕚|🕦|🌑|🌒|🌓|🌔|🌕|🌖|🌗|🌘|🌙|🌚|🌛|🌜|🌡|🌝|🌞|🪐|🌟|🌠|🌌|🌤|🌥|🌦|🌧|🌨|🌩|🌪|🌫|🌬|🌀|🌈|🌂|🔥|💧|🌊|🎃|🎄|🎆|🎇|🧨|🎈|🎉|🎊|🎋|🎍|🎎|🎏|🎐|🎑|🧧|🎀|🎁|🎗|🎟|🎫|🎖|🏆|🏅|🥇|🥈|🥉|🥎|🏀|🏐|🏈|🏉|🎾|🥏|🎳|🏏|🏑|🏒|🥍|🏓|🏸|🥊|🥋|🥅|🎣|🤿|🎽|🎿|🛷|🥌|🎯|🪀|🪁|🎱|🔮|🪄|🧿|🎮|🕹|🎰|🎲|🧩|🧸|🪅|🪆|🃏|🀄|🎴|🎭|🖼|🎨|🧵|🪡|🧶|🪢|👓|🕶|🥽|🥼|🦺|👔|👕|👖|🧣|🧤|🧥|🧦|👗|👘|🥻|🩱|🩲|🩳|👙|👚|👛|👜|👝|🛍|🎒|🩴|👞|👟|🥾|🥿|👠|👡|🩰|👢|👑|👒|🎩|🎓|🧢|🪖|📿|💄|💍|💎|🔇|🔈|🔉|🔊|📢|📣|📯|🔔|🔕|🎼|🎵|🎶|🎙|🎚|🎛|🎤|🎧|📻|🎷|🪗|🎸|🎹|🎺|🎻|🪕|🥁|🪘|📱|📲|📞|📟|📠|🔋|🔌|💻|🖥|🖨|🖱|🖲|💽|💾|💿|📀|🧮|🎥|🎞|📽|🎬|📺|📷|📸|📹|📼|🔍|🔎|🕯|💡|🔦|🏮|🪔|📔|📕|📖|📗|📘|📙|📚|📓|📒|📃|📜|📄|📰|🗞|📑|🔖|🏷|💰|🪙|💴|💵|💶|💷|💸|💳|🧾|💹|📧|📨|📩|📤|📥|📦|📫|📪|📬|📭|📮|🗳|🖋|🖊|🖌|🖍|📝|💼|📁|📂|🗂|📅|📆|🗒|🗓|📇|📈|📉|📊|📋|📌|📍|📎|🖇|📏|📐|🗃|🗄|🗑|🔒|🔓|🔏|🔐|🔑|🗝|🔨|🪓|🛠|🗡|🔫|🪃|🏹|🛡|🪚|🔧|🪛|🔩|🗜|🦯|🔗|🪝|🧰|🧲|🪜|🧪|🧫|🧬|🔬|🔭|📡|💉|🩸|💊|🩹|🩺|🚪|🛗|🪞|🪟|🛏|🛋|🪑|🚽|🪠|🚿|🛁|🪤|🪒|🧴|🧷|🧹|🧺|🧻|🪣|🧼|🪥|🧽|🧯|🛒|🚬|🪦|🗿|🪧|🏧|🚮|🚰|🚹|🚺|🚻|🚼|🚾|🛂|🛃|🛄|🛅|🚸|🚫|🚳|🚭|🚯|🚱|🚷|📵|🔞|🔃|🔄|🔙|🔚|🔛|🔜|🔝|🛐|🕉|🕎|🔯|🔀|🔁|🔂|🔼|🔽|🎦|🔅|🔆|📶|📳|📴|💱|💲|🔱|📛|🔰|🔟|🔠|🔡|🔢|🔣|🔤|🅰|🆎|🅱|🆑|🆒|🆓|🆔|🆕|🆖|🅾|🆗|🅿|🆘|🆙|🆚|🈁|🈂|🈷|🈶|🈯|🉐|🈹|🈚|🈲|🉑|🈸|🈴|🈳|🈺|🈵|🔴|🟠|🟡|🟢|🔵|🟣|🟤|🟥|🟧|🟨|🟩|🟦|🟪|🟫|🔶|🔷|🔸|🔹|🔺|🔻|💠|🔘|🔳|🔲|🏁|🚩|🎌|🏴|🏳|🏻|🏼|🏽|🏾|🏿|☺|☹|☠|❣|❤|✋|✌|☝|✊|✍|⛷|⛹|☘|☕|⛰|⛪|⛩|⛲|⛺|♨|⛽|⚓|⛵|⛴|✈|⌛|⏳|⌚|⏰|⏱|⏲|☀|⭐|☁|⛅|⛈|☂|☔|⛱|⚡|❄|☃|⛄|☄|✨|⚽|⚾|⛳|⛸|♠|♥|♦|♣|♟|⛑|☎|⌨|✉|✏|✒|✂|⛏|⚒|⚔|⚙|⚖|⛓|⚗|⚰|⚱|♿|⚠|⛔|☢|☣|⬆|↗|➡|↘|⬇|↙|⬅|↖|↕|↔|↩|↪|⤴|⤵|⚛|✡|☸|☯|✝|☦|☪|☮|♈|♉|♊|♋|♌|♍|♎|♏|♐|♑|♒|♓|⛎|▶|⏩|⏭|⏯|◀|⏪|⏮|⏫|⏬|⏸|⏹|⏺|⏏|♀|♂|⚧|✖|➕|➖|➗|♾|‼|⁉|❓|❔|❕|❗|〰|⚕|♻|⚜|⭕|✅|☑|✔|❌|❎|➰|➿|〽|✳|✴|❇|©|®|™|ℹ|Ⓜ|㊗|㊙|⚫|⚪|⬛|⬜|◼|◻|◾|◽|▪|▫)`

export const P5REASSIGN_COUNTER = 5000

export const DAYS_ARR = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]

export const ALLDEFAULTIMGS = [ // for invitationedit, and simulator
    `${S3CLOUD_CLOUDFRONT_ASSET}couple/couple1_lg.png`,
    `${S3CLOUD_CLOUDFRONT_ASSET}couple/couple1_sm.png`,
    `${S3CLOUD_CLOUDFRONT_ASSET}couple/couple3_lg.png`,
    `${S3CLOUD_CLOUDFRONT_ASSET}couple/couple3_sm.png`,
    `${S3CLOUD_CLOUDFRONT_ASSET}couple/couple5_lg.png`,
    `${S3CLOUD_CLOUDFRONT_ASSET}couple/couple5_sm.png`,
    `${S3CLOUD_CLOUDFRONT_ASSET}couple/couple7_lg.png`,
    `${S3CLOUD_CLOUDFRONT_ASSET}couple/couple7_sm.png`,
    `${S3CLOUD_CLOUDFRONT_ASSET}couple/couple8_lg.png`,
    `${S3CLOUD_CLOUDFRONT_ASSET}couple/couple8_sm.png`,
    `${S3CLOUD_CLOUDFRONT_ASSET}couple/couple10_lg.png`,
    `${S3CLOUD_CLOUDFRONT_ASSET}couple/couple10_sm.png`,
    `${S3CLOUD_CLOUDFRONT_ASSET}couple/couple11_lg.png`,
    `${S3CLOUD_CLOUDFRONT_ASSET}couple/couple11_sm.png`,
    `${S3CLOUD_CLOUDFRONT_ASSET}couple/couple13_lg.png`,
    `${S3CLOUD_CLOUDFRONT_ASSET}couple/couple13_sm.png`,
]

export const VENUE_RATING_TEXT_MAP = {
    venuerating0: 'How was the venue?',
    venuerating1: 'How was the service?',
    venuerating2: 'How was the food?'
}

export const TIER_DIAMOND_POSITION = [
    { y: 2 }, // nothing
    { y: 2 }, // bronze
    { y: -21 }, // silver
    { y: -45 } // gold
]

export const TIER_DIAMOND_POSITION_EXCEL = [
    { y: 2 }, // nothing
    { y: 2 }, // bronze
    { y: -12 }, // silver
    { y: -24 } // gold
]

export const TIER_DIAMOND_POSITION_VL = [
    { y: 2 }, // nothing
    { y: 2 }, // bronze
    { y: -19 }, // silver
    { y: -38 } // gold
]

export const ILOOKUPTEMPLATESINFO_MAP = {
    1: {// TEMPLATE_CARDPAGE
        'single': {
            img_dimension: ['portrait', 'landscape'], // all image will be cropped to portrait image
            img_edit: {
                neededit: true,
                aspectratio: 4 / 5
            },
            img_style: {
                imgcss: {
                    borderRadius: true,
                    boxShadow: true,
                    webimgconstant: 0.8,
                    tabletimgconstant: 0.9
                }
            }
        },
        'marquee': {
            img_dimension: ['portrait', 'landscape'],// all image will be cropped to portrait image
            img_edit: {
                neededit: true,
                aspectratio: 4 / 5,
            },
            img_style: {
                imgcss: {
                    borderRadius: true,
                    boxShadow: true,
                    webimgconstant: 0.8,
                    tabletimgconstant: 0.9
                }
            }
        },
        'slideshow': {
            img_dimension: ['portrait', 'landscape'], // all image will be cropped to portrait image
            img_edit: {
                neededit: true,
                aspectratio: 4 / 5
            },
            img_style: {
                imgcss: {
                    borderRadius: true,
                    boxShadow: true,
                    webimgconstant: 0.8,
                    tabletimgconstant: 0.9
                }
            }
        }
    },
    2: { // TEMPLATE_FULLPAGE
        'single': {
            img_dimension: ['portrait', 'landscape'],
            img_edit: {
                neededit: true,
                aspectratio: 16 / 9
                // aspectratio: 4 / 3, // edit image to landscape only
            },
            img_style: {
                imgcss: {

                }
            }
        },
        'marquee': {
            img_dimension: ['portrait', 'landscape'],
            img_edit: {
                neededit: true,
                aspectratio: 'BASED_ON_IMAGE'
                // aspectratio: 1/1
            },
            img_style: {
                imgcss: {

                }
            }
        },
        'slideshow': {
            img_dimension: ['portrait', 'landscape'],
            img_edit: {
                neededit: true,
                aspectratio: 16 / 9
                // aspectratio: 4 / 3, // edit image to landscape only
            },
            img_style: {
                imgcss: {

                }
            }
        }
    }
}

export const INVITATION_COUPLE_DEFAULT_IMGS_MAP = {

    // 1 TEMPLATE_CARDPAGE - all portrait images
    'single_1': [
        { img: '0000couple_p_lg.png', thumbnail: '0000couple_p_sm.png' }
    ],
    "marquee_1": [
        { img: '0000couple_p_lg.png', thumbnail: '0000couple_p_sm.png' },
        { img: '0001couple_p_lg.png', thumbnail: '0001couple_p_sm.png' },
        { img: '0010couple_p_lg.png', thumbnail: '0010couple_p_sm.png' },
        { img: '0011couple_p_lg.png', thumbnail: '0011couple_p_sm.png' },
    ],
    "slideshow_1": [
        { img: '0000couple_p_lg.png', thumbnail: '0000couple_p_sm.png' },
        { img: '0001couple_p_lg.png', thumbnail: '0001couple_p_sm.png' },
    ],

    // 2 TEMPLATE_FULLPAGE - all landscape images
    'single_2': [
        { img: '0000couple_l_lg.png', thumbnail: '0000couple_l_sm.png' }
    ],
    "marquee_2": [
        { img: '0000couple_l_lg.png', thumbnail: '0000couple_l_sm.png' },
        { img: '0001couple_l_lg.png', thumbnail: '0001couple_l_sm.png' },
        { img: '0010couple_l_lg.png', thumbnail: '0010couple_l_sm.png' },
        { img: '0011couple_l_lg.png', thumbnail: '0011couple_l_sm.png' },
    ],
    "slideshow_2": [
        { img: '0000couple_l_lg.png', thumbnail: '0000couple_l_sm.png' },
        { img: '0001couple_l_lg.png', thumbnail: '0001couple_l_sm.png' },
    ],

    // 3 coming soon
    'single_3': [],
    "marquee_3": [],
    "slideshow_3": [],

    // 4 coming soon
    'single_4': [],
    "marquee_4": [],
    "slideshow_4": [],

    // 5 coming soon
    'single_5': [],
    "marquee_5": [],
    "slideshow_5": [],
}

export const guestbookstub = '■' // ♥
export const guestbooklookupstub = '■' // ♥

export const guestbook_doodle_strokewt = 8